export const STORAGE_TOKEN = "TOKEN";

export const STORAGE_USER = "未登陆";

export const STATUS_DATA = [
    {value:0,label:'启用'},
    {value:1,label:'禁用'}
]
//终端类型
export const TERMINAL_TYPE_DATA = [
    {value:1,label:'医院'},
    {value:2,label:'药店'},
    {value:3,label:'商业公司'},
    {value:4,label:'基层医疗卫生机构'}
]
//产品类型
export const PRODUCT_TYPE_DATA = [
    {value:1,label:'产品'},
    {value:2,label:'药品'}
]
//药品类型
export const DRUGS_DATA = [
    {value:1,label:'OTC'},
    {value:2,label:'处方药'}
]
//展示状态
export const OPEN_DATA = [
    {value:1,label:'是'},
    {value:2,label:'否'}
]
//小程序端显示状态
export const APPLETS_DATA = [
    {value:1,label:'展示'},
    {value:2,label:'不展示'}
]
//服务类型
export const SERVICE_TYPE_DATA = [
    {value:1,label:'综合调研'},
    {value:2,label:'门店管理'},
    {value:3,label:'点击新闻资讯'},
    {value:4,label:'点击非院士级教学案例'},
    {value:5,label:'点击院士级教学案例'},
    {value:6,label:'点击大专家讲堂视频'},
    {value:7,label:'点击新闻资讯'},
    {value:8,label:'点击大会视频'},
    {value:9,label:'渠道维护'},
    {value:10,label:'拜访推广'},
    {value:11,label:'会议宣传'},
    {value:12,label:'市场调研'},
    {value:13,label:'市场分析报告'}
]
//结算状态
export const settlementTab = [
    {value:"0",label:'待审核'},
    {value:"1",label:'已结算'},
]
//模版字段类型
export const TEMPLATE_TYPE_DATA = [
    {value:"all",label:'已选中开启的'},
    {value:"1",label:'文本输入'},
    {value:"2",label:'数字输入'},
    {value:"3",label:'百分比输入'},
    {value:"4",label:'单选'},
    {value:"5",label:'多选'},
    {value:"6",label:'模版'},
    {value:"7",label:'开关'},
    /*{value:"8",label:'医院科室'},*/
    /*{value:"9",label:'链接地址'},
    {value:"10",label:'文件上传'},*/
    {value:"11",label:'图片上传'},
    /*{value:"12",label:'定位'},*/
    {value:"13",label:'日期选择'}
]

//协议签约模版
export const contractSignLink = 'https://eyy-temp.oss-cn-chengdu.aliyuncs.com/批量签约模板.xlsx?versionId=CAEQQhiBgICJpPuBvBciIDgwM2MxNjVjNmVjNjRiYTFhYzIzYzE5NTI0OTBiMjVk'
//产品模版
export const productLink = 'https://eyy-temp.oss-cn-chengdu.aliyuncs.com/产品导入模版.xlsx?versionId=CAEQQhiBgMCCpPuBvBciIDVmZjRhM2U5MmE0MTRhNGVhMmFkYjBkMDEzODMxZWFj'
//接包人员模版
export const packageUserLink = 'https://eyy-temp.oss-cn-chengdu.aliyuncs.com/接包人员模板.xlsx?versionId=CAEQQhiBgICGpPuBvBciIDc4ZjA2MDM3ZDY5NTQ1ZDJhMTBhODZiODE1OWFjOWM2'
//结算批次模版
export const settlementSignBatchLink = 'https://eyy-temp.oss-cn-chengdu.aliyuncs.com/结算批次模版.xlsx?versionId=CAEQQhiBgMCLuZ2DvBciIDgyNTM1NzZjYzUzYzRkOTc5NThiMjNiZDI2MjYzZGYw'

//城市
export const CITY_DATA = [
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "1101",
                                "id": 1,
                                "label": "东城区",
                                "value": "110101"
                            },
                            {
                                "father": "1101",
                                "id": 2,
                                "label": "西城区",
                                "value": "110102"
                            },
                            {
                                "father": "1101",
                                "id": 3,
                                "label": "朝阳区",
                                "value": "110105"
                            },
                            {
                                "father": "1101",
                                "id": 4,
                                "label": "丰台区",
                                "value": "110106"
                            },
                            {
                                "father": "1101",
                                "id": 5,
                                "label": "石景山区",
                                "value": "110107"
                            },
                            {
                                "father": "1101",
                                "id": 6,
                                "label": "海淀区",
                                "value": "110108"
                            },
                            {
                                "father": "1101",
                                "id": 7,
                                "label": "门头沟区",
                                "value": "110109"
                            },
                            {
                                "father": "1101",
                                "id": 8,
                                "label": "房山区",
                                "value": "110111"
                            },
                            {
                                "father": "1101",
                                "id": 9,
                                "label": "通州区",
                                "value": "110112"
                            },
                            {
                                "father": "1101",
                                "id": 10,
                                "label": "顺义区",
                                "value": "110113"
                            },
                            {
                                "father": "1101",
                                "id": 11,
                                "label": "昌平区",
                                "value": "110114"
                            },
                            {
                                "father": "1101",
                                "id": 12,
                                "label": "大兴区",
                                "value": "110115"
                            },
                            {
                                "father": "1101",
                                "id": 13,
                                "label": "怀柔区",
                                "value": "110116"
                            },
                            {
                                "father": "1101",
                                "id": 14,
                                "label": "平谷区",
                                "value": "110117"
                            },
                            {
                                "father": "1101",
                                "id": 15,
                                "label": "密云区",
                                "value": "110118"
                            },
                            {
                                "father": "1101",
                                "id": 16,
                                "label": "延庆区",
                                "value": "110119"
                            }
                        ],
                        "father": "11",
                        "id": 1,
                        "label": "市辖区",
                        "value": "1101"
                    }
                ],
                "id": 1,
                "label": "北京市",
                "value": "11"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "1201",
                                "id": 17,
                                "label": "和平区",
                                "value": "120101"
                            },
                            {
                                "father": "1201",
                                "id": 18,
                                "label": "河东区",
                                "value": "120102"
                            },
                            {
                                "father": "1201",
                                "id": 19,
                                "label": "河西区",
                                "value": "120103"
                            },
                            {
                                "father": "1201",
                                "id": 20,
                                "label": "南开区",
                                "value": "120104"
                            },
                            {
                                "father": "1201",
                                "id": 21,
                                "label": "河北区",
                                "value": "120105"
                            },
                            {
                                "father": "1201",
                                "id": 22,
                                "label": "红桥区",
                                "value": "120106"
                            },
                            {
                                "father": "1201",
                                "id": 23,
                                "label": "东丽区",
                                "value": "120110"
                            },
                            {
                                "father": "1201",
                                "id": 24,
                                "label": "西青区",
                                "value": "120111"
                            },
                            {
                                "father": "1201",
                                "id": 25,
                                "label": "津南区",
                                "value": "120112"
                            },
                            {
                                "father": "1201",
                                "id": 26,
                                "label": "北辰区",
                                "value": "120113"
                            },
                            {
                                "father": "1201",
                                "id": 27,
                                "label": "武清区",
                                "value": "120114"
                            },
                            {
                                "father": "1201",
                                "id": 28,
                                "label": "宝坻区",
                                "value": "120115"
                            },
                            {
                                "father": "1201",
                                "id": 29,
                                "label": "滨海新区",
                                "value": "120116"
                            },
                            {
                                "father": "1201",
                                "id": 30,
                                "label": "宁河区",
                                "value": "120117"
                            },
                            {
                                "father": "1201",
                                "id": 31,
                                "label": "静海区",
                                "value": "120118"
                            },
                            {
                                "father": "1201",
                                "id": 32,
                                "label": "蓟州区",
                                "value": "120119"
                            }
                        ],
                        "father": "12",
                        "id": 2,
                        "label": "市辖区",
                        "value": "1201"
                    }
                ],
                "id": 2,
                "label": "天津市",
                "value": "12"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "1301",
                                "id": 33,
                                "label": "长安区",
                                "value": "130102"
                            },
                            {
                                "father": "1301",
                                "id": 34,
                                "label": "桥西区",
                                "value": "130104"
                            },
                            {
                                "father": "1301",
                                "id": 35,
                                "label": "新华区",
                                "value": "130105"
                            },
                            {
                                "father": "1301",
                                "id": 36,
                                "label": "井陉矿区",
                                "value": "130107"
                            },
                            {
                                "father": "1301",
                                "id": 37,
                                "label": "裕华区",
                                "value": "130108"
                            },
                            {
                                "father": "1301",
                                "id": 38,
                                "label": "藁城区",
                                "value": "130109"
                            },
                            {
                                "father": "1301",
                                "id": 39,
                                "label": "鹿泉区",
                                "value": "130110"
                            },
                            {
                                "father": "1301",
                                "id": 40,
                                "label": "栾城区",
                                "value": "130111"
                            },
                            {
                                "father": "1301",
                                "id": 41,
                                "label": "井陉县",
                                "value": "130121"
                            },
                            {
                                "father": "1301",
                                "id": 42,
                                "label": "正定县",
                                "value": "130123"
                            },
                            {
                                "father": "1301",
                                "id": 43,
                                "label": "行唐县",
                                "value": "130125"
                            },
                            {
                                "father": "1301",
                                "id": 44,
                                "label": "灵寿县",
                                "value": "130126"
                            },
                            {
                                "father": "1301",
                                "id": 45,
                                "label": "高邑县",
                                "value": "130127"
                            },
                            {
                                "father": "1301",
                                "id": 46,
                                "label": "深泽县",
                                "value": "130128"
                            },
                            {
                                "father": "1301",
                                "id": 47,
                                "label": "赞皇县",
                                "value": "130129"
                            },
                            {
                                "father": "1301",
                                "id": 48,
                                "label": "无极县",
                                "value": "130130"
                            },
                            {
                                "father": "1301",
                                "id": 49,
                                "label": "平山县",
                                "value": "130131"
                            },
                            {
                                "father": "1301",
                                "id": 50,
                                "label": "元氏县",
                                "value": "130132"
                            },
                            {
                                "father": "1301",
                                "id": 51,
                                "label": "赵县",
                                "value": "130133"
                            },
                            {
                                "father": "1301",
                                "id": 52,
                                "label": "石家庄高新技术产业开发区",
                                "value": "130171"
                            },
                            {
                                "father": "1301",
                                "id": 53,
                                "label": "石家庄循环化工园区",
                                "value": "130172"
                            },
                            {
                                "father": "1301",
                                "id": 54,
                                "label": "辛集市",
                                "value": "130181"
                            },
                            {
                                "father": "1301",
                                "id": 55,
                                "label": "晋州市",
                                "value": "130183"
                            },
                            {
                                "father": "1301",
                                "id": 56,
                                "label": "新乐市",
                                "value": "130184"
                            }
                        ],
                        "father": "13",
                        "id": 3,
                        "label": "石家庄市",
                        "value": "1301"
                    },
                    {
                        "children": [
                            {
                                "father": "1302",
                                "id": 57,
                                "label": "路南区",
                                "value": "130202"
                            },
                            {
                                "father": "1302",
                                "id": 58,
                                "label": "路北区",
                                "value": "130203"
                            },
                            {
                                "father": "1302",
                                "id": 59,
                                "label": "古冶区",
                                "value": "130204"
                            },
                            {
                                "father": "1302",
                                "id": 60,
                                "label": "开平区",
                                "value": "130205"
                            },
                            {
                                "father": "1302",
                                "id": 61,
                                "label": "丰南区",
                                "value": "130207"
                            },
                            {
                                "father": "1302",
                                "id": 62,
                                "label": "丰润区",
                                "value": "130208"
                            },
                            {
                                "father": "1302",
                                "id": 63,
                                "label": "曹妃甸区",
                                "value": "130209"
                            },
                            {
                                "father": "1302",
                                "id": 64,
                                "label": "滦南县",
                                "value": "130224"
                            },
                            {
                                "father": "1302",
                                "id": 65,
                                "label": "乐亭县",
                                "value": "130225"
                            },
                            {
                                "father": "1302",
                                "id": 66,
                                "label": "迁西县",
                                "value": "130227"
                            },
                            {
                                "father": "1302",
                                "id": 67,
                                "label": "玉田县",
                                "value": "130229"
                            },
                            {
                                "father": "1302",
                                "id": 68,
                                "label": "河北唐山芦台经济开发区",
                                "value": "130271"
                            },
                            {
                                "father": "1302",
                                "id": 69,
                                "label": "唐山市汉沽管理区",
                                "value": "130272"
                            },
                            {
                                "father": "1302",
                                "id": 70,
                                "label": "唐山高新技术产业开发区",
                                "value": "130273"
                            },
                            {
                                "father": "1302",
                                "id": 71,
                                "label": "河北唐山海港经济开发区",
                                "value": "130274"
                            },
                            {
                                "father": "1302",
                                "id": 72,
                                "label": "遵化市",
                                "value": "130281"
                            },
                            {
                                "father": "1302",
                                "id": 73,
                                "label": "迁安市",
                                "value": "130283"
                            },
                            {
                                "father": "1302",
                                "id": 74,
                                "label": "滦州市",
                                "value": "130284"
                            }
                        ],
                        "father": "13",
                        "id": 4,
                        "label": "唐山市",
                        "value": "1302"
                    },
                    {
                        "children": [
                            {
                                "father": "1303",
                                "id": 75,
                                "label": "海港区",
                                "value": "130302"
                            },
                            {
                                "father": "1303",
                                "id": 76,
                                "label": "山海关区",
                                "value": "130303"
                            },
                            {
                                "father": "1303",
                                "id": 77,
                                "label": "北戴河区",
                                "value": "130304"
                            },
                            {
                                "father": "1303",
                                "id": 78,
                                "label": "抚宁区",
                                "value": "130306"
                            },
                            {
                                "father": "1303",
                                "id": 79,
                                "label": "青龙满族自治县",
                                "value": "130321"
                            },
                            {
                                "father": "1303",
                                "id": 80,
                                "label": "昌黎县",
                                "value": "130322"
                            },
                            {
                                "father": "1303",
                                "id": 81,
                                "label": "卢龙县",
                                "value": "130324"
                            },
                            {
                                "father": "1303",
                                "id": 82,
                                "label": "秦皇岛市经济技术开发区",
                                "value": "130371"
                            },
                            {
                                "father": "1303",
                                "id": 83,
                                "label": "北戴河新区",
                                "value": "130372"
                            }
                        ],
                        "father": "13",
                        "id": 5,
                        "label": "秦皇岛市",
                        "value": "1303"
                    },
                    {
                        "children": [
                            {
                                "father": "1304",
                                "id": 84,
                                "label": "邯山区",
                                "value": "130402"
                            },
                            {
                                "father": "1304",
                                "id": 85,
                                "label": "丛台区",
                                "value": "130403"
                            },
                            {
                                "father": "1304",
                                "id": 86,
                                "label": "复兴区",
                                "value": "130404"
                            },
                            {
                                "father": "1304",
                                "id": 87,
                                "label": "峰峰矿区",
                                "value": "130406"
                            },
                            {
                                "father": "1304",
                                "id": 88,
                                "label": "肥乡区",
                                "value": "130407"
                            },
                            {
                                "father": "1304",
                                "id": 89,
                                "label": "永年区",
                                "value": "130408"
                            },
                            {
                                "father": "1304",
                                "id": 90,
                                "label": "临漳县",
                                "value": "130423"
                            },
                            {
                                "father": "1304",
                                "id": 91,
                                "label": "成安县",
                                "value": "130424"
                            },
                            {
                                "father": "1304",
                                "id": 92,
                                "label": "大名县",
                                "value": "130425"
                            },
                            {
                                "father": "1304",
                                "id": 93,
                                "label": "涉县",
                                "value": "130426"
                            },
                            {
                                "father": "1304",
                                "id": 94,
                                "label": "磁县",
                                "value": "130427"
                            },
                            {
                                "father": "1304",
                                "id": 95,
                                "label": "邱县",
                                "value": "130430"
                            },
                            {
                                "father": "1304",
                                "id": 96,
                                "label": "鸡泽县",
                                "value": "130431"
                            },
                            {
                                "father": "1304",
                                "id": 97,
                                "label": "广平县",
                                "value": "130432"
                            },
                            {
                                "father": "1304",
                                "id": 98,
                                "label": "馆陶县",
                                "value": "130433"
                            },
                            {
                                "father": "1304",
                                "id": 99,
                                "label": "魏县",
                                "value": "130434"
                            },
                            {
                                "father": "1304",
                                "id": 100,
                                "label": "曲周县",
                                "value": "130435"
                            },
                            {
                                "father": "1304",
                                "id": 101,
                                "label": "邯郸经济技术开发区",
                                "value": "130471"
                            },
                            {
                                "father": "1304",
                                "id": 102,
                                "label": "邯郸冀南新区",
                                "value": "130473"
                            },
                            {
                                "father": "1304",
                                "id": 103,
                                "label": "武安市",
                                "value": "130481"
                            }
                        ],
                        "father": "13",
                        "id": 6,
                        "label": "邯郸市",
                        "value": "1304"
                    },
                    {
                        "children": [
                            {
                                "father": "1305",
                                "id": 104,
                                "label": "桥东区",
                                "value": "130502"
                            },
                            {
                                "father": "1305",
                                "id": 105,
                                "label": "桥西区",
                                "value": "130503"
                            },
                            {
                                "father": "1305",
                                "id": 106,
                                "label": "邢台县",
                                "value": "130521"
                            },
                            {
                                "father": "1305",
                                "id": 107,
                                "label": "临城县",
                                "value": "130522"
                            },
                            {
                                "father": "1305",
                                "id": 108,
                                "label": "内丘县",
                                "value": "130523"
                            },
                            {
                                "father": "1305",
                                "id": 109,
                                "label": "柏乡县",
                                "value": "130524"
                            },
                            {
                                "father": "1305",
                                "id": 110,
                                "label": "隆尧县",
                                "value": "130525"
                            },
                            {
                                "father": "1305",
                                "id": 111,
                                "label": "任县",
                                "value": "130526"
                            },
                            {
                                "father": "1305",
                                "id": 112,
                                "label": "南和县",
                                "value": "130527"
                            },
                            {
                                "father": "1305",
                                "id": 113,
                                "label": "宁晋县",
                                "value": "130528"
                            },
                            {
                                "father": "1305",
                                "id": 114,
                                "label": "巨鹿县",
                                "value": "130529"
                            },
                            {
                                "father": "1305",
                                "id": 115,
                                "label": "新河县",
                                "value": "130530"
                            },
                            {
                                "father": "1305",
                                "id": 116,
                                "label": "广宗县",
                                "value": "130531"
                            },
                            {
                                "father": "1305",
                                "id": 117,
                                "label": "平乡县",
                                "value": "130532"
                            },
                            {
                                "father": "1305",
                                "id": 118,
                                "label": "威县",
                                "value": "130533"
                            },
                            {
                                "father": "1305",
                                "id": 119,
                                "label": "清河县",
                                "value": "130534"
                            },
                            {
                                "father": "1305",
                                "id": 120,
                                "label": "临西县",
                                "value": "130535"
                            },
                            {
                                "father": "1305",
                                "id": 121,
                                "label": "河北邢台经济开发区",
                                "value": "130571"
                            },
                            {
                                "father": "1305",
                                "id": 122,
                                "label": "南宫市",
                                "value": "130581"
                            },
                            {
                                "father": "1305",
                                "id": 123,
                                "label": "沙河市",
                                "value": "130582"
                            }
                        ],
                        "father": "13",
                        "id": 7,
                        "label": "邢台市",
                        "value": "1305"
                    },
                    {
                        "children": [
                            {
                                "father": "1306",
                                "id": 124,
                                "label": "竞秀区",
                                "value": "130602"
                            },
                            {
                                "father": "1306",
                                "id": 125,
                                "label": "莲池区",
                                "value": "130606"
                            },
                            {
                                "father": "1306",
                                "id": 126,
                                "label": "满城区",
                                "value": "130607"
                            },
                            {
                                "father": "1306",
                                "id": 127,
                                "label": "清苑区",
                                "value": "130608"
                            },
                            {
                                "father": "1306",
                                "id": 128,
                                "label": "徐水区",
                                "value": "130609"
                            },
                            {
                                "father": "1306",
                                "id": 129,
                                "label": "涞水县",
                                "value": "130623"
                            },
                            {
                                "father": "1306",
                                "id": 130,
                                "label": "阜平县",
                                "value": "130624"
                            },
                            {
                                "father": "1306",
                                "id": 131,
                                "label": "定兴县",
                                "value": "130626"
                            },
                            {
                                "father": "1306",
                                "id": 132,
                                "label": "唐县",
                                "value": "130627"
                            },
                            {
                                "father": "1306",
                                "id": 133,
                                "label": "高阳县",
                                "value": "130628"
                            },
                            {
                                "father": "1306",
                                "id": 134,
                                "label": "容城县",
                                "value": "130629"
                            },
                            {
                                "father": "1306",
                                "id": 135,
                                "label": "涞源县",
                                "value": "130630"
                            },
                            {
                                "father": "1306",
                                "id": 136,
                                "label": "望都县",
                                "value": "130631"
                            },
                            {
                                "father": "1306",
                                "id": 137,
                                "label": "安新县",
                                "value": "130632"
                            },
                            {
                                "father": "1306",
                                "id": 138,
                                "label": "易县",
                                "value": "130633"
                            },
                            {
                                "father": "1306",
                                "id": 139,
                                "label": "曲阳县",
                                "value": "130634"
                            },
                            {
                                "father": "1306",
                                "id": 140,
                                "label": "蠡县",
                                "value": "130635"
                            },
                            {
                                "father": "1306",
                                "id": 141,
                                "label": "顺平县",
                                "value": "130636"
                            },
                            {
                                "father": "1306",
                                "id": 142,
                                "label": "博野县",
                                "value": "130637"
                            },
                            {
                                "father": "1306",
                                "id": 143,
                                "label": "雄县",
                                "value": "130638"
                            },
                            {
                                "father": "1306",
                                "id": 144,
                                "label": "保定高新技术产业开发区",
                                "value": "130671"
                            },
                            {
                                "father": "1306",
                                "id": 145,
                                "label": "保定白沟新城",
                                "value": "130672"
                            },
                            {
                                "father": "1306",
                                "id": 146,
                                "label": "涿州市",
                                "value": "130681"
                            },
                            {
                                "father": "1306",
                                "id": 147,
                                "label": "定州市",
                                "value": "130682"
                            },
                            {
                                "father": "1306",
                                "id": 148,
                                "label": "安国市",
                                "value": "130683"
                            },
                            {
                                "father": "1306",
                                "id": 149,
                                "label": "高碑店市",
                                "value": "130684"
                            }
                        ],
                        "father": "13",
                        "id": 8,
                        "label": "保定市",
                        "value": "1306"
                    },
                    {
                        "children": [
                            {
                                "father": "1307",
                                "id": 150,
                                "label": "桥东区",
                                "value": "130702"
                            },
                            {
                                "father": "1307",
                                "id": 151,
                                "label": "桥西区",
                                "value": "130703"
                            },
                            {
                                "father": "1307",
                                "id": 152,
                                "label": "宣化区",
                                "value": "130705"
                            },
                            {
                                "father": "1307",
                                "id": 153,
                                "label": "下花园区",
                                "value": "130706"
                            },
                            {
                                "father": "1307",
                                "id": 154,
                                "label": "万全区",
                                "value": "130708"
                            },
                            {
                                "father": "1307",
                                "id": 155,
                                "label": "崇礼区",
                                "value": "130709"
                            },
                            {
                                "father": "1307",
                                "id": 156,
                                "label": "张北县",
                                "value": "130722"
                            },
                            {
                                "father": "1307",
                                "id": 157,
                                "label": "康保县",
                                "value": "130723"
                            },
                            {
                                "father": "1307",
                                "id": 158,
                                "label": "沽源县",
                                "value": "130724"
                            },
                            {
                                "father": "1307",
                                "id": 159,
                                "label": "尚义县",
                                "value": "130725"
                            },
                            {
                                "father": "1307",
                                "id": 160,
                                "label": "蔚县",
                                "value": "130726"
                            },
                            {
                                "father": "1307",
                                "id": 161,
                                "label": "阳原县",
                                "value": "130727"
                            },
                            {
                                "father": "1307",
                                "id": 162,
                                "label": "怀安县",
                                "value": "130728"
                            },
                            {
                                "father": "1307",
                                "id": 163,
                                "label": "怀来县",
                                "value": "130730"
                            },
                            {
                                "father": "1307",
                                "id": 164,
                                "label": "涿鹿县",
                                "value": "130731"
                            },
                            {
                                "father": "1307",
                                "id": 165,
                                "label": "赤城县",
                                "value": "130732"
                            },
                            {
                                "father": "1307",
                                "id": 166,
                                "label": "张家口经济开发区",
                                "value": "130771"
                            },
                            {
                                "father": "1307",
                                "id": 167,
                                "label": "张家口市察北管理区",
                                "value": "130772"
                            },
                            {
                                "father": "1307",
                                "id": 168,
                                "label": "张家口市塞北管理区",
                                "value": "130773"
                            }
                        ],
                        "father": "13",
                        "id": 9,
                        "label": "张家口市",
                        "value": "1307"
                    },
                    {
                        "children": [
                            {
                                "father": "1308",
                                "id": 169,
                                "label": "双桥区",
                                "value": "130802"
                            },
                            {
                                "father": "1308",
                                "id": 170,
                                "label": "双滦区",
                                "value": "130803"
                            },
                            {
                                "father": "1308",
                                "id": 171,
                                "label": "鹰手营子矿区",
                                "value": "130804"
                            },
                            {
                                "father": "1308",
                                "id": 172,
                                "label": "承德县",
                                "value": "130821"
                            },
                            {
                                "father": "1308",
                                "id": 173,
                                "label": "兴隆县",
                                "value": "130822"
                            },
                            {
                                "father": "1308",
                                "id": 174,
                                "label": "滦平县",
                                "value": "130824"
                            },
                            {
                                "father": "1308",
                                "id": 175,
                                "label": "隆化县",
                                "value": "130825"
                            },
                            {
                                "father": "1308",
                                "id": 176,
                                "label": "丰宁满族自治县",
                                "value": "130826"
                            },
                            {
                                "father": "1308",
                                "id": 177,
                                "label": "宽城满族自治县",
                                "value": "130827"
                            },
                            {
                                "father": "1308",
                                "id": 178,
                                "label": "围场满族蒙古族自治县",
                                "value": "130828"
                            },
                            {
                                "father": "1308",
                                "id": 179,
                                "label": "承德高新技术产业开发区",
                                "value": "130871"
                            },
                            {
                                "father": "1308",
                                "id": 180,
                                "label": "平泉市",
                                "value": "130881"
                            }
                        ],
                        "father": "13",
                        "id": 10,
                        "label": "承德市",
                        "value": "1308"
                    },
                    {
                        "children": [
                            {
                                "father": "1309",
                                "id": 181,
                                "label": "新华区",
                                "value": "130902"
                            },
                            {
                                "father": "1309",
                                "id": 182,
                                "label": "运河区",
                                "value": "130903"
                            },
                            {
                                "father": "1309",
                                "id": 183,
                                "label": "沧县",
                                "value": "130921"
                            },
                            {
                                "father": "1309",
                                "id": 184,
                                "label": "青县",
                                "value": "130922"
                            },
                            {
                                "father": "1309",
                                "id": 185,
                                "label": "东光县",
                                "value": "130923"
                            },
                            {
                                "father": "1309",
                                "id": 186,
                                "label": "海兴县",
                                "value": "130924"
                            },
                            {
                                "father": "1309",
                                "id": 187,
                                "label": "盐山县",
                                "value": "130925"
                            },
                            {
                                "father": "1309",
                                "id": 188,
                                "label": "肃宁县",
                                "value": "130926"
                            },
                            {
                                "father": "1309",
                                "id": 189,
                                "label": "南皮县",
                                "value": "130927"
                            },
                            {
                                "father": "1309",
                                "id": 190,
                                "label": "吴桥县",
                                "value": "130928"
                            },
                            {
                                "father": "1309",
                                "id": 191,
                                "label": "献县",
                                "value": "130929"
                            },
                            {
                                "father": "1309",
                                "id": 192,
                                "label": "孟村回族自治县",
                                "value": "130930"
                            },
                            {
                                "father": "1309",
                                "id": 193,
                                "label": "河北沧州经济开发区",
                                "value": "130971"
                            },
                            {
                                "father": "1309",
                                "id": 194,
                                "label": "沧州高新技术产业开发区",
                                "value": "130972"
                            },
                            {
                                "father": "1309",
                                "id": 195,
                                "label": "沧州渤海新区",
                                "value": "130973"
                            },
                            {
                                "father": "1309",
                                "id": 196,
                                "label": "泊头市",
                                "value": "130981"
                            },
                            {
                                "father": "1309",
                                "id": 197,
                                "label": "任丘市",
                                "value": "130982"
                            },
                            {
                                "father": "1309",
                                "id": 198,
                                "label": "黄骅市",
                                "value": "130983"
                            },
                            {
                                "father": "1309",
                                "id": 199,
                                "label": "河间市",
                                "value": "130984"
                            }
                        ],
                        "father": "13",
                        "id": 11,
                        "label": "沧州市",
                        "value": "1309"
                    },
                    {
                        "children": [
                            {
                                "father": "1310",
                                "id": 200,
                                "label": "安次区",
                                "value": "131002"
                            },
                            {
                                "father": "1310",
                                "id": 201,
                                "label": "广阳区",
                                "value": "131003"
                            },
                            {
                                "father": "1310",
                                "id": 202,
                                "label": "固安县",
                                "value": "131022"
                            },
                            {
                                "father": "1310",
                                "id": 203,
                                "label": "永清县",
                                "value": "131023"
                            },
                            {
                                "father": "1310",
                                "id": 204,
                                "label": "香河县",
                                "value": "131024"
                            },
                            {
                                "father": "1310",
                                "id": 205,
                                "label": "大城县",
                                "value": "131025"
                            },
                            {
                                "father": "1310",
                                "id": 206,
                                "label": "文安县",
                                "value": "131026"
                            },
                            {
                                "father": "1310",
                                "id": 207,
                                "label": "大厂回族自治县",
                                "value": "131028"
                            },
                            {
                                "father": "1310",
                                "id": 208,
                                "label": "廊坊经济技术开发区",
                                "value": "131071"
                            },
                            {
                                "father": "1310",
                                "id": 209,
                                "label": "霸州市",
                                "value": "131081"
                            },
                            {
                                "father": "1310",
                                "id": 210,
                                "label": "三河市",
                                "value": "131082"
                            }
                        ],
                        "father": "13",
                        "id": 12,
                        "label": "廊坊市",
                        "value": "1310"
                    },
                    {
                        "children": [
                            {
                                "father": "1311",
                                "id": 211,
                                "label": "桃城区",
                                "value": "131102"
                            },
                            {
                                "father": "1311",
                                "id": 212,
                                "label": "冀州区",
                                "value": "131103"
                            },
                            {
                                "father": "1311",
                                "id": 213,
                                "label": "枣强县",
                                "value": "131121"
                            },
                            {
                                "father": "1311",
                                "id": 214,
                                "label": "武邑县",
                                "value": "131122"
                            },
                            {
                                "father": "1311",
                                "id": 215,
                                "label": "武强县",
                                "value": "131123"
                            },
                            {
                                "father": "1311",
                                "id": 216,
                                "label": "饶阳县",
                                "value": "131124"
                            },
                            {
                                "father": "1311",
                                "id": 217,
                                "label": "安平县",
                                "value": "131125"
                            },
                            {
                                "father": "1311",
                                "id": 218,
                                "label": "故城县",
                                "value": "131126"
                            },
                            {
                                "father": "1311",
                                "id": 219,
                                "label": "景县",
                                "value": "131127"
                            },
                            {
                                "father": "1311",
                                "id": 220,
                                "label": "阜城县",
                                "value": "131128"
                            },
                            {
                                "father": "1311",
                                "id": 221,
                                "label": "河北衡水高新技术产业开发区",
                                "value": "131171"
                            },
                            {
                                "father": "1311",
                                "id": 222,
                                "label": "衡水滨湖新区",
                                "value": "131172"
                            },
                            {
                                "father": "1311",
                                "id": 223,
                                "label": "深州市",
                                "value": "131182"
                            }
                        ],
                        "father": "13",
                        "id": 13,
                        "label": "衡水市",
                        "value": "1311"
                    }
                ],
                "id": 3,
                "label": "河北省",
                "value": "13"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "1401",
                                "id": 224,
                                "label": "小店区",
                                "value": "140105"
                            },
                            {
                                "father": "1401",
                                "id": 225,
                                "label": "迎泽区",
                                "value": "140106"
                            },
                            {
                                "father": "1401",
                                "id": 226,
                                "label": "杏花岭区",
                                "value": "140107"
                            },
                            {
                                "father": "1401",
                                "id": 227,
                                "label": "尖草坪区",
                                "value": "140108"
                            },
                            {
                                "father": "1401",
                                "id": 228,
                                "label": "万柏林区",
                                "value": "140109"
                            },
                            {
                                "father": "1401",
                                "id": 229,
                                "label": "晋源区",
                                "value": "140110"
                            },
                            {
                                "father": "1401",
                                "id": 230,
                                "label": "清徐县",
                                "value": "140121"
                            },
                            {
                                "father": "1401",
                                "id": 231,
                                "label": "阳曲县",
                                "value": "140122"
                            },
                            {
                                "father": "1401",
                                "id": 232,
                                "label": "娄烦县",
                                "value": "140123"
                            },
                            {
                                "father": "1401",
                                "id": 233,
                                "label": "山西转型综合改革示范区",
                                "value": "140171"
                            },
                            {
                                "father": "1401",
                                "id": 234,
                                "label": "古交市",
                                "value": "140181"
                            }
                        ],
                        "father": "14",
                        "id": 14,
                        "label": "太原市",
                        "value": "1401"
                    },
                    {
                        "children": [
                            {
                                "father": "1402",
                                "id": 235,
                                "label": "新荣区",
                                "value": "140212"
                            },
                            {
                                "father": "1402",
                                "id": 236,
                                "label": "平城区",
                                "value": "140213"
                            },
                            {
                                "father": "1402",
                                "id": 237,
                                "label": "云冈区",
                                "value": "140214"
                            },
                            {
                                "father": "1402",
                                "id": 238,
                                "label": "云州区",
                                "value": "140215"
                            },
                            {
                                "father": "1402",
                                "id": 239,
                                "label": "阳高县",
                                "value": "140221"
                            },
                            {
                                "father": "1402",
                                "id": 240,
                                "label": "天镇县",
                                "value": "140222"
                            },
                            {
                                "father": "1402",
                                "id": 241,
                                "label": "广灵县",
                                "value": "140223"
                            },
                            {
                                "father": "1402",
                                "id": 242,
                                "label": "灵丘县",
                                "value": "140224"
                            },
                            {
                                "father": "1402",
                                "id": 243,
                                "label": "浑源县",
                                "value": "140225"
                            },
                            {
                                "father": "1402",
                                "id": 244,
                                "label": "左云县",
                                "value": "140226"
                            },
                            {
                                "father": "1402",
                                "id": 245,
                                "label": "山西大同经济开发区",
                                "value": "140271"
                            }
                        ],
                        "father": "14",
                        "id": 15,
                        "label": "大同市",
                        "value": "1402"
                    },
                    {
                        "children": [
                            {
                                "father": "1403",
                                "id": 246,
                                "label": "城区",
                                "value": "140302"
                            },
                            {
                                "father": "1403",
                                "id": 247,
                                "label": "矿区",
                                "value": "140303"
                            },
                            {
                                "father": "1403",
                                "id": 248,
                                "label": "郊区",
                                "value": "140311"
                            },
                            {
                                "father": "1403",
                                "id": 249,
                                "label": "平定县",
                                "value": "140321"
                            },
                            {
                                "father": "1403",
                                "id": 250,
                                "label": "盂县",
                                "value": "140322"
                            }
                        ],
                        "father": "14",
                        "id": 16,
                        "label": "阳泉市",
                        "value": "1403"
                    },
                    {
                        "children": [
                            {
                                "father": "1404",
                                "id": 251,
                                "label": "潞州区",
                                "value": "140403"
                            },
                            {
                                "father": "1404",
                                "id": 252,
                                "label": "上党区",
                                "value": "140404"
                            },
                            {
                                "father": "1404",
                                "id": 253,
                                "label": "屯留区",
                                "value": "140405"
                            },
                            {
                                "father": "1404",
                                "id": 254,
                                "label": "潞城区",
                                "value": "140406"
                            },
                            {
                                "father": "1404",
                                "id": 255,
                                "label": "襄垣县",
                                "value": "140423"
                            },
                            {
                                "father": "1404",
                                "id": 256,
                                "label": "平顺县",
                                "value": "140425"
                            },
                            {
                                "father": "1404",
                                "id": 257,
                                "label": "黎城县",
                                "value": "140426"
                            },
                            {
                                "father": "1404",
                                "id": 258,
                                "label": "壶关县",
                                "value": "140427"
                            },
                            {
                                "father": "1404",
                                "id": 259,
                                "label": "长子县",
                                "value": "140428"
                            },
                            {
                                "father": "1404",
                                "id": 260,
                                "label": "武乡县",
                                "value": "140429"
                            },
                            {
                                "father": "1404",
                                "id": 261,
                                "label": "沁县",
                                "value": "140430"
                            },
                            {
                                "father": "1404",
                                "id": 262,
                                "label": "沁源县",
                                "value": "140431"
                            },
                            {
                                "father": "1404",
                                "id": 263,
                                "label": "山西长治高新技术产业园区",
                                "value": "140471"
                            }
                        ],
                        "father": "14",
                        "id": 17,
                        "label": "长治市",
                        "value": "1404"
                    },
                    {
                        "children": [
                            {
                                "father": "1405",
                                "id": 264,
                                "label": "城区",
                                "value": "140502"
                            },
                            {
                                "father": "1405",
                                "id": 265,
                                "label": "沁水县",
                                "value": "140521"
                            },
                            {
                                "father": "1405",
                                "id": 266,
                                "label": "阳城县",
                                "value": "140522"
                            },
                            {
                                "father": "1405",
                                "id": 267,
                                "label": "陵川县",
                                "value": "140524"
                            },
                            {
                                "father": "1405",
                                "id": 268,
                                "label": "泽州县",
                                "value": "140525"
                            },
                            {
                                "father": "1405",
                                "id": 269,
                                "label": "高平市",
                                "value": "140581"
                            }
                        ],
                        "father": "14",
                        "id": 18,
                        "label": "晋城市",
                        "value": "1405"
                    },
                    {
                        "children": [
                            {
                                "father": "1406",
                                "id": 270,
                                "label": "朔城区",
                                "value": "140602"
                            },
                            {
                                "father": "1406",
                                "id": 271,
                                "label": "平鲁区",
                                "value": "140603"
                            },
                            {
                                "father": "1406",
                                "id": 272,
                                "label": "山阴县",
                                "value": "140621"
                            },
                            {
                                "father": "1406",
                                "id": 273,
                                "label": "应县",
                                "value": "140622"
                            },
                            {
                                "father": "1406",
                                "id": 274,
                                "label": "右玉县",
                                "value": "140623"
                            },
                            {
                                "father": "1406",
                                "id": 275,
                                "label": "山西朔州经济开发区",
                                "value": "140671"
                            },
                            {
                                "father": "1406",
                                "id": 276,
                                "label": "怀仁市",
                                "value": "140681"
                            }
                        ],
                        "father": "14",
                        "id": 19,
                        "label": "朔州市",
                        "value": "1406"
                    },
                    {
                        "children": [
                            {
                                "father": "1407",
                                "id": 277,
                                "label": "榆次区",
                                "value": "140702"
                            },
                            {
                                "father": "1407",
                                "id": 278,
                                "label": "榆社县",
                                "value": "140721"
                            },
                            {
                                "father": "1407",
                                "id": 279,
                                "label": "左权县",
                                "value": "140722"
                            },
                            {
                                "father": "1407",
                                "id": 280,
                                "label": "和顺县",
                                "value": "140723"
                            },
                            {
                                "father": "1407",
                                "id": 281,
                                "label": "昔阳县",
                                "value": "140724"
                            },
                            {
                                "father": "1407",
                                "id": 282,
                                "label": "寿阳县",
                                "value": "140725"
                            },
                            {
                                "father": "1407",
                                "id": 283,
                                "label": "太谷县",
                                "value": "140726"
                            },
                            {
                                "father": "1407",
                                "id": 284,
                                "label": "祁县",
                                "value": "140727"
                            },
                            {
                                "father": "1407",
                                "id": 285,
                                "label": "平遥县",
                                "value": "140728"
                            },
                            {
                                "father": "1407",
                                "id": 286,
                                "label": "灵石县",
                                "value": "140729"
                            },
                            {
                                "father": "1407",
                                "id": 287,
                                "label": "介休市",
                                "value": "140781"
                            }
                        ],
                        "father": "14",
                        "id": 20,
                        "label": "晋中市",
                        "value": "1407"
                    },
                    {
                        "children": [
                            {
                                "father": "1408",
                                "id": 288,
                                "label": "盐湖区",
                                "value": "140802"
                            },
                            {
                                "father": "1408",
                                "id": 289,
                                "label": "临猗县",
                                "value": "140821"
                            },
                            {
                                "father": "1408",
                                "id": 290,
                                "label": "万荣县",
                                "value": "140822"
                            },
                            {
                                "father": "1408",
                                "id": 291,
                                "label": "闻喜县",
                                "value": "140823"
                            },
                            {
                                "father": "1408",
                                "id": 292,
                                "label": "稷山县",
                                "value": "140824"
                            },
                            {
                                "father": "1408",
                                "id": 293,
                                "label": "新绛县",
                                "value": "140825"
                            },
                            {
                                "father": "1408",
                                "id": 294,
                                "label": "绛县",
                                "value": "140826"
                            },
                            {
                                "father": "1408",
                                "id": 295,
                                "label": "垣曲县",
                                "value": "140827"
                            },
                            {
                                "father": "1408",
                                "id": 296,
                                "label": "夏县",
                                "value": "140828"
                            },
                            {
                                "father": "1408",
                                "id": 297,
                                "label": "平陆县",
                                "value": "140829"
                            },
                            {
                                "father": "1408",
                                "id": 298,
                                "label": "芮城县",
                                "value": "140830"
                            },
                            {
                                "father": "1408",
                                "id": 299,
                                "label": "永济市",
                                "value": "140881"
                            },
                            {
                                "father": "1408",
                                "id": 300,
                                "label": "河津市",
                                "value": "140882"
                            }
                        ],
                        "father": "14",
                        "id": 21,
                        "label": "运城市",
                        "value": "1408"
                    },
                    {
                        "children": [
                            {
                                "father": "1409",
                                "id": 301,
                                "label": "忻府区",
                                "value": "140902"
                            },
                            {
                                "father": "1409",
                                "id": 302,
                                "label": "定襄县",
                                "value": "140921"
                            },
                            {
                                "father": "1409",
                                "id": 303,
                                "label": "五台县",
                                "value": "140922"
                            },
                            {
                                "father": "1409",
                                "id": 304,
                                "label": "代县",
                                "value": "140923"
                            },
                            {
                                "father": "1409",
                                "id": 305,
                                "label": "繁峙县",
                                "value": "140924"
                            },
                            {
                                "father": "1409",
                                "id": 306,
                                "label": "宁武县",
                                "value": "140925"
                            },
                            {
                                "father": "1409",
                                "id": 307,
                                "label": "静乐县",
                                "value": "140926"
                            },
                            {
                                "father": "1409",
                                "id": 308,
                                "label": "神池县",
                                "value": "140927"
                            },
                            {
                                "father": "1409",
                                "id": 309,
                                "label": "五寨县",
                                "value": "140928"
                            },
                            {
                                "father": "1409",
                                "id": 310,
                                "label": "岢岚县",
                                "value": "140929"
                            },
                            {
                                "father": "1409",
                                "id": 311,
                                "label": "河曲县",
                                "value": "140930"
                            },
                            {
                                "father": "1409",
                                "id": 312,
                                "label": "保德县",
                                "value": "140931"
                            },
                            {
                                "father": "1409",
                                "id": 313,
                                "label": "偏关县",
                                "value": "140932"
                            },
                            {
                                "father": "1409",
                                "id": 314,
                                "label": "五台山风景名胜区",
                                "value": "140971"
                            },
                            {
                                "father": "1409",
                                "id": 315,
                                "label": "原平市",
                                "value": "140981"
                            }
                        ],
                        "father": "14",
                        "id": 22,
                        "label": "忻州市",
                        "value": "1409"
                    },
                    {
                        "children": [
                            {
                                "father": "1410",
                                "id": 316,
                                "label": "尧都区",
                                "value": "141002"
                            },
                            {
                                "father": "1410",
                                "id": 317,
                                "label": "曲沃县",
                                "value": "141021"
                            },
                            {
                                "father": "1410",
                                "id": 318,
                                "label": "翼城县",
                                "value": "141022"
                            },
                            {
                                "father": "1410",
                                "id": 319,
                                "label": "襄汾县",
                                "value": "141023"
                            },
                            {
                                "father": "1410",
                                "id": 320,
                                "label": "洪洞县",
                                "value": "141024"
                            },
                            {
                                "father": "1410",
                                "id": 321,
                                "label": "古县",
                                "value": "141025"
                            },
                            {
                                "father": "1410",
                                "id": 322,
                                "label": "安泽县",
                                "value": "141026"
                            },
                            {
                                "father": "1410",
                                "id": 323,
                                "label": "浮山县",
                                "value": "141027"
                            },
                            {
                                "father": "1410",
                                "id": 324,
                                "label": "吉县",
                                "value": "141028"
                            },
                            {
                                "father": "1410",
                                "id": 325,
                                "label": "乡宁县",
                                "value": "141029"
                            },
                            {
                                "father": "1410",
                                "id": 326,
                                "label": "大宁县",
                                "value": "141030"
                            },
                            {
                                "father": "1410",
                                "id": 327,
                                "label": "隰县",
                                "value": "141031"
                            },
                            {
                                "father": "1410",
                                "id": 328,
                                "label": "永和县",
                                "value": "141032"
                            },
                            {
                                "father": "1410",
                                "id": 329,
                                "label": "蒲县",
                                "value": "141033"
                            },
                            {
                                "father": "1410",
                                "id": 330,
                                "label": "汾西县",
                                "value": "141034"
                            },
                            {
                                "father": "1410",
                                "id": 331,
                                "label": "侯马市",
                                "value": "141081"
                            },
                            {
                                "father": "1410",
                                "id": 332,
                                "label": "霍州市",
                                "value": "141082"
                            }
                        ],
                        "father": "14",
                        "id": 23,
                        "label": "临汾市",
                        "value": "1410"
                    },
                    {
                        "children": [
                            {
                                "father": "1411",
                                "id": 333,
                                "label": "离石区",
                                "value": "141102"
                            },
                            {
                                "father": "1411",
                                "id": 334,
                                "label": "文水县",
                                "value": "141121"
                            },
                            {
                                "father": "1411",
                                "id": 335,
                                "label": "交城县",
                                "value": "141122"
                            },
                            {
                                "father": "1411",
                                "id": 336,
                                "label": "兴县",
                                "value": "141123"
                            },
                            {
                                "father": "1411",
                                "id": 337,
                                "label": "临县",
                                "value": "141124"
                            },
                            {
                                "father": "1411",
                                "id": 338,
                                "label": "柳林县",
                                "value": "141125"
                            },
                            {
                                "father": "1411",
                                "id": 339,
                                "label": "石楼县",
                                "value": "141126"
                            },
                            {
                                "father": "1411",
                                "id": 340,
                                "label": "岚县",
                                "value": "141127"
                            },
                            {
                                "father": "1411",
                                "id": 341,
                                "label": "方山县",
                                "value": "141128"
                            },
                            {
                                "father": "1411",
                                "id": 342,
                                "label": "中阳县",
                                "value": "141129"
                            },
                            {
                                "father": "1411",
                                "id": 343,
                                "label": "交口县",
                                "value": "141130"
                            },
                            {
                                "father": "1411",
                                "id": 344,
                                "label": "孝义市",
                                "value": "141181"
                            },
                            {
                                "father": "1411",
                                "id": 345,
                                "label": "汾阳市",
                                "value": "141182"
                            }
                        ],
                        "father": "14",
                        "id": 24,
                        "label": "吕梁市",
                        "value": "1411"
                    }
                ],
                "id": 4,
                "label": "山西省",
                "value": "14"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "1501",
                                "id": 346,
                                "label": "新城区",
                                "value": "150102"
                            },
                            {
                                "father": "1501",
                                "id": 347,
                                "label": "回民区",
                                "value": "150103"
                            },
                            {
                                "father": "1501",
                                "id": 348,
                                "label": "玉泉区",
                                "value": "150104"
                            },
                            {
                                "father": "1501",
                                "id": 349,
                                "label": "赛罕区",
                                "value": "150105"
                            },
                            {
                                "father": "1501",
                                "id": 350,
                                "label": "土默特左旗",
                                "value": "150121"
                            },
                            {
                                "father": "1501",
                                "id": 351,
                                "label": "托克托县",
                                "value": "150122"
                            },
                            {
                                "father": "1501",
                                "id": 352,
                                "label": "和林格尔县",
                                "value": "150123"
                            },
                            {
                                "father": "1501",
                                "id": 353,
                                "label": "清水河县",
                                "value": "150124"
                            },
                            {
                                "father": "1501",
                                "id": 354,
                                "label": "武川县",
                                "value": "150125"
                            },
                            {
                                "father": "1501",
                                "id": 355,
                                "label": "呼和浩特金海工业园区",
                                "value": "150171"
                            },
                            {
                                "father": "1501",
                                "id": 356,
                                "label": "呼和浩特经济技术开发区",
                                "value": "150172"
                            }
                        ],
                        "father": "15",
                        "id": 25,
                        "label": "呼和浩特市",
                        "value": "1501"
                    },
                    {
                        "children": [
                            {
                                "father": "1502",
                                "id": 357,
                                "label": "东河区",
                                "value": "150202"
                            },
                            {
                                "father": "1502",
                                "id": 358,
                                "label": "昆都仑区",
                                "value": "150203"
                            },
                            {
                                "father": "1502",
                                "id": 359,
                                "label": "青山区",
                                "value": "150204"
                            },
                            {
                                "father": "1502",
                                "id": 360,
                                "label": "石拐区",
                                "value": "150205"
                            },
                            {
                                "father": "1502",
                                "id": 361,
                                "label": "白云鄂博矿区",
                                "value": "150206"
                            },
                            {
                                "father": "1502",
                                "id": 362,
                                "label": "九原区",
                                "value": "150207"
                            },
                            {
                                "father": "1502",
                                "id": 363,
                                "label": "土默特右旗",
                                "value": "150221"
                            },
                            {
                                "father": "1502",
                                "id": 364,
                                "label": "固阳县",
                                "value": "150222"
                            },
                            {
                                "father": "1502",
                                "id": 365,
                                "label": "达尔罕茂明安联合旗",
                                "value": "150223"
                            },
                            {
                                "father": "1502",
                                "id": 366,
                                "label": "包头稀土高新技术产业开发区",
                                "value": "150271"
                            }
                        ],
                        "father": "15",
                        "id": 26,
                        "label": "包头市",
                        "value": "1502"
                    },
                    {
                        "children": [
                            {
                                "father": "1503",
                                "id": 367,
                                "label": "海勃湾区",
                                "value": "150302"
                            },
                            {
                                "father": "1503",
                                "id": 368,
                                "label": "海南区",
                                "value": "150303"
                            },
                            {
                                "father": "1503",
                                "id": 369,
                                "label": "乌达区",
                                "value": "150304"
                            }
                        ],
                        "father": "15",
                        "id": 27,
                        "label": "乌海市",
                        "value": "1503"
                    },
                    {
                        "children": [
                            {
                                "father": "1504",
                                "id": 370,
                                "label": "红山区",
                                "value": "150402"
                            },
                            {
                                "father": "1504",
                                "id": 371,
                                "label": "元宝山区",
                                "value": "150403"
                            },
                            {
                                "father": "1504",
                                "id": 372,
                                "label": "松山区",
                                "value": "150404"
                            },
                            {
                                "father": "1504",
                                "id": 373,
                                "label": "阿鲁科尔沁旗",
                                "value": "150421"
                            },
                            {
                                "father": "1504",
                                "id": 374,
                                "label": "巴林左旗",
                                "value": "150422"
                            },
                            {
                                "father": "1504",
                                "id": 375,
                                "label": "巴林右旗",
                                "value": "150423"
                            },
                            {
                                "father": "1504",
                                "id": 376,
                                "label": "林西县",
                                "value": "150424"
                            },
                            {
                                "father": "1504",
                                "id": 377,
                                "label": "克什克腾旗",
                                "value": "150425"
                            },
                            {
                                "father": "1504",
                                "id": 378,
                                "label": "翁牛特旗",
                                "value": "150426"
                            },
                            {
                                "father": "1504",
                                "id": 379,
                                "label": "喀喇沁旗",
                                "value": "150428"
                            },
                            {
                                "father": "1504",
                                "id": 380,
                                "label": "宁城县",
                                "value": "150429"
                            },
                            {
                                "father": "1504",
                                "id": 381,
                                "label": "敖汉旗",
                                "value": "150430"
                            }
                        ],
                        "father": "15",
                        "id": 28,
                        "label": "赤峰市",
                        "value": "1504"
                    },
                    {
                        "children": [
                            {
                                "father": "1505",
                                "id": 382,
                                "label": "科尔沁区",
                                "value": "150502"
                            },
                            {
                                "father": "1505",
                                "id": 383,
                                "label": "科尔沁左翼中旗",
                                "value": "150521"
                            },
                            {
                                "father": "1505",
                                "id": 384,
                                "label": "科尔沁左翼后旗",
                                "value": "150522"
                            },
                            {
                                "father": "1505",
                                "id": 385,
                                "label": "开鲁县",
                                "value": "150523"
                            },
                            {
                                "father": "1505",
                                "id": 386,
                                "label": "库伦旗",
                                "value": "150524"
                            },
                            {
                                "father": "1505",
                                "id": 387,
                                "label": "奈曼旗",
                                "value": "150525"
                            },
                            {
                                "father": "1505",
                                "id": 388,
                                "label": "扎鲁特旗",
                                "value": "150526"
                            },
                            {
                                "father": "1505",
                                "id": 389,
                                "label": "通辽经济技术开发区",
                                "value": "150571"
                            },
                            {
                                "father": "1505",
                                "id": 390,
                                "label": "霍林郭勒市",
                                "value": "150581"
                            }
                        ],
                        "father": "15",
                        "id": 29,
                        "label": "通辽市",
                        "value": "1505"
                    },
                    {
                        "children": [
                            {
                                "father": "1506",
                                "id": 391,
                                "label": "东胜区",
                                "value": "150602"
                            },
                            {
                                "father": "1506",
                                "id": 392,
                                "label": "康巴什区",
                                "value": "150603"
                            },
                            {
                                "father": "1506",
                                "id": 393,
                                "label": "达拉特旗",
                                "value": "150621"
                            },
                            {
                                "father": "1506",
                                "id": 394,
                                "label": "准格尔旗",
                                "value": "150622"
                            },
                            {
                                "father": "1506",
                                "id": 395,
                                "label": "鄂托克前旗",
                                "value": "150623"
                            },
                            {
                                "father": "1506",
                                "id": 396,
                                "label": "鄂托克旗",
                                "value": "150624"
                            },
                            {
                                "father": "1506",
                                "id": 397,
                                "label": "杭锦旗",
                                "value": "150625"
                            },
                            {
                                "father": "1506",
                                "id": 398,
                                "label": "乌审旗",
                                "value": "150626"
                            },
                            {
                                "father": "1506",
                                "id": 399,
                                "label": "伊金霍洛旗",
                                "value": "150627"
                            }
                        ],
                        "father": "15",
                        "id": 30,
                        "label": "鄂尔多斯市",
                        "value": "1506"
                    },
                    {
                        "children": [
                            {
                                "father": "1507",
                                "id": 400,
                                "label": "海拉尔区",
                                "value": "150702"
                            },
                            {
                                "father": "1507",
                                "id": 401,
                                "label": "扎赉诺尔区",
                                "value": "150703"
                            },
                            {
                                "father": "1507",
                                "id": 402,
                                "label": "阿荣旗",
                                "value": "150721"
                            },
                            {
                                "father": "1507",
                                "id": 403,
                                "label": "莫力达瓦达斡尔族自治旗",
                                "value": "150722"
                            },
                            {
                                "father": "1507",
                                "id": 404,
                                "label": "鄂伦春自治旗",
                                "value": "150723"
                            },
                            {
                                "father": "1507",
                                "id": 405,
                                "label": "鄂温克族自治旗",
                                "value": "150724"
                            },
                            {
                                "father": "1507",
                                "id": 406,
                                "label": "陈巴尔虎旗",
                                "value": "150725"
                            },
                            {
                                "father": "1507",
                                "id": 407,
                                "label": "新巴尔虎左旗",
                                "value": "150726"
                            },
                            {
                                "father": "1507",
                                "id": 408,
                                "label": "新巴尔虎右旗",
                                "value": "150727"
                            },
                            {
                                "father": "1507",
                                "id": 409,
                                "label": "满洲里市",
                                "value": "150781"
                            },
                            {
                                "father": "1507",
                                "id": 410,
                                "label": "牙克石市",
                                "value": "150782"
                            },
                            {
                                "father": "1507",
                                "id": 411,
                                "label": "扎兰屯市",
                                "value": "150783"
                            },
                            {
                                "father": "1507",
                                "id": 412,
                                "label": "额尔古纳市",
                                "value": "150784"
                            },
                            {
                                "father": "1507",
                                "id": 413,
                                "label": "根河市",
                                "value": "150785"
                            }
                        ],
                        "father": "15",
                        "id": 31,
                        "label": "呼伦贝尔市",
                        "value": "1507"
                    },
                    {
                        "children": [
                            {
                                "father": "1508",
                                "id": 414,
                                "label": "临河区",
                                "value": "150802"
                            },
                            {
                                "father": "1508",
                                "id": 415,
                                "label": "五原县",
                                "value": "150821"
                            },
                            {
                                "father": "1508",
                                "id": 416,
                                "label": "磴口县",
                                "value": "150822"
                            },
                            {
                                "father": "1508",
                                "id": 417,
                                "label": "乌拉特前旗",
                                "value": "150823"
                            },
                            {
                                "father": "1508",
                                "id": 418,
                                "label": "乌拉特中旗",
                                "value": "150824"
                            },
                            {
                                "father": "1508",
                                "id": 419,
                                "label": "乌拉特后旗",
                                "value": "150825"
                            },
                            {
                                "father": "1508",
                                "id": 420,
                                "label": "杭锦后旗",
                                "value": "150826"
                            }
                        ],
                        "father": "15",
                        "id": 32,
                        "label": "巴彦淖尔市",
                        "value": "1508"
                    },
                    {
                        "children": [
                            {
                                "father": "1509",
                                "id": 421,
                                "label": "集宁区",
                                "value": "150902"
                            },
                            {
                                "father": "1509",
                                "id": 422,
                                "label": "卓资县",
                                "value": "150921"
                            },
                            {
                                "father": "1509",
                                "id": 423,
                                "label": "化德县",
                                "value": "150922"
                            },
                            {
                                "father": "1509",
                                "id": 424,
                                "label": "商都县",
                                "value": "150923"
                            },
                            {
                                "father": "1509",
                                "id": 425,
                                "label": "兴和县",
                                "value": "150924"
                            },
                            {
                                "father": "1509",
                                "id": 426,
                                "label": "凉城县",
                                "value": "150925"
                            },
                            {
                                "father": "1509",
                                "id": 427,
                                "label": "察哈尔右翼前旗",
                                "value": "150926"
                            },
                            {
                                "father": "1509",
                                "id": 428,
                                "label": "察哈尔右翼中旗",
                                "value": "150927"
                            },
                            {
                                "father": "1509",
                                "id": 429,
                                "label": "察哈尔右翼后旗",
                                "value": "150928"
                            },
                            {
                                "father": "1509",
                                "id": 430,
                                "label": "四子王旗",
                                "value": "150929"
                            },
                            {
                                "father": "1509",
                                "id": 431,
                                "label": "丰镇市",
                                "value": "150981"
                            }
                        ],
                        "father": "15",
                        "id": 33,
                        "label": "乌兰察布市",
                        "value": "1509"
                    },
                    {
                        "children": [
                            {
                                "father": "1522",
                                "id": 432,
                                "label": "乌兰浩特市",
                                "value": "152201"
                            },
                            {
                                "father": "1522",
                                "id": 433,
                                "label": "阿尔山市",
                                "value": "152202"
                            },
                            {
                                "father": "1522",
                                "id": 434,
                                "label": "科尔沁右翼前旗",
                                "value": "152221"
                            },
                            {
                                "father": "1522",
                                "id": 435,
                                "label": "科尔沁右翼中旗",
                                "value": "152222"
                            },
                            {
                                "father": "1522",
                                "id": 436,
                                "label": "扎赉特旗",
                                "value": "152223"
                            },
                            {
                                "father": "1522",
                                "id": 437,
                                "label": "突泉县",
                                "value": "152224"
                            }
                        ],
                        "father": "15",
                        "id": 34,
                        "label": "兴安盟",
                        "value": "1522"
                    },
                    {
                        "children": [
                            {
                                "father": "1525",
                                "id": 438,
                                "label": "二连浩特市",
                                "value": "152501"
                            },
                            {
                                "father": "1525",
                                "id": 439,
                                "label": "锡林浩特市",
                                "value": "152502"
                            },
                            {
                                "father": "1525",
                                "id": 440,
                                "label": "阿巴嘎旗",
                                "value": "152522"
                            },
                            {
                                "father": "1525",
                                "id": 441,
                                "label": "苏尼特左旗",
                                "value": "152523"
                            },
                            {
                                "father": "1525",
                                "id": 442,
                                "label": "苏尼特右旗",
                                "value": "152524"
                            },
                            {
                                "father": "1525",
                                "id": 443,
                                "label": "东乌珠穆沁旗",
                                "value": "152525"
                            },
                            {
                                "father": "1525",
                                "id": 444,
                                "label": "西乌珠穆沁旗",
                                "value": "152526"
                            },
                            {
                                "father": "1525",
                                "id": 445,
                                "label": "太仆寺旗",
                                "value": "152527"
                            },
                            {
                                "father": "1525",
                                "id": 446,
                                "label": "镶黄旗",
                                "value": "152528"
                            },
                            {
                                "father": "1525",
                                "id": 447,
                                "label": "正镶白旗",
                                "value": "152529"
                            },
                            {
                                "father": "1525",
                                "id": 448,
                                "label": "正蓝旗",
                                "value": "152530"
                            },
                            {
                                "father": "1525",
                                "id": 449,
                                "label": "多伦县",
                                "value": "152531"
                            },
                            {
                                "father": "1525",
                                "id": 450,
                                "label": "乌拉盖管委会",
                                "value": "152571"
                            }
                        ],
                        "father": "15",
                        "id": 35,
                        "label": "锡林郭勒盟",
                        "value": "1525"
                    },
                    {
                        "children": [
                            {
                                "father": "1529",
                                "id": 451,
                                "label": "阿拉善左旗",
                                "value": "152921"
                            },
                            {
                                "father": "1529",
                                "id": 452,
                                "label": "阿拉善右旗",
                                "value": "152922"
                            },
                            {
                                "father": "1529",
                                "id": 453,
                                "label": "额济纳旗",
                                "value": "152923"
                            },
                            {
                                "father": "1529",
                                "id": 454,
                                "label": "内蒙古阿拉善经济开发区",
                                "value": "152971"
                            }
                        ],
                        "father": "15",
                        "id": 36,
                        "label": "阿拉善盟",
                        "value": "1529"
                    }
                ],
                "id": 5,
                "label": "内蒙古自治区",
                "value": "15"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "2101",
                                "id": 455,
                                "label": "和平区",
                                "value": "210102"
                            },
                            {
                                "father": "2101",
                                "id": 456,
                                "label": "沈河区",
                                "value": "210103"
                            },
                            {
                                "father": "2101",
                                "id": 457,
                                "label": "大东区",
                                "value": "210104"
                            },
                            {
                                "father": "2101",
                                "id": 458,
                                "label": "皇姑区",
                                "value": "210105"
                            },
                            {
                                "father": "2101",
                                "id": 459,
                                "label": "铁西区",
                                "value": "210106"
                            },
                            {
                                "father": "2101",
                                "id": 460,
                                "label": "苏家屯区",
                                "value": "210111"
                            },
                            {
                                "father": "2101",
                                "id": 461,
                                "label": "浑南区",
                                "value": "210112"
                            },
                            {
                                "father": "2101",
                                "id": 462,
                                "label": "沈北新区",
                                "value": "210113"
                            },
                            {
                                "father": "2101",
                                "id": 463,
                                "label": "于洪区",
                                "value": "210114"
                            },
                            {
                                "father": "2101",
                                "id": 464,
                                "label": "辽中区",
                                "value": "210115"
                            },
                            {
                                "father": "2101",
                                "id": 465,
                                "label": "康平县",
                                "value": "210123"
                            },
                            {
                                "father": "2101",
                                "id": 466,
                                "label": "法库县",
                                "value": "210124"
                            },
                            {
                                "father": "2101",
                                "id": 467,
                                "label": "新民市",
                                "value": "210181"
                            }
                        ],
                        "father": "21",
                        "id": 37,
                        "label": "沈阳市",
                        "value": "2101"
                    },
                    {
                        "children": [
                            {
                                "father": "2102",
                                "id": 468,
                                "label": "中山区",
                                "value": "210202"
                            },
                            {
                                "father": "2102",
                                "id": 469,
                                "label": "西岗区",
                                "value": "210203"
                            },
                            {
                                "father": "2102",
                                "id": 470,
                                "label": "沙河口区",
                                "value": "210204"
                            },
                            {
                                "father": "2102",
                                "id": 471,
                                "label": "甘井子区",
                                "value": "210211"
                            },
                            {
                                "father": "2102",
                                "id": 472,
                                "label": "旅顺口区",
                                "value": "210212"
                            },
                            {
                                "father": "2102",
                                "id": 473,
                                "label": "金州区",
                                "value": "210213"
                            },
                            {
                                "father": "2102",
                                "id": 474,
                                "label": "普兰店区",
                                "value": "210214"
                            },
                            {
                                "father": "2102",
                                "id": 475,
                                "label": "长海县",
                                "value": "210224"
                            },
                            {
                                "father": "2102",
                                "id": 476,
                                "label": "瓦房店市",
                                "value": "210281"
                            },
                            {
                                "father": "2102",
                                "id": 477,
                                "label": "庄河市",
                                "value": "210283"
                            }
                        ],
                        "father": "21",
                        "id": 38,
                        "label": "大连市",
                        "value": "2102"
                    },
                    {
                        "children": [
                            {
                                "father": "2103",
                                "id": 478,
                                "label": "铁东区",
                                "value": "210302"
                            },
                            {
                                "father": "2103",
                                "id": 479,
                                "label": "铁西区",
                                "value": "210303"
                            },
                            {
                                "father": "2103",
                                "id": 480,
                                "label": "立山区",
                                "value": "210304"
                            },
                            {
                                "father": "2103",
                                "id": 481,
                                "label": "千山区",
                                "value": "210311"
                            },
                            {
                                "father": "2103",
                                "id": 482,
                                "label": "台安县",
                                "value": "210321"
                            },
                            {
                                "father": "2103",
                                "id": 483,
                                "label": "岫岩满族自治县",
                                "value": "210323"
                            },
                            {
                                "father": "2103",
                                "id": 484,
                                "label": "海城市",
                                "value": "210381"
                            }
                        ],
                        "father": "21",
                        "id": 39,
                        "label": "鞍山市",
                        "value": "2103"
                    },
                    {
                        "children": [
                            {
                                "father": "2104",
                                "id": 485,
                                "label": "新抚区",
                                "value": "210402"
                            },
                            {
                                "father": "2104",
                                "id": 486,
                                "label": "东洲区",
                                "value": "210403"
                            },
                            {
                                "father": "2104",
                                "id": 487,
                                "label": "望花区",
                                "value": "210404"
                            },
                            {
                                "father": "2104",
                                "id": 488,
                                "label": "顺城区",
                                "value": "210411"
                            },
                            {
                                "father": "2104",
                                "id": 489,
                                "label": "抚顺县",
                                "value": "210421"
                            },
                            {
                                "father": "2104",
                                "id": 490,
                                "label": "新宾满族自治县",
                                "value": "210422"
                            },
                            {
                                "father": "2104",
                                "id": 491,
                                "label": "清原满族自治县",
                                "value": "210423"
                            }
                        ],
                        "father": "21",
                        "id": 40,
                        "label": "抚顺市",
                        "value": "2104"
                    },
                    {
                        "children": [
                            {
                                "father": "2105",
                                "id": 492,
                                "label": "平山区",
                                "value": "210502"
                            },
                            {
                                "father": "2105",
                                "id": 493,
                                "label": "溪湖区",
                                "value": "210503"
                            },
                            {
                                "father": "2105",
                                "id": 494,
                                "label": "明山区",
                                "value": "210504"
                            },
                            {
                                "father": "2105",
                                "id": 495,
                                "label": "南芬区",
                                "value": "210505"
                            },
                            {
                                "father": "2105",
                                "id": 496,
                                "label": "本溪满族自治县",
                                "value": "210521"
                            },
                            {
                                "father": "2105",
                                "id": 497,
                                "label": "桓仁满族自治县",
                                "value": "210522"
                            }
                        ],
                        "father": "21",
                        "id": 41,
                        "label": "本溪市",
                        "value": "2105"
                    },
                    {
                        "children": [
                            {
                                "father": "2106",
                                "id": 498,
                                "label": "元宝区",
                                "value": "210602"
                            },
                            {
                                "father": "2106",
                                "id": 499,
                                "label": "振兴区",
                                "value": "210603"
                            },
                            {
                                "father": "2106",
                                "id": 500,
                                "label": "振安区",
                                "value": "210604"
                            },
                            {
                                "father": "2106",
                                "id": 501,
                                "label": "宽甸满族自治县",
                                "value": "210624"
                            },
                            {
                                "father": "2106",
                                "id": 502,
                                "label": "东港市",
                                "value": "210681"
                            },
                            {
                                "father": "2106",
                                "id": 503,
                                "label": "凤城市",
                                "value": "210682"
                            }
                        ],
                        "father": "21",
                        "id": 42,
                        "label": "丹东市",
                        "value": "2106"
                    },
                    {
                        "children": [
                            {
                                "father": "2107",
                                "id": 504,
                                "label": "古塔区",
                                "value": "210702"
                            },
                            {
                                "father": "2107",
                                "id": 505,
                                "label": "凌河区",
                                "value": "210703"
                            },
                            {
                                "father": "2107",
                                "id": 506,
                                "label": "太和区",
                                "value": "210711"
                            },
                            {
                                "father": "2107",
                                "id": 507,
                                "label": "黑山县",
                                "value": "210726"
                            },
                            {
                                "father": "2107",
                                "id": 508,
                                "label": "义县",
                                "value": "210727"
                            },
                            {
                                "father": "2107",
                                "id": 509,
                                "label": "凌海市",
                                "value": "210781"
                            },
                            {
                                "father": "2107",
                                "id": 510,
                                "label": "北镇市",
                                "value": "210782"
                            }
                        ],
                        "father": "21",
                        "id": 43,
                        "label": "锦州市",
                        "value": "2107"
                    },
                    {
                        "children": [
                            {
                                "father": "2108",
                                "id": 511,
                                "label": "站前区",
                                "value": "210802"
                            },
                            {
                                "father": "2108",
                                "id": 512,
                                "label": "西市区",
                                "value": "210803"
                            },
                            {
                                "father": "2108",
                                "id": 513,
                                "label": "鲅鱼圈区",
                                "value": "210804"
                            },
                            {
                                "father": "2108",
                                "id": 514,
                                "label": "老边区",
                                "value": "210811"
                            },
                            {
                                "father": "2108",
                                "id": 515,
                                "label": "盖州市",
                                "value": "210881"
                            },
                            {
                                "father": "2108",
                                "id": 516,
                                "label": "大石桥市",
                                "value": "210882"
                            }
                        ],
                        "father": "21",
                        "id": 44,
                        "label": "营口市",
                        "value": "2108"
                    },
                    {
                        "children": [
                            {
                                "father": "2109",
                                "id": 517,
                                "label": "海州区",
                                "value": "210902"
                            },
                            {
                                "father": "2109",
                                "id": 518,
                                "label": "新邱区",
                                "value": "210903"
                            },
                            {
                                "father": "2109",
                                "id": 519,
                                "label": "太平区",
                                "value": "210904"
                            },
                            {
                                "father": "2109",
                                "id": 520,
                                "label": "清河门区",
                                "value": "210905"
                            },
                            {
                                "father": "2109",
                                "id": 521,
                                "label": "细河区",
                                "value": "210911"
                            },
                            {
                                "father": "2109",
                                "id": 522,
                                "label": "阜新蒙古族自治县",
                                "value": "210921"
                            },
                            {
                                "father": "2109",
                                "id": 523,
                                "label": "彰武县",
                                "value": "210922"
                            }
                        ],
                        "father": "21",
                        "id": 45,
                        "label": "阜新市",
                        "value": "2109"
                    },
                    {
                        "children": [
                            {
                                "father": "2110",
                                "id": 524,
                                "label": "白塔区",
                                "value": "211002"
                            },
                            {
                                "father": "2110",
                                "id": 525,
                                "label": "文圣区",
                                "value": "211003"
                            },
                            {
                                "father": "2110",
                                "id": 526,
                                "label": "宏伟区",
                                "value": "211004"
                            },
                            {
                                "father": "2110",
                                "id": 527,
                                "label": "弓长岭区",
                                "value": "211005"
                            },
                            {
                                "father": "2110",
                                "id": 528,
                                "label": "太子河区",
                                "value": "211011"
                            },
                            {
                                "father": "2110",
                                "id": 529,
                                "label": "辽阳县",
                                "value": "211021"
                            },
                            {
                                "father": "2110",
                                "id": 530,
                                "label": "灯塔市",
                                "value": "211081"
                            }
                        ],
                        "father": "21",
                        "id": 46,
                        "label": "辽阳市",
                        "value": "2110"
                    },
                    {
                        "children": [
                            {
                                "father": "2111",
                                "id": 531,
                                "label": "双台子区",
                                "value": "211102"
                            },
                            {
                                "father": "2111",
                                "id": 532,
                                "label": "兴隆台区",
                                "value": "211103"
                            },
                            {
                                "father": "2111",
                                "id": 533,
                                "label": "大洼区",
                                "value": "211104"
                            },
                            {
                                "father": "2111",
                                "id": 534,
                                "label": "盘山县",
                                "value": "211122"
                            }
                        ],
                        "father": "21",
                        "id": 47,
                        "label": "盘锦市",
                        "value": "2111"
                    },
                    {
                        "children": [
                            {
                                "father": "2112",
                                "id": 535,
                                "label": "银州区",
                                "value": "211202"
                            },
                            {
                                "father": "2112",
                                "id": 536,
                                "label": "清河区",
                                "value": "211204"
                            },
                            {
                                "father": "2112",
                                "id": 537,
                                "label": "铁岭县",
                                "value": "211221"
                            },
                            {
                                "father": "2112",
                                "id": 538,
                                "label": "西丰县",
                                "value": "211223"
                            },
                            {
                                "father": "2112",
                                "id": 539,
                                "label": "昌图县",
                                "value": "211224"
                            },
                            {
                                "father": "2112",
                                "id": 540,
                                "label": "调兵山市",
                                "value": "211281"
                            },
                            {
                                "father": "2112",
                                "id": 541,
                                "label": "开原市",
                                "value": "211282"
                            }
                        ],
                        "father": "21",
                        "id": 48,
                        "label": "铁岭市",
                        "value": "2112"
                    },
                    {
                        "children": [
                            {
                                "father": "2113",
                                "id": 542,
                                "label": "双塔区",
                                "value": "211302"
                            },
                            {
                                "father": "2113",
                                "id": 543,
                                "label": "龙城区",
                                "value": "211303"
                            },
                            {
                                "father": "2113",
                                "id": 544,
                                "label": "朝阳县",
                                "value": "211321"
                            },
                            {
                                "father": "2113",
                                "id": 545,
                                "label": "建平县",
                                "value": "211322"
                            },
                            {
                                "father": "2113",
                                "id": 546,
                                "label": "喀喇沁左翼蒙古族自治县",
                                "value": "211324"
                            },
                            {
                                "father": "2113",
                                "id": 547,
                                "label": "北票市",
                                "value": "211381"
                            },
                            {
                                "father": "2113",
                                "id": 548,
                                "label": "凌源市",
                                "value": "211382"
                            }
                        ],
                        "father": "21",
                        "id": 49,
                        "label": "朝阳市",
                        "value": "2113"
                    },
                    {
                        "children": [
                            {
                                "father": "2114",
                                "id": 549,
                                "label": "连山区",
                                "value": "211402"
                            },
                            {
                                "father": "2114",
                                "id": 550,
                                "label": "龙港区",
                                "value": "211403"
                            },
                            {
                                "father": "2114",
                                "id": 551,
                                "label": "南票区",
                                "value": "211404"
                            },
                            {
                                "father": "2114",
                                "id": 552,
                                "label": "绥中县",
                                "value": "211421"
                            },
                            {
                                "father": "2114",
                                "id": 553,
                                "label": "建昌县",
                                "value": "211422"
                            },
                            {
                                "father": "2114",
                                "id": 554,
                                "label": "兴城市",
                                "value": "211481"
                            }
                        ],
                        "father": "21",
                        "id": 50,
                        "label": "葫芦岛市",
                        "value": "2114"
                    }
                ],
                "id": 6,
                "label": "辽宁省",
                "value": "21"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "2201",
                                "id": 555,
                                "label": "南关区",
                                "value": "220102"
                            },
                            {
                                "father": "2201",
                                "id": 556,
                                "label": "宽城区",
                                "value": "220103"
                            },
                            {
                                "father": "2201",
                                "id": 557,
                                "label": "朝阳区",
                                "value": "220104"
                            },
                            {
                                "father": "2201",
                                "id": 558,
                                "label": "二道区",
                                "value": "220105"
                            },
                            {
                                "father": "2201",
                                "id": 559,
                                "label": "绿园区",
                                "value": "220106"
                            },
                            {
                                "father": "2201",
                                "id": 560,
                                "label": "双阳区",
                                "value": "220112"
                            },
                            {
                                "father": "2201",
                                "id": 561,
                                "label": "九台区",
                                "value": "220113"
                            },
                            {
                                "father": "2201",
                                "id": 562,
                                "label": "农安县",
                                "value": "220122"
                            },
                            {
                                "father": "2201",
                                "id": 563,
                                "label": "长春经济技术开发区",
                                "value": "220171"
                            },
                            {
                                "father": "2201",
                                "id": 564,
                                "label": "长春净月高新技术产业开发区",
                                "value": "220172"
                            },
                            {
                                "father": "2201",
                                "id": 565,
                                "label": "长春高新技术产业开发区",
                                "value": "220173"
                            },
                            {
                                "father": "2201",
                                "id": 566,
                                "label": "长春汽车经济技术开发区",
                                "value": "220174"
                            },
                            {
                                "father": "2201",
                                "id": 567,
                                "label": "榆树市",
                                "value": "220182"
                            },
                            {
                                "father": "2201",
                                "id": 568,
                                "label": "德惠市",
                                "value": "220183"
                            }
                        ],
                        "father": "22",
                        "id": 51,
                        "label": "长春市",
                        "value": "2201"
                    },
                    {
                        "children": [
                            {
                                "father": "2202",
                                "id": 569,
                                "label": "昌邑区",
                                "value": "220202"
                            },
                            {
                                "father": "2202",
                                "id": 570,
                                "label": "龙潭区",
                                "value": "220203"
                            },
                            {
                                "father": "2202",
                                "id": 571,
                                "label": "船营区",
                                "value": "220204"
                            },
                            {
                                "father": "2202",
                                "id": 572,
                                "label": "丰满区",
                                "value": "220211"
                            },
                            {
                                "father": "2202",
                                "id": 573,
                                "label": "永吉县",
                                "value": "220221"
                            },
                            {
                                "father": "2202",
                                "id": 574,
                                "label": "吉林经济开发区",
                                "value": "220271"
                            },
                            {
                                "father": "2202",
                                "id": 575,
                                "label": "吉林高新技术产业开发区",
                                "value": "220272"
                            },
                            {
                                "father": "2202",
                                "id": 576,
                                "label": "吉林中国新加坡食品区",
                                "value": "220273"
                            },
                            {
                                "father": "2202",
                                "id": 577,
                                "label": "蛟河市",
                                "value": "220281"
                            },
                            {
                                "father": "2202",
                                "id": 578,
                                "label": "桦甸市",
                                "value": "220282"
                            },
                            {
                                "father": "2202",
                                "id": 579,
                                "label": "舒兰市",
                                "value": "220283"
                            },
                            {
                                "father": "2202",
                                "id": 580,
                                "label": "磐石市",
                                "value": "220284"
                            }
                        ],
                        "father": "22",
                        "id": 52,
                        "label": "吉林市",
                        "value": "2202"
                    },
                    {
                        "children": [
                            {
                                "father": "2203",
                                "id": 581,
                                "label": "铁西区",
                                "value": "220302"
                            },
                            {
                                "father": "2203",
                                "id": 582,
                                "label": "铁东区",
                                "value": "220303"
                            },
                            {
                                "father": "2203",
                                "id": 583,
                                "label": "梨树县",
                                "value": "220322"
                            },
                            {
                                "father": "2203",
                                "id": 584,
                                "label": "伊通满族自治县",
                                "value": "220323"
                            },
                            {
                                "father": "2203",
                                "id": 585,
                                "label": "公主岭市",
                                "value": "220381"
                            },
                            {
                                "father": "2203",
                                "id": 586,
                                "label": "双辽市",
                                "value": "220382"
                            }
                        ],
                        "father": "22",
                        "id": 53,
                        "label": "四平市",
                        "value": "2203"
                    },
                    {
                        "children": [
                            {
                                "father": "2204",
                                "id": 587,
                                "label": "龙山区",
                                "value": "220402"
                            },
                            {
                                "father": "2204",
                                "id": 588,
                                "label": "西安区",
                                "value": "220403"
                            },
                            {
                                "father": "2204",
                                "id": 589,
                                "label": "东丰县",
                                "value": "220421"
                            },
                            {
                                "father": "2204",
                                "id": 590,
                                "label": "东辽县",
                                "value": "220422"
                            }
                        ],
                        "father": "22",
                        "id": 54,
                        "label": "辽源市",
                        "value": "2204"
                    },
                    {
                        "children": [
                            {
                                "father": "2205",
                                "id": 591,
                                "label": "东昌区",
                                "value": "220502"
                            },
                            {
                                "father": "2205",
                                "id": 592,
                                "label": "二道江区",
                                "value": "220503"
                            },
                            {
                                "father": "2205",
                                "id": 593,
                                "label": "通化县",
                                "value": "220521"
                            },
                            {
                                "father": "2205",
                                "id": 594,
                                "label": "辉南县",
                                "value": "220523"
                            },
                            {
                                "father": "2205",
                                "id": 595,
                                "label": "柳河县",
                                "value": "220524"
                            },
                            {
                                "father": "2205",
                                "id": 596,
                                "label": "梅河口市",
                                "value": "220581"
                            },
                            {
                                "father": "2205",
                                "id": 597,
                                "label": "集安市",
                                "value": "220582"
                            }
                        ],
                        "father": "22",
                        "id": 55,
                        "label": "通化市",
                        "value": "2205"
                    },
                    {
                        "children": [
                            {
                                "father": "2206",
                                "id": 598,
                                "label": "浑江区",
                                "value": "220602"
                            },
                            {
                                "father": "2206",
                                "id": 599,
                                "label": "江源区",
                                "value": "220605"
                            },
                            {
                                "father": "2206",
                                "id": 600,
                                "label": "抚松县",
                                "value": "220621"
                            },
                            {
                                "father": "2206",
                                "id": 601,
                                "label": "靖宇县",
                                "value": "220622"
                            },
                            {
                                "father": "2206",
                                "id": 602,
                                "label": "长白朝鲜族自治县",
                                "value": "220623"
                            },
                            {
                                "father": "2206",
                                "id": 603,
                                "label": "临江市",
                                "value": "220681"
                            }
                        ],
                        "father": "22",
                        "id": 56,
                        "label": "白山市",
                        "value": "2206"
                    },
                    {
                        "children": [
                            {
                                "father": "2207",
                                "id": 604,
                                "label": "宁江区",
                                "value": "220702"
                            },
                            {
                                "father": "2207",
                                "id": 605,
                                "label": "前郭尔罗斯蒙古族自治县",
                                "value": "220721"
                            },
                            {
                                "father": "2207",
                                "id": 606,
                                "label": "长岭县",
                                "value": "220722"
                            },
                            {
                                "father": "2207",
                                "id": 607,
                                "label": "乾安县",
                                "value": "220723"
                            },
                            {
                                "father": "2207",
                                "id": 608,
                                "label": "吉林松原经济开发区",
                                "value": "220771"
                            },
                            {
                                "father": "2207",
                                "id": 609,
                                "label": "扶余市",
                                "value": "220781"
                            }
                        ],
                        "father": "22",
                        "id": 57,
                        "label": "松原市",
                        "value": "2207"
                    },
                    {
                        "children": [
                            {
                                "father": "2208",
                                "id": 610,
                                "label": "洮北区",
                                "value": "220802"
                            },
                            {
                                "father": "2208",
                                "id": 611,
                                "label": "镇赉县",
                                "value": "220821"
                            },
                            {
                                "father": "2208",
                                "id": 612,
                                "label": "通榆县",
                                "value": "220822"
                            },
                            {
                                "father": "2208",
                                "id": 613,
                                "label": "吉林白城经济开发区",
                                "value": "220871"
                            },
                            {
                                "father": "2208",
                                "id": 614,
                                "label": "洮南市",
                                "value": "220881"
                            },
                            {
                                "father": "2208",
                                "id": 615,
                                "label": "大安市",
                                "value": "220882"
                            }
                        ],
                        "father": "22",
                        "id": 58,
                        "label": "白城市",
                        "value": "2208"
                    },
                    {
                        "children": [
                            {
                                "father": "2224",
                                "id": 616,
                                "label": "延吉市",
                                "value": "222401"
                            },
                            {
                                "father": "2224",
                                "id": 617,
                                "label": "图们市",
                                "value": "222402"
                            },
                            {
                                "father": "2224",
                                "id": 618,
                                "label": "敦化市",
                                "value": "222403"
                            },
                            {
                                "father": "2224",
                                "id": 619,
                                "label": "珲春市",
                                "value": "222404"
                            },
                            {
                                "father": "2224",
                                "id": 620,
                                "label": "龙井市",
                                "value": "222405"
                            },
                            {
                                "father": "2224",
                                "id": 621,
                                "label": "和龙市",
                                "value": "222406"
                            },
                            {
                                "father": "2224",
                                "id": 622,
                                "label": "汪清县",
                                "value": "222424"
                            },
                            {
                                "father": "2224",
                                "id": 623,
                                "label": "安图县",
                                "value": "222426"
                            }
                        ],
                        "father": "22",
                        "id": 59,
                        "label": "延边朝鲜族自治州",
                        "value": "2224"
                    }
                ],
                "id": 7,
                "label": "吉林省",
                "value": "22"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "2301",
                                "id": 624,
                                "label": "道里区",
                                "value": "230102"
                            },
                            {
                                "father": "2301",
                                "id": 625,
                                "label": "南岗区",
                                "value": "230103"
                            },
                            {
                                "father": "2301",
                                "id": 626,
                                "label": "道外区",
                                "value": "230104"
                            },
                            {
                                "father": "2301",
                                "id": 627,
                                "label": "平房区",
                                "value": "230108"
                            },
                            {
                                "father": "2301",
                                "id": 628,
                                "label": "松北区",
                                "value": "230109"
                            },
                            {
                                "father": "2301",
                                "id": 629,
                                "label": "香坊区",
                                "value": "230110"
                            },
                            {
                                "father": "2301",
                                "id": 630,
                                "label": "呼兰区",
                                "value": "230111"
                            },
                            {
                                "father": "2301",
                                "id": 631,
                                "label": "阿城区",
                                "value": "230112"
                            },
                            {
                                "father": "2301",
                                "id": 632,
                                "label": "双城区",
                                "value": "230113"
                            },
                            {
                                "father": "2301",
                                "id": 633,
                                "label": "依兰县",
                                "value": "230123"
                            },
                            {
                                "father": "2301",
                                "id": 634,
                                "label": "方正县",
                                "value": "230124"
                            },
                            {
                                "father": "2301",
                                "id": 635,
                                "label": "宾县",
                                "value": "230125"
                            },
                            {
                                "father": "2301",
                                "id": 636,
                                "label": "巴彦县",
                                "value": "230126"
                            },
                            {
                                "father": "2301",
                                "id": 637,
                                "label": "木兰县",
                                "value": "230127"
                            },
                            {
                                "father": "2301",
                                "id": 638,
                                "label": "通河县",
                                "value": "230128"
                            },
                            {
                                "father": "2301",
                                "id": 639,
                                "label": "延寿县",
                                "value": "230129"
                            },
                            {
                                "father": "2301",
                                "id": 640,
                                "label": "尚志市",
                                "value": "230183"
                            },
                            {
                                "father": "2301",
                                "id": 641,
                                "label": "五常市",
                                "value": "230184"
                            }
                        ],
                        "father": "23",
                        "id": 60,
                        "label": "哈尔滨市",
                        "value": "2301"
                    },
                    {
                        "children": [
                            {
                                "father": "2302",
                                "id": 642,
                                "label": "龙沙区",
                                "value": "230202"
                            },
                            {
                                "father": "2302",
                                "id": 643,
                                "label": "建华区",
                                "value": "230203"
                            },
                            {
                                "father": "2302",
                                "id": 644,
                                "label": "铁锋区",
                                "value": "230204"
                            },
                            {
                                "father": "2302",
                                "id": 645,
                                "label": "昂昂溪区",
                                "value": "230205"
                            },
                            {
                                "father": "2302",
                                "id": 646,
                                "label": "富拉尔基区",
                                "value": "230206"
                            },
                            {
                                "father": "2302",
                                "id": 647,
                                "label": "碾子山区",
                                "value": "230207"
                            },
                            {
                                "father": "2302",
                                "id": 648,
                                "label": "梅里斯达斡尔族区",
                                "value": "230208"
                            },
                            {
                                "father": "2302",
                                "id": 649,
                                "label": "龙江县",
                                "value": "230221"
                            },
                            {
                                "father": "2302",
                                "id": 650,
                                "label": "依安县",
                                "value": "230223"
                            },
                            {
                                "father": "2302",
                                "id": 651,
                                "label": "泰来县",
                                "value": "230224"
                            },
                            {
                                "father": "2302",
                                "id": 652,
                                "label": "甘南县",
                                "value": "230225"
                            },
                            {
                                "father": "2302",
                                "id": 653,
                                "label": "富裕县",
                                "value": "230227"
                            },
                            {
                                "father": "2302",
                                "id": 654,
                                "label": "克山县",
                                "value": "230229"
                            },
                            {
                                "father": "2302",
                                "id": 655,
                                "label": "克东县",
                                "value": "230230"
                            },
                            {
                                "father": "2302",
                                "id": 656,
                                "label": "拜泉县",
                                "value": "230231"
                            },
                            {
                                "father": "2302",
                                "id": 657,
                                "label": "讷河市",
                                "value": "230281"
                            }
                        ],
                        "father": "23",
                        "id": 61,
                        "label": "齐齐哈尔市",
                        "value": "2302"
                    },
                    {
                        "children": [
                            {
                                "father": "2303",
                                "id": 658,
                                "label": "鸡冠区",
                                "value": "230302"
                            },
                            {
                                "father": "2303",
                                "id": 659,
                                "label": "恒山区",
                                "value": "230303"
                            },
                            {
                                "father": "2303",
                                "id": 660,
                                "label": "滴道区",
                                "value": "230304"
                            },
                            {
                                "father": "2303",
                                "id": 661,
                                "label": "梨树区",
                                "value": "230305"
                            },
                            {
                                "father": "2303",
                                "id": 662,
                                "label": "城子河区",
                                "value": "230306"
                            },
                            {
                                "father": "2303",
                                "id": 663,
                                "label": "麻山区",
                                "value": "230307"
                            },
                            {
                                "father": "2303",
                                "id": 664,
                                "label": "鸡东县",
                                "value": "230321"
                            },
                            {
                                "father": "2303",
                                "id": 665,
                                "label": "虎林市",
                                "value": "230381"
                            },
                            {
                                "father": "2303",
                                "id": 666,
                                "label": "密山市",
                                "value": "230382"
                            }
                        ],
                        "father": "23",
                        "id": 62,
                        "label": "鸡西市",
                        "value": "2303"
                    },
                    {
                        "children": [
                            {
                                "father": "2304",
                                "id": 667,
                                "label": "向阳区",
                                "value": "230402"
                            },
                            {
                                "father": "2304",
                                "id": 668,
                                "label": "工农区",
                                "value": "230403"
                            },
                            {
                                "father": "2304",
                                "id": 669,
                                "label": "南山区",
                                "value": "230404"
                            },
                            {
                                "father": "2304",
                                "id": 670,
                                "label": "兴安区",
                                "value": "230405"
                            },
                            {
                                "father": "2304",
                                "id": 671,
                                "label": "东山区",
                                "value": "230406"
                            },
                            {
                                "father": "2304",
                                "id": 672,
                                "label": "兴山区",
                                "value": "230407"
                            },
                            {
                                "father": "2304",
                                "id": 673,
                                "label": "萝北县",
                                "value": "230421"
                            },
                            {
                                "father": "2304",
                                "id": 674,
                                "label": "绥滨县",
                                "value": "230422"
                            }
                        ],
                        "father": "23",
                        "id": 63,
                        "label": "鹤岗市",
                        "value": "2304"
                    },
                    {
                        "children": [
                            {
                                "father": "2305",
                                "id": 675,
                                "label": "尖山区",
                                "value": "230502"
                            },
                            {
                                "father": "2305",
                                "id": 676,
                                "label": "岭东区",
                                "value": "230503"
                            },
                            {
                                "father": "2305",
                                "id": 677,
                                "label": "四方台区",
                                "value": "230505"
                            },
                            {
                                "father": "2305",
                                "id": 678,
                                "label": "宝山区",
                                "value": "230506"
                            },
                            {
                                "father": "2305",
                                "id": 679,
                                "label": "集贤县",
                                "value": "230521"
                            },
                            {
                                "father": "2305",
                                "id": 680,
                                "label": "友谊县",
                                "value": "230522"
                            },
                            {
                                "father": "2305",
                                "id": 681,
                                "label": "宝清县",
                                "value": "230523"
                            },
                            {
                                "father": "2305",
                                "id": 682,
                                "label": "饶河县",
                                "value": "230524"
                            }
                        ],
                        "father": "23",
                        "id": 64,
                        "label": "双鸭山市",
                        "value": "2305"
                    },
                    {
                        "children": [
                            {
                                "father": "2306",
                                "id": 683,
                                "label": "萨尔图区",
                                "value": "230602"
                            },
                            {
                                "father": "2306",
                                "id": 684,
                                "label": "龙凤区",
                                "value": "230603"
                            },
                            {
                                "father": "2306",
                                "id": 685,
                                "label": "让胡路区",
                                "value": "230604"
                            },
                            {
                                "father": "2306",
                                "id": 686,
                                "label": "红岗区",
                                "value": "230605"
                            },
                            {
                                "father": "2306",
                                "id": 687,
                                "label": "大同区",
                                "value": "230606"
                            },
                            {
                                "father": "2306",
                                "id": 688,
                                "label": "肇州县",
                                "value": "230621"
                            },
                            {
                                "father": "2306",
                                "id": 689,
                                "label": "肇源县",
                                "value": "230622"
                            },
                            {
                                "father": "2306",
                                "id": 690,
                                "label": "林甸县",
                                "value": "230623"
                            },
                            {
                                "father": "2306",
                                "id": 691,
                                "label": "杜尔伯特蒙古族自治县",
                                "value": "230624"
                            },
                            {
                                "father": "2306",
                                "id": 692,
                                "label": "大庆高新技术产业开发区",
                                "value": "230671"
                            }
                        ],
                        "father": "23",
                        "id": 65,
                        "label": "大庆市",
                        "value": "2306"
                    },
                    {
                        "children": [
                            {
                                "father": "2307",
                                "id": 693,
                                "label": "伊美区",
                                "value": "230717"
                            },
                            {
                                "father": "2307",
                                "id": 694,
                                "label": "乌翠区",
                                "value": "230718"
                            },
                            {
                                "father": "2307",
                                "id": 695,
                                "label": "友好区",
                                "value": "230719"
                            },
                            {
                                "father": "2307",
                                "id": 696,
                                "label": "嘉荫县",
                                "value": "230722"
                            },
                            {
                                "father": "2307",
                                "id": 697,
                                "label": "汤旺县",
                                "value": "230723"
                            },
                            {
                                "father": "2307",
                                "id": 698,
                                "label": "丰林县",
                                "value": "230724"
                            },
                            {
                                "father": "2307",
                                "id": 699,
                                "label": "大箐山县",
                                "value": "230725"
                            },
                            {
                                "father": "2307",
                                "id": 700,
                                "label": "南岔县",
                                "value": "230726"
                            },
                            {
                                "father": "2307",
                                "id": 701,
                                "label": "金林区",
                                "value": "230751"
                            },
                            {
                                "father": "2307",
                                "id": 702,
                                "label": "铁力市",
                                "value": "230781"
                            }
                        ],
                        "father": "23",
                        "id": 66,
                        "label": "伊春市",
                        "value": "2307"
                    },
                    {
                        "children": [
                            {
                                "father": "2308",
                                "id": 703,
                                "label": "向阳区",
                                "value": "230803"
                            },
                            {
                                "father": "2308",
                                "id": 704,
                                "label": "前进区",
                                "value": "230804"
                            },
                            {
                                "father": "2308",
                                "id": 705,
                                "label": "东风区",
                                "value": "230805"
                            },
                            {
                                "father": "2308",
                                "id": 706,
                                "label": "郊区",
                                "value": "230811"
                            },
                            {
                                "father": "2308",
                                "id": 707,
                                "label": "桦南县",
                                "value": "230822"
                            },
                            {
                                "father": "2308",
                                "id": 708,
                                "label": "桦川县",
                                "value": "230826"
                            },
                            {
                                "father": "2308",
                                "id": 709,
                                "label": "汤原县",
                                "value": "230828"
                            },
                            {
                                "father": "2308",
                                "id": 710,
                                "label": "同江市",
                                "value": "230881"
                            },
                            {
                                "father": "2308",
                                "id": 711,
                                "label": "富锦市",
                                "value": "230882"
                            },
                            {
                                "father": "2308",
                                "id": 712,
                                "label": "抚远市",
                                "value": "230883"
                            }
                        ],
                        "father": "23",
                        "id": 67,
                        "label": "佳木斯市",
                        "value": "2308"
                    },
                    {
                        "children": [
                            {
                                "father": "2309",
                                "id": 713,
                                "label": "新兴区",
                                "value": "230902"
                            },
                            {
                                "father": "2309",
                                "id": 714,
                                "label": "桃山区",
                                "value": "230903"
                            },
                            {
                                "father": "2309",
                                "id": 715,
                                "label": "茄子河区",
                                "value": "230904"
                            },
                            {
                                "father": "2309",
                                "id": 716,
                                "label": "勃利县",
                                "value": "230921"
                            }
                        ],
                        "father": "23",
                        "id": 68,
                        "label": "七台河市",
                        "value": "2309"
                    },
                    {
                        "children": [
                            {
                                "father": "2310",
                                "id": 717,
                                "label": "东安区",
                                "value": "231002"
                            },
                            {
                                "father": "2310",
                                "id": 718,
                                "label": "阳明区",
                                "value": "231003"
                            },
                            {
                                "father": "2310",
                                "id": 719,
                                "label": "爱民区",
                                "value": "231004"
                            },
                            {
                                "father": "2310",
                                "id": 720,
                                "label": "西安区",
                                "value": "231005"
                            },
                            {
                                "father": "2310",
                                "id": 721,
                                "label": "林口县",
                                "value": "231025"
                            },
                            {
                                "father": "2310",
                                "id": 722,
                                "label": "牡丹江经济技术开发区",
                                "value": "231071"
                            },
                            {
                                "father": "2310",
                                "id": 723,
                                "label": "绥芬河市",
                                "value": "231081"
                            },
                            {
                                "father": "2310",
                                "id": 724,
                                "label": "海林市",
                                "value": "231083"
                            },
                            {
                                "father": "2310",
                                "id": 725,
                                "label": "宁安市",
                                "value": "231084"
                            },
                            {
                                "father": "2310",
                                "id": 726,
                                "label": "穆棱市",
                                "value": "231085"
                            },
                            {
                                "father": "2310",
                                "id": 727,
                                "label": "东宁市",
                                "value": "231086"
                            }
                        ],
                        "father": "23",
                        "id": 69,
                        "label": "牡丹江市",
                        "value": "2310"
                    },
                    {
                        "children": [
                            {
                                "father": "2311",
                                "id": 728,
                                "label": "爱辉区",
                                "value": "231102"
                            },
                            {
                                "father": "2311",
                                "id": 729,
                                "label": "逊克县",
                                "value": "231123"
                            },
                            {
                                "father": "2311",
                                "id": 730,
                                "label": "孙吴县",
                                "value": "231124"
                            },
                            {
                                "father": "2311",
                                "id": 731,
                                "label": "北安市",
                                "value": "231181"
                            },
                            {
                                "father": "2311",
                                "id": 732,
                                "label": "五大连池市",
                                "value": "231182"
                            },
                            {
                                "father": "2311",
                                "id": 733,
                                "label": "嫩江市",
                                "value": "231183"
                            }
                        ],
                        "father": "23",
                        "id": 70,
                        "label": "黑河市",
                        "value": "2311"
                    },
                    {
                        "children": [
                            {
                                "father": "2312",
                                "id": 734,
                                "label": "北林区",
                                "value": "231202"
                            },
                            {
                                "father": "2312",
                                "id": 735,
                                "label": "望奎县",
                                "value": "231221"
                            },
                            {
                                "father": "2312",
                                "id": 736,
                                "label": "兰西县",
                                "value": "231222"
                            },
                            {
                                "father": "2312",
                                "id": 737,
                                "label": "青冈县",
                                "value": "231223"
                            },
                            {
                                "father": "2312",
                                "id": 738,
                                "label": "庆安县",
                                "value": "231224"
                            },
                            {
                                "father": "2312",
                                "id": 739,
                                "label": "明水县",
                                "value": "231225"
                            },
                            {
                                "father": "2312",
                                "id": 740,
                                "label": "绥棱县",
                                "value": "231226"
                            },
                            {
                                "father": "2312",
                                "id": 741,
                                "label": "安达市",
                                "value": "231281"
                            },
                            {
                                "father": "2312",
                                "id": 742,
                                "label": "肇东市",
                                "value": "231282"
                            },
                            {
                                "father": "2312",
                                "id": 743,
                                "label": "海伦市",
                                "value": "231283"
                            }
                        ],
                        "father": "23",
                        "id": 71,
                        "label": "绥化市",
                        "value": "2312"
                    },
                    {
                        "children": [
                            {
                                "father": "2327",
                                "id": 744,
                                "label": "漠河市",
                                "value": "232701"
                            },
                            {
                                "father": "2327",
                                "id": 745,
                                "label": "呼玛县",
                                "value": "232721"
                            },
                            {
                                "father": "2327",
                                "id": 746,
                                "label": "塔河县",
                                "value": "232722"
                            },
                            {
                                "father": "2327",
                                "id": 747,
                                "label": "加格达奇区",
                                "value": "232761"
                            },
                            {
                                "father": "2327",
                                "id": 748,
                                "label": "松岭区",
                                "value": "232762"
                            },
                            {
                                "father": "2327",
                                "id": 749,
                                "label": "新林区",
                                "value": "232763"
                            },
                            {
                                "father": "2327",
                                "id": 750,
                                "label": "呼中区",
                                "value": "232764"
                            }
                        ],
                        "father": "23",
                        "id": 72,
                        "label": "大兴安岭地区",
                        "value": "2327"
                    }
                ],
                "id": 8,
                "label": "黑龙江省",
                "value": "23"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "3101",
                                "id": 751,
                                "label": "黄浦区",
                                "value": "310101"
                            },
                            {
                                "father": "3101",
                                "id": 752,
                                "label": "徐汇区",
                                "value": "310104"
                            },
                            {
                                "father": "3101",
                                "id": 753,
                                "label": "长宁区",
                                "value": "310105"
                            },
                            {
                                "father": "3101",
                                "id": 754,
                                "label": "静安区",
                                "value": "310106"
                            },
                            {
                                "father": "3101",
                                "id": 755,
                                "label": "普陀区",
                                "value": "310107"
                            },
                            {
                                "father": "3101",
                                "id": 756,
                                "label": "虹口区",
                                "value": "310109"
                            },
                            {
                                "father": "3101",
                                "id": 757,
                                "label": "杨浦区",
                                "value": "310110"
                            },
                            {
                                "father": "3101",
                                "id": 758,
                                "label": "闵行区",
                                "value": "310112"
                            },
                            {
                                "father": "3101",
                                "id": 759,
                                "label": "宝山区",
                                "value": "310113"
                            },
                            {
                                "father": "3101",
                                "id": 760,
                                "label": "嘉定区",
                                "value": "310114"
                            },
                            {
                                "father": "3101",
                                "id": 761,
                                "label": "浦东新区",
                                "value": "310115"
                            },
                            {
                                "father": "3101",
                                "id": 762,
                                "label": "金山区",
                                "value": "310116"
                            },
                            {
                                "father": "3101",
                                "id": 763,
                                "label": "松江区",
                                "value": "310117"
                            },
                            {
                                "father": "3101",
                                "id": 764,
                                "label": "青浦区",
                                "value": "310118"
                            },
                            {
                                "father": "3101",
                                "id": 765,
                                "label": "奉贤区",
                                "value": "310120"
                            },
                            {
                                "father": "3101",
                                "id": 766,
                                "label": "崇明区",
                                "value": "310151"
                            }
                        ],
                        "father": "31",
                        "id": 73,
                        "label": "市辖区",
                        "value": "3101"
                    }
                ],
                "id": 9,
                "label": "上海市",
                "value": "31"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "3201",
                                "id": 767,
                                "label": "玄武区",
                                "value": "320102"
                            },
                            {
                                "father": "3201",
                                "id": 768,
                                "label": "秦淮区",
                                "value": "320104"
                            },
                            {
                                "father": "3201",
                                "id": 769,
                                "label": "建邺区",
                                "value": "320105"
                            },
                            {
                                "father": "3201",
                                "id": 770,
                                "label": "鼓楼区",
                                "value": "320106"
                            },
                            {
                                "father": "3201",
                                "id": 771,
                                "label": "浦口区",
                                "value": "320111"
                            },
                            {
                                "father": "3201",
                                "id": 772,
                                "label": "栖霞区",
                                "value": "320113"
                            },
                            {
                                "father": "3201",
                                "id": 773,
                                "label": "雨花台区",
                                "value": "320114"
                            },
                            {
                                "father": "3201",
                                "id": 774,
                                "label": "江宁区",
                                "value": "320115"
                            },
                            {
                                "father": "3201",
                                "id": 775,
                                "label": "六合区",
                                "value": "320116"
                            },
                            {
                                "father": "3201",
                                "id": 776,
                                "label": "溧水区",
                                "value": "320117"
                            },
                            {
                                "father": "3201",
                                "id": 777,
                                "label": "高淳区",
                                "value": "320118"
                            }
                        ],
                        "father": "32",
                        "id": 74,
                        "label": "南京市",
                        "value": "3201"
                    },
                    {
                        "children": [
                            {
                                "father": "3202",
                                "id": 778,
                                "label": "锡山区",
                                "value": "320205"
                            },
                            {
                                "father": "3202",
                                "id": 779,
                                "label": "惠山区",
                                "value": "320206"
                            },
                            {
                                "father": "3202",
                                "id": 780,
                                "label": "滨湖区",
                                "value": "320211"
                            },
                            {
                                "father": "3202",
                                "id": 781,
                                "label": "梁溪区",
                                "value": "320213"
                            },
                            {
                                "father": "3202",
                                "id": 782,
                                "label": "新吴区",
                                "value": "320214"
                            },
                            {
                                "father": "3202",
                                "id": 783,
                                "label": "江阴市",
                                "value": "320281"
                            },
                            {
                                "father": "3202",
                                "id": 784,
                                "label": "宜兴市",
                                "value": "320282"
                            }
                        ],
                        "father": "32",
                        "id": 75,
                        "label": "无锡市",
                        "value": "3202"
                    },
                    {
                        "children": [
                            {
                                "father": "3203",
                                "id": 785,
                                "label": "鼓楼区",
                                "value": "320302"
                            },
                            {
                                "father": "3203",
                                "id": 786,
                                "label": "云龙区",
                                "value": "320303"
                            },
                            {
                                "father": "3203",
                                "id": 787,
                                "label": "贾汪区",
                                "value": "320305"
                            },
                            {
                                "father": "3203",
                                "id": 788,
                                "label": "泉山区",
                                "value": "320311"
                            },
                            {
                                "father": "3203",
                                "id": 789,
                                "label": "铜山区",
                                "value": "320312"
                            },
                            {
                                "father": "3203",
                                "id": 790,
                                "label": "丰县",
                                "value": "320321"
                            },
                            {
                                "father": "3203",
                                "id": 791,
                                "label": "沛县",
                                "value": "320322"
                            },
                            {
                                "father": "3203",
                                "id": 792,
                                "label": "睢宁县",
                                "value": "320324"
                            },
                            {
                                "father": "3203",
                                "id": 793,
                                "label": "徐州经济技术开发区",
                                "value": "320371"
                            },
                            {
                                "father": "3203",
                                "id": 794,
                                "label": "新沂市",
                                "value": "320381"
                            },
                            {
                                "father": "3203",
                                "id": 795,
                                "label": "邳州市",
                                "value": "320382"
                            }
                        ],
                        "father": "32",
                        "id": 76,
                        "label": "徐州市",
                        "value": "3203"
                    },
                    {
                        "children": [
                            {
                                "father": "3204",
                                "id": 796,
                                "label": "天宁区",
                                "value": "320402"
                            },
                            {
                                "father": "3204",
                                "id": 797,
                                "label": "钟楼区",
                                "value": "320404"
                            },
                            {
                                "father": "3204",
                                "id": 798,
                                "label": "新北区",
                                "value": "320411"
                            },
                            {
                                "father": "3204",
                                "id": 799,
                                "label": "武进区",
                                "value": "320412"
                            },
                            {
                                "father": "3204",
                                "id": 800,
                                "label": "金坛区",
                                "value": "320413"
                            },
                            {
                                "father": "3204",
                                "id": 801,
                                "label": "溧阳市",
                                "value": "320481"
                            }
                        ],
                        "father": "32",
                        "id": 77,
                        "label": "常州市",
                        "value": "3204"
                    },
                    {
                        "children": [
                            {
                                "father": "3205",
                                "id": 802,
                                "label": "虎丘区",
                                "value": "320505"
                            },
                            {
                                "father": "3205",
                                "id": 803,
                                "label": "吴中区",
                                "value": "320506"
                            },
                            {
                                "father": "3205",
                                "id": 804,
                                "label": "相城区",
                                "value": "320507"
                            },
                            {
                                "father": "3205",
                                "id": 805,
                                "label": "姑苏区",
                                "value": "320508"
                            },
                            {
                                "father": "3205",
                                "id": 806,
                                "label": "吴江区",
                                "value": "320509"
                            },
                            {
                                "father": "3205",
                                "id": 807,
                                "label": "苏州工业园区",
                                "value": "320571"
                            },
                            {
                                "father": "3205",
                                "id": 808,
                                "label": "常熟市",
                                "value": "320581"
                            },
                            {
                                "father": "3205",
                                "id": 809,
                                "label": "张家港市",
                                "value": "320582"
                            },
                            {
                                "father": "3205",
                                "id": 810,
                                "label": "昆山市",
                                "value": "320583"
                            },
                            {
                                "father": "3205",
                                "id": 811,
                                "label": "太仓市",
                                "value": "320585"
                            }
                        ],
                        "father": "32",
                        "id": 78,
                        "label": "苏州市",
                        "value": "3205"
                    },
                    {
                        "children": [
                            {
                                "father": "3206",
                                "id": 812,
                                "label": "崇川区",
                                "value": "320602"
                            },
                            {
                                "father": "3206",
                                "id": 813,
                                "label": "港闸区",
                                "value": "320611"
                            },
                            {
                                "father": "3206",
                                "id": 814,
                                "label": "通州区",
                                "value": "320612"
                            },
                            {
                                "father": "3206",
                                "id": 815,
                                "label": "如东县",
                                "value": "320623"
                            },
                            {
                                "father": "3206",
                                "id": 816,
                                "label": "南通经济技术开发区",
                                "value": "320671"
                            },
                            {
                                "father": "3206",
                                "id": 817,
                                "label": "启东市",
                                "value": "320681"
                            },
                            {
                                "father": "3206",
                                "id": 818,
                                "label": "如皋市",
                                "value": "320682"
                            },
                            {
                                "father": "3206",
                                "id": 819,
                                "label": "海门市",
                                "value": "320684"
                            },
                            {
                                "father": "3206",
                                "id": 820,
                                "label": "海安市",
                                "value": "320685"
                            }
                        ],
                        "father": "32",
                        "id": 79,
                        "label": "南通市",
                        "value": "3206"
                    },
                    {
                        "children": [
                            {
                                "father": "3207",
                                "id": 821,
                                "label": "连云区",
                                "value": "320703"
                            },
                            {
                                "father": "3207",
                                "id": 822,
                                "label": "海州区",
                                "value": "320706"
                            },
                            {
                                "father": "3207",
                                "id": 823,
                                "label": "赣榆区",
                                "value": "320707"
                            },
                            {
                                "father": "3207",
                                "id": 824,
                                "label": "东海县",
                                "value": "320722"
                            },
                            {
                                "father": "3207",
                                "id": 825,
                                "label": "灌云县",
                                "value": "320723"
                            },
                            {
                                "father": "3207",
                                "id": 826,
                                "label": "灌南县",
                                "value": "320724"
                            },
                            {
                                "father": "3207",
                                "id": 827,
                                "label": "连云港经济技术开发区",
                                "value": "320771"
                            },
                            {
                                "father": "3207",
                                "id": 828,
                                "label": "连云港高新技术产业开发区",
                                "value": "320772"
                            }
                        ],
                        "father": "32",
                        "id": 80,
                        "label": "连云港市",
                        "value": "3207"
                    },
                    {
                        "children": [
                            {
                                "father": "3208",
                                "id": 829,
                                "label": "淮安区",
                                "value": "320803"
                            },
                            {
                                "father": "3208",
                                "id": 830,
                                "label": "淮阴区",
                                "value": "320804"
                            },
                            {
                                "father": "3208",
                                "id": 831,
                                "label": "清江浦区",
                                "value": "320812"
                            },
                            {
                                "father": "3208",
                                "id": 832,
                                "label": "洪泽区",
                                "value": "320813"
                            },
                            {
                                "father": "3208",
                                "id": 833,
                                "label": "涟水县",
                                "value": "320826"
                            },
                            {
                                "father": "3208",
                                "id": 834,
                                "label": "盱眙县",
                                "value": "320830"
                            },
                            {
                                "father": "3208",
                                "id": 835,
                                "label": "金湖县",
                                "value": "320831"
                            },
                            {
                                "father": "3208",
                                "id": 836,
                                "label": "淮安经济技术开发区",
                                "value": "320871"
                            }
                        ],
                        "father": "32",
                        "id": 81,
                        "label": "淮安市",
                        "value": "3208"
                    },
                    {
                        "children": [
                            {
                                "father": "3209",
                                "id": 837,
                                "label": "亭湖区",
                                "value": "320902"
                            },
                            {
                                "father": "3209",
                                "id": 838,
                                "label": "盐都区",
                                "value": "320903"
                            },
                            {
                                "father": "3209",
                                "id": 839,
                                "label": "大丰区",
                                "value": "320904"
                            },
                            {
                                "father": "3209",
                                "id": 840,
                                "label": "响水县",
                                "value": "320921"
                            },
                            {
                                "father": "3209",
                                "id": 841,
                                "label": "滨海县",
                                "value": "320922"
                            },
                            {
                                "father": "3209",
                                "id": 842,
                                "label": "阜宁县",
                                "value": "320923"
                            },
                            {
                                "father": "3209",
                                "id": 843,
                                "label": "射阳县",
                                "value": "320924"
                            },
                            {
                                "father": "3209",
                                "id": 844,
                                "label": "建湖县",
                                "value": "320925"
                            },
                            {
                                "father": "3209",
                                "id": 845,
                                "label": "盐城经济技术开发区",
                                "value": "320971"
                            },
                            {
                                "father": "3209",
                                "id": 846,
                                "label": "东台市",
                                "value": "320981"
                            }
                        ],
                        "father": "32",
                        "id": 82,
                        "label": "盐城市",
                        "value": "3209"
                    },
                    {
                        "children": [
                            {
                                "father": "3210",
                                "id": 847,
                                "label": "广陵区",
                                "value": "321002"
                            },
                            {
                                "father": "3210",
                                "id": 848,
                                "label": "邗江区",
                                "value": "321003"
                            },
                            {
                                "father": "3210",
                                "id": 849,
                                "label": "江都区",
                                "value": "321012"
                            },
                            {
                                "father": "3210",
                                "id": 850,
                                "label": "宝应县",
                                "value": "321023"
                            },
                            {
                                "father": "3210",
                                "id": 851,
                                "label": "扬州经济技术开发区",
                                "value": "321071"
                            },
                            {
                                "father": "3210",
                                "id": 852,
                                "label": "仪征市",
                                "value": "321081"
                            },
                            {
                                "father": "3210",
                                "id": 853,
                                "label": "高邮市",
                                "value": "321084"
                            }
                        ],
                        "father": "32",
                        "id": 83,
                        "label": "扬州市",
                        "value": "3210"
                    },
                    {
                        "children": [
                            {
                                "father": "3211",
                                "id": 854,
                                "label": "京口区",
                                "value": "321102"
                            },
                            {
                                "father": "3211",
                                "id": 855,
                                "label": "润州区",
                                "value": "321111"
                            },
                            {
                                "father": "3211",
                                "id": 856,
                                "label": "丹徒区",
                                "value": "321112"
                            },
                            {
                                "father": "3211",
                                "id": 857,
                                "label": "镇江新区",
                                "value": "321171"
                            },
                            {
                                "father": "3211",
                                "id": 858,
                                "label": "丹阳市",
                                "value": "321181"
                            },
                            {
                                "father": "3211",
                                "id": 859,
                                "label": "扬中市",
                                "value": "321182"
                            },
                            {
                                "father": "3211",
                                "id": 860,
                                "label": "句容市",
                                "value": "321183"
                            }
                        ],
                        "father": "32",
                        "id": 84,
                        "label": "镇江市",
                        "value": "3211"
                    },
                    {
                        "children": [
                            {
                                "father": "3212",
                                "id": 861,
                                "label": "海陵区",
                                "value": "321202"
                            },
                            {
                                "father": "3212",
                                "id": 862,
                                "label": "高港区",
                                "value": "321203"
                            },
                            {
                                "father": "3212",
                                "id": 863,
                                "label": "姜堰区",
                                "value": "321204"
                            },
                            {
                                "father": "3212",
                                "id": 864,
                                "label": "泰州医药高新技术产业开发区",
                                "value": "321271"
                            },
                            {
                                "father": "3212",
                                "id": 865,
                                "label": "兴化市",
                                "value": "321281"
                            },
                            {
                                "father": "3212",
                                "id": 866,
                                "label": "靖江市",
                                "value": "321282"
                            },
                            {
                                "father": "3212",
                                "id": 867,
                                "label": "泰兴市",
                                "value": "321283"
                            }
                        ],
                        "father": "32",
                        "id": 85,
                        "label": "泰州市",
                        "value": "3212"
                    },
                    {
                        "children": [
                            {
                                "father": "3213",
                                "id": 868,
                                "label": "宿城区",
                                "value": "321302"
                            },
                            {
                                "father": "3213",
                                "id": 869,
                                "label": "宿豫区",
                                "value": "321311"
                            },
                            {
                                "father": "3213",
                                "id": 870,
                                "label": "沭阳县",
                                "value": "321322"
                            },
                            {
                                "father": "3213",
                                "id": 871,
                                "label": "泗阳县",
                                "value": "321323"
                            },
                            {
                                "father": "3213",
                                "id": 872,
                                "label": "泗洪县",
                                "value": "321324"
                            },
                            {
                                "father": "3213",
                                "id": 873,
                                "label": "宿迁经济技术开发区",
                                "value": "321371"
                            }
                        ],
                        "father": "32",
                        "id": 86,
                        "label": "宿迁市",
                        "value": "3213"
                    }
                ],
                "id": 10,
                "label": "江苏省",
                "value": "32"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "3301",
                                "id": 874,
                                "label": "上城区",
                                "value": "330102"
                            },
                            {
                                "father": "3301",
                                "id": 875,
                                "label": "下城区",
                                "value": "330103"
                            },
                            {
                                "father": "3301",
                                "id": 876,
                                "label": "江干区",
                                "value": "330104"
                            },
                            {
                                "father": "3301",
                                "id": 877,
                                "label": "拱墅区",
                                "value": "330105"
                            },
                            {
                                "father": "3301",
                                "id": 878,
                                "label": "西湖区",
                                "value": "330106"
                            },
                            {
                                "father": "3301",
                                "id": 879,
                                "label": "滨江区",
                                "value": "330108"
                            },
                            {
                                "father": "3301",
                                "id": 880,
                                "label": "萧山区",
                                "value": "330109"
                            },
                            {
                                "father": "3301",
                                "id": 881,
                                "label": "余杭区",
                                "value": "330110"
                            },
                            {
                                "father": "3301",
                                "id": 882,
                                "label": "富阳区",
                                "value": "330111"
                            },
                            {
                                "father": "3301",
                                "id": 883,
                                "label": "临安区",
                                "value": "330112"
                            },
                            {
                                "father": "3301",
                                "id": 884,
                                "label": "桐庐县",
                                "value": "330122"
                            },
                            {
                                "father": "3301",
                                "id": 885,
                                "label": "淳安县",
                                "value": "330127"
                            },
                            {
                                "father": "3301",
                                "id": 886,
                                "label": "建德市",
                                "value": "330182"
                            }
                        ],
                        "father": "33",
                        "id": 87,
                        "label": "杭州市",
                        "value": "3301"
                    },
                    {
                        "children": [
                            {
                                "father": "3302",
                                "id": 887,
                                "label": "海曙区",
                                "value": "330203"
                            },
                            {
                                "father": "3302",
                                "id": 888,
                                "label": "江北区",
                                "value": "330205"
                            },
                            {
                                "father": "3302",
                                "id": 889,
                                "label": "北仑区",
                                "value": "330206"
                            },
                            {
                                "father": "3302",
                                "id": 890,
                                "label": "镇海区",
                                "value": "330211"
                            },
                            {
                                "father": "3302",
                                "id": 891,
                                "label": "鄞州区",
                                "value": "330212"
                            },
                            {
                                "father": "3302",
                                "id": 892,
                                "label": "奉化区",
                                "value": "330213"
                            },
                            {
                                "father": "3302",
                                "id": 893,
                                "label": "象山县",
                                "value": "330225"
                            },
                            {
                                "father": "3302",
                                "id": 894,
                                "label": "宁海县",
                                "value": "330226"
                            },
                            {
                                "father": "3302",
                                "id": 895,
                                "label": "余姚市",
                                "value": "330281"
                            },
                            {
                                "father": "3302",
                                "id": 896,
                                "label": "慈溪市",
                                "value": "330282"
                            }
                        ],
                        "father": "33",
                        "id": 88,
                        "label": "宁波市",
                        "value": "3302"
                    },
                    {
                        "children": [
                            {
                                "father": "3303",
                                "id": 897,
                                "label": "鹿城区",
                                "value": "330302"
                            },
                            {
                                "father": "3303",
                                "id": 898,
                                "label": "龙湾区",
                                "value": "330303"
                            },
                            {
                                "father": "3303",
                                "id": 899,
                                "label": "瓯海区",
                                "value": "330304"
                            },
                            {
                                "father": "3303",
                                "id": 900,
                                "label": "洞头区",
                                "value": "330305"
                            },
                            {
                                "father": "3303",
                                "id": 901,
                                "label": "永嘉县",
                                "value": "330324"
                            },
                            {
                                "father": "3303",
                                "id": 902,
                                "label": "平阳县",
                                "value": "330326"
                            },
                            {
                                "father": "3303",
                                "id": 903,
                                "label": "苍南县",
                                "value": "330327"
                            },
                            {
                                "father": "3303",
                                "id": 904,
                                "label": "文成县",
                                "value": "330328"
                            },
                            {
                                "father": "3303",
                                "id": 905,
                                "label": "泰顺县",
                                "value": "330329"
                            },
                            {
                                "father": "3303",
                                "id": 906,
                                "label": "温州经济技术开发区",
                                "value": "330371"
                            },
                            {
                                "father": "3303",
                                "id": 907,
                                "label": "瑞安市",
                                "value": "330381"
                            },
                            {
                                "father": "3303",
                                "id": 908,
                                "label": "乐清市",
                                "value": "330382"
                            },
                            {
                                "father": "3303",
                                "id": 909,
                                "label": "龙港市",
                                "value": "330383"
                            }
                        ],
                        "father": "33",
                        "id": 89,
                        "label": "温州市",
                        "value": "3303"
                    },
                    {
                        "children": [
                            {
                                "father": "3304",
                                "id": 910,
                                "label": "南湖区",
                                "value": "330402"
                            },
                            {
                                "father": "3304",
                                "id": 911,
                                "label": "秀洲区",
                                "value": "330411"
                            },
                            {
                                "father": "3304",
                                "id": 912,
                                "label": "嘉善县",
                                "value": "330421"
                            },
                            {
                                "father": "3304",
                                "id": 913,
                                "label": "海盐县",
                                "value": "330424"
                            },
                            {
                                "father": "3304",
                                "id": 914,
                                "label": "海宁市",
                                "value": "330481"
                            },
                            {
                                "father": "3304",
                                "id": 915,
                                "label": "平湖市",
                                "value": "330482"
                            },
                            {
                                "father": "3304",
                                "id": 916,
                                "label": "桐乡市",
                                "value": "330483"
                            }
                        ],
                        "father": "33",
                        "id": 90,
                        "label": "嘉兴市",
                        "value": "3304"
                    },
                    {
                        "children": [
                            {
                                "father": "3305",
                                "id": 917,
                                "label": "吴兴区",
                                "value": "330502"
                            },
                            {
                                "father": "3305",
                                "id": 918,
                                "label": "南浔区",
                                "value": "330503"
                            },
                            {
                                "father": "3305",
                                "id": 919,
                                "label": "德清县",
                                "value": "330521"
                            },
                            {
                                "father": "3305",
                                "id": 920,
                                "label": "长兴县",
                                "value": "330522"
                            },
                            {
                                "father": "3305",
                                "id": 921,
                                "label": "安吉县",
                                "value": "330523"
                            }
                        ],
                        "father": "33",
                        "id": 91,
                        "label": "湖州市",
                        "value": "3305"
                    },
                    {
                        "children": [
                            {
                                "father": "3306",
                                "id": 922,
                                "label": "越城区",
                                "value": "330602"
                            },
                            {
                                "father": "3306",
                                "id": 923,
                                "label": "柯桥区",
                                "value": "330603"
                            },
                            {
                                "father": "3306",
                                "id": 924,
                                "label": "上虞区",
                                "value": "330604"
                            },
                            {
                                "father": "3306",
                                "id": 925,
                                "label": "新昌县",
                                "value": "330624"
                            },
                            {
                                "father": "3306",
                                "id": 926,
                                "label": "诸暨市",
                                "value": "330681"
                            },
                            {
                                "father": "3306",
                                "id": 927,
                                "label": "嵊州市",
                                "value": "330683"
                            }
                        ],
                        "father": "33",
                        "id": 92,
                        "label": "绍兴市",
                        "value": "3306"
                    },
                    {
                        "children": [
                            {
                                "father": "3307",
                                "id": 928,
                                "label": "婺城区",
                                "value": "330702"
                            },
                            {
                                "father": "3307",
                                "id": 929,
                                "label": "金东区",
                                "value": "330703"
                            },
                            {
                                "father": "3307",
                                "id": 930,
                                "label": "武义县",
                                "value": "330723"
                            },
                            {
                                "father": "3307",
                                "id": 931,
                                "label": "浦江县",
                                "value": "330726"
                            },
                            {
                                "father": "3307",
                                "id": 932,
                                "label": "磐安县",
                                "value": "330727"
                            },
                            {
                                "father": "3307",
                                "id": 933,
                                "label": "兰溪市",
                                "value": "330781"
                            },
                            {
                                "father": "3307",
                                "id": 934,
                                "label": "义乌市",
                                "value": "330782"
                            },
                            {
                                "father": "3307",
                                "id": 935,
                                "label": "东阳市",
                                "value": "330783"
                            },
                            {
                                "father": "3307",
                                "id": 936,
                                "label": "永康市",
                                "value": "330784"
                            }
                        ],
                        "father": "33",
                        "id": 93,
                        "label": "金华市",
                        "value": "3307"
                    },
                    {
                        "children": [
                            {
                                "father": "3308",
                                "id": 937,
                                "label": "柯城区",
                                "value": "330802"
                            },
                            {
                                "father": "3308",
                                "id": 938,
                                "label": "衢江区",
                                "value": "330803"
                            },
                            {
                                "father": "3308",
                                "id": 939,
                                "label": "常山县",
                                "value": "330822"
                            },
                            {
                                "father": "3308",
                                "id": 940,
                                "label": "开化县",
                                "value": "330824"
                            },
                            {
                                "father": "3308",
                                "id": 941,
                                "label": "龙游县",
                                "value": "330825"
                            },
                            {
                                "father": "3308",
                                "id": 942,
                                "label": "江山市",
                                "value": "330881"
                            }
                        ],
                        "father": "33",
                        "id": 94,
                        "label": "衢州市",
                        "value": "3308"
                    },
                    {
                        "children": [
                            {
                                "father": "3309",
                                "id": 943,
                                "label": "定海区",
                                "value": "330902"
                            },
                            {
                                "father": "3309",
                                "id": 944,
                                "label": "普陀区",
                                "value": "330903"
                            },
                            {
                                "father": "3309",
                                "id": 945,
                                "label": "岱山县",
                                "value": "330921"
                            },
                            {
                                "father": "3309",
                                "id": 946,
                                "label": "嵊泗县",
                                "value": "330922"
                            }
                        ],
                        "father": "33",
                        "id": 95,
                        "label": "舟山市",
                        "value": "3309"
                    },
                    {
                        "children": [
                            {
                                "father": "3310",
                                "id": 947,
                                "label": "椒江区",
                                "value": "331002"
                            },
                            {
                                "father": "3310",
                                "id": 948,
                                "label": "黄岩区",
                                "value": "331003"
                            },
                            {
                                "father": "3310",
                                "id": 949,
                                "label": "路桥区",
                                "value": "331004"
                            },
                            {
                                "father": "3310",
                                "id": 950,
                                "label": "三门县",
                                "value": "331022"
                            },
                            {
                                "father": "3310",
                                "id": 951,
                                "label": "天台县",
                                "value": "331023"
                            },
                            {
                                "father": "3310",
                                "id": 952,
                                "label": "仙居县",
                                "value": "331024"
                            },
                            {
                                "father": "3310",
                                "id": 953,
                                "label": "温岭市",
                                "value": "331081"
                            },
                            {
                                "father": "3310",
                                "id": 954,
                                "label": "临海市",
                                "value": "331082"
                            },
                            {
                                "father": "3310",
                                "id": 955,
                                "label": "玉环市",
                                "value": "331083"
                            }
                        ],
                        "father": "33",
                        "id": 96,
                        "label": "台州市",
                        "value": "3310"
                    },
                    {
                        "children": [
                            {
                                "father": "3311",
                                "id": 956,
                                "label": "莲都区",
                                "value": "331102"
                            },
                            {
                                "father": "3311",
                                "id": 957,
                                "label": "青田县",
                                "value": "331121"
                            },
                            {
                                "father": "3311",
                                "id": 958,
                                "label": "缙云县",
                                "value": "331122"
                            },
                            {
                                "father": "3311",
                                "id": 959,
                                "label": "遂昌县",
                                "value": "331123"
                            },
                            {
                                "father": "3311",
                                "id": 960,
                                "label": "松阳县",
                                "value": "331124"
                            },
                            {
                                "father": "3311",
                                "id": 961,
                                "label": "云和县",
                                "value": "331125"
                            },
                            {
                                "father": "3311",
                                "id": 962,
                                "label": "庆元县",
                                "value": "331126"
                            },
                            {
                                "father": "3311",
                                "id": 963,
                                "label": "景宁畲族自治县",
                                "value": "331127"
                            },
                            {
                                "father": "3311",
                                "id": 964,
                                "label": "龙泉市",
                                "value": "331181"
                            }
                        ],
                        "father": "33",
                        "id": 97,
                        "label": "丽水市",
                        "value": "3311"
                    }
                ],
                "id": 11,
                "label": "浙江省",
                "value": "33"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "3401",
                                "id": 965,
                                "label": "瑶海区",
                                "value": "340102"
                            },
                            {
                                "father": "3401",
                                "id": 966,
                                "label": "庐阳区",
                                "value": "340103"
                            },
                            {
                                "father": "3401",
                                "id": 967,
                                "label": "蜀山区",
                                "value": "340104"
                            },
                            {
                                "father": "3401",
                                "id": 968,
                                "label": "包河区",
                                "value": "340111"
                            },
                            {
                                "father": "3401",
                                "id": 969,
                                "label": "长丰县",
                                "value": "340121"
                            },
                            {
                                "father": "3401",
                                "id": 970,
                                "label": "肥东县",
                                "value": "340122"
                            },
                            {
                                "father": "3401",
                                "id": 971,
                                "label": "肥西县",
                                "value": "340123"
                            },
                            {
                                "father": "3401",
                                "id": 972,
                                "label": "庐江县",
                                "value": "340124"
                            },
                            {
                                "father": "3401",
                                "id": 973,
                                "label": "合肥高新技术产业开发区",
                                "value": "340171"
                            },
                            {
                                "father": "3401",
                                "id": 974,
                                "label": "合肥经济技术开发区",
                                "value": "340172"
                            },
                            {
                                "father": "3401",
                                "id": 975,
                                "label": "合肥新站高新技术产业开发区",
                                "value": "340173"
                            },
                            {
                                "father": "3401",
                                "id": 976,
                                "label": "巢湖市",
                                "value": "340181"
                            }
                        ],
                        "father": "34",
                        "id": 98,
                        "label": "合肥市",
                        "value": "3401"
                    },
                    {
                        "children": [
                            {
                                "father": "3402",
                                "id": 977,
                                "label": "镜湖区",
                                "value": "340202"
                            },
                            {
                                "father": "3402",
                                "id": 978,
                                "label": "弋江区",
                                "value": "340203"
                            },
                            {
                                "father": "3402",
                                "id": 979,
                                "label": "鸠江区",
                                "value": "340207"
                            },
                            {
                                "father": "3402",
                                "id": 980,
                                "label": "三山区",
                                "value": "340208"
                            },
                            {
                                "father": "3402",
                                "id": 981,
                                "label": "芜湖县",
                                "value": "340221"
                            },
                            {
                                "father": "3402",
                                "id": 982,
                                "label": "繁昌县",
                                "value": "340222"
                            },
                            {
                                "father": "3402",
                                "id": 983,
                                "label": "南陵县",
                                "value": "340223"
                            },
                            {
                                "father": "3402",
                                "id": 984,
                                "label": "无为县",
                                "value": "340225"
                            },
                            {
                                "father": "3402",
                                "id": 985,
                                "label": "芜湖经济技术开发区",
                                "value": "340271"
                            },
                            {
                                "father": "3402",
                                "id": 986,
                                "label": "安徽芜湖长江大桥经济开发区",
                                "value": "340272"
                            }
                        ],
                        "father": "34",
                        "id": 99,
                        "label": "芜湖市",
                        "value": "3402"
                    },
                    {
                        "children": [
                            {
                                "father": "3403",
                                "id": 987,
                                "label": "龙子湖区",
                                "value": "340302"
                            },
                            {
                                "father": "3403",
                                "id": 988,
                                "label": "蚌山区",
                                "value": "340303"
                            },
                            {
                                "father": "3403",
                                "id": 989,
                                "label": "禹会区",
                                "value": "340304"
                            },
                            {
                                "father": "3403",
                                "id": 990,
                                "label": "淮上区",
                                "value": "340311"
                            },
                            {
                                "father": "3403",
                                "id": 991,
                                "label": "怀远县",
                                "value": "340321"
                            },
                            {
                                "father": "3403",
                                "id": 992,
                                "label": "五河县",
                                "value": "340322"
                            },
                            {
                                "father": "3403",
                                "id": 993,
                                "label": "固镇县",
                                "value": "340323"
                            },
                            {
                                "father": "3403",
                                "id": 994,
                                "label": "蚌埠市高新技术开发区",
                                "value": "340371"
                            },
                            {
                                "father": "3403",
                                "id": 995,
                                "label": "蚌埠市经济开发区",
                                "value": "340372"
                            }
                        ],
                        "father": "34",
                        "id": 100,
                        "label": "蚌埠市",
                        "value": "3403"
                    },
                    {
                        "children": [
                            {
                                "father": "3404",
                                "id": 996,
                                "label": "大通区",
                                "value": "340402"
                            },
                            {
                                "father": "3404",
                                "id": 997,
                                "label": "田家庵区",
                                "value": "340403"
                            },
                            {
                                "father": "3404",
                                "id": 998,
                                "label": "谢家集区",
                                "value": "340404"
                            },
                            {
                                "father": "3404",
                                "id": 999,
                                "label": "八公山区",
                                "value": "340405"
                            },
                            {
                                "father": "3404",
                                "id": 1000,
                                "label": "潘集区",
                                "value": "340406"
                            },
                            {
                                "father": "3404",
                                "id": 1001,
                                "label": "凤台县",
                                "value": "340421"
                            },
                            {
                                "father": "3404",
                                "id": 1002,
                                "label": "寿县",
                                "value": "340422"
                            }
                        ],
                        "father": "34",
                        "id": 101,
                        "label": "淮南市",
                        "value": "3404"
                    },
                    {
                        "children": [
                            {
                                "father": "3405",
                                "id": 1003,
                                "label": "花山区",
                                "value": "340503"
                            },
                            {
                                "father": "3405",
                                "id": 1004,
                                "label": "雨山区",
                                "value": "340504"
                            },
                            {
                                "father": "3405",
                                "id": 1005,
                                "label": "博望区",
                                "value": "340506"
                            },
                            {
                                "father": "3405",
                                "id": 1006,
                                "label": "当涂县",
                                "value": "340521"
                            },
                            {
                                "father": "3405",
                                "id": 1007,
                                "label": "含山县",
                                "value": "340522"
                            },
                            {
                                "father": "3405",
                                "id": 1008,
                                "label": "和县",
                                "value": "340523"
                            }
                        ],
                        "father": "34",
                        "id": 102,
                        "label": "马鞍山市",
                        "value": "3405"
                    },
                    {
                        "children": [
                            {
                                "father": "3406",
                                "id": 1009,
                                "label": "杜集区",
                                "value": "340602"
                            },
                            {
                                "father": "3406",
                                "id": 1010,
                                "label": "相山区",
                                "value": "340603"
                            },
                            {
                                "father": "3406",
                                "id": 1011,
                                "label": "烈山区",
                                "value": "340604"
                            },
                            {
                                "father": "3406",
                                "id": 1012,
                                "label": "濉溪县",
                                "value": "340621"
                            }
                        ],
                        "father": "34",
                        "id": 103,
                        "label": "淮北市",
                        "value": "3406"
                    },
                    {
                        "children": [
                            {
                                "father": "3407",
                                "id": 1013,
                                "label": "铜官区",
                                "value": "340705"
                            },
                            {
                                "father": "3407",
                                "id": 1014,
                                "label": "义安区",
                                "value": "340706"
                            },
                            {
                                "father": "3407",
                                "id": 1015,
                                "label": "郊区",
                                "value": "340711"
                            },
                            {
                                "father": "3407",
                                "id": 1016,
                                "label": "枞阳县",
                                "value": "340722"
                            }
                        ],
                        "father": "34",
                        "id": 104,
                        "label": "铜陵市",
                        "value": "3407"
                    },
                    {
                        "children": [
                            {
                                "father": "3408",
                                "id": 1017,
                                "label": "迎江区",
                                "value": "340802"
                            },
                            {
                                "father": "3408",
                                "id": 1018,
                                "label": "大观区",
                                "value": "340803"
                            },
                            {
                                "father": "3408",
                                "id": 1019,
                                "label": "宜秀区",
                                "value": "340811"
                            },
                            {
                                "father": "3408",
                                "id": 1020,
                                "label": "怀宁县",
                                "value": "340822"
                            },
                            {
                                "father": "3408",
                                "id": 1021,
                                "label": "太湖县",
                                "value": "340825"
                            },
                            {
                                "father": "3408",
                                "id": 1022,
                                "label": "宿松县",
                                "value": "340826"
                            },
                            {
                                "father": "3408",
                                "id": 1023,
                                "label": "望江县",
                                "value": "340827"
                            },
                            {
                                "father": "3408",
                                "id": 1024,
                                "label": "岳西县",
                                "value": "340828"
                            },
                            {
                                "father": "3408",
                                "id": 1025,
                                "label": "安徽安庆经济开发区",
                                "value": "340871"
                            },
                            {
                                "father": "3408",
                                "id": 1026,
                                "label": "桐城市",
                                "value": "340881"
                            },
                            {
                                "father": "3408",
                                "id": 1027,
                                "label": "潜山市",
                                "value": "340882"
                            }
                        ],
                        "father": "34",
                        "id": 105,
                        "label": "安庆市",
                        "value": "3408"
                    },
                    {
                        "children": [
                            {
                                "father": "3410",
                                "id": 1028,
                                "label": "屯溪区",
                                "value": "341002"
                            },
                            {
                                "father": "3410",
                                "id": 1029,
                                "label": "黄山区",
                                "value": "341003"
                            },
                            {
                                "father": "3410",
                                "id": 1030,
                                "label": "徽州区",
                                "value": "341004"
                            },
                            {
                                "father": "3410",
                                "id": 1031,
                                "label": "歙县",
                                "value": "341021"
                            },
                            {
                                "father": "3410",
                                "id": 1032,
                                "label": "休宁县",
                                "value": "341022"
                            },
                            {
                                "father": "3410",
                                "id": 1033,
                                "label": "黟县",
                                "value": "341023"
                            },
                            {
                                "father": "3410",
                                "id": 1034,
                                "label": "祁门县",
                                "value": "341024"
                            }
                        ],
                        "father": "34",
                        "id": 106,
                        "label": "黄山市",
                        "value": "3410"
                    },
                    {
                        "children": [
                            {
                                "father": "3411",
                                "id": 1035,
                                "label": "琅琊区",
                                "value": "341102"
                            },
                            {
                                "father": "3411",
                                "id": 1036,
                                "label": "南谯区",
                                "value": "341103"
                            },
                            {
                                "father": "3411",
                                "id": 1037,
                                "label": "来安县",
                                "value": "341122"
                            },
                            {
                                "father": "3411",
                                "id": 1038,
                                "label": "全椒县",
                                "value": "341124"
                            },
                            {
                                "father": "3411",
                                "id": 1039,
                                "label": "定远县",
                                "value": "341125"
                            },
                            {
                                "father": "3411",
                                "id": 1040,
                                "label": "凤阳县",
                                "value": "341126"
                            },
                            {
                                "father": "3411",
                                "id": 1041,
                                "label": "苏滁现代产业园",
                                "value": "341171"
                            },
                            {
                                "father": "3411",
                                "id": 1042,
                                "label": "滁州经济技术开发区",
                                "value": "341172"
                            },
                            {
                                "father": "3411",
                                "id": 1043,
                                "label": "天长市",
                                "value": "341181"
                            },
                            {
                                "father": "3411",
                                "id": 1044,
                                "label": "明光市",
                                "value": "341182"
                            }
                        ],
                        "father": "34",
                        "id": 107,
                        "label": "滁州市",
                        "value": "3411"
                    },
                    {
                        "children": [
                            {
                                "father": "3412",
                                "id": 1045,
                                "label": "颍州区",
                                "value": "341202"
                            },
                            {
                                "father": "3412",
                                "id": 1046,
                                "label": "颍东区",
                                "value": "341203"
                            },
                            {
                                "father": "3412",
                                "id": 1047,
                                "label": "颍泉区",
                                "value": "341204"
                            },
                            {
                                "father": "3412",
                                "id": 1048,
                                "label": "临泉县",
                                "value": "341221"
                            },
                            {
                                "father": "3412",
                                "id": 1049,
                                "label": "太和县",
                                "value": "341222"
                            },
                            {
                                "father": "3412",
                                "id": 1050,
                                "label": "阜南县",
                                "value": "341225"
                            },
                            {
                                "father": "3412",
                                "id": 1051,
                                "label": "颍上县",
                                "value": "341226"
                            },
                            {
                                "father": "3412",
                                "id": 1052,
                                "label": "阜阳合肥现代产业园区",
                                "value": "341271"
                            },
                            {
                                "father": "3412",
                                "id": 1053,
                                "label": "阜阳经济技术开发区",
                                "value": "341272"
                            },
                            {
                                "father": "3412",
                                "id": 1054,
                                "label": "界首市",
                                "value": "341282"
                            }
                        ],
                        "father": "34",
                        "id": 108,
                        "label": "阜阳市",
                        "value": "3412"
                    },
                    {
                        "children": [
                            {
                                "father": "3413",
                                "id": 1055,
                                "label": "埇桥区",
                                "value": "341302"
                            },
                            {
                                "father": "3413",
                                "id": 1056,
                                "label": "砀山县",
                                "value": "341321"
                            },
                            {
                                "father": "3413",
                                "id": 1057,
                                "label": "萧县",
                                "value": "341322"
                            },
                            {
                                "father": "3413",
                                "id": 1058,
                                "label": "灵璧县",
                                "value": "341323"
                            },
                            {
                                "father": "3413",
                                "id": 1059,
                                "label": "泗县",
                                "value": "341324"
                            },
                            {
                                "father": "3413",
                                "id": 1060,
                                "label": "宿州马鞍山现代产业园区",
                                "value": "341371"
                            },
                            {
                                "father": "3413",
                                "id": 1061,
                                "label": "宿州经济技术开发区",
                                "value": "341372"
                            }
                        ],
                        "father": "34",
                        "id": 109,
                        "label": "宿州市",
                        "value": "3413"
                    },
                    {
                        "children": [
                            {
                                "father": "3415",
                                "id": 1062,
                                "label": "金安区",
                                "value": "341502"
                            },
                            {
                                "father": "3415",
                                "id": 1063,
                                "label": "裕安区",
                                "value": "341503"
                            },
                            {
                                "father": "3415",
                                "id": 1064,
                                "label": "叶集区",
                                "value": "341504"
                            },
                            {
                                "father": "3415",
                                "id": 1065,
                                "label": "霍邱县",
                                "value": "341522"
                            },
                            {
                                "father": "3415",
                                "id": 1066,
                                "label": "舒城县",
                                "value": "341523"
                            },
                            {
                                "father": "3415",
                                "id": 1067,
                                "label": "金寨县",
                                "value": "341524"
                            },
                            {
                                "father": "3415",
                                "id": 1068,
                                "label": "霍山县",
                                "value": "341525"
                            }
                        ],
                        "father": "34",
                        "id": 110,
                        "label": "六安市",
                        "value": "3415"
                    },
                    {
                        "children": [
                            {
                                "father": "3416",
                                "id": 1069,
                                "label": "谯城区",
                                "value": "341602"
                            },
                            {
                                "father": "3416",
                                "id": 1070,
                                "label": "涡阳县",
                                "value": "341621"
                            },
                            {
                                "father": "3416",
                                "id": 1071,
                                "label": "蒙城县",
                                "value": "341622"
                            },
                            {
                                "father": "3416",
                                "id": 1072,
                                "label": "利辛县",
                                "value": "341623"
                            }
                        ],
                        "father": "34",
                        "id": 111,
                        "label": "亳州市",
                        "value": "3416"
                    },
                    {
                        "children": [
                            {
                                "father": "3417",
                                "id": 1073,
                                "label": "贵池区",
                                "value": "341702"
                            },
                            {
                                "father": "3417",
                                "id": 1074,
                                "label": "东至县",
                                "value": "341721"
                            },
                            {
                                "father": "3417",
                                "id": 1075,
                                "label": "石台县",
                                "value": "341722"
                            },
                            {
                                "father": "3417",
                                "id": 1076,
                                "label": "青阳县",
                                "value": "341723"
                            }
                        ],
                        "father": "34",
                        "id": 112,
                        "label": "池州市",
                        "value": "3417"
                    },
                    {
                        "children": [
                            {
                                "father": "3418",
                                "id": 1077,
                                "label": "宣州区",
                                "value": "341802"
                            },
                            {
                                "father": "3418",
                                "id": 1078,
                                "label": "郎溪县",
                                "value": "341821"
                            },
                            {
                                "father": "3418",
                                "id": 1079,
                                "label": "泾县",
                                "value": "341823"
                            },
                            {
                                "father": "3418",
                                "id": 1080,
                                "label": "绩溪县",
                                "value": "341824"
                            },
                            {
                                "father": "3418",
                                "id": 1081,
                                "label": "旌德县",
                                "value": "341825"
                            },
                            {
                                "father": "3418",
                                "id": 1082,
                                "label": "宣城市经济开发区",
                                "value": "341871"
                            },
                            {
                                "father": "3418",
                                "id": 1083,
                                "label": "宁国市",
                                "value": "341881"
                            },
                            {
                                "father": "3418",
                                "id": 1084,
                                "label": "广德市",
                                "value": "341882"
                            }
                        ],
                        "father": "34",
                        "id": 113,
                        "label": "宣城市",
                        "value": "3418"
                    }
                ],
                "id": 12,
                "label": "安徽省",
                "value": "34"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "3501",
                                "id": 1085,
                                "label": "鼓楼区",
                                "value": "350102"
                            },
                            {
                                "father": "3501",
                                "id": 1086,
                                "label": "台江区",
                                "value": "350103"
                            },
                            {
                                "father": "3501",
                                "id": 1087,
                                "label": "仓山区",
                                "value": "350104"
                            },
                            {
                                "father": "3501",
                                "id": 1088,
                                "label": "马尾区",
                                "value": "350105"
                            },
                            {
                                "father": "3501",
                                "id": 1089,
                                "label": "晋安区",
                                "value": "350111"
                            },
                            {
                                "father": "3501",
                                "id": 1090,
                                "label": "长乐区",
                                "value": "350112"
                            },
                            {
                                "father": "3501",
                                "id": 1091,
                                "label": "闽侯县",
                                "value": "350121"
                            },
                            {
                                "father": "3501",
                                "id": 1092,
                                "label": "连江县",
                                "value": "350122"
                            },
                            {
                                "father": "3501",
                                "id": 1093,
                                "label": "罗源县",
                                "value": "350123"
                            },
                            {
                                "father": "3501",
                                "id": 1094,
                                "label": "闽清县",
                                "value": "350124"
                            },
                            {
                                "father": "3501",
                                "id": 1095,
                                "label": "永泰县",
                                "value": "350125"
                            },
                            {
                                "father": "3501",
                                "id": 1096,
                                "label": "平潭县",
                                "value": "350128"
                            },
                            {
                                "father": "3501",
                                "id": 1097,
                                "label": "福清市",
                                "value": "350181"
                            }
                        ],
                        "father": "35",
                        "id": 114,
                        "label": "福州市",
                        "value": "3501"
                    },
                    {
                        "children": [
                            {
                                "father": "3502",
                                "id": 1098,
                                "label": "思明区",
                                "value": "350203"
                            },
                            {
                                "father": "3502",
                                "id": 1099,
                                "label": "海沧区",
                                "value": "350205"
                            },
                            {
                                "father": "3502",
                                "id": 1100,
                                "label": "湖里区",
                                "value": "350206"
                            },
                            {
                                "father": "3502",
                                "id": 1101,
                                "label": "集美区",
                                "value": "350211"
                            },
                            {
                                "father": "3502",
                                "id": 1102,
                                "label": "同安区",
                                "value": "350212"
                            },
                            {
                                "father": "3502",
                                "id": 1103,
                                "label": "翔安区",
                                "value": "350213"
                            }
                        ],
                        "father": "35",
                        "id": 115,
                        "label": "厦门市",
                        "value": "3502"
                    },
                    {
                        "children": [
                            {
                                "father": "3503",
                                "id": 1104,
                                "label": "城厢区",
                                "value": "350302"
                            },
                            {
                                "father": "3503",
                                "id": 1105,
                                "label": "涵江区",
                                "value": "350303"
                            },
                            {
                                "father": "3503",
                                "id": 1106,
                                "label": "荔城区",
                                "value": "350304"
                            },
                            {
                                "father": "3503",
                                "id": 1107,
                                "label": "秀屿区",
                                "value": "350305"
                            },
                            {
                                "father": "3503",
                                "id": 1108,
                                "label": "仙游县",
                                "value": "350322"
                            }
                        ],
                        "father": "35",
                        "id": 116,
                        "label": "莆田市",
                        "value": "3503"
                    },
                    {
                        "children": [
                            {
                                "father": "3504",
                                "id": 1109,
                                "label": "梅列区",
                                "value": "350402"
                            },
                            {
                                "father": "3504",
                                "id": 1110,
                                "label": "三元区",
                                "value": "350403"
                            },
                            {
                                "father": "3504",
                                "id": 1111,
                                "label": "明溪县",
                                "value": "350421"
                            },
                            {
                                "father": "3504",
                                "id": 1112,
                                "label": "清流县",
                                "value": "350423"
                            },
                            {
                                "father": "3504",
                                "id": 1113,
                                "label": "宁化县",
                                "value": "350424"
                            },
                            {
                                "father": "3504",
                                "id": 1114,
                                "label": "大田县",
                                "value": "350425"
                            },
                            {
                                "father": "3504",
                                "id": 1115,
                                "label": "尤溪县",
                                "value": "350426"
                            },
                            {
                                "father": "3504",
                                "id": 1116,
                                "label": "沙县",
                                "value": "350427"
                            },
                            {
                                "father": "3504",
                                "id": 1117,
                                "label": "将乐县",
                                "value": "350428"
                            },
                            {
                                "father": "3504",
                                "id": 1118,
                                "label": "泰宁县",
                                "value": "350429"
                            },
                            {
                                "father": "3504",
                                "id": 1119,
                                "label": "建宁县",
                                "value": "350430"
                            },
                            {
                                "father": "3504",
                                "id": 1120,
                                "label": "永安市",
                                "value": "350481"
                            }
                        ],
                        "father": "35",
                        "id": 117,
                        "label": "三明市",
                        "value": "3504"
                    },
                    {
                        "children": [
                            {
                                "father": "3505",
                                "id": 1121,
                                "label": "鲤城区",
                                "value": "350502"
                            },
                            {
                                "father": "3505",
                                "id": 1122,
                                "label": "丰泽区",
                                "value": "350503"
                            },
                            {
                                "father": "3505",
                                "id": 1123,
                                "label": "洛江区",
                                "value": "350504"
                            },
                            {
                                "father": "3505",
                                "id": 1124,
                                "label": "泉港区",
                                "value": "350505"
                            },
                            {
                                "father": "3505",
                                "id": 1125,
                                "label": "惠安县",
                                "value": "350521"
                            },
                            {
                                "father": "3505",
                                "id": 1126,
                                "label": "安溪县",
                                "value": "350524"
                            },
                            {
                                "father": "3505",
                                "id": 1127,
                                "label": "永春县",
                                "value": "350525"
                            },
                            {
                                "father": "3505",
                                "id": 1128,
                                "label": "德化县",
                                "value": "350526"
                            },
                            {
                                "father": "3505",
                                "id": 1129,
                                "label": "金门县",
                                "value": "350527"
                            },
                            {
                                "father": "3505",
                                "id": 1130,
                                "label": "石狮市",
                                "value": "350581"
                            },
                            {
                                "father": "3505",
                                "id": 1131,
                                "label": "晋江市",
                                "value": "350582"
                            },
                            {
                                "father": "3505",
                                "id": 1132,
                                "label": "南安市",
                                "value": "350583"
                            }
                        ],
                        "father": "35",
                        "id": 118,
                        "label": "泉州市",
                        "value": "3505"
                    },
                    {
                        "children": [
                            {
                                "father": "3506",
                                "id": 1133,
                                "label": "芗城区",
                                "value": "350602"
                            },
                            {
                                "father": "3506",
                                "id": 1134,
                                "label": "龙文区",
                                "value": "350603"
                            },
                            {
                                "father": "3506",
                                "id": 1135,
                                "label": "云霄县",
                                "value": "350622"
                            },
                            {
                                "father": "3506",
                                "id": 1136,
                                "label": "漳浦县",
                                "value": "350623"
                            },
                            {
                                "father": "3506",
                                "id": 1137,
                                "label": "诏安县",
                                "value": "350624"
                            },
                            {
                                "father": "3506",
                                "id": 1138,
                                "label": "长泰县",
                                "value": "350625"
                            },
                            {
                                "father": "3506",
                                "id": 1139,
                                "label": "东山县",
                                "value": "350626"
                            },
                            {
                                "father": "3506",
                                "id": 1140,
                                "label": "南靖县",
                                "value": "350627"
                            },
                            {
                                "father": "3506",
                                "id": 1141,
                                "label": "平和县",
                                "value": "350628"
                            },
                            {
                                "father": "3506",
                                "id": 1142,
                                "label": "华安县",
                                "value": "350629"
                            },
                            {
                                "father": "3506",
                                "id": 1143,
                                "label": "龙海市",
                                "value": "350681"
                            }
                        ],
                        "father": "35",
                        "id": 119,
                        "label": "漳州市",
                        "value": "3506"
                    },
                    {
                        "children": [
                            {
                                "father": "3507",
                                "id": 1144,
                                "label": "延平区",
                                "value": "350702"
                            },
                            {
                                "father": "3507",
                                "id": 1145,
                                "label": "建阳区",
                                "value": "350703"
                            },
                            {
                                "father": "3507",
                                "id": 1146,
                                "label": "顺昌县",
                                "value": "350721"
                            },
                            {
                                "father": "3507",
                                "id": 1147,
                                "label": "浦城县",
                                "value": "350722"
                            },
                            {
                                "father": "3507",
                                "id": 1148,
                                "label": "光泽县",
                                "value": "350723"
                            },
                            {
                                "father": "3507",
                                "id": 1149,
                                "label": "松溪县",
                                "value": "350724"
                            },
                            {
                                "father": "3507",
                                "id": 1150,
                                "label": "政和县",
                                "value": "350725"
                            },
                            {
                                "father": "3507",
                                "id": 1151,
                                "label": "邵武市",
                                "value": "350781"
                            },
                            {
                                "father": "3507",
                                "id": 1152,
                                "label": "武夷山市",
                                "value": "350782"
                            },
                            {
                                "father": "3507",
                                "id": 1153,
                                "label": "建瓯市",
                                "value": "350783"
                            }
                        ],
                        "father": "35",
                        "id": 120,
                        "label": "南平市",
                        "value": "3507"
                    },
                    {
                        "children": [
                            {
                                "father": "3508",
                                "id": 1154,
                                "label": "新罗区",
                                "value": "350802"
                            },
                            {
                                "father": "3508",
                                "id": 1155,
                                "label": "永定区",
                                "value": "350803"
                            },
                            {
                                "father": "3508",
                                "id": 1156,
                                "label": "长汀县",
                                "value": "350821"
                            },
                            {
                                "father": "3508",
                                "id": 1157,
                                "label": "上杭县",
                                "value": "350823"
                            },
                            {
                                "father": "3508",
                                "id": 1158,
                                "label": "武平县",
                                "value": "350824"
                            },
                            {
                                "father": "3508",
                                "id": 1159,
                                "label": "连城县",
                                "value": "350825"
                            },
                            {
                                "father": "3508",
                                "id": 1160,
                                "label": "漳平市",
                                "value": "350881"
                            }
                        ],
                        "father": "35",
                        "id": 121,
                        "label": "龙岩市",
                        "value": "3508"
                    },
                    {
                        "children": [
                            {
                                "father": "3509",
                                "id": 1161,
                                "label": "蕉城区",
                                "value": "350902"
                            },
                            {
                                "father": "3509",
                                "id": 1162,
                                "label": "霞浦县",
                                "value": "350921"
                            },
                            {
                                "father": "3509",
                                "id": 1163,
                                "label": "古田县",
                                "value": "350922"
                            },
                            {
                                "father": "3509",
                                "id": 1164,
                                "label": "屏南县",
                                "value": "350923"
                            },
                            {
                                "father": "3509",
                                "id": 1165,
                                "label": "寿宁县",
                                "value": "350924"
                            },
                            {
                                "father": "3509",
                                "id": 1166,
                                "label": "周宁县",
                                "value": "350925"
                            },
                            {
                                "father": "3509",
                                "id": 1167,
                                "label": "柘荣县",
                                "value": "350926"
                            },
                            {
                                "father": "3509",
                                "id": 1168,
                                "label": "福安市",
                                "value": "350981"
                            },
                            {
                                "father": "3509",
                                "id": 1169,
                                "label": "福鼎市",
                                "value": "350982"
                            }
                        ],
                        "father": "35",
                        "id": 122,
                        "label": "宁德市",
                        "value": "3509"
                    }
                ],
                "id": 13,
                "label": "福建省",
                "value": "35"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "3601",
                                "id": 1170,
                                "label": "东湖区",
                                "value": "360102"
                            },
                            {
                                "father": "3601",
                                "id": 1171,
                                "label": "西湖区",
                                "value": "360103"
                            },
                            {
                                "father": "3601",
                                "id": 1172,
                                "label": "青云谱区",
                                "value": "360104"
                            },
                            {
                                "father": "3601",
                                "id": 1173,
                                "label": "湾里区",
                                "value": "360105"
                            },
                            {
                                "father": "3601",
                                "id": 1174,
                                "label": "青山湖区",
                                "value": "360111"
                            },
                            {
                                "father": "3601",
                                "id": 1175,
                                "label": "新建区",
                                "value": "360112"
                            },
                            {
                                "father": "3601",
                                "id": 1176,
                                "label": "南昌县",
                                "value": "360121"
                            },
                            {
                                "father": "3601",
                                "id": 1177,
                                "label": "安义县",
                                "value": "360123"
                            },
                            {
                                "father": "3601",
                                "id": 1178,
                                "label": "进贤县",
                                "value": "360124"
                            }
                        ],
                        "father": "36",
                        "id": 123,
                        "label": "南昌市",
                        "value": "3601"
                    },
                    {
                        "children": [
                            {
                                "father": "3602",
                                "id": 1179,
                                "label": "昌江区",
                                "value": "360202"
                            },
                            {
                                "father": "3602",
                                "id": 1180,
                                "label": "珠山区",
                                "value": "360203"
                            },
                            {
                                "father": "3602",
                                "id": 1181,
                                "label": "浮梁县",
                                "value": "360222"
                            },
                            {
                                "father": "3602",
                                "id": 1182,
                                "label": "乐平市",
                                "value": "360281"
                            }
                        ],
                        "father": "36",
                        "id": 124,
                        "label": "景德镇市",
                        "value": "3602"
                    },
                    {
                        "children": [
                            {
                                "father": "3603",
                                "id": 1183,
                                "label": "安源区",
                                "value": "360302"
                            },
                            {
                                "father": "3603",
                                "id": 1184,
                                "label": "湘东区",
                                "value": "360313"
                            },
                            {
                                "father": "3603",
                                "id": 1185,
                                "label": "莲花县",
                                "value": "360321"
                            },
                            {
                                "father": "3603",
                                "id": 1186,
                                "label": "上栗县",
                                "value": "360322"
                            },
                            {
                                "father": "3603",
                                "id": 1187,
                                "label": "芦溪县",
                                "value": "360323"
                            }
                        ],
                        "father": "36",
                        "id": 125,
                        "label": "萍乡市",
                        "value": "3603"
                    },
                    {
                        "children": [
                            {
                                "father": "3604",
                                "id": 1188,
                                "label": "濂溪区",
                                "value": "360402"
                            },
                            {
                                "father": "3604",
                                "id": 1189,
                                "label": "浔阳区",
                                "value": "360403"
                            },
                            {
                                "father": "3604",
                                "id": 1190,
                                "label": "柴桑区",
                                "value": "360404"
                            },
                            {
                                "father": "3604",
                                "id": 1191,
                                "label": "武宁县",
                                "value": "360423"
                            },
                            {
                                "father": "3604",
                                "id": 1192,
                                "label": "修水县",
                                "value": "360424"
                            },
                            {
                                "father": "3604",
                                "id": 1193,
                                "label": "永修县",
                                "value": "360425"
                            },
                            {
                                "father": "3604",
                                "id": 1194,
                                "label": "德安县",
                                "value": "360426"
                            },
                            {
                                "father": "3604",
                                "id": 1195,
                                "label": "都昌县",
                                "value": "360428"
                            },
                            {
                                "father": "3604",
                                "id": 1196,
                                "label": "湖口县",
                                "value": "360429"
                            },
                            {
                                "father": "3604",
                                "id": 1197,
                                "label": "彭泽县",
                                "value": "360430"
                            },
                            {
                                "father": "3604",
                                "id": 1198,
                                "label": "瑞昌市",
                                "value": "360481"
                            },
                            {
                                "father": "3604",
                                "id": 1199,
                                "label": "共青城市",
                                "value": "360482"
                            },
                            {
                                "father": "3604",
                                "id": 1200,
                                "label": "庐山市",
                                "value": "360483"
                            }
                        ],
                        "father": "36",
                        "id": 126,
                        "label": "九江市",
                        "value": "3604"
                    },
                    {
                        "children": [
                            {
                                "father": "3605",
                                "id": 1201,
                                "label": "渝水区",
                                "value": "360502"
                            },
                            {
                                "father": "3605",
                                "id": 1202,
                                "label": "分宜县",
                                "value": "360521"
                            }
                        ],
                        "father": "36",
                        "id": 127,
                        "label": "新余市",
                        "value": "3605"
                    },
                    {
                        "children": [
                            {
                                "father": "3606",
                                "id": 1203,
                                "label": "月湖区",
                                "value": "360602"
                            },
                            {
                                "father": "3606",
                                "id": 1204,
                                "label": "余江区",
                                "value": "360603"
                            },
                            {
                                "father": "3606",
                                "id": 1205,
                                "label": "贵溪市",
                                "value": "360681"
                            }
                        ],
                        "father": "36",
                        "id": 128,
                        "label": "鹰潭市",
                        "value": "3606"
                    },
                    {
                        "children": [
                            {
                                "father": "3607",
                                "id": 1206,
                                "label": "章贡区",
                                "value": "360702"
                            },
                            {
                                "father": "3607",
                                "id": 1207,
                                "label": "南康区",
                                "value": "360703"
                            },
                            {
                                "father": "3607",
                                "id": 1208,
                                "label": "赣县区",
                                "value": "360704"
                            },
                            {
                                "father": "3607",
                                "id": 1209,
                                "label": "信丰县",
                                "value": "360722"
                            },
                            {
                                "father": "3607",
                                "id": 1210,
                                "label": "大余县",
                                "value": "360723"
                            },
                            {
                                "father": "3607",
                                "id": 1211,
                                "label": "上犹县",
                                "value": "360724"
                            },
                            {
                                "father": "3607",
                                "id": 1212,
                                "label": "崇义县",
                                "value": "360725"
                            },
                            {
                                "father": "3607",
                                "id": 1213,
                                "label": "安远县",
                                "value": "360726"
                            },
                            {
                                "father": "3607",
                                "id": 1214,
                                "label": "龙南县",
                                "value": "360727"
                            },
                            {
                                "father": "3607",
                                "id": 1215,
                                "label": "定南县",
                                "value": "360728"
                            },
                            {
                                "father": "3607",
                                "id": 1216,
                                "label": "全南县",
                                "value": "360729"
                            },
                            {
                                "father": "3607",
                                "id": 1217,
                                "label": "宁都县",
                                "value": "360730"
                            },
                            {
                                "father": "3607",
                                "id": 1218,
                                "label": "于都县",
                                "value": "360731"
                            },
                            {
                                "father": "3607",
                                "id": 1219,
                                "label": "兴国县",
                                "value": "360732"
                            },
                            {
                                "father": "3607",
                                "id": 1220,
                                "label": "会昌县",
                                "value": "360733"
                            },
                            {
                                "father": "3607",
                                "id": 1221,
                                "label": "寻乌县",
                                "value": "360734"
                            },
                            {
                                "father": "3607",
                                "id": 1222,
                                "label": "石城县",
                                "value": "360735"
                            },
                            {
                                "father": "3607",
                                "id": 1223,
                                "label": "瑞金市",
                                "value": "360781"
                            }
                        ],
                        "father": "36",
                        "id": 129,
                        "label": "赣州市",
                        "value": "3607"
                    },
                    {
                        "children": [
                            {
                                "father": "3608",
                                "id": 1224,
                                "label": "吉州区",
                                "value": "360802"
                            },
                            {
                                "father": "3608",
                                "id": 1225,
                                "label": "青原区",
                                "value": "360803"
                            },
                            {
                                "father": "3608",
                                "id": 1226,
                                "label": "吉安县",
                                "value": "360821"
                            },
                            {
                                "father": "3608",
                                "id": 1227,
                                "label": "吉水县",
                                "value": "360822"
                            },
                            {
                                "father": "3608",
                                "id": 1228,
                                "label": "峡江县",
                                "value": "360823"
                            },
                            {
                                "father": "3608",
                                "id": 1229,
                                "label": "新干县",
                                "value": "360824"
                            },
                            {
                                "father": "3608",
                                "id": 1230,
                                "label": "永丰县",
                                "value": "360825"
                            },
                            {
                                "father": "3608",
                                "id": 1231,
                                "label": "泰和县",
                                "value": "360826"
                            },
                            {
                                "father": "3608",
                                "id": 1232,
                                "label": "遂川县",
                                "value": "360827"
                            },
                            {
                                "father": "3608",
                                "id": 1233,
                                "label": "万安县",
                                "value": "360828"
                            },
                            {
                                "father": "3608",
                                "id": 1234,
                                "label": "安福县",
                                "value": "360829"
                            },
                            {
                                "father": "3608",
                                "id": 1235,
                                "label": "永新县",
                                "value": "360830"
                            },
                            {
                                "father": "3608",
                                "id": 1236,
                                "label": "井冈山市",
                                "value": "360881"
                            }
                        ],
                        "father": "36",
                        "id": 130,
                        "label": "吉安市",
                        "value": "3608"
                    },
                    {
                        "children": [
                            {
                                "father": "3609",
                                "id": 1237,
                                "label": "袁州区",
                                "value": "360902"
                            },
                            {
                                "father": "3609",
                                "id": 1238,
                                "label": "奉新县",
                                "value": "360921"
                            },
                            {
                                "father": "3609",
                                "id": 1239,
                                "label": "万载县",
                                "value": "360922"
                            },
                            {
                                "father": "3609",
                                "id": 1240,
                                "label": "上高县",
                                "value": "360923"
                            },
                            {
                                "father": "3609",
                                "id": 1241,
                                "label": "宜丰县",
                                "value": "360924"
                            },
                            {
                                "father": "3609",
                                "id": 1242,
                                "label": "靖安县",
                                "value": "360925"
                            },
                            {
                                "father": "3609",
                                "id": 1243,
                                "label": "铜鼓县",
                                "value": "360926"
                            },
                            {
                                "father": "3609",
                                "id": 1244,
                                "label": "丰城市",
                                "value": "360981"
                            },
                            {
                                "father": "3609",
                                "id": 1245,
                                "label": "樟树市",
                                "value": "360982"
                            },
                            {
                                "father": "3609",
                                "id": 1246,
                                "label": "高安市",
                                "value": "360983"
                            }
                        ],
                        "father": "36",
                        "id": 131,
                        "label": "宜春市",
                        "value": "3609"
                    },
                    {
                        "children": [
                            {
                                "father": "3610",
                                "id": 1247,
                                "label": "临川区",
                                "value": "361002"
                            },
                            {
                                "father": "3610",
                                "id": 1248,
                                "label": "东乡区",
                                "value": "361003"
                            },
                            {
                                "father": "3610",
                                "id": 1249,
                                "label": "南城县",
                                "value": "361021"
                            },
                            {
                                "father": "3610",
                                "id": 1250,
                                "label": "黎川县",
                                "value": "361022"
                            },
                            {
                                "father": "3610",
                                "id": 1251,
                                "label": "南丰县",
                                "value": "361023"
                            },
                            {
                                "father": "3610",
                                "id": 1252,
                                "label": "崇仁县",
                                "value": "361024"
                            },
                            {
                                "father": "3610",
                                "id": 1253,
                                "label": "乐安县",
                                "value": "361025"
                            },
                            {
                                "father": "3610",
                                "id": 1254,
                                "label": "宜黄县",
                                "value": "361026"
                            },
                            {
                                "father": "3610",
                                "id": 1255,
                                "label": "金溪县",
                                "value": "361027"
                            },
                            {
                                "father": "3610",
                                "id": 1256,
                                "label": "资溪县",
                                "value": "361028"
                            },
                            {
                                "father": "3610",
                                "id": 1257,
                                "label": "广昌县",
                                "value": "361030"
                            }
                        ],
                        "father": "36",
                        "id": 132,
                        "label": "抚州市",
                        "value": "3610"
                    },
                    {
                        "children": [
                            {
                                "father": "3611",
                                "id": 1258,
                                "label": "信州区",
                                "value": "361102"
                            },
                            {
                                "father": "3611",
                                "id": 1259,
                                "label": "广丰区",
                                "value": "361103"
                            },
                            {
                                "father": "3611",
                                "id": 1260,
                                "label": "广信区",
                                "value": "361104"
                            },
                            {
                                "father": "3611",
                                "id": 1261,
                                "label": "玉山县",
                                "value": "361123"
                            },
                            {
                                "father": "3611",
                                "id": 1262,
                                "label": "铅山县",
                                "value": "361124"
                            },
                            {
                                "father": "3611",
                                "id": 1263,
                                "label": "横峰县",
                                "value": "361125"
                            },
                            {
                                "father": "3611",
                                "id": 1264,
                                "label": "弋阳县",
                                "value": "361126"
                            },
                            {
                                "father": "3611",
                                "id": 1265,
                                "label": "余干县",
                                "value": "361127"
                            },
                            {
                                "father": "3611",
                                "id": 1266,
                                "label": "鄱阳县",
                                "value": "361128"
                            },
                            {
                                "father": "3611",
                                "id": 1267,
                                "label": "万年县",
                                "value": "361129"
                            },
                            {
                                "father": "3611",
                                "id": 1268,
                                "label": "婺源县",
                                "value": "361130"
                            },
                            {
                                "father": "3611",
                                "id": 1269,
                                "label": "德兴市",
                                "value": "361181"
                            }
                        ],
                        "father": "36",
                        "id": 133,
                        "label": "上饶市",
                        "value": "3611"
                    }
                ],
                "id": 14,
                "label": "江西省",
                "value": "36"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "3701",
                                "id": 1270,
                                "label": "历下区",
                                "value": "370102"
                            },
                            {
                                "father": "3701",
                                "id": 1271,
                                "label": "市中区",
                                "value": "370103"
                            },
                            {
                                "father": "3701",
                                "id": 1272,
                                "label": "槐荫区",
                                "value": "370104"
                            },
                            {
                                "father": "3701",
                                "id": 1273,
                                "label": "天桥区",
                                "value": "370105"
                            },
                            {
                                "father": "3701",
                                "id": 1274,
                                "label": "历城区",
                                "value": "370112"
                            },
                            {
                                "father": "3701",
                                "id": 1275,
                                "label": "长清区",
                                "value": "370113"
                            },
                            {
                                "father": "3701",
                                "id": 1276,
                                "label": "章丘区",
                                "value": "370114"
                            },
                            {
                                "father": "3701",
                                "id": 1277,
                                "label": "济阳区",
                                "value": "370115"
                            },
                            {
                                "father": "3701",
                                "id": 1278,
                                "label": "莱芜区",
                                "value": "370116"
                            },
                            {
                                "father": "3701",
                                "id": 1279,
                                "label": "钢城区",
                                "value": "370117"
                            },
                            {
                                "father": "3701",
                                "id": 1280,
                                "label": "平阴县",
                                "value": "370124"
                            },
                            {
                                "father": "3701",
                                "id": 1281,
                                "label": "商河县",
                                "value": "370126"
                            },
                            {
                                "father": "3701",
                                "id": 1282,
                                "label": "济南高新技术产业开发区",
                                "value": "370171"
                            }
                        ],
                        "father": "37",
                        "id": 134,
                        "label": "济南市",
                        "value": "3701"
                    },
                    {
                        "children": [
                            {
                                "father": "3702",
                                "id": 1283,
                                "label": "市南区",
                                "value": "370202"
                            },
                            {
                                "father": "3702",
                                "id": 1284,
                                "label": "市北区",
                                "value": "370203"
                            },
                            {
                                "father": "3702",
                                "id": 1285,
                                "label": "黄岛区",
                                "value": "370211"
                            },
                            {
                                "father": "3702",
                                "id": 1286,
                                "label": "崂山区",
                                "value": "370212"
                            },
                            {
                                "father": "3702",
                                "id": 1287,
                                "label": "李沧区",
                                "value": "370213"
                            },
                            {
                                "father": "3702",
                                "id": 1288,
                                "label": "城阳区",
                                "value": "370214"
                            },
                            {
                                "father": "3702",
                                "id": 1289,
                                "label": "即墨区",
                                "value": "370215"
                            },
                            {
                                "father": "3702",
                                "id": 1290,
                                "label": "青岛高新技术产业开发区",
                                "value": "370271"
                            },
                            {
                                "father": "3702",
                                "id": 1291,
                                "label": "胶州市",
                                "value": "370281"
                            },
                            {
                                "father": "3702",
                                "id": 1292,
                                "label": "平度市",
                                "value": "370283"
                            },
                            {
                                "father": "3702",
                                "id": 1293,
                                "label": "莱西市",
                                "value": "370285"
                            }
                        ],
                        "father": "37",
                        "id": 135,
                        "label": "青岛市",
                        "value": "3702"
                    },
                    {
                        "children": [
                            {
                                "father": "3703",
                                "id": 1294,
                                "label": "淄川区",
                                "value": "370302"
                            },
                            {
                                "father": "3703",
                                "id": 1295,
                                "label": "张店区",
                                "value": "370303"
                            },
                            {
                                "father": "3703",
                                "id": 1296,
                                "label": "博山区",
                                "value": "370304"
                            },
                            {
                                "father": "3703",
                                "id": 1297,
                                "label": "临淄区",
                                "value": "370305"
                            },
                            {
                                "father": "3703",
                                "id": 1298,
                                "label": "周村区",
                                "value": "370306"
                            },
                            {
                                "father": "3703",
                                "id": 1299,
                                "label": "桓台县",
                                "value": "370321"
                            },
                            {
                                "father": "3703",
                                "id": 1300,
                                "label": "高青县",
                                "value": "370322"
                            },
                            {
                                "father": "3703",
                                "id": 1301,
                                "label": "沂源县",
                                "value": "370323"
                            }
                        ],
                        "father": "37",
                        "id": 136,
                        "label": "淄博市",
                        "value": "3703"
                    },
                    {
                        "children": [
                            {
                                "father": "3704",
                                "id": 1302,
                                "label": "市中区",
                                "value": "370402"
                            },
                            {
                                "father": "3704",
                                "id": 1303,
                                "label": "薛城区",
                                "value": "370403"
                            },
                            {
                                "father": "3704",
                                "id": 1304,
                                "label": "峄城区",
                                "value": "370404"
                            },
                            {
                                "father": "3704",
                                "id": 1305,
                                "label": "台儿庄区",
                                "value": "370405"
                            },
                            {
                                "father": "3704",
                                "id": 1306,
                                "label": "山亭区",
                                "value": "370406"
                            },
                            {
                                "father": "3704",
                                "id": 1307,
                                "label": "滕州市",
                                "value": "370481"
                            }
                        ],
                        "father": "37",
                        "id": 137,
                        "label": "枣庄市",
                        "value": "3704"
                    },
                    {
                        "children": [
                            {
                                "father": "3705",
                                "id": 1308,
                                "label": "东营区",
                                "value": "370502"
                            },
                            {
                                "father": "3705",
                                "id": 1309,
                                "label": "河口区",
                                "value": "370503"
                            },
                            {
                                "father": "3705",
                                "id": 1310,
                                "label": "垦利区",
                                "value": "370505"
                            },
                            {
                                "father": "3705",
                                "id": 1311,
                                "label": "利津县",
                                "value": "370522"
                            },
                            {
                                "father": "3705",
                                "id": 1312,
                                "label": "广饶县",
                                "value": "370523"
                            },
                            {
                                "father": "3705",
                                "id": 1313,
                                "label": "东营经济技术开发区",
                                "value": "370571"
                            },
                            {
                                "father": "3705",
                                "id": 1314,
                                "label": "东营港经济开发区",
                                "value": "370572"
                            }
                        ],
                        "father": "37",
                        "id": 138,
                        "label": "东营市",
                        "value": "3705"
                    },
                    {
                        "children": [
                            {
                                "father": "3706",
                                "id": 1315,
                                "label": "芝罘区",
                                "value": "370602"
                            },
                            {
                                "father": "3706",
                                "id": 1316,
                                "label": "福山区",
                                "value": "370611"
                            },
                            {
                                "father": "3706",
                                "id": 1317,
                                "label": "牟平区",
                                "value": "370612"
                            },
                            {
                                "father": "3706",
                                "id": 1318,
                                "label": "莱山区",
                                "value": "370613"
                            },
                            {
                                "father": "3706",
                                "id": 1319,
                                "label": "长岛县",
                                "value": "370634"
                            },
                            {
                                "father": "3706",
                                "id": 1320,
                                "label": "烟台高新技术产业开发区",
                                "value": "370671"
                            },
                            {
                                "father": "3706",
                                "id": 1321,
                                "label": "烟台经济技术开发区",
                                "value": "370672"
                            },
                            {
                                "father": "3706",
                                "id": 1322,
                                "label": "龙口市",
                                "value": "370681"
                            },
                            {
                                "father": "3706",
                                "id": 1323,
                                "label": "莱阳市",
                                "value": "370682"
                            },
                            {
                                "father": "3706",
                                "id": 1324,
                                "label": "莱州市",
                                "value": "370683"
                            },
                            {
                                "father": "3706",
                                "id": 1325,
                                "label": "蓬莱市",
                                "value": "370684"
                            },
                            {
                                "father": "3706",
                                "id": 1326,
                                "label": "招远市",
                                "value": "370685"
                            },
                            {
                                "father": "3706",
                                "id": 1327,
                                "label": "栖霞市",
                                "value": "370686"
                            },
                            {
                                "father": "3706",
                                "id": 1328,
                                "label": "海阳市",
                                "value": "370687"
                            }
                        ],
                        "father": "37",
                        "id": 139,
                        "label": "烟台市",
                        "value": "3706"
                    },
                    {
                        "children": [
                            {
                                "father": "3707",
                                "id": 1329,
                                "label": "潍城区",
                                "value": "370702"
                            },
                            {
                                "father": "3707",
                                "id": 1330,
                                "label": "寒亭区",
                                "value": "370703"
                            },
                            {
                                "father": "3707",
                                "id": 1331,
                                "label": "坊子区",
                                "value": "370704"
                            },
                            {
                                "father": "3707",
                                "id": 1332,
                                "label": "奎文区",
                                "value": "370705"
                            },
                            {
                                "father": "3707",
                                "id": 1333,
                                "label": "临朐县",
                                "value": "370724"
                            },
                            {
                                "father": "3707",
                                "id": 1334,
                                "label": "昌乐县",
                                "value": "370725"
                            },
                            {
                                "father": "3707",
                                "id": 1335,
                                "label": "潍坊滨海经济技术开发区",
                                "value": "370772"
                            },
                            {
                                "father": "3707",
                                "id": 1336,
                                "label": "青州市",
                                "value": "370781"
                            },
                            {
                                "father": "3707",
                                "id": 1337,
                                "label": "诸城市",
                                "value": "370782"
                            },
                            {
                                "father": "3707",
                                "id": 1338,
                                "label": "寿光市",
                                "value": "370783"
                            },
                            {
                                "father": "3707",
                                "id": 1339,
                                "label": "安丘市",
                                "value": "370784"
                            },
                            {
                                "father": "3707",
                                "id": 1340,
                                "label": "高密市",
                                "value": "370785"
                            },
                            {
                                "father": "3707",
                                "id": 1341,
                                "label": "昌邑市",
                                "value": "370786"
                            }
                        ],
                        "father": "37",
                        "id": 140,
                        "label": "潍坊市",
                        "value": "3707"
                    },
                    {
                        "children": [
                            {
                                "father": "3708",
                                "id": 1342,
                                "label": "任城区",
                                "value": "370811"
                            },
                            {
                                "father": "3708",
                                "id": 1343,
                                "label": "兖州区",
                                "value": "370812"
                            },
                            {
                                "father": "3708",
                                "id": 1344,
                                "label": "微山县",
                                "value": "370826"
                            },
                            {
                                "father": "3708",
                                "id": 1345,
                                "label": "鱼台县",
                                "value": "370827"
                            },
                            {
                                "father": "3708",
                                "id": 1346,
                                "label": "金乡县",
                                "value": "370828"
                            },
                            {
                                "father": "3708",
                                "id": 1347,
                                "label": "嘉祥县",
                                "value": "370829"
                            },
                            {
                                "father": "3708",
                                "id": 1348,
                                "label": "汶上县",
                                "value": "370830"
                            },
                            {
                                "father": "3708",
                                "id": 1349,
                                "label": "泗水县",
                                "value": "370831"
                            },
                            {
                                "father": "3708",
                                "id": 1350,
                                "label": "梁山县",
                                "value": "370832"
                            },
                            {
                                "father": "3708",
                                "id": 1351,
                                "label": "济宁高新技术产业开发区",
                                "value": "370871"
                            },
                            {
                                "father": "3708",
                                "id": 1352,
                                "label": "曲阜市",
                                "value": "370881"
                            },
                            {
                                "father": "3708",
                                "id": 1353,
                                "label": "邹城市",
                                "value": "370883"
                            }
                        ],
                        "father": "37",
                        "id": 141,
                        "label": "济宁市",
                        "value": "3708"
                    },
                    {
                        "children": [
                            {
                                "father": "3709",
                                "id": 1354,
                                "label": "泰山区",
                                "value": "370902"
                            },
                            {
                                "father": "3709",
                                "id": 1355,
                                "label": "岱岳区",
                                "value": "370911"
                            },
                            {
                                "father": "3709",
                                "id": 1356,
                                "label": "宁阳县",
                                "value": "370921"
                            },
                            {
                                "father": "3709",
                                "id": 1357,
                                "label": "东平县",
                                "value": "370923"
                            },
                            {
                                "father": "3709",
                                "id": 1358,
                                "label": "新泰市",
                                "value": "370982"
                            },
                            {
                                "father": "3709",
                                "id": 1359,
                                "label": "肥城市",
                                "value": "370983"
                            }
                        ],
                        "father": "37",
                        "id": 142,
                        "label": "泰安市",
                        "value": "3709"
                    },
                    {
                        "children": [
                            {
                                "father": "3710",
                                "id": 1360,
                                "label": "环翠区",
                                "value": "371002"
                            },
                            {
                                "father": "3710",
                                "id": 1361,
                                "label": "文登区",
                                "value": "371003"
                            },
                            {
                                "father": "3710",
                                "id": 1362,
                                "label": "威海火炬高技术产业开发区",
                                "value": "371071"
                            },
                            {
                                "father": "3710",
                                "id": 1363,
                                "label": "威海经济技术开发区",
                                "value": "371072"
                            },
                            {
                                "father": "3710",
                                "id": 1364,
                                "label": "威海临港经济技术开发区",
                                "value": "371073"
                            },
                            {
                                "father": "3710",
                                "id": 1365,
                                "label": "荣成市",
                                "value": "371082"
                            },
                            {
                                "father": "3710",
                                "id": 1366,
                                "label": "乳山市",
                                "value": "371083"
                            }
                        ],
                        "father": "37",
                        "id": 143,
                        "label": "威海市",
                        "value": "3710"
                    },
                    {
                        "children": [
                            {
                                "father": "3711",
                                "id": 1367,
                                "label": "东港区",
                                "value": "371102"
                            },
                            {
                                "father": "3711",
                                "id": 1368,
                                "label": "岚山区",
                                "value": "371103"
                            },
                            {
                                "father": "3711",
                                "id": 1369,
                                "label": "五莲县",
                                "value": "371121"
                            },
                            {
                                "father": "3711",
                                "id": 1370,
                                "label": "莒县",
                                "value": "371122"
                            },
                            {
                                "father": "3711",
                                "id": 1371,
                                "label": "日照经济技术开发区",
                                "value": "371171"
                            }
                        ],
                        "father": "37",
                        "id": 144,
                        "label": "日照市",
                        "value": "3711"
                    },
                    {
                        "children": [
                            {
                                "father": "3713",
                                "id": 1372,
                                "label": "兰山区",
                                "value": "371302"
                            },
                            {
                                "father": "3713",
                                "id": 1373,
                                "label": "罗庄区",
                                "value": "371311"
                            },
                            {
                                "father": "3713",
                                "id": 1374,
                                "label": "河东区",
                                "value": "371312"
                            },
                            {
                                "father": "3713",
                                "id": 1375,
                                "label": "沂南县",
                                "value": "371321"
                            },
                            {
                                "father": "3713",
                                "id": 1376,
                                "label": "郯城县",
                                "value": "371322"
                            },
                            {
                                "father": "3713",
                                "id": 1377,
                                "label": "沂水县",
                                "value": "371323"
                            },
                            {
                                "father": "3713",
                                "id": 1378,
                                "label": "兰陵县",
                                "value": "371324"
                            },
                            {
                                "father": "3713",
                                "id": 1379,
                                "label": "费县",
                                "value": "371325"
                            },
                            {
                                "father": "3713",
                                "id": 1380,
                                "label": "平邑县",
                                "value": "371326"
                            },
                            {
                                "father": "3713",
                                "id": 1381,
                                "label": "莒南县",
                                "value": "371327"
                            },
                            {
                                "father": "3713",
                                "id": 1382,
                                "label": "蒙阴县",
                                "value": "371328"
                            },
                            {
                                "father": "3713",
                                "id": 1383,
                                "label": "临沭县",
                                "value": "371329"
                            },
                            {
                                "father": "3713",
                                "id": 1384,
                                "label": "临沂高新技术产业开发区",
                                "value": "371371"
                            },
                            {
                                "father": "3713",
                                "id": 1385,
                                "label": "临沂经济技术开发区",
                                "value": "371372"
                            },
                            {
                                "father": "3713",
                                "id": 1386,
                                "label": "临沂临港经济开发区",
                                "value": "371373"
                            }
                        ],
                        "father": "37",
                        "id": 145,
                        "label": "临沂市",
                        "value": "3713"
                    },
                    {
                        "children": [
                            {
                                "father": "3714",
                                "id": 1387,
                                "label": "德城区",
                                "value": "371402"
                            },
                            {
                                "father": "3714",
                                "id": 1388,
                                "label": "陵城区",
                                "value": "371403"
                            },
                            {
                                "father": "3714",
                                "id": 1389,
                                "label": "宁津县",
                                "value": "371422"
                            },
                            {
                                "father": "3714",
                                "id": 1390,
                                "label": "庆云县",
                                "value": "371423"
                            },
                            {
                                "father": "3714",
                                "id": 1391,
                                "label": "临邑县",
                                "value": "371424"
                            },
                            {
                                "father": "3714",
                                "id": 1392,
                                "label": "齐河县",
                                "value": "371425"
                            },
                            {
                                "father": "3714",
                                "id": 1393,
                                "label": "平原县",
                                "value": "371426"
                            },
                            {
                                "father": "3714",
                                "id": 1394,
                                "label": "夏津县",
                                "value": "371427"
                            },
                            {
                                "father": "3714",
                                "id": 1395,
                                "label": "武城县",
                                "value": "371428"
                            },
                            {
                                "father": "3714",
                                "id": 1396,
                                "label": "德州经济技术开发区",
                                "value": "371471"
                            },
                            {
                                "father": "3714",
                                "id": 1397,
                                "label": "德州运河经济开发区",
                                "value": "371472"
                            },
                            {
                                "father": "3714",
                                "id": 1398,
                                "label": "乐陵市",
                                "value": "371481"
                            },
                            {
                                "father": "3714",
                                "id": 1399,
                                "label": "禹城市",
                                "value": "371482"
                            }
                        ],
                        "father": "37",
                        "id": 146,
                        "label": "德州市",
                        "value": "3714"
                    },
                    {
                        "children": [
                            {
                                "father": "3715",
                                "id": 1400,
                                "label": "东昌府区",
                                "value": "371502"
                            },
                            {
                                "father": "3715",
                                "id": 1401,
                                "label": "茌平区",
                                "value": "371503"
                            },
                            {
                                "father": "3715",
                                "id": 1402,
                                "label": "阳谷县",
                                "value": "371521"
                            },
                            {
                                "father": "3715",
                                "id": 1403,
                                "label": "莘县",
                                "value": "371522"
                            },
                            {
                                "father": "3715",
                                "id": 1404,
                                "label": "东阿县",
                                "value": "371524"
                            },
                            {
                                "father": "3715",
                                "id": 1405,
                                "label": "冠县",
                                "value": "371525"
                            },
                            {
                                "father": "3715",
                                "id": 1406,
                                "label": "高唐县",
                                "value": "371526"
                            },
                            {
                                "father": "3715",
                                "id": 1407,
                                "label": "临清市",
                                "value": "371581"
                            }
                        ],
                        "father": "37",
                        "id": 147,
                        "label": "聊城市",
                        "value": "3715"
                    },
                    {
                        "children": [
                            {
                                "father": "3716",
                                "id": 1408,
                                "label": "滨城区",
                                "value": "371602"
                            },
                            {
                                "father": "3716",
                                "id": 1409,
                                "label": "沾化区",
                                "value": "371603"
                            },
                            {
                                "father": "3716",
                                "id": 1410,
                                "label": "惠民县",
                                "value": "371621"
                            },
                            {
                                "father": "3716",
                                "id": 1411,
                                "label": "阳信县",
                                "value": "371622"
                            },
                            {
                                "father": "3716",
                                "id": 1412,
                                "label": "无棣县",
                                "value": "371623"
                            },
                            {
                                "father": "3716",
                                "id": 1413,
                                "label": "博兴县",
                                "value": "371625"
                            },
                            {
                                "father": "3716",
                                "id": 1414,
                                "label": "邹平市",
                                "value": "371681"
                            }
                        ],
                        "father": "37",
                        "id": 148,
                        "label": "滨州市",
                        "value": "3716"
                    },
                    {
                        "children": [
                            {
                                "father": "3717",
                                "id": 1415,
                                "label": "牡丹区",
                                "value": "371702"
                            },
                            {
                                "father": "3717",
                                "id": 1416,
                                "label": "定陶区",
                                "value": "371703"
                            },
                            {
                                "father": "3717",
                                "id": 1417,
                                "label": "曹县",
                                "value": "371721"
                            },
                            {
                                "father": "3717",
                                "id": 1418,
                                "label": "单县",
                                "value": "371722"
                            },
                            {
                                "father": "3717",
                                "id": 1419,
                                "label": "成武县",
                                "value": "371723"
                            },
                            {
                                "father": "3717",
                                "id": 1420,
                                "label": "巨野县",
                                "value": "371724"
                            },
                            {
                                "father": "3717",
                                "id": 1421,
                                "label": "郓城县",
                                "value": "371725"
                            },
                            {
                                "father": "3717",
                                "id": 1422,
                                "label": "鄄城县",
                                "value": "371726"
                            },
                            {
                                "father": "3717",
                                "id": 1423,
                                "label": "东明县",
                                "value": "371728"
                            },
                            {
                                "father": "3717",
                                "id": 1424,
                                "label": "菏泽经济技术开发区",
                                "value": "371771"
                            },
                            {
                                "father": "3717",
                                "id": 1425,
                                "label": "菏泽高新技术开发区",
                                "value": "371772"
                            }
                        ],
                        "father": "37",
                        "id": 149,
                        "label": "菏泽市",
                        "value": "3717"
                    }
                ],
                "id": 15,
                "label": "山东省",
                "value": "37"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "4101",
                                "id": 1426,
                                "label": "中原区",
                                "value": "410102"
                            },
                            {
                                "father": "4101",
                                "id": 1427,
                                "label": "二七区",
                                "value": "410103"
                            },
                            {
                                "father": "4101",
                                "id": 1428,
                                "label": "管城回族区",
                                "value": "410104"
                            },
                            {
                                "father": "4101",
                                "id": 1429,
                                "label": "金水区",
                                "value": "410105"
                            },
                            {
                                "father": "4101",
                                "id": 1430,
                                "label": "上街区",
                                "value": "410106"
                            },
                            {
                                "father": "4101",
                                "id": 1431,
                                "label": "惠济区",
                                "value": "410108"
                            },
                            {
                                "father": "4101",
                                "id": 1432,
                                "label": "中牟县",
                                "value": "410122"
                            },
                            {
                                "father": "4101",
                                "id": 1433,
                                "label": "郑州经济技术开发区",
                                "value": "410171"
                            },
                            {
                                "father": "4101",
                                "id": 1434,
                                "label": "郑州高新技术产业开发区",
                                "value": "410172"
                            },
                            {
                                "father": "4101",
                                "id": 1435,
                                "label": "郑州航空港经济综合实验区",
                                "value": "410173"
                            },
                            {
                                "father": "4101",
                                "id": 1436,
                                "label": "巩义市",
                                "value": "410181"
                            },
                            {
                                "father": "4101",
                                "id": 1437,
                                "label": "荥阳市",
                                "value": "410182"
                            },
                            {
                                "father": "4101",
                                "id": 1438,
                                "label": "新密市",
                                "value": "410183"
                            },
                            {
                                "father": "4101",
                                "id": 1439,
                                "label": "新郑市",
                                "value": "410184"
                            },
                            {
                                "father": "4101",
                                "id": 1440,
                                "label": "登封市",
                                "value": "410185"
                            }
                        ],
                        "father": "41",
                        "id": 150,
                        "label": "郑州市",
                        "value": "4101"
                    },
                    {
                        "children": [
                            {
                                "father": "4102",
                                "id": 1441,
                                "label": "龙亭区",
                                "value": "410202"
                            },
                            {
                                "father": "4102",
                                "id": 1442,
                                "label": "顺河回族区",
                                "value": "410203"
                            },
                            {
                                "father": "4102",
                                "id": 1443,
                                "label": "鼓楼区",
                                "value": "410204"
                            },
                            {
                                "father": "4102",
                                "id": 1444,
                                "label": "禹王台区",
                                "value": "410205"
                            },
                            {
                                "father": "4102",
                                "id": 1445,
                                "label": "祥符区",
                                "value": "410212"
                            },
                            {
                                "father": "4102",
                                "id": 1446,
                                "label": "杞县",
                                "value": "410221"
                            },
                            {
                                "father": "4102",
                                "id": 1447,
                                "label": "通许县",
                                "value": "410222"
                            },
                            {
                                "father": "4102",
                                "id": 1448,
                                "label": "尉氏县",
                                "value": "410223"
                            },
                            {
                                "father": "4102",
                                "id": 1449,
                                "label": "兰考县",
                                "value": "410225"
                            }
                        ],
                        "father": "41",
                        "id": 151,
                        "label": "开封市",
                        "value": "4102"
                    },
                    {
                        "children": [
                            {
                                "father": "4103",
                                "id": 1450,
                                "label": "老城区",
                                "value": "410302"
                            },
                            {
                                "father": "4103",
                                "id": 1451,
                                "label": "西工区",
                                "value": "410303"
                            },
                            {
                                "father": "4103",
                                "id": 1452,
                                "label": "瀍河回族区",
                                "value": "410304"
                            },
                            {
                                "father": "4103",
                                "id": 1453,
                                "label": "涧西区",
                                "value": "410305"
                            },
                            {
                                "father": "4103",
                                "id": 1454,
                                "label": "吉利区",
                                "value": "410306"
                            },
                            {
                                "father": "4103",
                                "id": 1455,
                                "label": "洛龙区",
                                "value": "410311"
                            },
                            {
                                "father": "4103",
                                "id": 1456,
                                "label": "孟津县",
                                "value": "410322"
                            },
                            {
                                "father": "4103",
                                "id": 1457,
                                "label": "新安县",
                                "value": "410323"
                            },
                            {
                                "father": "4103",
                                "id": 1458,
                                "label": "栾川县",
                                "value": "410324"
                            },
                            {
                                "father": "4103",
                                "id": 1459,
                                "label": "嵩县",
                                "value": "410325"
                            },
                            {
                                "father": "4103",
                                "id": 1460,
                                "label": "汝阳县",
                                "value": "410326"
                            },
                            {
                                "father": "4103",
                                "id": 1461,
                                "label": "宜阳县",
                                "value": "410327"
                            },
                            {
                                "father": "4103",
                                "id": 1462,
                                "label": "洛宁县",
                                "value": "410328"
                            },
                            {
                                "father": "4103",
                                "id": 1463,
                                "label": "伊川县",
                                "value": "410329"
                            },
                            {
                                "father": "4103",
                                "id": 1464,
                                "label": "洛阳高新技术产业开发区",
                                "value": "410371"
                            },
                            {
                                "father": "4103",
                                "id": 1465,
                                "label": "偃师市",
                                "value": "410381"
                            }
                        ],
                        "father": "41",
                        "id": 152,
                        "label": "洛阳市",
                        "value": "4103"
                    },
                    {
                        "children": [
                            {
                                "father": "4104",
                                "id": 1466,
                                "label": "新华区",
                                "value": "410402"
                            },
                            {
                                "father": "4104",
                                "id": 1467,
                                "label": "卫东区",
                                "value": "410403"
                            },
                            {
                                "father": "4104",
                                "id": 1468,
                                "label": "石龙区",
                                "value": "410404"
                            },
                            {
                                "father": "4104",
                                "id": 1469,
                                "label": "湛河区",
                                "value": "410411"
                            },
                            {
                                "father": "4104",
                                "id": 1470,
                                "label": "宝丰县",
                                "value": "410421"
                            },
                            {
                                "father": "4104",
                                "id": 1471,
                                "label": "叶县",
                                "value": "410422"
                            },
                            {
                                "father": "4104",
                                "id": 1472,
                                "label": "鲁山县",
                                "value": "410423"
                            },
                            {
                                "father": "4104",
                                "id": 1473,
                                "label": "郏县",
                                "value": "410425"
                            },
                            {
                                "father": "4104",
                                "id": 1474,
                                "label": "平顶山高新技术产业开发区",
                                "value": "410471"
                            },
                            {
                                "father": "4104",
                                "id": 1475,
                                "label": "平顶山市城乡一体化示范区",
                                "value": "410472"
                            },
                            {
                                "father": "4104",
                                "id": 1476,
                                "label": "舞钢市",
                                "value": "410481"
                            },
                            {
                                "father": "4104",
                                "id": 1477,
                                "label": "汝州市",
                                "value": "410482"
                            }
                        ],
                        "father": "41",
                        "id": 153,
                        "label": "平顶山市",
                        "value": "4104"
                    },
                    {
                        "children": [
                            {
                                "father": "4105",
                                "id": 1478,
                                "label": "文峰区",
                                "value": "410502"
                            },
                            {
                                "father": "4105",
                                "id": 1479,
                                "label": "北关区",
                                "value": "410503"
                            },
                            {
                                "father": "4105",
                                "id": 1480,
                                "label": "殷都区",
                                "value": "410505"
                            },
                            {
                                "father": "4105",
                                "id": 1481,
                                "label": "龙安区",
                                "value": "410506"
                            },
                            {
                                "father": "4105",
                                "id": 1482,
                                "label": "安阳县",
                                "value": "410522"
                            },
                            {
                                "father": "4105",
                                "id": 1483,
                                "label": "汤阴县",
                                "value": "410523"
                            },
                            {
                                "father": "4105",
                                "id": 1484,
                                "label": "滑县",
                                "value": "410526"
                            },
                            {
                                "father": "4105",
                                "id": 1485,
                                "label": "内黄县",
                                "value": "410527"
                            },
                            {
                                "father": "4105",
                                "id": 1486,
                                "label": "安阳高新技术产业开发区",
                                "value": "410571"
                            },
                            {
                                "father": "4105",
                                "id": 1487,
                                "label": "林州市",
                                "value": "410581"
                            }
                        ],
                        "father": "41",
                        "id": 154,
                        "label": "安阳市",
                        "value": "4105"
                    },
                    {
                        "children": [
                            {
                                "father": "4106",
                                "id": 1488,
                                "label": "鹤山区",
                                "value": "410602"
                            },
                            {
                                "father": "4106",
                                "id": 1489,
                                "label": "山城区",
                                "value": "410603"
                            },
                            {
                                "father": "4106",
                                "id": 1490,
                                "label": "淇滨区",
                                "value": "410611"
                            },
                            {
                                "father": "4106",
                                "id": 1491,
                                "label": "浚县",
                                "value": "410621"
                            },
                            {
                                "father": "4106",
                                "id": 1492,
                                "label": "淇县",
                                "value": "410622"
                            },
                            {
                                "father": "4106",
                                "id": 1493,
                                "label": "鹤壁经济技术开发区",
                                "value": "410671"
                            }
                        ],
                        "father": "41",
                        "id": 155,
                        "label": "鹤壁市",
                        "value": "4106"
                    },
                    {
                        "children": [
                            {
                                "father": "4107",
                                "id": 1494,
                                "label": "红旗区",
                                "value": "410702"
                            },
                            {
                                "father": "4107",
                                "id": 1495,
                                "label": "卫滨区",
                                "value": "410703"
                            },
                            {
                                "father": "4107",
                                "id": 1496,
                                "label": "凤泉区",
                                "value": "410704"
                            },
                            {
                                "father": "4107",
                                "id": 1497,
                                "label": "牧野区",
                                "value": "410711"
                            },
                            {
                                "father": "4107",
                                "id": 1498,
                                "label": "新乡县",
                                "value": "410721"
                            },
                            {
                                "father": "4107",
                                "id": 1499,
                                "label": "获嘉县",
                                "value": "410724"
                            },
                            {
                                "father": "4107",
                                "id": 1500,
                                "label": "原阳县",
                                "value": "410725"
                            },
                            {
                                "father": "4107",
                                "id": 1501,
                                "label": "延津县",
                                "value": "410726"
                            },
                            {
                                "father": "4107",
                                "id": 1502,
                                "label": "封丘县",
                                "value": "410727"
                            },
                            {
                                "father": "4107",
                                "id": 1503,
                                "label": "新乡高新技术产业开发区",
                                "value": "410771"
                            },
                            {
                                "father": "4107",
                                "id": 1504,
                                "label": "新乡经济技术开发区",
                                "value": "410772"
                            },
                            {
                                "father": "4107",
                                "id": 1505,
                                "label": "新乡市平原城乡一体化示范区",
                                "value": "410773"
                            },
                            {
                                "father": "4107",
                                "id": 1506,
                                "label": "卫辉市",
                                "value": "410781"
                            },
                            {
                                "father": "4107",
                                "id": 1507,
                                "label": "辉县市",
                                "value": "410782"
                            },
                            {
                                "father": "4107",
                                "id": 1508,
                                "label": "长垣市",
                                "value": "410783"
                            }
                        ],
                        "father": "41",
                        "id": 156,
                        "label": "新乡市",
                        "value": "4107"
                    },
                    {
                        "children": [
                            {
                                "father": "4108",
                                "id": 1509,
                                "label": "解放区",
                                "value": "410802"
                            },
                            {
                                "father": "4108",
                                "id": 1510,
                                "label": "中站区",
                                "value": "410803"
                            },
                            {
                                "father": "4108",
                                "id": 1511,
                                "label": "马村区",
                                "value": "410804"
                            },
                            {
                                "father": "4108",
                                "id": 1512,
                                "label": "山阳区",
                                "value": "410811"
                            },
                            {
                                "father": "4108",
                                "id": 1513,
                                "label": "修武县",
                                "value": "410821"
                            },
                            {
                                "father": "4108",
                                "id": 1514,
                                "label": "博爱县",
                                "value": "410822"
                            },
                            {
                                "father": "4108",
                                "id": 1515,
                                "label": "武陟县",
                                "value": "410823"
                            },
                            {
                                "father": "4108",
                                "id": 1516,
                                "label": "温县",
                                "value": "410825"
                            },
                            {
                                "father": "4108",
                                "id": 1517,
                                "label": "焦作城乡一体化示范区",
                                "value": "410871"
                            },
                            {
                                "father": "4108",
                                "id": 1518,
                                "label": "沁阳市",
                                "value": "410882"
                            },
                            {
                                "father": "4108",
                                "id": 1519,
                                "label": "孟州市",
                                "value": "410883"
                            }
                        ],
                        "father": "41",
                        "id": 157,
                        "label": "焦作市",
                        "value": "4108"
                    },
                    {
                        "children": [
                            {
                                "father": "4109",
                                "id": 1520,
                                "label": "华龙区",
                                "value": "410902"
                            },
                            {
                                "father": "4109",
                                "id": 1521,
                                "label": "清丰县",
                                "value": "410922"
                            },
                            {
                                "father": "4109",
                                "id": 1522,
                                "label": "南乐县",
                                "value": "410923"
                            },
                            {
                                "father": "4109",
                                "id": 1523,
                                "label": "范县",
                                "value": "410926"
                            },
                            {
                                "father": "4109",
                                "id": 1524,
                                "label": "台前县",
                                "value": "410927"
                            },
                            {
                                "father": "4109",
                                "id": 1525,
                                "label": "濮阳县",
                                "value": "410928"
                            },
                            {
                                "father": "4109",
                                "id": 1526,
                                "label": "河南濮阳工业园区",
                                "value": "410971"
                            },
                            {
                                "father": "4109",
                                "id": 1527,
                                "label": "濮阳经济技术开发区",
                                "value": "410972"
                            }
                        ],
                        "father": "41",
                        "id": 158,
                        "label": "濮阳市",
                        "value": "4109"
                    },
                    {
                        "children": [
                            {
                                "father": "4110",
                                "id": 1528,
                                "label": "魏都区",
                                "value": "411002"
                            },
                            {
                                "father": "4110",
                                "id": 1529,
                                "label": "建安区",
                                "value": "411003"
                            },
                            {
                                "father": "4110",
                                "id": 1530,
                                "label": "鄢陵县",
                                "value": "411024"
                            },
                            {
                                "father": "4110",
                                "id": 1531,
                                "label": "襄城县",
                                "value": "411025"
                            },
                            {
                                "father": "4110",
                                "id": 1532,
                                "label": "许昌经济技术开发区",
                                "value": "411071"
                            },
                            {
                                "father": "4110",
                                "id": 1533,
                                "label": "禹州市",
                                "value": "411081"
                            },
                            {
                                "father": "4110",
                                "id": 1534,
                                "label": "长葛市",
                                "value": "411082"
                            }
                        ],
                        "father": "41",
                        "id": 159,
                        "label": "许昌市",
                        "value": "4110"
                    },
                    {
                        "children": [
                            {
                                "father": "4111",
                                "id": 1535,
                                "label": "源汇区",
                                "value": "411102"
                            },
                            {
                                "father": "4111",
                                "id": 1536,
                                "label": "郾城区",
                                "value": "411103"
                            },
                            {
                                "father": "4111",
                                "id": 1537,
                                "label": "召陵区",
                                "value": "411104"
                            },
                            {
                                "father": "4111",
                                "id": 1538,
                                "label": "舞阳县",
                                "value": "411121"
                            },
                            {
                                "father": "4111",
                                "id": 1539,
                                "label": "临颍县",
                                "value": "411122"
                            },
                            {
                                "father": "4111",
                                "id": 1540,
                                "label": "漯河经济技术开发区",
                                "value": "411171"
                            }
                        ],
                        "father": "41",
                        "id": 160,
                        "label": "漯河市",
                        "value": "4111"
                    },
                    {
                        "children": [
                            {
                                "father": "4112",
                                "id": 1541,
                                "label": "湖滨区",
                                "value": "411202"
                            },
                            {
                                "father": "4112",
                                "id": 1542,
                                "label": "陕州区",
                                "value": "411203"
                            },
                            {
                                "father": "4112",
                                "id": 1543,
                                "label": "渑池县",
                                "value": "411221"
                            },
                            {
                                "father": "4112",
                                "id": 1544,
                                "label": "卢氏县",
                                "value": "411224"
                            },
                            {
                                "father": "4112",
                                "id": 1545,
                                "label": "河南三门峡经济开发区",
                                "value": "411271"
                            },
                            {
                                "father": "4112",
                                "id": 1546,
                                "label": "义马市",
                                "value": "411281"
                            },
                            {
                                "father": "4112",
                                "id": 1547,
                                "label": "灵宝市",
                                "value": "411282"
                            }
                        ],
                        "father": "41",
                        "id": 161,
                        "label": "三门峡市",
                        "value": "4112"
                    },
                    {
                        "children": [
                            {
                                "father": "4113",
                                "id": 1548,
                                "label": "宛城区",
                                "value": "411302"
                            },
                            {
                                "father": "4113",
                                "id": 1549,
                                "label": "卧龙区",
                                "value": "411303"
                            },
                            {
                                "father": "4113",
                                "id": 1550,
                                "label": "南召县",
                                "value": "411321"
                            },
                            {
                                "father": "4113",
                                "id": 1551,
                                "label": "方城县",
                                "value": "411322"
                            },
                            {
                                "father": "4113",
                                "id": 1552,
                                "label": "西峡县",
                                "value": "411323"
                            },
                            {
                                "father": "4113",
                                "id": 1553,
                                "label": "镇平县",
                                "value": "411324"
                            },
                            {
                                "father": "4113",
                                "id": 1554,
                                "label": "内乡县",
                                "value": "411325"
                            },
                            {
                                "father": "4113",
                                "id": 1555,
                                "label": "淅川县",
                                "value": "411326"
                            },
                            {
                                "father": "4113",
                                "id": 1556,
                                "label": "社旗县",
                                "value": "411327"
                            },
                            {
                                "father": "4113",
                                "id": 1557,
                                "label": "唐河县",
                                "value": "411328"
                            },
                            {
                                "father": "4113",
                                "id": 1558,
                                "label": "新野县",
                                "value": "411329"
                            },
                            {
                                "father": "4113",
                                "id": 1559,
                                "label": "桐柏县",
                                "value": "411330"
                            },
                            {
                                "father": "4113",
                                "id": 1560,
                                "label": "南阳高新技术产业开发区",
                                "value": "411371"
                            },
                            {
                                "father": "4113",
                                "id": 1561,
                                "label": "南阳市城乡一体化示范区",
                                "value": "411372"
                            },
                            {
                                "father": "4113",
                                "id": 1562,
                                "label": "邓州市",
                                "value": "411381"
                            }
                        ],
                        "father": "41",
                        "id": 162,
                        "label": "南阳市",
                        "value": "4113"
                    },
                    {
                        "children": [
                            {
                                "father": "4114",
                                "id": 1563,
                                "label": "梁园区",
                                "value": "411402"
                            },
                            {
                                "father": "4114",
                                "id": 1564,
                                "label": "睢阳区",
                                "value": "411403"
                            },
                            {
                                "father": "4114",
                                "id": 1565,
                                "label": "民权县",
                                "value": "411421"
                            },
                            {
                                "father": "4114",
                                "id": 1566,
                                "label": "睢县",
                                "value": "411422"
                            },
                            {
                                "father": "4114",
                                "id": 1567,
                                "label": "宁陵县",
                                "value": "411423"
                            },
                            {
                                "father": "4114",
                                "id": 1568,
                                "label": "柘城县",
                                "value": "411424"
                            },
                            {
                                "father": "4114",
                                "id": 1569,
                                "label": "虞城县",
                                "value": "411425"
                            },
                            {
                                "father": "4114",
                                "id": 1570,
                                "label": "夏邑县",
                                "value": "411426"
                            },
                            {
                                "father": "4114",
                                "id": 1571,
                                "label": "豫东综合物流产业聚集区",
                                "value": "411471"
                            },
                            {
                                "father": "4114",
                                "id": 1572,
                                "label": "河南商丘经济开发区",
                                "value": "411472"
                            },
                            {
                                "father": "4114",
                                "id": 1573,
                                "label": "永城市",
                                "value": "411481"
                            }
                        ],
                        "father": "41",
                        "id": 163,
                        "label": "商丘市",
                        "value": "4114"
                    },
                    {
                        "children": [
                            {
                                "father": "4115",
                                "id": 1574,
                                "label": "浉河区",
                                "value": "411502"
                            },
                            {
                                "father": "4115",
                                "id": 1575,
                                "label": "平桥区",
                                "value": "411503"
                            },
                            {
                                "father": "4115",
                                "id": 1576,
                                "label": "罗山县",
                                "value": "411521"
                            },
                            {
                                "father": "4115",
                                "id": 1577,
                                "label": "光山县",
                                "value": "411522"
                            },
                            {
                                "father": "4115",
                                "id": 1578,
                                "label": "新县",
                                "value": "411523"
                            },
                            {
                                "father": "4115",
                                "id": 1579,
                                "label": "商城县",
                                "value": "411524"
                            },
                            {
                                "father": "4115",
                                "id": 1580,
                                "label": "固始县",
                                "value": "411525"
                            },
                            {
                                "father": "4115",
                                "id": 1581,
                                "label": "潢川县",
                                "value": "411526"
                            },
                            {
                                "father": "4115",
                                "id": 1582,
                                "label": "淮滨县",
                                "value": "411527"
                            },
                            {
                                "father": "4115",
                                "id": 1583,
                                "label": "息县",
                                "value": "411528"
                            },
                            {
                                "father": "4115",
                                "id": 1584,
                                "label": "信阳高新技术产业开发区",
                                "value": "411571"
                            }
                        ],
                        "father": "41",
                        "id": 164,
                        "label": "信阳市",
                        "value": "4115"
                    },
                    {
                        "children": [
                            {
                                "father": "4116",
                                "id": 1585,
                                "label": "川汇区",
                                "value": "411602"
                            },
                            {
                                "father": "4116",
                                "id": 1586,
                                "label": "淮阳区",
                                "value": "411603"
                            },
                            {
                                "father": "4116",
                                "id": 1587,
                                "label": "扶沟县",
                                "value": "411621"
                            },
                            {
                                "father": "4116",
                                "id": 1588,
                                "label": "西华县",
                                "value": "411622"
                            },
                            {
                                "father": "4116",
                                "id": 1589,
                                "label": "商水县",
                                "value": "411623"
                            },
                            {
                                "father": "4116",
                                "id": 1590,
                                "label": "沈丘县",
                                "value": "411624"
                            },
                            {
                                "father": "4116",
                                "id": 1591,
                                "label": "郸城县",
                                "value": "411625"
                            },
                            {
                                "father": "4116",
                                "id": 1592,
                                "label": "太康县",
                                "value": "411627"
                            },
                            {
                                "father": "4116",
                                "id": 1593,
                                "label": "鹿邑县",
                                "value": "411628"
                            },
                            {
                                "father": "4116",
                                "id": 1594,
                                "label": "河南周口经济开发区",
                                "value": "411671"
                            },
                            {
                                "father": "4116",
                                "id": 1595,
                                "label": "项城市",
                                "value": "411681"
                            }
                        ],
                        "father": "41",
                        "id": 165,
                        "label": "周口市",
                        "value": "4116"
                    },
                    {
                        "children": [
                            {
                                "father": "4117",
                                "id": 1596,
                                "label": "驿城区",
                                "value": "411702"
                            },
                            {
                                "father": "4117",
                                "id": 1597,
                                "label": "西平县",
                                "value": "411721"
                            },
                            {
                                "father": "4117",
                                "id": 1598,
                                "label": "上蔡县",
                                "value": "411722"
                            },
                            {
                                "father": "4117",
                                "id": 1599,
                                "label": "平舆县",
                                "value": "411723"
                            },
                            {
                                "father": "4117",
                                "id": 1600,
                                "label": "正阳县",
                                "value": "411724"
                            },
                            {
                                "father": "4117",
                                "id": 1601,
                                "label": "确山县",
                                "value": "411725"
                            },
                            {
                                "father": "4117",
                                "id": 1602,
                                "label": "泌阳县",
                                "value": "411726"
                            },
                            {
                                "father": "4117",
                                "id": 1603,
                                "label": "汝南县",
                                "value": "411727"
                            },
                            {
                                "father": "4117",
                                "id": 1604,
                                "label": "遂平县",
                                "value": "411728"
                            },
                            {
                                "father": "4117",
                                "id": 1605,
                                "label": "新蔡县",
                                "value": "411729"
                            },
                            {
                                "father": "4117",
                                "id": 1606,
                                "label": "河南驻马店经济开发区",
                                "value": "411771"
                            }
                        ],
                        "father": "41",
                        "id": 166,
                        "label": "驻马店市",
                        "value": "4117"
                    },
                    {
                        "children": [
                            {
                                "father": "4190",
                                "id": 1607,
                                "label": "济源市",
                                "value": "419001"
                            }
                        ],
                        "father": "41",
                        "id": 167,
                        "label": "省直辖县级行政区划",
                        "value": "4190"
                    }
                ],
                "id": 16,
                "label": "河南省",
                "value": "41"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "4201",
                                "id": 1608,
                                "label": "江岸区",
                                "value": "420102"
                            },
                            {
                                "father": "4201",
                                "id": 1609,
                                "label": "江汉区",
                                "value": "420103"
                            },
                            {
                                "father": "4201",
                                "id": 1610,
                                "label": "硚口区",
                                "value": "420104"
                            },
                            {
                                "father": "4201",
                                "id": 1611,
                                "label": "汉阳区",
                                "value": "420105"
                            },
                            {
                                "father": "4201",
                                "id": 1612,
                                "label": "武昌区",
                                "value": "420106"
                            },
                            {
                                "father": "4201",
                                "id": 1613,
                                "label": "青山区",
                                "value": "420107"
                            },
                            {
                                "father": "4201",
                                "id": 1614,
                                "label": "洪山区",
                                "value": "420111"
                            },
                            {
                                "father": "4201",
                                "id": 1615,
                                "label": "东西湖区",
                                "value": "420112"
                            },
                            {
                                "father": "4201",
                                "id": 1616,
                                "label": "汉南区",
                                "value": "420113"
                            },
                            {
                                "father": "4201",
                                "id": 1617,
                                "label": "蔡甸区",
                                "value": "420114"
                            },
                            {
                                "father": "4201",
                                "id": 1618,
                                "label": "江夏区",
                                "value": "420115"
                            },
                            {
                                "father": "4201",
                                "id": 1619,
                                "label": "黄陂区",
                                "value": "420116"
                            },
                            {
                                "father": "4201",
                                "id": 1620,
                                "label": "新洲区",
                                "value": "420117"
                            }
                        ],
                        "father": "42",
                        "id": 168,
                        "label": "武汉市",
                        "value": "4201"
                    },
                    {
                        "children": [
                            {
                                "father": "4202",
                                "id": 1621,
                                "label": "黄石港区",
                                "value": "420202"
                            },
                            {
                                "father": "4202",
                                "id": 1622,
                                "label": "西塞山区",
                                "value": "420203"
                            },
                            {
                                "father": "4202",
                                "id": 1623,
                                "label": "下陆区",
                                "value": "420204"
                            },
                            {
                                "father": "4202",
                                "id": 1624,
                                "label": "铁山区",
                                "value": "420205"
                            },
                            {
                                "father": "4202",
                                "id": 1625,
                                "label": "阳新县",
                                "value": "420222"
                            },
                            {
                                "father": "4202",
                                "id": 1626,
                                "label": "大冶市",
                                "value": "420281"
                            }
                        ],
                        "father": "42",
                        "id": 169,
                        "label": "黄石市",
                        "value": "4202"
                    },
                    {
                        "children": [
                            {
                                "father": "4203",
                                "id": 1627,
                                "label": "茅箭区",
                                "value": "420302"
                            },
                            {
                                "father": "4203",
                                "id": 1628,
                                "label": "张湾区",
                                "value": "420303"
                            },
                            {
                                "father": "4203",
                                "id": 1629,
                                "label": "郧阳区",
                                "value": "420304"
                            },
                            {
                                "father": "4203",
                                "id": 1630,
                                "label": "郧西县",
                                "value": "420322"
                            },
                            {
                                "father": "4203",
                                "id": 1631,
                                "label": "竹山县",
                                "value": "420323"
                            },
                            {
                                "father": "4203",
                                "id": 1632,
                                "label": "竹溪县",
                                "value": "420324"
                            },
                            {
                                "father": "4203",
                                "id": 1633,
                                "label": "房县",
                                "value": "420325"
                            },
                            {
                                "father": "4203",
                                "id": 1634,
                                "label": "丹江口市",
                                "value": "420381"
                            }
                        ],
                        "father": "42",
                        "id": 170,
                        "label": "十堰市",
                        "value": "4203"
                    },
                    {
                        "children": [
                            {
                                "father": "4205",
                                "id": 1635,
                                "label": "西陵区",
                                "value": "420502"
                            },
                            {
                                "father": "4205",
                                "id": 1636,
                                "label": "伍家岗区",
                                "value": "420503"
                            },
                            {
                                "father": "4205",
                                "id": 1637,
                                "label": "点军区",
                                "value": "420504"
                            },
                            {
                                "father": "4205",
                                "id": 1638,
                                "label": "猇亭区",
                                "value": "420505"
                            },
                            {
                                "father": "4205",
                                "id": 1639,
                                "label": "夷陵区",
                                "value": "420506"
                            },
                            {
                                "father": "4205",
                                "id": 1640,
                                "label": "远安县",
                                "value": "420525"
                            },
                            {
                                "father": "4205",
                                "id": 1641,
                                "label": "兴山县",
                                "value": "420526"
                            },
                            {
                                "father": "4205",
                                "id": 1642,
                                "label": "秭归县",
                                "value": "420527"
                            },
                            {
                                "father": "4205",
                                "id": 1643,
                                "label": "长阳土家族自治县",
                                "value": "420528"
                            },
                            {
                                "father": "4205",
                                "id": 1644,
                                "label": "五峰土家族自治县",
                                "value": "420529"
                            },
                            {
                                "father": "4205",
                                "id": 1645,
                                "label": "宜都市",
                                "value": "420581"
                            },
                            {
                                "father": "4205",
                                "id": 1646,
                                "label": "当阳市",
                                "value": "420582"
                            },
                            {
                                "father": "4205",
                                "id": 1647,
                                "label": "枝江市",
                                "value": "420583"
                            }
                        ],
                        "father": "42",
                        "id": 171,
                        "label": "宜昌市",
                        "value": "4205"
                    },
                    {
                        "children": [
                            {
                                "father": "4206",
                                "id": 1648,
                                "label": "襄城区",
                                "value": "420602"
                            },
                            {
                                "father": "4206",
                                "id": 1649,
                                "label": "樊城区",
                                "value": "420606"
                            },
                            {
                                "father": "4206",
                                "id": 1650,
                                "label": "襄州区",
                                "value": "420607"
                            },
                            {
                                "father": "4206",
                                "id": 1651,
                                "label": "南漳县",
                                "value": "420624"
                            },
                            {
                                "father": "4206",
                                "id": 1652,
                                "label": "谷城县",
                                "value": "420625"
                            },
                            {
                                "father": "4206",
                                "id": 1653,
                                "label": "保康县",
                                "value": "420626"
                            },
                            {
                                "father": "4206",
                                "id": 1654,
                                "label": "老河口市",
                                "value": "420682"
                            },
                            {
                                "father": "4206",
                                "id": 1655,
                                "label": "枣阳市",
                                "value": "420683"
                            },
                            {
                                "father": "4206",
                                "id": 1656,
                                "label": "宜城市",
                                "value": "420684"
                            }
                        ],
                        "father": "42",
                        "id": 172,
                        "label": "襄阳市",
                        "value": "4206"
                    },
                    {
                        "children": [
                            {
                                "father": "4207",
                                "id": 1657,
                                "label": "梁子湖区",
                                "value": "420702"
                            },
                            {
                                "father": "4207",
                                "id": 1658,
                                "label": "华容区",
                                "value": "420703"
                            },
                            {
                                "father": "4207",
                                "id": 1659,
                                "label": "鄂城区",
                                "value": "420704"
                            }
                        ],
                        "father": "42",
                        "id": 173,
                        "label": "鄂州市",
                        "value": "4207"
                    },
                    {
                        "children": [
                            {
                                "father": "4208",
                                "id": 1660,
                                "label": "东宝区",
                                "value": "420802"
                            },
                            {
                                "father": "4208",
                                "id": 1661,
                                "label": "掇刀区",
                                "value": "420804"
                            },
                            {
                                "father": "4208",
                                "id": 1662,
                                "label": "沙洋县",
                                "value": "420822"
                            },
                            {
                                "father": "4208",
                                "id": 1663,
                                "label": "钟祥市",
                                "value": "420881"
                            },
                            {
                                "father": "4208",
                                "id": 1664,
                                "label": "京山市",
                                "value": "420882"
                            }
                        ],
                        "father": "42",
                        "id": 174,
                        "label": "荆门市",
                        "value": "4208"
                    },
                    {
                        "children": [
                            {
                                "father": "4209",
                                "id": 1665,
                                "label": "孝南区",
                                "value": "420902"
                            },
                            {
                                "father": "4209",
                                "id": 1666,
                                "label": "孝昌县",
                                "value": "420921"
                            },
                            {
                                "father": "4209",
                                "id": 1667,
                                "label": "大悟县",
                                "value": "420922"
                            },
                            {
                                "father": "4209",
                                "id": 1668,
                                "label": "云梦县",
                                "value": "420923"
                            },
                            {
                                "father": "4209",
                                "id": 1669,
                                "label": "应城市",
                                "value": "420981"
                            },
                            {
                                "father": "4209",
                                "id": 1670,
                                "label": "安陆市",
                                "value": "420982"
                            },
                            {
                                "father": "4209",
                                "id": 1671,
                                "label": "汉川市",
                                "value": "420984"
                            }
                        ],
                        "father": "42",
                        "id": 175,
                        "label": "孝感市",
                        "value": "4209"
                    },
                    {
                        "children": [
                            {
                                "father": "4210",
                                "id": 1672,
                                "label": "沙市区",
                                "value": "421002"
                            },
                            {
                                "father": "4210",
                                "id": 1673,
                                "label": "荆州区",
                                "value": "421003"
                            },
                            {
                                "father": "4210",
                                "id": 1674,
                                "label": "公安县",
                                "value": "421022"
                            },
                            {
                                "father": "4210",
                                "id": 1675,
                                "label": "监利县",
                                "value": "421023"
                            },
                            {
                                "father": "4210",
                                "id": 1676,
                                "label": "江陵县",
                                "value": "421024"
                            },
                            {
                                "father": "4210",
                                "id": 1677,
                                "label": "荆州经济技术开发区",
                                "value": "421071"
                            },
                            {
                                "father": "4210",
                                "id": 1678,
                                "label": "石首市",
                                "value": "421081"
                            },
                            {
                                "father": "4210",
                                "id": 1679,
                                "label": "洪湖市",
                                "value": "421083"
                            },
                            {
                                "father": "4210",
                                "id": 1680,
                                "label": "松滋市",
                                "value": "421087"
                            }
                        ],
                        "father": "42",
                        "id": 176,
                        "label": "荆州市",
                        "value": "4210"
                    },
                    {
                        "children": [
                            {
                                "father": "4211",
                                "id": 1681,
                                "label": "黄州区",
                                "value": "421102"
                            },
                            {
                                "father": "4211",
                                "id": 1682,
                                "label": "团风县",
                                "value": "421121"
                            },
                            {
                                "father": "4211",
                                "id": 1683,
                                "label": "红安县",
                                "value": "421122"
                            },
                            {
                                "father": "4211",
                                "id": 1684,
                                "label": "罗田县",
                                "value": "421123"
                            },
                            {
                                "father": "4211",
                                "id": 1685,
                                "label": "英山县",
                                "value": "421124"
                            },
                            {
                                "father": "4211",
                                "id": 1686,
                                "label": "浠水县",
                                "value": "421125"
                            },
                            {
                                "father": "4211",
                                "id": 1687,
                                "label": "蕲春县",
                                "value": "421126"
                            },
                            {
                                "father": "4211",
                                "id": 1688,
                                "label": "黄梅县",
                                "value": "421127"
                            },
                            {
                                "father": "4211",
                                "id": 1689,
                                "label": "龙感湖管理区",
                                "value": "421171"
                            },
                            {
                                "father": "4211",
                                "id": 1690,
                                "label": "麻城市",
                                "value": "421181"
                            },
                            {
                                "father": "4211",
                                "id": 1691,
                                "label": "武穴市",
                                "value": "421182"
                            }
                        ],
                        "father": "42",
                        "id": 177,
                        "label": "黄冈市",
                        "value": "4211"
                    },
                    {
                        "children": [
                            {
                                "father": "4212",
                                "id": 1692,
                                "label": "咸安区",
                                "value": "421202"
                            },
                            {
                                "father": "4212",
                                "id": 1693,
                                "label": "嘉鱼县",
                                "value": "421221"
                            },
                            {
                                "father": "4212",
                                "id": 1694,
                                "label": "通城县",
                                "value": "421222"
                            },
                            {
                                "father": "4212",
                                "id": 1695,
                                "label": "崇阳县",
                                "value": "421223"
                            },
                            {
                                "father": "4212",
                                "id": 1696,
                                "label": "通山县",
                                "value": "421224"
                            },
                            {
                                "father": "4212",
                                "id": 1697,
                                "label": "赤壁市",
                                "value": "421281"
                            }
                        ],
                        "father": "42",
                        "id": 178,
                        "label": "咸宁市",
                        "value": "4212"
                    },
                    {
                        "children": [
                            {
                                "father": "4213",
                                "id": 1698,
                                "label": "曾都区",
                                "value": "421303"
                            },
                            {
                                "father": "4213",
                                "id": 1699,
                                "label": "随县",
                                "value": "421321"
                            },
                            {
                                "father": "4213",
                                "id": 1700,
                                "label": "广水市",
                                "value": "421381"
                            }
                        ],
                        "father": "42",
                        "id": 179,
                        "label": "随州市",
                        "value": "4213"
                    },
                    {
                        "children": [
                            {
                                "father": "4228",
                                "id": 1701,
                                "label": "恩施市",
                                "value": "422801"
                            },
                            {
                                "father": "4228",
                                "id": 1702,
                                "label": "利川市",
                                "value": "422802"
                            },
                            {
                                "father": "4228",
                                "id": 1703,
                                "label": "建始县",
                                "value": "422822"
                            },
                            {
                                "father": "4228",
                                "id": 1704,
                                "label": "巴东县",
                                "value": "422823"
                            },
                            {
                                "father": "4228",
                                "id": 1705,
                                "label": "宣恩县",
                                "value": "422825"
                            },
                            {
                                "father": "4228",
                                "id": 1706,
                                "label": "咸丰县",
                                "value": "422826"
                            },
                            {
                                "father": "4228",
                                "id": 1707,
                                "label": "来凤县",
                                "value": "422827"
                            },
                            {
                                "father": "4228",
                                "id": 1708,
                                "label": "鹤峰县",
                                "value": "422828"
                            }
                        ],
                        "father": "42",
                        "id": 180,
                        "label": "恩施土家族苗族自治州",
                        "value": "4228"
                    },
                    {
                        "children": [
                            {
                                "father": "4290",
                                "id": 1709,
                                "label": "仙桃市",
                                "value": "429004"
                            },
                            {
                                "father": "4290",
                                "id": 1710,
                                "label": "潜江市",
                                "value": "429005"
                            },
                            {
                                "father": "4290",
                                "id": 1711,
                                "label": "天门市",
                                "value": "429006"
                            },
                            {
                                "father": "4290",
                                "id": 1712,
                                "label": "神农架林区",
                                "value": "429021"
                            }
                        ],
                        "father": "42",
                        "id": 181,
                        "label": "省直辖县级行政区划",
                        "value": "4290"
                    }
                ],
                "id": 17,
                "label": "湖北省",
                "value": "42"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "4301",
                                "id": 1713,
                                "label": "芙蓉区",
                                "value": "430102"
                            },
                            {
                                "father": "4301",
                                "id": 1714,
                                "label": "天心区",
                                "value": "430103"
                            },
                            {
                                "father": "4301",
                                "id": 1715,
                                "label": "岳麓区",
                                "value": "430104"
                            },
                            {
                                "father": "4301",
                                "id": 1716,
                                "label": "开福区",
                                "value": "430105"
                            },
                            {
                                "father": "4301",
                                "id": 1717,
                                "label": "雨花区",
                                "value": "430111"
                            },
                            {
                                "father": "4301",
                                "id": 1718,
                                "label": "望城区",
                                "value": "430112"
                            },
                            {
                                "father": "4301",
                                "id": 1719,
                                "label": "长沙县",
                                "value": "430121"
                            },
                            {
                                "father": "4301",
                                "id": 1720,
                                "label": "浏阳市",
                                "value": "430181"
                            },
                            {
                                "father": "4301",
                                "id": 1721,
                                "label": "宁乡市",
                                "value": "430182"
                            }
                        ],
                        "father": "43",
                        "id": 182,
                        "label": "长沙市",
                        "value": "4301"
                    },
                    {
                        "children": [
                            {
                                "father": "4302",
                                "id": 1722,
                                "label": "荷塘区",
                                "value": "430202"
                            },
                            {
                                "father": "4302",
                                "id": 1723,
                                "label": "芦淞区",
                                "value": "430203"
                            },
                            {
                                "father": "4302",
                                "id": 1724,
                                "label": "石峰区",
                                "value": "430204"
                            },
                            {
                                "father": "4302",
                                "id": 1725,
                                "label": "天元区",
                                "value": "430211"
                            },
                            {
                                "father": "4302",
                                "id": 1726,
                                "label": "渌口区",
                                "value": "430212"
                            },
                            {
                                "father": "4302",
                                "id": 1727,
                                "label": "攸县",
                                "value": "430223"
                            },
                            {
                                "father": "4302",
                                "id": 1728,
                                "label": "茶陵县",
                                "value": "430224"
                            },
                            {
                                "father": "4302",
                                "id": 1729,
                                "label": "炎陵县",
                                "value": "430225"
                            },
                            {
                                "father": "4302",
                                "id": 1730,
                                "label": "云龙示范区",
                                "value": "430271"
                            },
                            {
                                "father": "4302",
                                "id": 1731,
                                "label": "醴陵市",
                                "value": "430281"
                            }
                        ],
                        "father": "43",
                        "id": 183,
                        "label": "株洲市",
                        "value": "4302"
                    },
                    {
                        "children": [
                            {
                                "father": "4303",
                                "id": 1732,
                                "label": "雨湖区",
                                "value": "430302"
                            },
                            {
                                "father": "4303",
                                "id": 1733,
                                "label": "岳塘区",
                                "value": "430304"
                            },
                            {
                                "father": "4303",
                                "id": 1734,
                                "label": "湘潭县",
                                "value": "430321"
                            },
                            {
                                "father": "4303",
                                "id": 1735,
                                "label": "湖南湘潭高新技术产业园区",
                                "value": "430371"
                            },
                            {
                                "father": "4303",
                                "id": 1736,
                                "label": "湘潭昭山示范区",
                                "value": "430372"
                            },
                            {
                                "father": "4303",
                                "id": 1737,
                                "label": "湘潭九华示范区",
                                "value": "430373"
                            },
                            {
                                "father": "4303",
                                "id": 1738,
                                "label": "湘乡市",
                                "value": "430381"
                            },
                            {
                                "father": "4303",
                                "id": 1739,
                                "label": "韶山市",
                                "value": "430382"
                            }
                        ],
                        "father": "43",
                        "id": 184,
                        "label": "湘潭市",
                        "value": "4303"
                    },
                    {
                        "children": [
                            {
                                "father": "4304",
                                "id": 1740,
                                "label": "珠晖区",
                                "value": "430405"
                            },
                            {
                                "father": "4304",
                                "id": 1741,
                                "label": "雁峰区",
                                "value": "430406"
                            },
                            {
                                "father": "4304",
                                "id": 1742,
                                "label": "石鼓区",
                                "value": "430407"
                            },
                            {
                                "father": "4304",
                                "id": 1743,
                                "label": "蒸湘区",
                                "value": "430408"
                            },
                            {
                                "father": "4304",
                                "id": 1744,
                                "label": "南岳区",
                                "value": "430412"
                            },
                            {
                                "father": "4304",
                                "id": 1745,
                                "label": "衡阳县",
                                "value": "430421"
                            },
                            {
                                "father": "4304",
                                "id": 1746,
                                "label": "衡南县",
                                "value": "430422"
                            },
                            {
                                "father": "4304",
                                "id": 1747,
                                "label": "衡山县",
                                "value": "430423"
                            },
                            {
                                "father": "4304",
                                "id": 1748,
                                "label": "衡东县",
                                "value": "430424"
                            },
                            {
                                "father": "4304",
                                "id": 1749,
                                "label": "祁东县",
                                "value": "430426"
                            },
                            {
                                "father": "4304",
                                "id": 1750,
                                "label": "衡阳综合保税区",
                                "value": "430471"
                            },
                            {
                                "father": "4304",
                                "id": 1751,
                                "label": "湖南衡阳高新技术产业园区",
                                "value": "430472"
                            },
                            {
                                "father": "4304",
                                "id": 1752,
                                "label": "湖南衡阳松木经济开发区",
                                "value": "430473"
                            },
                            {
                                "father": "4304",
                                "id": 1753,
                                "label": "耒阳市",
                                "value": "430481"
                            },
                            {
                                "father": "4304",
                                "id": 1754,
                                "label": "常宁市",
                                "value": "430482"
                            }
                        ],
                        "father": "43",
                        "id": 185,
                        "label": "衡阳市",
                        "value": "4304"
                    },
                    {
                        "children": [
                            {
                                "father": "4305",
                                "id": 1755,
                                "label": "双清区",
                                "value": "430502"
                            },
                            {
                                "father": "4305",
                                "id": 1756,
                                "label": "大祥区",
                                "value": "430503"
                            },
                            {
                                "father": "4305",
                                "id": 1757,
                                "label": "北塔区",
                                "value": "430511"
                            },
                            {
                                "father": "4305",
                                "id": 1758,
                                "label": "新邵县",
                                "value": "430522"
                            },
                            {
                                "father": "4305",
                                "id": 1759,
                                "label": "邵阳县",
                                "value": "430523"
                            },
                            {
                                "father": "4305",
                                "id": 1760,
                                "label": "隆回县",
                                "value": "430524"
                            },
                            {
                                "father": "4305",
                                "id": 1761,
                                "label": "洞口县",
                                "value": "430525"
                            },
                            {
                                "father": "4305",
                                "id": 1762,
                                "label": "绥宁县",
                                "value": "430527"
                            },
                            {
                                "father": "4305",
                                "id": 1763,
                                "label": "新宁县",
                                "value": "430528"
                            },
                            {
                                "father": "4305",
                                "id": 1764,
                                "label": "城步苗族自治县",
                                "value": "430529"
                            },
                            {
                                "father": "4305",
                                "id": 1765,
                                "label": "武冈市",
                                "value": "430581"
                            },
                            {
                                "father": "4305",
                                "id": 1766,
                                "label": "邵东市",
                                "value": "430582"
                            }
                        ],
                        "father": "43",
                        "id": 186,
                        "label": "邵阳市",
                        "value": "4305"
                    },
                    {
                        "children": [
                            {
                                "father": "4306",
                                "id": 1767,
                                "label": "岳阳楼区",
                                "value": "430602"
                            },
                            {
                                "father": "4306",
                                "id": 1768,
                                "label": "云溪区",
                                "value": "430603"
                            },
                            {
                                "father": "4306",
                                "id": 1769,
                                "label": "君山区",
                                "value": "430611"
                            },
                            {
                                "father": "4306",
                                "id": 1770,
                                "label": "岳阳县",
                                "value": "430621"
                            },
                            {
                                "father": "4306",
                                "id": 1771,
                                "label": "华容县",
                                "value": "430623"
                            },
                            {
                                "father": "4306",
                                "id": 1772,
                                "label": "湘阴县",
                                "value": "430624"
                            },
                            {
                                "father": "4306",
                                "id": 1773,
                                "label": "平江县",
                                "value": "430626"
                            },
                            {
                                "father": "4306",
                                "id": 1774,
                                "label": "岳阳市屈原管理区",
                                "value": "430671"
                            },
                            {
                                "father": "4306",
                                "id": 1775,
                                "label": "汨罗市",
                                "value": "430681"
                            },
                            {
                                "father": "4306",
                                "id": 1776,
                                "label": "临湘市",
                                "value": "430682"
                            }
                        ],
                        "father": "43",
                        "id": 187,
                        "label": "岳阳市",
                        "value": "4306"
                    },
                    {
                        "children": [
                            {
                                "father": "4307",
                                "id": 1777,
                                "label": "武陵区",
                                "value": "430702"
                            },
                            {
                                "father": "4307",
                                "id": 1778,
                                "label": "鼎城区",
                                "value": "430703"
                            },
                            {
                                "father": "4307",
                                "id": 1779,
                                "label": "安乡县",
                                "value": "430721"
                            },
                            {
                                "father": "4307",
                                "id": 1780,
                                "label": "汉寿县",
                                "value": "430722"
                            },
                            {
                                "father": "4307",
                                "id": 1781,
                                "label": "澧县",
                                "value": "430723"
                            },
                            {
                                "father": "4307",
                                "id": 1782,
                                "label": "临澧县",
                                "value": "430724"
                            },
                            {
                                "father": "4307",
                                "id": 1783,
                                "label": "桃源县",
                                "value": "430725"
                            },
                            {
                                "father": "4307",
                                "id": 1784,
                                "label": "石门县",
                                "value": "430726"
                            },
                            {
                                "father": "4307",
                                "id": 1785,
                                "label": "常德市西洞庭管理区",
                                "value": "430771"
                            },
                            {
                                "father": "4307",
                                "id": 1786,
                                "label": "津市市",
                                "value": "430781"
                            }
                        ],
                        "father": "43",
                        "id": 188,
                        "label": "常德市",
                        "value": "4307"
                    },
                    {
                        "children": [
                            {
                                "father": "4308",
                                "id": 1787,
                                "label": "永定区",
                                "value": "430802"
                            },
                            {
                                "father": "4308",
                                "id": 1788,
                                "label": "武陵源区",
                                "value": "430811"
                            },
                            {
                                "father": "4308",
                                "id": 1789,
                                "label": "慈利县",
                                "value": "430821"
                            },
                            {
                                "father": "4308",
                                "id": 1790,
                                "label": "桑植县",
                                "value": "430822"
                            }
                        ],
                        "father": "43",
                        "id": 189,
                        "label": "张家界市",
                        "value": "4308"
                    },
                    {
                        "children": [
                            {
                                "father": "4309",
                                "id": 1791,
                                "label": "资阳区",
                                "value": "430902"
                            },
                            {
                                "father": "4309",
                                "id": 1792,
                                "label": "赫山区",
                                "value": "430903"
                            },
                            {
                                "father": "4309",
                                "id": 1793,
                                "label": "南县",
                                "value": "430921"
                            },
                            {
                                "father": "4309",
                                "id": 1794,
                                "label": "桃江县",
                                "value": "430922"
                            },
                            {
                                "father": "4309",
                                "id": 1795,
                                "label": "安化县",
                                "value": "430923"
                            },
                            {
                                "father": "4309",
                                "id": 1796,
                                "label": "益阳市大通湖管理区",
                                "value": "430971"
                            },
                            {
                                "father": "4309",
                                "id": 1797,
                                "label": "湖南益阳高新技术产业园区",
                                "value": "430972"
                            },
                            {
                                "father": "4309",
                                "id": 1798,
                                "label": "沅江市",
                                "value": "430981"
                            }
                        ],
                        "father": "43",
                        "id": 190,
                        "label": "益阳市",
                        "value": "4309"
                    },
                    {
                        "children": [
                            {
                                "father": "4310",
                                "id": 1799,
                                "label": "北湖区",
                                "value": "431002"
                            },
                            {
                                "father": "4310",
                                "id": 1800,
                                "label": "苏仙区",
                                "value": "431003"
                            },
                            {
                                "father": "4310",
                                "id": 1801,
                                "label": "桂阳县",
                                "value": "431021"
                            },
                            {
                                "father": "4310",
                                "id": 1802,
                                "label": "宜章县",
                                "value": "431022"
                            },
                            {
                                "father": "4310",
                                "id": 1803,
                                "label": "永兴县",
                                "value": "431023"
                            },
                            {
                                "father": "4310",
                                "id": 1804,
                                "label": "嘉禾县",
                                "value": "431024"
                            },
                            {
                                "father": "4310",
                                "id": 1805,
                                "label": "临武县",
                                "value": "431025"
                            },
                            {
                                "father": "4310",
                                "id": 1806,
                                "label": "汝城县",
                                "value": "431026"
                            },
                            {
                                "father": "4310",
                                "id": 1807,
                                "label": "桂东县",
                                "value": "431027"
                            },
                            {
                                "father": "4310",
                                "id": 1808,
                                "label": "安仁县",
                                "value": "431028"
                            },
                            {
                                "father": "4310",
                                "id": 1809,
                                "label": "资兴市",
                                "value": "431081"
                            }
                        ],
                        "father": "43",
                        "id": 191,
                        "label": "郴州市",
                        "value": "4310"
                    },
                    {
                        "children": [
                            {
                                "father": "4311",
                                "id": 1810,
                                "label": "零陵区",
                                "value": "431102"
                            },
                            {
                                "father": "4311",
                                "id": 1811,
                                "label": "冷水滩区",
                                "value": "431103"
                            },
                            {
                                "father": "4311",
                                "id": 1812,
                                "label": "祁阳县",
                                "value": "431121"
                            },
                            {
                                "father": "4311",
                                "id": 1813,
                                "label": "东安县",
                                "value": "431122"
                            },
                            {
                                "father": "4311",
                                "id": 1814,
                                "label": "双牌县",
                                "value": "431123"
                            },
                            {
                                "father": "4311",
                                "id": 1815,
                                "label": "道县",
                                "value": "431124"
                            },
                            {
                                "father": "4311",
                                "id": 1816,
                                "label": "江永县",
                                "value": "431125"
                            },
                            {
                                "father": "4311",
                                "id": 1817,
                                "label": "宁远县",
                                "value": "431126"
                            },
                            {
                                "father": "4311",
                                "id": 1818,
                                "label": "蓝山县",
                                "value": "431127"
                            },
                            {
                                "father": "4311",
                                "id": 1819,
                                "label": "新田县",
                                "value": "431128"
                            },
                            {
                                "father": "4311",
                                "id": 1820,
                                "label": "江华瑶族自治县",
                                "value": "431129"
                            },
                            {
                                "father": "4311",
                                "id": 1821,
                                "label": "永州经济技术开发区",
                                "value": "431171"
                            },
                            {
                                "father": "4311",
                                "id": 1822,
                                "label": "永州市金洞管理区",
                                "value": "431172"
                            },
                            {
                                "father": "4311",
                                "id": 1823,
                                "label": "永州市回龙圩管理区",
                                "value": "431173"
                            }
                        ],
                        "father": "43",
                        "id": 192,
                        "label": "永州市",
                        "value": "4311"
                    },
                    {
                        "children": [
                            {
                                "father": "4312",
                                "id": 1824,
                                "label": "鹤城区",
                                "value": "431202"
                            },
                            {
                                "father": "4312",
                                "id": 1825,
                                "label": "中方县",
                                "value": "431221"
                            },
                            {
                                "father": "4312",
                                "id": 1826,
                                "label": "沅陵县",
                                "value": "431222"
                            },
                            {
                                "father": "4312",
                                "id": 1827,
                                "label": "辰溪县",
                                "value": "431223"
                            },
                            {
                                "father": "4312",
                                "id": 1828,
                                "label": "溆浦县",
                                "value": "431224"
                            },
                            {
                                "father": "4312",
                                "id": 1829,
                                "label": "会同县",
                                "value": "431225"
                            },
                            {
                                "father": "4312",
                                "id": 1830,
                                "label": "麻阳苗族自治县",
                                "value": "431226"
                            },
                            {
                                "father": "4312",
                                "id": 1831,
                                "label": "新晃侗族自治县",
                                "value": "431227"
                            },
                            {
                                "father": "4312",
                                "id": 1832,
                                "label": "芷江侗族自治县",
                                "value": "431228"
                            },
                            {
                                "father": "4312",
                                "id": 1833,
                                "label": "靖州苗族侗族自治县",
                                "value": "431229"
                            },
                            {
                                "father": "4312",
                                "id": 1834,
                                "label": "通道侗族自治县",
                                "value": "431230"
                            },
                            {
                                "father": "4312",
                                "id": 1835,
                                "label": "怀化市洪江管理区",
                                "value": "431271"
                            },
                            {
                                "father": "4312",
                                "id": 1836,
                                "label": "洪江市",
                                "value": "431281"
                            }
                        ],
                        "father": "43",
                        "id": 193,
                        "label": "怀化市",
                        "value": "4312"
                    },
                    {
                        "children": [
                            {
                                "father": "4313",
                                "id": 1837,
                                "label": "娄星区",
                                "value": "431302"
                            },
                            {
                                "father": "4313",
                                "id": 1838,
                                "label": "双峰县",
                                "value": "431321"
                            },
                            {
                                "father": "4313",
                                "id": 1839,
                                "label": "新化县",
                                "value": "431322"
                            },
                            {
                                "father": "4313",
                                "id": 1840,
                                "label": "冷水江市",
                                "value": "431381"
                            },
                            {
                                "father": "4313",
                                "id": 1841,
                                "label": "涟源市",
                                "value": "431382"
                            }
                        ],
                        "father": "43",
                        "id": 194,
                        "label": "娄底市",
                        "value": "4313"
                    },
                    {
                        "children": [
                            {
                                "father": "4331",
                                "id": 1842,
                                "label": "吉首市",
                                "value": "433101"
                            },
                            {
                                "father": "4331",
                                "id": 1843,
                                "label": "泸溪县",
                                "value": "433122"
                            },
                            {
                                "father": "4331",
                                "id": 1844,
                                "label": "凤凰县",
                                "value": "433123"
                            },
                            {
                                "father": "4331",
                                "id": 1845,
                                "label": "花垣县",
                                "value": "433124"
                            },
                            {
                                "father": "4331",
                                "id": 1846,
                                "label": "保靖县",
                                "value": "433125"
                            },
                            {
                                "father": "4331",
                                "id": 1847,
                                "label": "古丈县",
                                "value": "433126"
                            },
                            {
                                "father": "4331",
                                "id": 1848,
                                "label": "永顺县",
                                "value": "433127"
                            },
                            {
                                "father": "4331",
                                "id": 1849,
                                "label": "龙山县",
                                "value": "433130"
                            },
                            {
                                "father": "4331",
                                "id": 1850,
                                "label": "湖南永顺经济开发区",
                                "value": "433173"
                            }
                        ],
                        "father": "43",
                        "id": 195,
                        "label": "湘西土家族苗族自治州",
                        "value": "4331"
                    }
                ],
                "id": 18,
                "label": "湖南省",
                "value": "43"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "4401",
                                "id": 1851,
                                "label": "荔湾区",
                                "value": "440103"
                            },
                            {
                                "father": "4401",
                                "id": 1852,
                                "label": "越秀区",
                                "value": "440104"
                            },
                            {
                                "father": "4401",
                                "id": 1853,
                                "label": "海珠区",
                                "value": "440105"
                            },
                            {
                                "father": "4401",
                                "id": 1854,
                                "label": "天河区",
                                "value": "440106"
                            },
                            {
                                "father": "4401",
                                "id": 1855,
                                "label": "白云区",
                                "value": "440111"
                            },
                            {
                                "father": "4401",
                                "id": 1856,
                                "label": "黄埔区",
                                "value": "440112"
                            },
                            {
                                "father": "4401",
                                "id": 1857,
                                "label": "番禺区",
                                "value": "440113"
                            },
                            {
                                "father": "4401",
                                "id": 1858,
                                "label": "花都区",
                                "value": "440114"
                            },
                            {
                                "father": "4401",
                                "id": 1859,
                                "label": "南沙区",
                                "value": "440115"
                            },
                            {
                                "father": "4401",
                                "id": 1860,
                                "label": "从化区",
                                "value": "440117"
                            },
                            {
                                "father": "4401",
                                "id": 1861,
                                "label": "增城区",
                                "value": "440118"
                            }
                        ],
                        "father": "44",
                        "id": 196,
                        "label": "广州市",
                        "value": "4401"
                    },
                    {
                        "children": [
                            {
                                "father": "4402",
                                "id": 1862,
                                "label": "武江区",
                                "value": "440203"
                            },
                            {
                                "father": "4402",
                                "id": 1863,
                                "label": "浈江区",
                                "value": "440204"
                            },
                            {
                                "father": "4402",
                                "id": 1864,
                                "label": "曲江区",
                                "value": "440205"
                            },
                            {
                                "father": "4402",
                                "id": 1865,
                                "label": "始兴县",
                                "value": "440222"
                            },
                            {
                                "father": "4402",
                                "id": 1866,
                                "label": "仁化县",
                                "value": "440224"
                            },
                            {
                                "father": "4402",
                                "id": 1867,
                                "label": "翁源县",
                                "value": "440229"
                            },
                            {
                                "father": "4402",
                                "id": 1868,
                                "label": "乳源瑶族自治县",
                                "value": "440232"
                            },
                            {
                                "father": "4402",
                                "id": 1869,
                                "label": "新丰县",
                                "value": "440233"
                            },
                            {
                                "father": "4402",
                                "id": 1870,
                                "label": "乐昌市",
                                "value": "440281"
                            },
                            {
                                "father": "4402",
                                "id": 1871,
                                "label": "南雄市",
                                "value": "440282"
                            }
                        ],
                        "father": "44",
                        "id": 197,
                        "label": "韶关市",
                        "value": "4402"
                    },
                    {
                        "children": [
                            {
                                "father": "4403",
                                "id": 1872,
                                "label": "罗湖区",
                                "value": "440303"
                            },
                            {
                                "father": "4403",
                                "id": 1873,
                                "label": "福田区",
                                "value": "440304"
                            },
                            {
                                "father": "4403",
                                "id": 1874,
                                "label": "南山区",
                                "value": "440305"
                            },
                            {
                                "father": "4403",
                                "id": 1875,
                                "label": "宝安区",
                                "value": "440306"
                            },
                            {
                                "father": "4403",
                                "id": 1876,
                                "label": "龙岗区",
                                "value": "440307"
                            },
                            {
                                "father": "4403",
                                "id": 1877,
                                "label": "盐田区",
                                "value": "440308"
                            },
                            {
                                "father": "4403",
                                "id": 1878,
                                "label": "龙华区",
                                "value": "440309"
                            },
                            {
                                "father": "4403",
                                "id": 1879,
                                "label": "坪山区",
                                "value": "440310"
                            },
                            {
                                "father": "4403",
                                "id": 1880,
                                "label": "光明区",
                                "value": "440311"
                            }
                        ],
                        "father": "44",
                        "id": 198,
                        "label": "深圳市",
                        "value": "4403"
                    },
                    {
                        "children": [
                            {
                                "father": "4404",
                                "id": 1881,
                                "label": "香洲区",
                                "value": "440402"
                            },
                            {
                                "father": "4404",
                                "id": 1882,
                                "label": "斗门区",
                                "value": "440403"
                            },
                            {
                                "father": "4404",
                                "id": 1883,
                                "label": "金湾区",
                                "value": "440404"
                            }
                        ],
                        "father": "44",
                        "id": 199,
                        "label": "珠海市",
                        "value": "4404"
                    },
                    {
                        "children": [
                            {
                                "father": "4405",
                                "id": 1884,
                                "label": "龙湖区",
                                "value": "440507"
                            },
                            {
                                "father": "4405",
                                "id": 1885,
                                "label": "金平区",
                                "value": "440511"
                            },
                            {
                                "father": "4405",
                                "id": 1886,
                                "label": "濠江区",
                                "value": "440512"
                            },
                            {
                                "father": "4405",
                                "id": 1887,
                                "label": "潮阳区",
                                "value": "440513"
                            },
                            {
                                "father": "4405",
                                "id": 1888,
                                "label": "潮南区",
                                "value": "440514"
                            },
                            {
                                "father": "4405",
                                "id": 1889,
                                "label": "澄海区",
                                "value": "440515"
                            },
                            {
                                "father": "4405",
                                "id": 1890,
                                "label": "南澳县",
                                "value": "440523"
                            }
                        ],
                        "father": "44",
                        "id": 200,
                        "label": "汕头市",
                        "value": "4405"
                    },
                    {
                        "children": [
                            {
                                "father": "4406",
                                "id": 1891,
                                "label": "禅城区",
                                "value": "440604"
                            },
                            {
                                "father": "4406",
                                "id": 1892,
                                "label": "南海区",
                                "value": "440605"
                            },
                            {
                                "father": "4406",
                                "id": 1893,
                                "label": "顺德区",
                                "value": "440606"
                            },
                            {
                                "father": "4406",
                                "id": 1894,
                                "label": "三水区",
                                "value": "440607"
                            },
                            {
                                "father": "4406",
                                "id": 1895,
                                "label": "高明区",
                                "value": "440608"
                            }
                        ],
                        "father": "44",
                        "id": 201,
                        "label": "佛山市",
                        "value": "4406"
                    },
                    {
                        "children": [
                            {
                                "father": "4407",
                                "id": 1896,
                                "label": "蓬江区",
                                "value": "440703"
                            },
                            {
                                "father": "4407",
                                "id": 1897,
                                "label": "江海区",
                                "value": "440704"
                            },
                            {
                                "father": "4407",
                                "id": 1898,
                                "label": "新会区",
                                "value": "440705"
                            },
                            {
                                "father": "4407",
                                "id": 1899,
                                "label": "台山市",
                                "value": "440781"
                            },
                            {
                                "father": "4407",
                                "id": 1900,
                                "label": "开平市",
                                "value": "440783"
                            },
                            {
                                "father": "4407",
                                "id": 1901,
                                "label": "鹤山市",
                                "value": "440784"
                            },
                            {
                                "father": "4407",
                                "id": 1902,
                                "label": "恩平市",
                                "value": "440785"
                            }
                        ],
                        "father": "44",
                        "id": 202,
                        "label": "江门市",
                        "value": "4407"
                    },
                    {
                        "children": [
                            {
                                "father": "4408",
                                "id": 1903,
                                "label": "赤坎区",
                                "value": "440802"
                            },
                            {
                                "father": "4408",
                                "id": 1904,
                                "label": "霞山区",
                                "value": "440803"
                            },
                            {
                                "father": "4408",
                                "id": 1905,
                                "label": "坡头区",
                                "value": "440804"
                            },
                            {
                                "father": "4408",
                                "id": 1906,
                                "label": "麻章区",
                                "value": "440811"
                            },
                            {
                                "father": "4408",
                                "id": 1907,
                                "label": "遂溪县",
                                "value": "440823"
                            },
                            {
                                "father": "4408",
                                "id": 1908,
                                "label": "徐闻县",
                                "value": "440825"
                            },
                            {
                                "father": "4408",
                                "id": 1909,
                                "label": "廉江市",
                                "value": "440881"
                            },
                            {
                                "father": "4408",
                                "id": 1910,
                                "label": "雷州市",
                                "value": "440882"
                            },
                            {
                                "father": "4408",
                                "id": 1911,
                                "label": "吴川市",
                                "value": "440883"
                            }
                        ],
                        "father": "44",
                        "id": 203,
                        "label": "湛江市",
                        "value": "4408"
                    },
                    {
                        "children": [
                            {
                                "father": "4409",
                                "id": 1912,
                                "label": "茂南区",
                                "value": "440902"
                            },
                            {
                                "father": "4409",
                                "id": 1913,
                                "label": "电白区",
                                "value": "440904"
                            },
                            {
                                "father": "4409",
                                "id": 1914,
                                "label": "高州市",
                                "value": "440981"
                            },
                            {
                                "father": "4409",
                                "id": 1915,
                                "label": "化州市",
                                "value": "440982"
                            },
                            {
                                "father": "4409",
                                "id": 1916,
                                "label": "信宜市",
                                "value": "440983"
                            }
                        ],
                        "father": "44",
                        "id": 204,
                        "label": "茂名市",
                        "value": "4409"
                    },
                    {
                        "children": [
                            {
                                "father": "4412",
                                "id": 1917,
                                "label": "端州区",
                                "value": "441202"
                            },
                            {
                                "father": "4412",
                                "id": 1918,
                                "label": "鼎湖区",
                                "value": "441203"
                            },
                            {
                                "father": "4412",
                                "id": 1919,
                                "label": "高要区",
                                "value": "441204"
                            },
                            {
                                "father": "4412",
                                "id": 1920,
                                "label": "广宁县",
                                "value": "441223"
                            },
                            {
                                "father": "4412",
                                "id": 1921,
                                "label": "怀集县",
                                "value": "441224"
                            },
                            {
                                "father": "4412",
                                "id": 1922,
                                "label": "封开县",
                                "value": "441225"
                            },
                            {
                                "father": "4412",
                                "id": 1923,
                                "label": "德庆县",
                                "value": "441226"
                            },
                            {
                                "father": "4412",
                                "id": 1924,
                                "label": "四会市",
                                "value": "441284"
                            }
                        ],
                        "father": "44",
                        "id": 205,
                        "label": "肇庆市",
                        "value": "4412"
                    },
                    {
                        "children": [
                            {
                                "father": "4413",
                                "id": 1925,
                                "label": "惠城区",
                                "value": "441302"
                            },
                            {
                                "father": "4413",
                                "id": 1926,
                                "label": "惠阳区",
                                "value": "441303"
                            },
                            {
                                "father": "4413",
                                "id": 1927,
                                "label": "博罗县",
                                "value": "441322"
                            },
                            {
                                "father": "4413",
                                "id": 1928,
                                "label": "惠东县",
                                "value": "441323"
                            },
                            {
                                "father": "4413",
                                "id": 1929,
                                "label": "龙门县",
                                "value": "441324"
                            }
                        ],
                        "father": "44",
                        "id": 206,
                        "label": "惠州市",
                        "value": "4413"
                    },
                    {
                        "children": [
                            {
                                "father": "4414",
                                "id": 1930,
                                "label": "梅江区",
                                "value": "441402"
                            },
                            {
                                "father": "4414",
                                "id": 1931,
                                "label": "梅县区",
                                "value": "441403"
                            },
                            {
                                "father": "4414",
                                "id": 1932,
                                "label": "大埔县",
                                "value": "441422"
                            },
                            {
                                "father": "4414",
                                "id": 1933,
                                "label": "丰顺县",
                                "value": "441423"
                            },
                            {
                                "father": "4414",
                                "id": 1934,
                                "label": "五华县",
                                "value": "441424"
                            },
                            {
                                "father": "4414",
                                "id": 1935,
                                "label": "平远县",
                                "value": "441426"
                            },
                            {
                                "father": "4414",
                                "id": 1936,
                                "label": "蕉岭县",
                                "value": "441427"
                            },
                            {
                                "father": "4414",
                                "id": 1937,
                                "label": "兴宁市",
                                "value": "441481"
                            }
                        ],
                        "father": "44",
                        "id": 207,
                        "label": "梅州市",
                        "value": "4414"
                    },
                    {
                        "children": [
                            {
                                "father": "4415",
                                "id": 1938,
                                "label": "城区",
                                "value": "441502"
                            },
                            {
                                "father": "4415",
                                "id": 1939,
                                "label": "海丰县",
                                "value": "441521"
                            },
                            {
                                "father": "4415",
                                "id": 1940,
                                "label": "陆河县",
                                "value": "441523"
                            },
                            {
                                "father": "4415",
                                "id": 1941,
                                "label": "陆丰市",
                                "value": "441581"
                            }
                        ],
                        "father": "44",
                        "id": 208,
                        "label": "汕尾市",
                        "value": "4415"
                    },
                    {
                        "children": [
                            {
                                "father": "4416",
                                "id": 1942,
                                "label": "源城区",
                                "value": "441602"
                            },
                            {
                                "father": "4416",
                                "id": 1943,
                                "label": "紫金县",
                                "value": "441621"
                            },
                            {
                                "father": "4416",
                                "id": 1944,
                                "label": "龙川县",
                                "value": "441622"
                            },
                            {
                                "father": "4416",
                                "id": 1945,
                                "label": "连平县",
                                "value": "441623"
                            },
                            {
                                "father": "4416",
                                "id": 1946,
                                "label": "和平县",
                                "value": "441624"
                            },
                            {
                                "father": "4416",
                                "id": 1947,
                                "label": "东源县",
                                "value": "441625"
                            }
                        ],
                        "father": "44",
                        "id": 209,
                        "label": "河源市",
                        "value": "4416"
                    },
                    {
                        "children": [
                            {
                                "father": "4417",
                                "id": 1948,
                                "label": "江城区",
                                "value": "441702"
                            },
                            {
                                "father": "4417",
                                "id": 1949,
                                "label": "阳东区",
                                "value": "441704"
                            },
                            {
                                "father": "4417",
                                "id": 1950,
                                "label": "阳西县",
                                "value": "441721"
                            },
                            {
                                "father": "4417",
                                "id": 1951,
                                "label": "阳春市",
                                "value": "441781"
                            }
                        ],
                        "father": "44",
                        "id": 210,
                        "label": "阳江市",
                        "value": "4417"
                    },
                    {
                        "children": [
                            {
                                "father": "4418",
                                "id": 1952,
                                "label": "清城区",
                                "value": "441802"
                            },
                            {
                                "father": "4418",
                                "id": 1953,
                                "label": "清新区",
                                "value": "441803"
                            },
                            {
                                "father": "4418",
                                "id": 1954,
                                "label": "佛冈县",
                                "value": "441821"
                            },
                            {
                                "father": "4418",
                                "id": 1955,
                                "label": "阳山县",
                                "value": "441823"
                            },
                            {
                                "father": "4418",
                                "id": 1956,
                                "label": "连山壮族瑶族自治县",
                                "value": "441825"
                            },
                            {
                                "father": "4418",
                                "id": 1957,
                                "label": "连南瑶族自治县",
                                "value": "441826"
                            },
                            {
                                "father": "4418",
                                "id": 1958,
                                "label": "英德市",
                                "value": "441881"
                            },
                            {
                                "father": "4418",
                                "id": 1959,
                                "label": "连州市",
                                "value": "441882"
                            }
                        ],
                        "father": "44",
                        "id": 211,
                        "label": "清远市",
                        "value": "4418"
                    },
                    {
                        "children": [
                            {
                                "father": "4419",
                                "id": 1960,
                                "label": "东莞市",
                                "value": "441900"
                            }
                        ],
                        "father": "44",
                        "id": 212,
                        "label": "东莞市",
                        "value": "4419"
                    },
                    {
                        "children": [
                            {
                                "father": "4420",
                                "id": 1961,
                                "label": "中山市",
                                "value": "442000"
                            }
                        ],
                        "father": "44",
                        "id": 213,
                        "label": "中山市",
                        "value": "4420"
                    },
                    {
                        "children": [
                            {
                                "father": "4451",
                                "id": 1962,
                                "label": "湘桥区",
                                "value": "445102"
                            },
                            {
                                "father": "4451",
                                "id": 1963,
                                "label": "潮安区",
                                "value": "445103"
                            },
                            {
                                "father": "4451",
                                "id": 1964,
                                "label": "饶平县",
                                "value": "445122"
                            }
                        ],
                        "father": "44",
                        "id": 214,
                        "label": "潮州市",
                        "value": "4451"
                    },
                    {
                        "children": [
                            {
                                "father": "4452",
                                "id": 1965,
                                "label": "榕城区",
                                "value": "445202"
                            },
                            {
                                "father": "4452",
                                "id": 1966,
                                "label": "揭东区",
                                "value": "445203"
                            },
                            {
                                "father": "4452",
                                "id": 1967,
                                "label": "揭西县",
                                "value": "445222"
                            },
                            {
                                "father": "4452",
                                "id": 1968,
                                "label": "惠来县",
                                "value": "445224"
                            },
                            {
                                "father": "4452",
                                "id": 1969,
                                "label": "普宁市",
                                "value": "445281"
                            }
                        ],
                        "father": "44",
                        "id": 215,
                        "label": "揭阳市",
                        "value": "4452"
                    },
                    {
                        "children": [
                            {
                                "father": "4453",
                                "id": 1970,
                                "label": "云城区",
                                "value": "445302"
                            },
                            {
                                "father": "4453",
                                "id": 1971,
                                "label": "云安区",
                                "value": "445303"
                            },
                            {
                                "father": "4453",
                                "id": 1972,
                                "label": "新兴县",
                                "value": "445321"
                            },
                            {
                                "father": "4453",
                                "id": 1973,
                                "label": "郁南县",
                                "value": "445322"
                            },
                            {
                                "father": "4453",
                                "id": 1974,
                                "label": "罗定市",
                                "value": "445381"
                            }
                        ],
                        "father": "44",
                        "id": 216,
                        "label": "云浮市",
                        "value": "4453"
                    }
                ],
                "id": 19,
                "label": "广东省",
                "value": "44"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "4501",
                                "id": 1975,
                                "label": "兴宁区",
                                "value": "450102"
                            },
                            {
                                "father": "4501",
                                "id": 1976,
                                "label": "青秀区",
                                "value": "450103"
                            },
                            {
                                "father": "4501",
                                "id": 1977,
                                "label": "江南区",
                                "value": "450105"
                            },
                            {
                                "father": "4501",
                                "id": 1978,
                                "label": "西乡塘区",
                                "value": "450107"
                            },
                            {
                                "father": "4501",
                                "id": 1979,
                                "label": "良庆区",
                                "value": "450108"
                            },
                            {
                                "father": "4501",
                                "id": 1980,
                                "label": "邕宁区",
                                "value": "450109"
                            },
                            {
                                "father": "4501",
                                "id": 1981,
                                "label": "武鸣区",
                                "value": "450110"
                            },
                            {
                                "father": "4501",
                                "id": 1982,
                                "label": "隆安县",
                                "value": "450123"
                            },
                            {
                                "father": "4501",
                                "id": 1983,
                                "label": "马山县",
                                "value": "450124"
                            },
                            {
                                "father": "4501",
                                "id": 1984,
                                "label": "上林县",
                                "value": "450125"
                            },
                            {
                                "father": "4501",
                                "id": 1985,
                                "label": "宾阳县",
                                "value": "450126"
                            },
                            {
                                "father": "4501",
                                "id": 1986,
                                "label": "横县",
                                "value": "450127"
                            }
                        ],
                        "father": "45",
                        "id": 217,
                        "label": "南宁市",
                        "value": "4501"
                    },
                    {
                        "children": [
                            {
                                "father": "4502",
                                "id": 1987,
                                "label": "城中区",
                                "value": "450202"
                            },
                            {
                                "father": "4502",
                                "id": 1988,
                                "label": "鱼峰区",
                                "value": "450203"
                            },
                            {
                                "father": "4502",
                                "id": 1989,
                                "label": "柳南区",
                                "value": "450204"
                            },
                            {
                                "father": "4502",
                                "id": 1990,
                                "label": "柳北区",
                                "value": "450205"
                            },
                            {
                                "father": "4502",
                                "id": 1991,
                                "label": "柳江区",
                                "value": "450206"
                            },
                            {
                                "father": "4502",
                                "id": 1992,
                                "label": "柳城县",
                                "value": "450222"
                            },
                            {
                                "father": "4502",
                                "id": 1993,
                                "label": "鹿寨县",
                                "value": "450223"
                            },
                            {
                                "father": "4502",
                                "id": 1994,
                                "label": "融安县",
                                "value": "450224"
                            },
                            {
                                "father": "4502",
                                "id": 1995,
                                "label": "融水苗族自治县",
                                "value": "450225"
                            },
                            {
                                "father": "4502",
                                "id": 1996,
                                "label": "三江侗族自治县",
                                "value": "450226"
                            }
                        ],
                        "father": "45",
                        "id": 218,
                        "label": "柳州市",
                        "value": "4502"
                    },
                    {
                        "children": [
                            {
                                "father": "4503",
                                "id": 1997,
                                "label": "秀峰区",
                                "value": "450302"
                            },
                            {
                                "father": "4503",
                                "id": 1998,
                                "label": "叠彩区",
                                "value": "450303"
                            },
                            {
                                "father": "4503",
                                "id": 1999,
                                "label": "象山区",
                                "value": "450304"
                            },
                            {
                                "father": "4503",
                                "id": 2000,
                                "label": "七星区",
                                "value": "450305"
                            },
                            {
                                "father": "4503",
                                "id": 2001,
                                "label": "雁山区",
                                "value": "450311"
                            },
                            {
                                "father": "4503",
                                "id": 2002,
                                "label": "临桂区",
                                "value": "450312"
                            },
                            {
                                "father": "4503",
                                "id": 2003,
                                "label": "阳朔县",
                                "value": "450321"
                            },
                            {
                                "father": "4503",
                                "id": 2004,
                                "label": "灵川县",
                                "value": "450323"
                            },
                            {
                                "father": "4503",
                                "id": 2005,
                                "label": "全州县",
                                "value": "450324"
                            },
                            {
                                "father": "4503",
                                "id": 2006,
                                "label": "兴安县",
                                "value": "450325"
                            },
                            {
                                "father": "4503",
                                "id": 2007,
                                "label": "永福县",
                                "value": "450326"
                            },
                            {
                                "father": "4503",
                                "id": 2008,
                                "label": "灌阳县",
                                "value": "450327"
                            },
                            {
                                "father": "4503",
                                "id": 2009,
                                "label": "龙胜各族自治县",
                                "value": "450328"
                            },
                            {
                                "father": "4503",
                                "id": 2010,
                                "label": "资源县",
                                "value": "450329"
                            },
                            {
                                "father": "4503",
                                "id": 2011,
                                "label": "平乐县",
                                "value": "450330"
                            },
                            {
                                "father": "4503",
                                "id": 2012,
                                "label": "恭城瑶族自治县",
                                "value": "450332"
                            },
                            {
                                "father": "4503",
                                "id": 2013,
                                "label": "荔浦市",
                                "value": "450381"
                            }
                        ],
                        "father": "45",
                        "id": 219,
                        "label": "桂林市",
                        "value": "4503"
                    },
                    {
                        "children": [
                            {
                                "father": "4504",
                                "id": 2014,
                                "label": "万秀区",
                                "value": "450403"
                            },
                            {
                                "father": "4504",
                                "id": 2015,
                                "label": "长洲区",
                                "value": "450405"
                            },
                            {
                                "father": "4504",
                                "id": 2016,
                                "label": "龙圩区",
                                "value": "450406"
                            },
                            {
                                "father": "4504",
                                "id": 2017,
                                "label": "苍梧县",
                                "value": "450421"
                            },
                            {
                                "father": "4504",
                                "id": 2018,
                                "label": "藤县",
                                "value": "450422"
                            },
                            {
                                "father": "4504",
                                "id": 2019,
                                "label": "蒙山县",
                                "value": "450423"
                            },
                            {
                                "father": "4504",
                                "id": 2020,
                                "label": "岑溪市",
                                "value": "450481"
                            }
                        ],
                        "father": "45",
                        "id": 220,
                        "label": "梧州市",
                        "value": "4504"
                    },
                    {
                        "children": [
                            {
                                "father": "4505",
                                "id": 2021,
                                "label": "海城区",
                                "value": "450502"
                            },
                            {
                                "father": "4505",
                                "id": 2022,
                                "label": "银海区",
                                "value": "450503"
                            },
                            {
                                "father": "4505",
                                "id": 2023,
                                "label": "铁山港区",
                                "value": "450512"
                            },
                            {
                                "father": "4505",
                                "id": 2024,
                                "label": "合浦县",
                                "value": "450521"
                            }
                        ],
                        "father": "45",
                        "id": 221,
                        "label": "北海市",
                        "value": "4505"
                    },
                    {
                        "children": [
                            {
                                "father": "4506",
                                "id": 2025,
                                "label": "港口区",
                                "value": "450602"
                            },
                            {
                                "father": "4506",
                                "id": 2026,
                                "label": "防城区",
                                "value": "450603"
                            },
                            {
                                "father": "4506",
                                "id": 2027,
                                "label": "上思县",
                                "value": "450621"
                            },
                            {
                                "father": "4506",
                                "id": 2028,
                                "label": "东兴市",
                                "value": "450681"
                            }
                        ],
                        "father": "45",
                        "id": 222,
                        "label": "防城港市",
                        "value": "4506"
                    },
                    {
                        "children": [
                            {
                                "father": "4507",
                                "id": 2029,
                                "label": "钦南区",
                                "value": "450702"
                            },
                            {
                                "father": "4507",
                                "id": 2030,
                                "label": "钦北区",
                                "value": "450703"
                            },
                            {
                                "father": "4507",
                                "id": 2031,
                                "label": "灵山县",
                                "value": "450721"
                            },
                            {
                                "father": "4507",
                                "id": 2032,
                                "label": "浦北县",
                                "value": "450722"
                            }
                        ],
                        "father": "45",
                        "id": 223,
                        "label": "钦州市",
                        "value": "4507"
                    },
                    {
                        "children": [
                            {
                                "father": "4508",
                                "id": 2033,
                                "label": "港北区",
                                "value": "450802"
                            },
                            {
                                "father": "4508",
                                "id": 2034,
                                "label": "港南区",
                                "value": "450803"
                            },
                            {
                                "father": "4508",
                                "id": 2035,
                                "label": "覃塘区",
                                "value": "450804"
                            },
                            {
                                "father": "4508",
                                "id": 2036,
                                "label": "平南县",
                                "value": "450821"
                            },
                            {
                                "father": "4508",
                                "id": 2037,
                                "label": "桂平市",
                                "value": "450881"
                            }
                        ],
                        "father": "45",
                        "id": 224,
                        "label": "贵港市",
                        "value": "4508"
                    },
                    {
                        "children": [
                            {
                                "father": "4509",
                                "id": 2038,
                                "label": "玉州区",
                                "value": "450902"
                            },
                            {
                                "father": "4509",
                                "id": 2039,
                                "label": "福绵区",
                                "value": "450903"
                            },
                            {
                                "father": "4509",
                                "id": 2040,
                                "label": "容县",
                                "value": "450921"
                            },
                            {
                                "father": "4509",
                                "id": 2041,
                                "label": "陆川县",
                                "value": "450922"
                            },
                            {
                                "father": "4509",
                                "id": 2042,
                                "label": "博白县",
                                "value": "450923"
                            },
                            {
                                "father": "4509",
                                "id": 2043,
                                "label": "兴业县",
                                "value": "450924"
                            },
                            {
                                "father": "4509",
                                "id": 2044,
                                "label": "北流市",
                                "value": "450981"
                            }
                        ],
                        "father": "45",
                        "id": 225,
                        "label": "玉林市",
                        "value": "4509"
                    },
                    {
                        "children": [
                            {
                                "father": "4510",
                                "id": 2045,
                                "label": "右江区",
                                "value": "451002"
                            },
                            {
                                "father": "4510",
                                "id": 2046,
                                "label": "田阳区",
                                "value": "451003"
                            },
                            {
                                "father": "4510",
                                "id": 2047,
                                "label": "田东县",
                                "value": "451022"
                            },
                            {
                                "father": "4510",
                                "id": 2048,
                                "label": "平果县",
                                "value": "451023"
                            },
                            {
                                "father": "4510",
                                "id": 2049,
                                "label": "德保县",
                                "value": "451024"
                            },
                            {
                                "father": "4510",
                                "id": 2050,
                                "label": "那坡县",
                                "value": "451026"
                            },
                            {
                                "father": "4510",
                                "id": 2051,
                                "label": "凌云县",
                                "value": "451027"
                            },
                            {
                                "father": "4510",
                                "id": 2052,
                                "label": "乐业县",
                                "value": "451028"
                            },
                            {
                                "father": "4510",
                                "id": 2053,
                                "label": "田林县",
                                "value": "451029"
                            },
                            {
                                "father": "4510",
                                "id": 2054,
                                "label": "西林县",
                                "value": "451030"
                            },
                            {
                                "father": "4510",
                                "id": 2055,
                                "label": "隆林各族自治县",
                                "value": "451031"
                            },
                            {
                                "father": "4510",
                                "id": 2056,
                                "label": "靖西市",
                                "value": "451081"
                            }
                        ],
                        "father": "45",
                        "id": 226,
                        "label": "百色市",
                        "value": "4510"
                    },
                    {
                        "children": [
                            {
                                "father": "4511",
                                "id": 2057,
                                "label": "八步区",
                                "value": "451102"
                            },
                            {
                                "father": "4511",
                                "id": 2058,
                                "label": "平桂区",
                                "value": "451103"
                            },
                            {
                                "father": "4511",
                                "id": 2059,
                                "label": "昭平县",
                                "value": "451121"
                            },
                            {
                                "father": "4511",
                                "id": 2060,
                                "label": "钟山县",
                                "value": "451122"
                            },
                            {
                                "father": "4511",
                                "id": 2061,
                                "label": "富川瑶族自治县",
                                "value": "451123"
                            }
                        ],
                        "father": "45",
                        "id": 227,
                        "label": "贺州市",
                        "value": "4511"
                    },
                    {
                        "children": [
                            {
                                "father": "4512",
                                "id": 2062,
                                "label": "金城江区",
                                "value": "451202"
                            },
                            {
                                "father": "4512",
                                "id": 2063,
                                "label": "宜州区",
                                "value": "451203"
                            },
                            {
                                "father": "4512",
                                "id": 2064,
                                "label": "南丹县",
                                "value": "451221"
                            },
                            {
                                "father": "4512",
                                "id": 2065,
                                "label": "天峨县",
                                "value": "451222"
                            },
                            {
                                "father": "4512",
                                "id": 2066,
                                "label": "凤山县",
                                "value": "451223"
                            },
                            {
                                "father": "4512",
                                "id": 2067,
                                "label": "东兰县",
                                "value": "451224"
                            },
                            {
                                "father": "4512",
                                "id": 2068,
                                "label": "罗城仫佬族自治县",
                                "value": "451225"
                            },
                            {
                                "father": "4512",
                                "id": 2069,
                                "label": "环江毛南族自治县",
                                "value": "451226"
                            },
                            {
                                "father": "4512",
                                "id": 2070,
                                "label": "巴马瑶族自治县",
                                "value": "451227"
                            },
                            {
                                "father": "4512",
                                "id": 2071,
                                "label": "都安瑶族自治县",
                                "value": "451228"
                            },
                            {
                                "father": "4512",
                                "id": 2072,
                                "label": "大化瑶族自治县",
                                "value": "451229"
                            }
                        ],
                        "father": "45",
                        "id": 228,
                        "label": "河池市",
                        "value": "4512"
                    },
                    {
                        "children": [
                            {
                                "father": "4513",
                                "id": 2073,
                                "label": "兴宾区",
                                "value": "451302"
                            },
                            {
                                "father": "4513",
                                "id": 2074,
                                "label": "忻城县",
                                "value": "451321"
                            },
                            {
                                "father": "4513",
                                "id": 2075,
                                "label": "象州县",
                                "value": "451322"
                            },
                            {
                                "father": "4513",
                                "id": 2076,
                                "label": "武宣县",
                                "value": "451323"
                            },
                            {
                                "father": "4513",
                                "id": 2077,
                                "label": "金秀瑶族自治县",
                                "value": "451324"
                            },
                            {
                                "father": "4513",
                                "id": 2078,
                                "label": "合山市",
                                "value": "451381"
                            }
                        ],
                        "father": "45",
                        "id": 229,
                        "label": "来宾市",
                        "value": "4513"
                    },
                    {
                        "children": [
                            {
                                "father": "4514",
                                "id": 2079,
                                "label": "江州区",
                                "value": "451402"
                            },
                            {
                                "father": "4514",
                                "id": 2080,
                                "label": "扶绥县",
                                "value": "451421"
                            },
                            {
                                "father": "4514",
                                "id": 2081,
                                "label": "宁明县",
                                "value": "451422"
                            },
                            {
                                "father": "4514",
                                "id": 2082,
                                "label": "龙州县",
                                "value": "451423"
                            },
                            {
                                "father": "4514",
                                "id": 2083,
                                "label": "大新县",
                                "value": "451424"
                            },
                            {
                                "father": "4514",
                                "id": 2084,
                                "label": "天等县",
                                "value": "451425"
                            },
                            {
                                "father": "4514",
                                "id": 2085,
                                "label": "凭祥市",
                                "value": "451481"
                            }
                        ],
                        "father": "45",
                        "id": 230,
                        "label": "崇左市",
                        "value": "4514"
                    }
                ],
                "id": 20,
                "label": "广西壮族自治区",
                "value": "45"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "4601",
                                "id": 2086,
                                "label": "秀英区",
                                "value": "460105"
                            },
                            {
                                "father": "4601",
                                "id": 2087,
                                "label": "龙华区",
                                "value": "460106"
                            },
                            {
                                "father": "4601",
                                "id": 2088,
                                "label": "琼山区",
                                "value": "460107"
                            },
                            {
                                "father": "4601",
                                "id": 2089,
                                "label": "美兰区",
                                "value": "460108"
                            }
                        ],
                        "father": "46",
                        "id": 231,
                        "label": "海口市",
                        "value": "4601"
                    },
                    {
                        "children": [
                            {
                                "father": "4602",
                                "id": 2090,
                                "label": "海棠区",
                                "value": "460202"
                            },
                            {
                                "father": "4602",
                                "id": 2091,
                                "label": "吉阳区",
                                "value": "460203"
                            },
                            {
                                "father": "4602",
                                "id": 2092,
                                "label": "天涯区",
                                "value": "460204"
                            },
                            {
                                "father": "4602",
                                "id": 2093,
                                "label": "崖州区",
                                "value": "460205"
                            }
                        ],
                        "father": "46",
                        "id": 232,
                        "label": "三亚市",
                        "value": "4602"
                    },
                    {
                        "children": [
                            {
                                "father": "4603",
                                "id": 2094,
                                "label": "西沙群岛",
                                "value": "460321"
                            },
                            {
                                "father": "4603",
                                "id": 2095,
                                "label": "南沙群岛",
                                "value": "460322"
                            },
                            {
                                "father": "4603",
                                "id": 2096,
                                "label": "中沙群岛的岛礁及其海域",
                                "value": "460323"
                            }
                        ],
                        "father": "46",
                        "id": 233,
                        "label": "三沙市",
                        "value": "4603"
                    },
                    {
                        "children": [
                            {
                                "father": "4604",
                                "id": 2097,
                                "label": "儋州市",
                                "value": "460400"
                            }
                        ],
                        "father": "46",
                        "id": 234,
                        "label": "儋州市",
                        "value": "4604"
                    },
                    {
                        "children": [
                            {
                                "father": "4690",
                                "id": 2098,
                                "label": "五指山市",
                                "value": "469001"
                            },
                            {
                                "father": "4690",
                                "id": 2099,
                                "label": "琼海市",
                                "value": "469002"
                            },
                            {
                                "father": "4690",
                                "id": 2100,
                                "label": "文昌市",
                                "value": "469005"
                            },
                            {
                                "father": "4690",
                                "id": 2101,
                                "label": "万宁市",
                                "value": "469006"
                            },
                            {
                                "father": "4690",
                                "id": 2102,
                                "label": "东方市",
                                "value": "469007"
                            },
                            {
                                "father": "4690",
                                "id": 2103,
                                "label": "定安县",
                                "value": "469021"
                            },
                            {
                                "father": "4690",
                                "id": 2104,
                                "label": "屯昌县",
                                "value": "469022"
                            },
                            {
                                "father": "4690",
                                "id": 2105,
                                "label": "澄迈县",
                                "value": "469023"
                            },
                            {
                                "father": "4690",
                                "id": 2106,
                                "label": "临高县",
                                "value": "469024"
                            },
                            {
                                "father": "4690",
                                "id": 2107,
                                "label": "白沙黎族自治县",
                                "value": "469025"
                            },
                            {
                                "father": "4690",
                                "id": 2108,
                                "label": "昌江黎族自治县",
                                "value": "469026"
                            },
                            {
                                "father": "4690",
                                "id": 2109,
                                "label": "乐东黎族自治县",
                                "value": "469027"
                            },
                            {
                                "father": "4690",
                                "id": 2110,
                                "label": "陵水黎族自治县",
                                "value": "469028"
                            },
                            {
                                "father": "4690",
                                "id": 2111,
                                "label": "保亭黎族苗族自治县",
                                "value": "469029"
                            },
                            {
                                "father": "4690",
                                "id": 2112,
                                "label": "琼中黎族苗族自治县",
                                "value": "469030"
                            }
                        ],
                        "father": "46",
                        "id": 235,
                        "label": "省直辖县级行政区划",
                        "value": "4690"
                    }
                ],
                "id": 21,
                "label": "海南省",
                "value": "46"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "5001",
                                "id": 2113,
                                "label": "万州区",
                                "value": "500101"
                            },
                            {
                                "father": "5001",
                                "id": 2114,
                                "label": "涪陵区",
                                "value": "500102"
                            },
                            {
                                "father": "5001",
                                "id": 2115,
                                "label": "渝中区",
                                "value": "500103"
                            },
                            {
                                "father": "5001",
                                "id": 2116,
                                "label": "大渡口区",
                                "value": "500104"
                            },
                            {
                                "father": "5001",
                                "id": 2117,
                                "label": "江北区",
                                "value": "500105"
                            },
                            {
                                "father": "5001",
                                "id": 2118,
                                "label": "沙坪坝区",
                                "value": "500106"
                            },
                            {
                                "father": "5001",
                                "id": 2119,
                                "label": "九龙坡区",
                                "value": "500107"
                            },
                            {
                                "father": "5001",
                                "id": 2120,
                                "label": "南岸区",
                                "value": "500108"
                            },
                            {
                                "father": "5001",
                                "id": 2121,
                                "label": "北碚区",
                                "value": "500109"
                            },
                            {
                                "father": "5001",
                                "id": 2122,
                                "label": "綦江区",
                                "value": "500110"
                            },
                            {
                                "father": "5001",
                                "id": 2123,
                                "label": "大足区",
                                "value": "500111"
                            },
                            {
                                "father": "5001",
                                "id": 2124,
                                "label": "渝北区",
                                "value": "500112"
                            },
                            {
                                "father": "5001",
                                "id": 2125,
                                "label": "巴南区",
                                "value": "500113"
                            },
                            {
                                "father": "5001",
                                "id": 2126,
                                "label": "黔江区",
                                "value": "500114"
                            },
                            {
                                "father": "5001",
                                "id": 2127,
                                "label": "长寿区",
                                "value": "500115"
                            },
                            {
                                "father": "5001",
                                "id": 2128,
                                "label": "江津区",
                                "value": "500116"
                            },
                            {
                                "father": "5001",
                                "id": 2129,
                                "label": "合川区",
                                "value": "500117"
                            },
                            {
                                "father": "5001",
                                "id": 2130,
                                "label": "永川区",
                                "value": "500118"
                            },
                            {
                                "father": "5001",
                                "id": 2131,
                                "label": "南川区",
                                "value": "500119"
                            },
                            {
                                "father": "5001",
                                "id": 2132,
                                "label": "璧山区",
                                "value": "500120"
                            },
                            {
                                "father": "5001",
                                "id": 2133,
                                "label": "铜梁区",
                                "value": "500151"
                            },
                            {
                                "father": "5001",
                                "id": 2134,
                                "label": "潼南区",
                                "value": "500152"
                            },
                            {
                                "father": "5001",
                                "id": 2135,
                                "label": "荣昌区",
                                "value": "500153"
                            },
                            {
                                "father": "5001",
                                "id": 2136,
                                "label": "开州区",
                                "value": "500154"
                            },
                            {
                                "father": "5001",
                                "id": 2137,
                                "label": "梁平区",
                                "value": "500155"
                            },
                            {
                                "father": "5001",
                                "id": 2138,
                                "label": "武隆区",
                                "value": "500156"
                            }
                        ],
                        "father": "50",
                        "id": 236,
                        "label": "市辖区",
                        "value": "5001"
                    },
                    {
                        "children": [
                            {
                                "father": "5002",
                                "id": 2139,
                                "label": "城口县",
                                "value": "500229"
                            },
                            {
                                "father": "5002",
                                "id": 2140,
                                "label": "丰都县",
                                "value": "500230"
                            },
                            {
                                "father": "5002",
                                "id": 2141,
                                "label": "垫江县",
                                "value": "500231"
                            },
                            {
                                "father": "5002",
                                "id": 2142,
                                "label": "忠县",
                                "value": "500233"
                            },
                            {
                                "father": "5002",
                                "id": 2143,
                                "label": "云阳县",
                                "value": "500235"
                            },
                            {
                                "father": "5002",
                                "id": 2144,
                                "label": "奉节县",
                                "value": "500236"
                            },
                            {
                                "father": "5002",
                                "id": 2145,
                                "label": "巫山县",
                                "value": "500237"
                            },
                            {
                                "father": "5002",
                                "id": 2146,
                                "label": "巫溪县",
                                "value": "500238"
                            },
                            {
                                "father": "5002",
                                "id": 2147,
                                "label": "石柱土家族自治县",
                                "value": "500240"
                            },
                            {
                                "father": "5002",
                                "id": 2148,
                                "label": "秀山土家族苗族自治县",
                                "value": "500241"
                            },
                            {
                                "father": "5002",
                                "id": 2149,
                                "label": "酉阳土家族苗族自治县",
                                "value": "500242"
                            },
                            {
                                "father": "5002",
                                "id": 2150,
                                "label": "彭水苗族土家族自治县",
                                "value": "500243"
                            }
                        ],
                        "father": "50",
                        "id": 237,
                        "label": "县",
                        "value": "5002"
                    }
                ],
                "id": 22,
                "label": "重庆市",
                "value": "50"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "5101",
                                "id": 2151,
                                "label": "锦江区",
                                "value": "510104"
                            },
                            {
                                "father": "5101",
                                "id": 2152,
                                "label": "青羊区",
                                "value": "510105"
                            },
                            {
                                "father": "5101",
                                "id": 2153,
                                "label": "金牛区",
                                "value": "510106"
                            },
                            {
                                "father": "5101",
                                "id": 2154,
                                "label": "武侯区",
                                "value": "510107"
                            },
                            {
                                "father": "5101",
                                "id": 2155,
                                "label": "成华区",
                                "value": "510108"
                            },
                            {
                                "father": "5101",
                                "id": 2156,
                                "label": "龙泉驿区",
                                "value": "510112"
                            },
                            {
                                "father": "5101",
                                "id": 2157,
                                "label": "青白江区",
                                "value": "510113"
                            },
                            {
                                "father": "5101",
                                "id": 2158,
                                "label": "新都区",
                                "value": "510114"
                            },
                            {
                                "father": "5101",
                                "id": 2159,
                                "label": "温江区",
                                "value": "510115"
                            },
                            {
                                "father": "5101",
                                "id": 2160,
                                "label": "双流区",
                                "value": "510116"
                            },
                            {
                                "father": "5101",
                                "id": 2161,
                                "label": "郫都区",
                                "value": "510117"
                            },
                            {
                                "father": "5101",
                                "id": 2162,
                                "label": "金堂县",
                                "value": "510121"
                            },
                            {
                                "father": "5101",
                                "id": 2163,
                                "label": "大邑县",
                                "value": "510129"
                            },
                            {
                                "father": "5101",
                                "id": 2164,
                                "label": "蒲江县",
                                "value": "510131"
                            },
                            {
                                "father": "5101",
                                "id": 2165,
                                "label": "新津县",
                                "value": "510132"
                            },
                            {
                                "father": "5101",
                                "id": 2166,
                                "label": "都江堰市",
                                "value": "510181"
                            },
                            {
                                "father": "5101",
                                "id": 2167,
                                "label": "彭州市",
                                "value": "510182"
                            },
                            {
                                "father": "5101",
                                "id": 2168,
                                "label": "邛崃市",
                                "value": "510183"
                            },
                            {
                                "father": "5101",
                                "id": 2169,
                                "label": "崇州市",
                                "value": "510184"
                            },
                            {
                                "father": "5101",
                                "id": 2170,
                                "label": "简阳市",
                                "value": "510185"
                            }
                        ],
                        "father": "51",
                        "id": 238,
                        "label": "成都市",
                        "value": "5101"
                    },
                    {
                        "children": [
                            {
                                "father": "5103",
                                "id": 2171,
                                "label": "自流井区",
                                "value": "510302"
                            },
                            {
                                "father": "5103",
                                "id": 2172,
                                "label": "贡井区",
                                "value": "510303"
                            },
                            {
                                "father": "5103",
                                "id": 2173,
                                "label": "大安区",
                                "value": "510304"
                            },
                            {
                                "father": "5103",
                                "id": 2174,
                                "label": "沿滩区",
                                "value": "510311"
                            },
                            {
                                "father": "5103",
                                "id": 2175,
                                "label": "荣县",
                                "value": "510321"
                            },
                            {
                                "father": "5103",
                                "id": 2176,
                                "label": "富顺县",
                                "value": "510322"
                            }
                        ],
                        "father": "51",
                        "id": 239,
                        "label": "自贡市",
                        "value": "5103"
                    },
                    {
                        "children": [
                            {
                                "father": "5104",
                                "id": 2177,
                                "label": "东区",
                                "value": "510402"
                            },
                            {
                                "father": "5104",
                                "id": 2178,
                                "label": "西区",
                                "value": "510403"
                            },
                            {
                                "father": "5104",
                                "id": 2179,
                                "label": "仁和区",
                                "value": "510411"
                            },
                            {
                                "father": "5104",
                                "id": 2180,
                                "label": "米易县",
                                "value": "510421"
                            },
                            {
                                "father": "5104",
                                "id": 2181,
                                "label": "盐边县",
                                "value": "510422"
                            }
                        ],
                        "father": "51",
                        "id": 240,
                        "label": "攀枝花市",
                        "value": "5104"
                    },
                    {
                        "children": [
                            {
                                "father": "5105",
                                "id": 2182,
                                "label": "江阳区",
                                "value": "510502"
                            },
                            {
                                "father": "5105",
                                "id": 2183,
                                "label": "纳溪区",
                                "value": "510503"
                            },
                            {
                                "father": "5105",
                                "id": 2184,
                                "label": "龙马潭区",
                                "value": "510504"
                            },
                            {
                                "father": "5105",
                                "id": 2185,
                                "label": "泸县",
                                "value": "510521"
                            },
                            {
                                "father": "5105",
                                "id": 2186,
                                "label": "合江县",
                                "value": "510522"
                            },
                            {
                                "father": "5105",
                                "id": 2187,
                                "label": "叙永县",
                                "value": "510524"
                            },
                            {
                                "father": "5105",
                                "id": 2188,
                                "label": "古蔺县",
                                "value": "510525"
                            }
                        ],
                        "father": "51",
                        "id": 241,
                        "label": "泸州市",
                        "value": "5105"
                    },
                    {
                        "children": [
                            {
                                "father": "5106",
                                "id": 2189,
                                "label": "旌阳区",
                                "value": "510603"
                            },
                            {
                                "father": "5106",
                                "id": 2190,
                                "label": "罗江区",
                                "value": "510604"
                            },
                            {
                                "father": "5106",
                                "id": 2191,
                                "label": "中江县",
                                "value": "510623"
                            },
                            {
                                "father": "5106",
                                "id": 2192,
                                "label": "广汉市",
                                "value": "510681"
                            },
                            {
                                "father": "5106",
                                "id": 2193,
                                "label": "什邡市",
                                "value": "510682"
                            },
                            {
                                "father": "5106",
                                "id": 2194,
                                "label": "绵竹市",
                                "value": "510683"
                            }
                        ],
                        "father": "51",
                        "id": 242,
                        "label": "德阳市",
                        "value": "5106"
                    },
                    {
                        "children": [
                            {
                                "father": "5107",
                                "id": 2195,
                                "label": "涪城区",
                                "value": "510703"
                            },
                            {
                                "father": "5107",
                                "id": 2196,
                                "label": "游仙区",
                                "value": "510704"
                            },
                            {
                                "father": "5107",
                                "id": 2197,
                                "label": "安州区",
                                "value": "510705"
                            },
                            {
                                "father": "5107",
                                "id": 2198,
                                "label": "三台县",
                                "value": "510722"
                            },
                            {
                                "father": "5107",
                                "id": 2199,
                                "label": "盐亭县",
                                "value": "510723"
                            },
                            {
                                "father": "5107",
                                "id": 2200,
                                "label": "梓潼县",
                                "value": "510725"
                            },
                            {
                                "father": "5107",
                                "id": 2201,
                                "label": "北川羌族自治县",
                                "value": "510726"
                            },
                            {
                                "father": "5107",
                                "id": 2202,
                                "label": "平武县",
                                "value": "510727"
                            },
                            {
                                "father": "5107",
                                "id": 2203,
                                "label": "江油市",
                                "value": "510781"
                            }
                        ],
                        "father": "51",
                        "id": 243,
                        "label": "绵阳市",
                        "value": "5107"
                    },
                    {
                        "children": [
                            {
                                "father": "5108",
                                "id": 2204,
                                "label": "利州区",
                                "value": "510802"
                            },
                            {
                                "father": "5108",
                                "id": 2205,
                                "label": "昭化区",
                                "value": "510811"
                            },
                            {
                                "father": "5108",
                                "id": 2206,
                                "label": "朝天区",
                                "value": "510812"
                            },
                            {
                                "father": "5108",
                                "id": 2207,
                                "label": "旺苍县",
                                "value": "510821"
                            },
                            {
                                "father": "5108",
                                "id": 2208,
                                "label": "青川县",
                                "value": "510822"
                            },
                            {
                                "father": "5108",
                                "id": 2209,
                                "label": "剑阁县",
                                "value": "510823"
                            },
                            {
                                "father": "5108",
                                "id": 2210,
                                "label": "苍溪县",
                                "value": "510824"
                            }
                        ],
                        "father": "51",
                        "id": 244,
                        "label": "广元市",
                        "value": "5108"
                    },
                    {
                        "children": [
                            {
                                "father": "5109",
                                "id": 2211,
                                "label": "船山区",
                                "value": "510903"
                            },
                            {
                                "father": "5109",
                                "id": 2212,
                                "label": "安居区",
                                "value": "510904"
                            },
                            {
                                "father": "5109",
                                "id": 2213,
                                "label": "蓬溪县",
                                "value": "510921"
                            },
                            {
                                "father": "5109",
                                "id": 2214,
                                "label": "大英县",
                                "value": "510923"
                            },
                            {
                                "father": "5109",
                                "id": 2215,
                                "label": "射洪市",
                                "value": "510981"
                            }
                        ],
                        "father": "51",
                        "id": 245,
                        "label": "遂宁市",
                        "value": "5109"
                    },
                    {
                        "children": [
                            {
                                "father": "5110",
                                "id": 2216,
                                "label": "市中区",
                                "value": "511002"
                            },
                            {
                                "father": "5110",
                                "id": 2217,
                                "label": "东兴区",
                                "value": "511011"
                            },
                            {
                                "father": "5110",
                                "id": 2218,
                                "label": "威远县",
                                "value": "511024"
                            },
                            {
                                "father": "5110",
                                "id": 2219,
                                "label": "资中县",
                                "value": "511025"
                            },
                            {
                                "father": "5110",
                                "id": 2220,
                                "label": "内江经济开发区",
                                "value": "511071"
                            },
                            {
                                "father": "5110",
                                "id": 2221,
                                "label": "隆昌市",
                                "value": "511083"
                            }
                        ],
                        "father": "51",
                        "id": 246,
                        "label": "内江市",
                        "value": "5110"
                    },
                    {
                        "children": [
                            {
                                "father": "5111",
                                "id": 2222,
                                "label": "市中区",
                                "value": "511102"
                            },
                            {
                                "father": "5111",
                                "id": 2223,
                                "label": "沙湾区",
                                "value": "511111"
                            },
                            {
                                "father": "5111",
                                "id": 2224,
                                "label": "五通桥区",
                                "value": "511112"
                            },
                            {
                                "father": "5111",
                                "id": 2225,
                                "label": "金口河区",
                                "value": "511113"
                            },
                            {
                                "father": "5111",
                                "id": 2226,
                                "label": "犍为县",
                                "value": "511123"
                            },
                            {
                                "father": "5111",
                                "id": 2227,
                                "label": "井研县",
                                "value": "511124"
                            },
                            {
                                "father": "5111",
                                "id": 2228,
                                "label": "夹江县",
                                "value": "511126"
                            },
                            {
                                "father": "5111",
                                "id": 2229,
                                "label": "沐川县",
                                "value": "511129"
                            },
                            {
                                "father": "5111",
                                "id": 2230,
                                "label": "峨边彝族自治县",
                                "value": "511132"
                            },
                            {
                                "father": "5111",
                                "id": 2231,
                                "label": "马边彝族自治县",
                                "value": "511133"
                            },
                            {
                                "father": "5111",
                                "id": 2232,
                                "label": "峨眉山市",
                                "value": "511181"
                            }
                        ],
                        "father": "51",
                        "id": 247,
                        "label": "乐山市",
                        "value": "5111"
                    },
                    {
                        "children": [
                            {
                                "father": "5113",
                                "id": 2233,
                                "label": "顺庆区",
                                "value": "511302"
                            },
                            {
                                "father": "5113",
                                "id": 2234,
                                "label": "高坪区",
                                "value": "511303"
                            },
                            {
                                "father": "5113",
                                "id": 2235,
                                "label": "嘉陵区",
                                "value": "511304"
                            },
                            {
                                "father": "5113",
                                "id": 2236,
                                "label": "南部县",
                                "value": "511321"
                            },
                            {
                                "father": "5113",
                                "id": 2237,
                                "label": "营山县",
                                "value": "511322"
                            },
                            {
                                "father": "5113",
                                "id": 2238,
                                "label": "蓬安县",
                                "value": "511323"
                            },
                            {
                                "father": "5113",
                                "id": 2239,
                                "label": "仪陇县",
                                "value": "511324"
                            },
                            {
                                "father": "5113",
                                "id": 2240,
                                "label": "西充县",
                                "value": "511325"
                            },
                            {
                                "father": "5113",
                                "id": 2241,
                                "label": "阆中市",
                                "value": "511381"
                            }
                        ],
                        "father": "51",
                        "id": 248,
                        "label": "南充市",
                        "value": "5113"
                    },
                    {
                        "children": [
                            {
                                "father": "5114",
                                "id": 2242,
                                "label": "东坡区",
                                "value": "511402"
                            },
                            {
                                "father": "5114",
                                "id": 2243,
                                "label": "彭山区",
                                "value": "511403"
                            },
                            {
                                "father": "5114",
                                "id": 2244,
                                "label": "仁寿县",
                                "value": "511421"
                            },
                            {
                                "father": "5114",
                                "id": 2245,
                                "label": "洪雅县",
                                "value": "511423"
                            },
                            {
                                "father": "5114",
                                "id": 2246,
                                "label": "丹棱县",
                                "value": "511424"
                            },
                            {
                                "father": "5114",
                                "id": 2247,
                                "label": "青神县",
                                "value": "511425"
                            }
                        ],
                        "father": "51",
                        "id": 249,
                        "label": "眉山市",
                        "value": "5114"
                    },
                    {
                        "children": [
                            {
                                "father": "5115",
                                "id": 2248,
                                "label": "翠屏区",
                                "value": "511502"
                            },
                            {
                                "father": "5115",
                                "id": 2249,
                                "label": "南溪区",
                                "value": "511503"
                            },
                            {
                                "father": "5115",
                                "id": 2250,
                                "label": "叙州区",
                                "value": "511504"
                            },
                            {
                                "father": "5115",
                                "id": 2251,
                                "label": "江安县",
                                "value": "511523"
                            },
                            {
                                "father": "5115",
                                "id": 2252,
                                "label": "长宁县",
                                "value": "511524"
                            },
                            {
                                "father": "5115",
                                "id": 2253,
                                "label": "高县",
                                "value": "511525"
                            },
                            {
                                "father": "5115",
                                "id": 2254,
                                "label": "珙县",
                                "value": "511526"
                            },
                            {
                                "father": "5115",
                                "id": 2255,
                                "label": "筠连县",
                                "value": "511527"
                            },
                            {
                                "father": "5115",
                                "id": 2256,
                                "label": "兴文县",
                                "value": "511528"
                            },
                            {
                                "father": "5115",
                                "id": 2257,
                                "label": "屏山县",
                                "value": "511529"
                            }
                        ],
                        "father": "51",
                        "id": 250,
                        "label": "宜宾市",
                        "value": "5115"
                    },
                    {
                        "children": [
                            {
                                "father": "5116",
                                "id": 2258,
                                "label": "广安区",
                                "value": "511602"
                            },
                            {
                                "father": "5116",
                                "id": 2259,
                                "label": "前锋区",
                                "value": "511603"
                            },
                            {
                                "father": "5116",
                                "id": 2260,
                                "label": "岳池县",
                                "value": "511621"
                            },
                            {
                                "father": "5116",
                                "id": 2261,
                                "label": "武胜县",
                                "value": "511622"
                            },
                            {
                                "father": "5116",
                                "id": 2262,
                                "label": "邻水县",
                                "value": "511623"
                            },
                            {
                                "father": "5116",
                                "id": 2263,
                                "label": "华蓥市",
                                "value": "511681"
                            }
                        ],
                        "father": "51",
                        "id": 251,
                        "label": "广安市",
                        "value": "5116"
                    },
                    {
                        "children": [
                            {
                                "father": "5117",
                                "id": 2264,
                                "label": "通川区",
                                "value": "511702"
                            },
                            {
                                "father": "5117",
                                "id": 2265,
                                "label": "达川区",
                                "value": "511703"
                            },
                            {
                                "father": "5117",
                                "id": 2266,
                                "label": "宣汉县",
                                "value": "511722"
                            },
                            {
                                "father": "5117",
                                "id": 2267,
                                "label": "开江县",
                                "value": "511723"
                            },
                            {
                                "father": "5117",
                                "id": 2268,
                                "label": "大竹县",
                                "value": "511724"
                            },
                            {
                                "father": "5117",
                                "id": 2269,
                                "label": "渠县",
                                "value": "511725"
                            },
                            {
                                "father": "5117",
                                "id": 2270,
                                "label": "达州经济开发区",
                                "value": "511771"
                            },
                            {
                                "father": "5117",
                                "id": 2271,
                                "label": "万源市",
                                "value": "511781"
                            }
                        ],
                        "father": "51",
                        "id": 252,
                        "label": "达州市",
                        "value": "5117"
                    },
                    {
                        "children": [
                            {
                                "father": "5118",
                                "id": 2272,
                                "label": "雨城区",
                                "value": "511802"
                            },
                            {
                                "father": "5118",
                                "id": 2273,
                                "label": "名山区",
                                "value": "511803"
                            },
                            {
                                "father": "5118",
                                "id": 2274,
                                "label": "荥经县",
                                "value": "511822"
                            },
                            {
                                "father": "5118",
                                "id": 2275,
                                "label": "汉源县",
                                "value": "511823"
                            },
                            {
                                "father": "5118",
                                "id": 2276,
                                "label": "石棉县",
                                "value": "511824"
                            },
                            {
                                "father": "5118",
                                "id": 2277,
                                "label": "天全县",
                                "value": "511825"
                            },
                            {
                                "father": "5118",
                                "id": 2278,
                                "label": "芦山县",
                                "value": "511826"
                            },
                            {
                                "father": "5118",
                                "id": 2279,
                                "label": "宝兴县",
                                "value": "511827"
                            }
                        ],
                        "father": "51",
                        "id": 253,
                        "label": "雅安市",
                        "value": "5118"
                    },
                    {
                        "children": [
                            {
                                "father": "5119",
                                "id": 2280,
                                "label": "巴州区",
                                "value": "511902"
                            },
                            {
                                "father": "5119",
                                "id": 2281,
                                "label": "恩阳区",
                                "value": "511903"
                            },
                            {
                                "father": "5119",
                                "id": 2282,
                                "label": "通江县",
                                "value": "511921"
                            },
                            {
                                "father": "5119",
                                "id": 2283,
                                "label": "南江县",
                                "value": "511922"
                            },
                            {
                                "father": "5119",
                                "id": 2284,
                                "label": "平昌县",
                                "value": "511923"
                            },
                            {
                                "father": "5119",
                                "id": 2285,
                                "label": "巴中经济开发区",
                                "value": "511971"
                            }
                        ],
                        "father": "51",
                        "id": 254,
                        "label": "巴中市",
                        "value": "5119"
                    },
                    {
                        "children": [
                            {
                                "father": "5120",
                                "id": 2286,
                                "label": "雁江区",
                                "value": "512002"
                            },
                            {
                                "father": "5120",
                                "id": 2287,
                                "label": "安岳县",
                                "value": "512021"
                            },
                            {
                                "father": "5120",
                                "id": 2288,
                                "label": "乐至县",
                                "value": "512022"
                            }
                        ],
                        "father": "51",
                        "id": 255,
                        "label": "资阳市",
                        "value": "5120"
                    },
                    {
                        "children": [
                            {
                                "father": "5132",
                                "id": 2289,
                                "label": "马尔康市",
                                "value": "513201"
                            },
                            {
                                "father": "5132",
                                "id": 2290,
                                "label": "汶川县",
                                "value": "513221"
                            },
                            {
                                "father": "5132",
                                "id": 2291,
                                "label": "理县",
                                "value": "513222"
                            },
                            {
                                "father": "5132",
                                "id": 2292,
                                "label": "茂县",
                                "value": "513223"
                            },
                            {
                                "father": "5132",
                                "id": 2293,
                                "label": "松潘县",
                                "value": "513224"
                            },
                            {
                                "father": "5132",
                                "id": 2294,
                                "label": "九寨沟县",
                                "value": "513225"
                            },
                            {
                                "father": "5132",
                                "id": 2295,
                                "label": "金川县",
                                "value": "513226"
                            },
                            {
                                "father": "5132",
                                "id": 2296,
                                "label": "小金县",
                                "value": "513227"
                            },
                            {
                                "father": "5132",
                                "id": 2297,
                                "label": "黑水县",
                                "value": "513228"
                            },
                            {
                                "father": "5132",
                                "id": 2298,
                                "label": "壤塘县",
                                "value": "513230"
                            },
                            {
                                "father": "5132",
                                "id": 2299,
                                "label": "阿坝县",
                                "value": "513231"
                            },
                            {
                                "father": "5132",
                                "id": 2300,
                                "label": "若尔盖县",
                                "value": "513232"
                            },
                            {
                                "father": "5132",
                                "id": 2301,
                                "label": "红原县",
                                "value": "513233"
                            }
                        ],
                        "father": "51",
                        "id": 256,
                        "label": "阿坝藏族羌族自治州",
                        "value": "5132"
                    },
                    {
                        "children": [
                            {
                                "father": "5133",
                                "id": 2302,
                                "label": "康定市",
                                "value": "513301"
                            },
                            {
                                "father": "5133",
                                "id": 2303,
                                "label": "泸定县",
                                "value": "513322"
                            },
                            {
                                "father": "5133",
                                "id": 2304,
                                "label": "丹巴县",
                                "value": "513323"
                            },
                            {
                                "father": "5133",
                                "id": 2305,
                                "label": "九龙县",
                                "value": "513324"
                            },
                            {
                                "father": "5133",
                                "id": 2306,
                                "label": "雅江县",
                                "value": "513325"
                            },
                            {
                                "father": "5133",
                                "id": 2307,
                                "label": "道孚县",
                                "value": "513326"
                            },
                            {
                                "father": "5133",
                                "id": 2308,
                                "label": "炉霍县",
                                "value": "513327"
                            },
                            {
                                "father": "5133",
                                "id": 2309,
                                "label": "甘孜县",
                                "value": "513328"
                            },
                            {
                                "father": "5133",
                                "id": 2310,
                                "label": "新龙县",
                                "value": "513329"
                            },
                            {
                                "father": "5133",
                                "id": 2311,
                                "label": "德格县",
                                "value": "513330"
                            },
                            {
                                "father": "5133",
                                "id": 2312,
                                "label": "白玉县",
                                "value": "513331"
                            },
                            {
                                "father": "5133",
                                "id": 2313,
                                "label": "石渠县",
                                "value": "513332"
                            },
                            {
                                "father": "5133",
                                "id": 2314,
                                "label": "色达县",
                                "value": "513333"
                            },
                            {
                                "father": "5133",
                                "id": 2315,
                                "label": "理塘县",
                                "value": "513334"
                            },
                            {
                                "father": "5133",
                                "id": 2316,
                                "label": "巴塘县",
                                "value": "513335"
                            },
                            {
                                "father": "5133",
                                "id": 2317,
                                "label": "乡城县",
                                "value": "513336"
                            },
                            {
                                "father": "5133",
                                "id": 2318,
                                "label": "稻城县",
                                "value": "513337"
                            },
                            {
                                "father": "5133",
                                "id": 2319,
                                "label": "得荣县",
                                "value": "513338"
                            }
                        ],
                        "father": "51",
                        "id": 257,
                        "label": "甘孜藏族自治州",
                        "value": "5133"
                    },
                    {
                        "children": [
                            {
                                "father": "5134",
                                "id": 2320,
                                "label": "西昌市",
                                "value": "513401"
                            },
                            {
                                "father": "5134",
                                "id": 2321,
                                "label": "木里藏族自治县",
                                "value": "513422"
                            },
                            {
                                "father": "5134",
                                "id": 2322,
                                "label": "盐源县",
                                "value": "513423"
                            },
                            {
                                "father": "5134",
                                "id": 2323,
                                "label": "德昌县",
                                "value": "513424"
                            },
                            {
                                "father": "5134",
                                "id": 2324,
                                "label": "会理县",
                                "value": "513425"
                            },
                            {
                                "father": "5134",
                                "id": 2325,
                                "label": "会东县",
                                "value": "513426"
                            },
                            {
                                "father": "5134",
                                "id": 2326,
                                "label": "宁南县",
                                "value": "513427"
                            },
                            {
                                "father": "5134",
                                "id": 2327,
                                "label": "普格县",
                                "value": "513428"
                            },
                            {
                                "father": "5134",
                                "id": 2328,
                                "label": "布拖县",
                                "value": "513429"
                            },
                            {
                                "father": "5134",
                                "id": 2329,
                                "label": "金阳县",
                                "value": "513430"
                            },
                            {
                                "father": "5134",
                                "id": 2330,
                                "label": "昭觉县",
                                "value": "513431"
                            },
                            {
                                "father": "5134",
                                "id": 2331,
                                "label": "喜德县",
                                "value": "513432"
                            },
                            {
                                "father": "5134",
                                "id": 2332,
                                "label": "冕宁县",
                                "value": "513433"
                            },
                            {
                                "father": "5134",
                                "id": 2333,
                                "label": "越西县",
                                "value": "513434"
                            },
                            {
                                "father": "5134",
                                "id": 2334,
                                "label": "甘洛县",
                                "value": "513435"
                            },
                            {
                                "father": "5134",
                                "id": 2335,
                                "label": "美姑县",
                                "value": "513436"
                            },
                            {
                                "father": "5134",
                                "id": 2336,
                                "label": "雷波县",
                                "value": "513437"
                            }
                        ],
                        "father": "51",
                        "id": 258,
                        "label": "凉山彝族自治州",
                        "value": "5134"
                    }
                ],
                "id": 23,
                "label": "四川省",
                "value": "51"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "5201",
                                "id": 2337,
                                "label": "南明区",
                                "value": "520102"
                            },
                            {
                                "father": "5201",
                                "id": 2338,
                                "label": "云岩区",
                                "value": "520103"
                            },
                            {
                                "father": "5201",
                                "id": 2339,
                                "label": "花溪区",
                                "value": "520111"
                            },
                            {
                                "father": "5201",
                                "id": 2340,
                                "label": "乌当区",
                                "value": "520112"
                            },
                            {
                                "father": "5201",
                                "id": 2341,
                                "label": "白云区",
                                "value": "520113"
                            },
                            {
                                "father": "5201",
                                "id": 2342,
                                "label": "观山湖区",
                                "value": "520115"
                            },
                            {
                                "father": "5201",
                                "id": 2343,
                                "label": "开阳县",
                                "value": "520121"
                            },
                            {
                                "father": "5201",
                                "id": 2344,
                                "label": "息烽县",
                                "value": "520122"
                            },
                            {
                                "father": "5201",
                                "id": 2345,
                                "label": "修文县",
                                "value": "520123"
                            },
                            {
                                "father": "5201",
                                "id": 2346,
                                "label": "清镇市",
                                "value": "520181"
                            }
                        ],
                        "father": "52",
                        "id": 259,
                        "label": "贵阳市",
                        "value": "5201"
                    },
                    {
                        "children": [
                            {
                                "father": "5202",
                                "id": 2347,
                                "label": "钟山区",
                                "value": "520201"
                            },
                            {
                                "father": "5202",
                                "id": 2348,
                                "label": "六枝特区",
                                "value": "520203"
                            },
                            {
                                "father": "5202",
                                "id": 2349,
                                "label": "水城县",
                                "value": "520221"
                            },
                            {
                                "father": "5202",
                                "id": 2350,
                                "label": "盘州市",
                                "value": "520281"
                            }
                        ],
                        "father": "52",
                        "id": 260,
                        "label": "六盘水市",
                        "value": "5202"
                    },
                    {
                        "children": [
                            {
                                "father": "5203",
                                "id": 2351,
                                "label": "红花岗区",
                                "value": "520302"
                            },
                            {
                                "father": "5203",
                                "id": 2352,
                                "label": "汇川区",
                                "value": "520303"
                            },
                            {
                                "father": "5203",
                                "id": 2353,
                                "label": "播州区",
                                "value": "520304"
                            },
                            {
                                "father": "5203",
                                "id": 2354,
                                "label": "桐梓县",
                                "value": "520322"
                            },
                            {
                                "father": "5203",
                                "id": 2355,
                                "label": "绥阳县",
                                "value": "520323"
                            },
                            {
                                "father": "5203",
                                "id": 2356,
                                "label": "正安县",
                                "value": "520324"
                            },
                            {
                                "father": "5203",
                                "id": 2357,
                                "label": "道真仡佬族苗族自治县",
                                "value": "520325"
                            },
                            {
                                "father": "5203",
                                "id": 2358,
                                "label": "务川仡佬族苗族自治县",
                                "value": "520326"
                            },
                            {
                                "father": "5203",
                                "id": 2359,
                                "label": "凤冈县",
                                "value": "520327"
                            },
                            {
                                "father": "5203",
                                "id": 2360,
                                "label": "湄潭县",
                                "value": "520328"
                            },
                            {
                                "father": "5203",
                                "id": 2361,
                                "label": "余庆县",
                                "value": "520329"
                            },
                            {
                                "father": "5203",
                                "id": 2362,
                                "label": "习水县",
                                "value": "520330"
                            },
                            {
                                "father": "5203",
                                "id": 2363,
                                "label": "赤水市",
                                "value": "520381"
                            },
                            {
                                "father": "5203",
                                "id": 2364,
                                "label": "仁怀市",
                                "value": "520382"
                            }
                        ],
                        "father": "52",
                        "id": 261,
                        "label": "遵义市",
                        "value": "5203"
                    },
                    {
                        "children": [
                            {
                                "father": "5204",
                                "id": 2365,
                                "label": "西秀区",
                                "value": "520402"
                            },
                            {
                                "father": "5204",
                                "id": 2366,
                                "label": "平坝区",
                                "value": "520403"
                            },
                            {
                                "father": "5204",
                                "id": 2367,
                                "label": "普定县",
                                "value": "520422"
                            },
                            {
                                "father": "5204",
                                "id": 2368,
                                "label": "镇宁布依族苗族自治县",
                                "value": "520423"
                            },
                            {
                                "father": "5204",
                                "id": 2369,
                                "label": "关岭布依族苗族自治县",
                                "value": "520424"
                            },
                            {
                                "father": "5204",
                                "id": 2370,
                                "label": "紫云苗族布依族自治县",
                                "value": "520425"
                            }
                        ],
                        "father": "52",
                        "id": 262,
                        "label": "安顺市",
                        "value": "5204"
                    },
                    {
                        "children": [
                            {
                                "father": "5205",
                                "id": 2371,
                                "label": "七星关区",
                                "value": "520502"
                            },
                            {
                                "father": "5205",
                                "id": 2372,
                                "label": "大方县",
                                "value": "520521"
                            },
                            {
                                "father": "5205",
                                "id": 2373,
                                "label": "黔西县",
                                "value": "520522"
                            },
                            {
                                "father": "5205",
                                "id": 2374,
                                "label": "金沙县",
                                "value": "520523"
                            },
                            {
                                "father": "5205",
                                "id": 2375,
                                "label": "织金县",
                                "value": "520524"
                            },
                            {
                                "father": "5205",
                                "id": 2376,
                                "label": "纳雍县",
                                "value": "520525"
                            },
                            {
                                "father": "5205",
                                "id": 2377,
                                "label": "威宁彝族回族苗族自治县",
                                "value": "520526"
                            },
                            {
                                "father": "5205",
                                "id": 2378,
                                "label": "赫章县",
                                "value": "520527"
                            }
                        ],
                        "father": "52",
                        "id": 263,
                        "label": "毕节市",
                        "value": "5205"
                    },
                    {
                        "children": [
                            {
                                "father": "5206",
                                "id": 2379,
                                "label": "碧江区",
                                "value": "520602"
                            },
                            {
                                "father": "5206",
                                "id": 2380,
                                "label": "万山区",
                                "value": "520603"
                            },
                            {
                                "father": "5206",
                                "id": 2381,
                                "label": "江口县",
                                "value": "520621"
                            },
                            {
                                "father": "5206",
                                "id": 2382,
                                "label": "玉屏侗族自治县",
                                "value": "520622"
                            },
                            {
                                "father": "5206",
                                "id": 2383,
                                "label": "石阡县",
                                "value": "520623"
                            },
                            {
                                "father": "5206",
                                "id": 2384,
                                "label": "思南县",
                                "value": "520624"
                            },
                            {
                                "father": "5206",
                                "id": 2385,
                                "label": "印江土家族苗族自治县",
                                "value": "520625"
                            },
                            {
                                "father": "5206",
                                "id": 2386,
                                "label": "德江县",
                                "value": "520626"
                            },
                            {
                                "father": "5206",
                                "id": 2387,
                                "label": "沿河土家族自治县",
                                "value": "520627"
                            },
                            {
                                "father": "5206",
                                "id": 2388,
                                "label": "松桃苗族自治县",
                                "value": "520628"
                            }
                        ],
                        "father": "52",
                        "id": 264,
                        "label": "铜仁市",
                        "value": "5206"
                    },
                    {
                        "children": [
                            {
                                "father": "5223",
                                "id": 2389,
                                "label": "兴义市",
                                "value": "522301"
                            },
                            {
                                "father": "5223",
                                "id": 2390,
                                "label": "兴仁市",
                                "value": "522302"
                            },
                            {
                                "father": "5223",
                                "id": 2391,
                                "label": "普安县",
                                "value": "522323"
                            },
                            {
                                "father": "5223",
                                "id": 2392,
                                "label": "晴隆县",
                                "value": "522324"
                            },
                            {
                                "father": "5223",
                                "id": 2393,
                                "label": "贞丰县",
                                "value": "522325"
                            },
                            {
                                "father": "5223",
                                "id": 2394,
                                "label": "望谟县",
                                "value": "522326"
                            },
                            {
                                "father": "5223",
                                "id": 2395,
                                "label": "册亨县",
                                "value": "522327"
                            },
                            {
                                "father": "5223",
                                "id": 2396,
                                "label": "安龙县",
                                "value": "522328"
                            }
                        ],
                        "father": "52",
                        "id": 265,
                        "label": "黔西南布依族苗族自治州",
                        "value": "5223"
                    },
                    {
                        "children": [
                            {
                                "father": "5226",
                                "id": 2397,
                                "label": "凯里市",
                                "value": "522601"
                            },
                            {
                                "father": "5226",
                                "id": 2398,
                                "label": "黄平县",
                                "value": "522622"
                            },
                            {
                                "father": "5226",
                                "id": 2399,
                                "label": "施秉县",
                                "value": "522623"
                            },
                            {
                                "father": "5226",
                                "id": 2400,
                                "label": "三穗县",
                                "value": "522624"
                            },
                            {
                                "father": "5226",
                                "id": 2401,
                                "label": "镇远县",
                                "value": "522625"
                            },
                            {
                                "father": "5226",
                                "id": 2402,
                                "label": "岑巩县",
                                "value": "522626"
                            },
                            {
                                "father": "5226",
                                "id": 2403,
                                "label": "天柱县",
                                "value": "522627"
                            },
                            {
                                "father": "5226",
                                "id": 2404,
                                "label": "锦屏县",
                                "value": "522628"
                            },
                            {
                                "father": "5226",
                                "id": 2405,
                                "label": "剑河县",
                                "value": "522629"
                            },
                            {
                                "father": "5226",
                                "id": 2406,
                                "label": "台江县",
                                "value": "522630"
                            },
                            {
                                "father": "5226",
                                "id": 2407,
                                "label": "黎平县",
                                "value": "522631"
                            },
                            {
                                "father": "5226",
                                "id": 2408,
                                "label": "榕江县",
                                "value": "522632"
                            },
                            {
                                "father": "5226",
                                "id": 2409,
                                "label": "从江县",
                                "value": "522633"
                            },
                            {
                                "father": "5226",
                                "id": 2410,
                                "label": "雷山县",
                                "value": "522634"
                            },
                            {
                                "father": "5226",
                                "id": 2411,
                                "label": "麻江县",
                                "value": "522635"
                            },
                            {
                                "father": "5226",
                                "id": 2412,
                                "label": "丹寨县",
                                "value": "522636"
                            }
                        ],
                        "father": "52",
                        "id": 266,
                        "label": "黔东南苗族侗族自治州",
                        "value": "5226"
                    },
                    {
                        "children": [
                            {
                                "father": "5227",
                                "id": 2413,
                                "label": "都匀市",
                                "value": "522701"
                            },
                            {
                                "father": "5227",
                                "id": 2414,
                                "label": "福泉市",
                                "value": "522702"
                            },
                            {
                                "father": "5227",
                                "id": 2415,
                                "label": "荔波县",
                                "value": "522722"
                            },
                            {
                                "father": "5227",
                                "id": 2416,
                                "label": "贵定县",
                                "value": "522723"
                            },
                            {
                                "father": "5227",
                                "id": 2417,
                                "label": "瓮安县",
                                "value": "522725"
                            },
                            {
                                "father": "5227",
                                "id": 2418,
                                "label": "独山县",
                                "value": "522726"
                            },
                            {
                                "father": "5227",
                                "id": 2419,
                                "label": "平塘县",
                                "value": "522727"
                            },
                            {
                                "father": "5227",
                                "id": 2420,
                                "label": "罗甸县",
                                "value": "522728"
                            },
                            {
                                "father": "5227",
                                "id": 2421,
                                "label": "长顺县",
                                "value": "522729"
                            },
                            {
                                "father": "5227",
                                "id": 2422,
                                "label": "龙里县",
                                "value": "522730"
                            },
                            {
                                "father": "5227",
                                "id": 2423,
                                "label": "惠水县",
                                "value": "522731"
                            },
                            {
                                "father": "5227",
                                "id": 2424,
                                "label": "三都水族自治县",
                                "value": "522732"
                            }
                        ],
                        "father": "52",
                        "id": 267,
                        "label": "黔南布依族苗族自治州",
                        "value": "5227"
                    }
                ],
                "id": 24,
                "label": "贵州省",
                "value": "52"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "5301",
                                "id": 2425,
                                "label": "五华区",
                                "value": "530102"
                            },
                            {
                                "father": "5301",
                                "id": 2426,
                                "label": "盘龙区",
                                "value": "530103"
                            },
                            {
                                "father": "5301",
                                "id": 2427,
                                "label": "官渡区",
                                "value": "530111"
                            },
                            {
                                "father": "5301",
                                "id": 2428,
                                "label": "西山区",
                                "value": "530112"
                            },
                            {
                                "father": "5301",
                                "id": 2429,
                                "label": "东川区",
                                "value": "530113"
                            },
                            {
                                "father": "5301",
                                "id": 2430,
                                "label": "呈贡区",
                                "value": "530114"
                            },
                            {
                                "father": "5301",
                                "id": 2431,
                                "label": "晋宁区",
                                "value": "530115"
                            },
                            {
                                "father": "5301",
                                "id": 2432,
                                "label": "富民县",
                                "value": "530124"
                            },
                            {
                                "father": "5301",
                                "id": 2433,
                                "label": "宜良县",
                                "value": "530125"
                            },
                            {
                                "father": "5301",
                                "id": 2434,
                                "label": "石林彝族自治县",
                                "value": "530126"
                            },
                            {
                                "father": "5301",
                                "id": 2435,
                                "label": "嵩明县",
                                "value": "530127"
                            },
                            {
                                "father": "5301",
                                "id": 2436,
                                "label": "禄劝彝族苗族自治县",
                                "value": "530128"
                            },
                            {
                                "father": "5301",
                                "id": 2437,
                                "label": "寻甸回族彝族自治县",
                                "value": "530129"
                            },
                            {
                                "father": "5301",
                                "id": 2438,
                                "label": "安宁市",
                                "value": "530181"
                            }
                        ],
                        "father": "53",
                        "id": 268,
                        "label": "昆明市",
                        "value": "5301"
                    },
                    {
                        "children": [
                            {
                                "father": "5303",
                                "id": 2439,
                                "label": "麒麟区",
                                "value": "530302"
                            },
                            {
                                "father": "5303",
                                "id": 2440,
                                "label": "沾益区",
                                "value": "530303"
                            },
                            {
                                "father": "5303",
                                "id": 2441,
                                "label": "马龙区",
                                "value": "530304"
                            },
                            {
                                "father": "5303",
                                "id": 2442,
                                "label": "陆良县",
                                "value": "530322"
                            },
                            {
                                "father": "5303",
                                "id": 2443,
                                "label": "师宗县",
                                "value": "530323"
                            },
                            {
                                "father": "5303",
                                "id": 2444,
                                "label": "罗平县",
                                "value": "530324"
                            },
                            {
                                "father": "5303",
                                "id": 2445,
                                "label": "富源县",
                                "value": "530325"
                            },
                            {
                                "father": "5303",
                                "id": 2446,
                                "label": "会泽县",
                                "value": "530326"
                            },
                            {
                                "father": "5303",
                                "id": 2447,
                                "label": "宣威市",
                                "value": "530381"
                            }
                        ],
                        "father": "53",
                        "id": 269,
                        "label": "曲靖市",
                        "value": "5303"
                    },
                    {
                        "children": [
                            {
                                "father": "5304",
                                "id": 2448,
                                "label": "红塔区",
                                "value": "530402"
                            },
                            {
                                "father": "5304",
                                "id": 2449,
                                "label": "江川区",
                                "value": "530403"
                            },
                            {
                                "father": "5304",
                                "id": 2450,
                                "label": "澄江县",
                                "value": "530422"
                            },
                            {
                                "father": "5304",
                                "id": 2451,
                                "label": "通海县",
                                "value": "530423"
                            },
                            {
                                "father": "5304",
                                "id": 2452,
                                "label": "华宁县",
                                "value": "530424"
                            },
                            {
                                "father": "5304",
                                "id": 2453,
                                "label": "易门县",
                                "value": "530425"
                            },
                            {
                                "father": "5304",
                                "id": 2454,
                                "label": "峨山彝族自治县",
                                "value": "530426"
                            },
                            {
                                "father": "5304",
                                "id": 2455,
                                "label": "新平彝族傣族自治县",
                                "value": "530427"
                            },
                            {
                                "father": "5304",
                                "id": 2456,
                                "label": "元江哈尼族彝族傣族自治县",
                                "value": "530428"
                            }
                        ],
                        "father": "53",
                        "id": 270,
                        "label": "玉溪市",
                        "value": "5304"
                    },
                    {
                        "children": [
                            {
                                "father": "5305",
                                "id": 2457,
                                "label": "隆阳区",
                                "value": "530502"
                            },
                            {
                                "father": "5305",
                                "id": 2458,
                                "label": "施甸县",
                                "value": "530521"
                            },
                            {
                                "father": "5305",
                                "id": 2459,
                                "label": "龙陵县",
                                "value": "530523"
                            },
                            {
                                "father": "5305",
                                "id": 2460,
                                "label": "昌宁县",
                                "value": "530524"
                            },
                            {
                                "father": "5305",
                                "id": 2461,
                                "label": "腾冲市",
                                "value": "530581"
                            }
                        ],
                        "father": "53",
                        "id": 271,
                        "label": "保山市",
                        "value": "5305"
                    },
                    {
                        "children": [
                            {
                                "father": "5306",
                                "id": 2462,
                                "label": "昭阳区",
                                "value": "530602"
                            },
                            {
                                "father": "5306",
                                "id": 2463,
                                "label": "鲁甸县",
                                "value": "530621"
                            },
                            {
                                "father": "5306",
                                "id": 2464,
                                "label": "巧家县",
                                "value": "530622"
                            },
                            {
                                "father": "5306",
                                "id": 2465,
                                "label": "盐津县",
                                "value": "530623"
                            },
                            {
                                "father": "5306",
                                "id": 2466,
                                "label": "大关县",
                                "value": "530624"
                            },
                            {
                                "father": "5306",
                                "id": 2467,
                                "label": "永善县",
                                "value": "530625"
                            },
                            {
                                "father": "5306",
                                "id": 2468,
                                "label": "绥江县",
                                "value": "530626"
                            },
                            {
                                "father": "5306",
                                "id": 2469,
                                "label": "镇雄县",
                                "value": "530627"
                            },
                            {
                                "father": "5306",
                                "id": 2470,
                                "label": "彝良县",
                                "value": "530628"
                            },
                            {
                                "father": "5306",
                                "id": 2471,
                                "label": "威信县",
                                "value": "530629"
                            },
                            {
                                "father": "5306",
                                "id": 2472,
                                "label": "水富市",
                                "value": "530681"
                            }
                        ],
                        "father": "53",
                        "id": 272,
                        "label": "昭通市",
                        "value": "5306"
                    },
                    {
                        "children": [
                            {
                                "father": "5307",
                                "id": 2473,
                                "label": "古城区",
                                "value": "530702"
                            },
                            {
                                "father": "5307",
                                "id": 2474,
                                "label": "玉龙纳西族自治县",
                                "value": "530721"
                            },
                            {
                                "father": "5307",
                                "id": 2475,
                                "label": "永胜县",
                                "value": "530722"
                            },
                            {
                                "father": "5307",
                                "id": 2476,
                                "label": "华坪县",
                                "value": "530723"
                            },
                            {
                                "father": "5307",
                                "id": 2477,
                                "label": "宁蒗彝族自治县",
                                "value": "530724"
                            }
                        ],
                        "father": "53",
                        "id": 273,
                        "label": "丽江市",
                        "value": "5307"
                    },
                    {
                        "children": [
                            {
                                "father": "5308",
                                "id": 2478,
                                "label": "思茅区",
                                "value": "530802"
                            },
                            {
                                "father": "5308",
                                "id": 2479,
                                "label": "宁洱哈尼族彝族自治县",
                                "value": "530821"
                            },
                            {
                                "father": "5308",
                                "id": 2480,
                                "label": "墨江哈尼族自治县",
                                "value": "530822"
                            },
                            {
                                "father": "5308",
                                "id": 2481,
                                "label": "景东彝族自治县",
                                "value": "530823"
                            },
                            {
                                "father": "5308",
                                "id": 2482,
                                "label": "景谷傣族彝族自治县",
                                "value": "530824"
                            },
                            {
                                "father": "5308",
                                "id": 2483,
                                "label": "镇沅彝族哈尼族拉祜族自治县",
                                "value": "530825"
                            },
                            {
                                "father": "5308",
                                "id": 2484,
                                "label": "江城哈尼族彝族自治县",
                                "value": "530826"
                            },
                            {
                                "father": "5308",
                                "id": 2485,
                                "label": "孟连傣族拉祜族佤族自治县",
                                "value": "530827"
                            },
                            {
                                "father": "5308",
                                "id": 2486,
                                "label": "澜沧拉祜族自治县",
                                "value": "530828"
                            },
                            {
                                "father": "5308",
                                "id": 2487,
                                "label": "西盟佤族自治县",
                                "value": "530829"
                            }
                        ],
                        "father": "53",
                        "id": 274,
                        "label": "普洱市",
                        "value": "5308"
                    },
                    {
                        "children": [
                            {
                                "father": "5309",
                                "id": 2488,
                                "label": "临翔区",
                                "value": "530902"
                            },
                            {
                                "father": "5309",
                                "id": 2489,
                                "label": "凤庆县",
                                "value": "530921"
                            },
                            {
                                "father": "5309",
                                "id": 2490,
                                "label": "云县",
                                "value": "530922"
                            },
                            {
                                "father": "5309",
                                "id": 2491,
                                "label": "永德县",
                                "value": "530923"
                            },
                            {
                                "father": "5309",
                                "id": 2492,
                                "label": "镇康县",
                                "value": "530924"
                            },
                            {
                                "father": "5309",
                                "id": 2493,
                                "label": "双江拉祜族佤族布朗族傣族自治县",
                                "value": "530925"
                            },
                            {
                                "father": "5309",
                                "id": 2494,
                                "label": "耿马傣族佤族自治县",
                                "value": "530926"
                            },
                            {
                                "father": "5309",
                                "id": 2495,
                                "label": "沧源佤族自治县",
                                "value": "530927"
                            }
                        ],
                        "father": "53",
                        "id": 275,
                        "label": "临沧市",
                        "value": "5309"
                    },
                    {
                        "children": [
                            {
                                "father": "5323",
                                "id": 2496,
                                "label": "楚雄市",
                                "value": "532301"
                            },
                            {
                                "father": "5323",
                                "id": 2497,
                                "label": "双柏县",
                                "value": "532322"
                            },
                            {
                                "father": "5323",
                                "id": 2498,
                                "label": "牟定县",
                                "value": "532323"
                            },
                            {
                                "father": "5323",
                                "id": 2499,
                                "label": "南华县",
                                "value": "532324"
                            },
                            {
                                "father": "5323",
                                "id": 2500,
                                "label": "姚安县",
                                "value": "532325"
                            },
                            {
                                "father": "5323",
                                "id": 2501,
                                "label": "大姚县",
                                "value": "532326"
                            },
                            {
                                "father": "5323",
                                "id": 2502,
                                "label": "永仁县",
                                "value": "532327"
                            },
                            {
                                "father": "5323",
                                "id": 2503,
                                "label": "元谋县",
                                "value": "532328"
                            },
                            {
                                "father": "5323",
                                "id": 2504,
                                "label": "武定县",
                                "value": "532329"
                            },
                            {
                                "father": "5323",
                                "id": 2505,
                                "label": "禄丰县",
                                "value": "532331"
                            }
                        ],
                        "father": "53",
                        "id": 276,
                        "label": "楚雄彝族自治州",
                        "value": "5323"
                    },
                    {
                        "children": [
                            {
                                "father": "5325",
                                "id": 2506,
                                "label": "个旧市",
                                "value": "532501"
                            },
                            {
                                "father": "5325",
                                "id": 2507,
                                "label": "开远市",
                                "value": "532502"
                            },
                            {
                                "father": "5325",
                                "id": 2508,
                                "label": "蒙自市",
                                "value": "532503"
                            },
                            {
                                "father": "5325",
                                "id": 2509,
                                "label": "弥勒市",
                                "value": "532504"
                            },
                            {
                                "father": "5325",
                                "id": 2510,
                                "label": "屏边苗族自治县",
                                "value": "532523"
                            },
                            {
                                "father": "5325",
                                "id": 2511,
                                "label": "建水县",
                                "value": "532524"
                            },
                            {
                                "father": "5325",
                                "id": 2512,
                                "label": "石屏县",
                                "value": "532525"
                            },
                            {
                                "father": "5325",
                                "id": 2513,
                                "label": "泸西县",
                                "value": "532527"
                            },
                            {
                                "father": "5325",
                                "id": 2514,
                                "label": "元阳县",
                                "value": "532528"
                            },
                            {
                                "father": "5325",
                                "id": 2515,
                                "label": "红河县",
                                "value": "532529"
                            },
                            {
                                "father": "5325",
                                "id": 2516,
                                "label": "金平苗族瑶族傣族自治县",
                                "value": "532530"
                            },
                            {
                                "father": "5325",
                                "id": 2517,
                                "label": "绿春县",
                                "value": "532531"
                            },
                            {
                                "father": "5325",
                                "id": 2518,
                                "label": "河口瑶族自治县",
                                "value": "532532"
                            }
                        ],
                        "father": "53",
                        "id": 277,
                        "label": "红河哈尼族彝族自治州",
                        "value": "5325"
                    },
                    {
                        "children": [
                            {
                                "father": "5326",
                                "id": 2519,
                                "label": "文山市",
                                "value": "532601"
                            },
                            {
                                "father": "5326",
                                "id": 2520,
                                "label": "砚山县",
                                "value": "532622"
                            },
                            {
                                "father": "5326",
                                "id": 2521,
                                "label": "西畴县",
                                "value": "532623"
                            },
                            {
                                "father": "5326",
                                "id": 2522,
                                "label": "麻栗坡县",
                                "value": "532624"
                            },
                            {
                                "father": "5326",
                                "id": 2523,
                                "label": "马关县",
                                "value": "532625"
                            },
                            {
                                "father": "5326",
                                "id": 2524,
                                "label": "丘北县",
                                "value": "532626"
                            },
                            {
                                "father": "5326",
                                "id": 2525,
                                "label": "广南县",
                                "value": "532627"
                            },
                            {
                                "father": "5326",
                                "id": 2526,
                                "label": "富宁县",
                                "value": "532628"
                            }
                        ],
                        "father": "53",
                        "id": 278,
                        "label": "文山壮族苗族自治州",
                        "value": "5326"
                    },
                    {
                        "children": [
                            {
                                "father": "5328",
                                "id": 2527,
                                "label": "景洪市",
                                "value": "532801"
                            },
                            {
                                "father": "5328",
                                "id": 2528,
                                "label": "勐海县",
                                "value": "532822"
                            },
                            {
                                "father": "5328",
                                "id": 2529,
                                "label": "勐腊县",
                                "value": "532823"
                            }
                        ],
                        "father": "53",
                        "id": 279,
                        "label": "西双版纳傣族自治州",
                        "value": "5328"
                    },
                    {
                        "children": [
                            {
                                "father": "5329",
                                "id": 2530,
                                "label": "大理市",
                                "value": "532901"
                            },
                            {
                                "father": "5329",
                                "id": 2531,
                                "label": "漾濞彝族自治县",
                                "value": "532922"
                            },
                            {
                                "father": "5329",
                                "id": 2532,
                                "label": "祥云县",
                                "value": "532923"
                            },
                            {
                                "father": "5329",
                                "id": 2533,
                                "label": "宾川县",
                                "value": "532924"
                            },
                            {
                                "father": "5329",
                                "id": 2534,
                                "label": "弥渡县",
                                "value": "532925"
                            },
                            {
                                "father": "5329",
                                "id": 2535,
                                "label": "南涧彝族自治县",
                                "value": "532926"
                            },
                            {
                                "father": "5329",
                                "id": 2536,
                                "label": "巍山彝族回族自治县",
                                "value": "532927"
                            },
                            {
                                "father": "5329",
                                "id": 2537,
                                "label": "永平县",
                                "value": "532928"
                            },
                            {
                                "father": "5329",
                                "id": 2538,
                                "label": "云龙县",
                                "value": "532929"
                            },
                            {
                                "father": "5329",
                                "id": 2539,
                                "label": "洱源县",
                                "value": "532930"
                            },
                            {
                                "father": "5329",
                                "id": 2540,
                                "label": "剑川县",
                                "value": "532931"
                            },
                            {
                                "father": "5329",
                                "id": 2541,
                                "label": "鹤庆县",
                                "value": "532932"
                            }
                        ],
                        "father": "53",
                        "id": 280,
                        "label": "大理白族自治州",
                        "value": "5329"
                    },
                    {
                        "children": [
                            {
                                "father": "5331",
                                "id": 2542,
                                "label": "瑞丽市",
                                "value": "533102"
                            },
                            {
                                "father": "5331",
                                "id": 2543,
                                "label": "芒市",
                                "value": "533103"
                            },
                            {
                                "father": "5331",
                                "id": 2544,
                                "label": "梁河县",
                                "value": "533122"
                            },
                            {
                                "father": "5331",
                                "id": 2545,
                                "label": "盈江县",
                                "value": "533123"
                            },
                            {
                                "father": "5331",
                                "id": 2546,
                                "label": "陇川县",
                                "value": "533124"
                            }
                        ],
                        "father": "53",
                        "id": 281,
                        "label": "德宏傣族景颇族自治州",
                        "value": "5331"
                    },
                    {
                        "children": [
                            {
                                "father": "5333",
                                "id": 2547,
                                "label": "泸水市",
                                "value": "533301"
                            },
                            {
                                "father": "5333",
                                "id": 2548,
                                "label": "福贡县",
                                "value": "533323"
                            },
                            {
                                "father": "5333",
                                "id": 2549,
                                "label": "贡山独龙族怒族自治县",
                                "value": "533324"
                            },
                            {
                                "father": "5333",
                                "id": 2550,
                                "label": "兰坪白族普米族自治县",
                                "value": "533325"
                            }
                        ],
                        "father": "53",
                        "id": 282,
                        "label": "怒江傈僳族自治州",
                        "value": "5333"
                    },
                    {
                        "children": [
                            {
                                "father": "5334",
                                "id": 2551,
                                "label": "香格里拉市",
                                "value": "533401"
                            },
                            {
                                "father": "5334",
                                "id": 2552,
                                "label": "德钦县",
                                "value": "533422"
                            },
                            {
                                "father": "5334",
                                "id": 2553,
                                "label": "维西傈僳族自治县",
                                "value": "533423"
                            }
                        ],
                        "father": "53",
                        "id": 283,
                        "label": "迪庆藏族自治州",
                        "value": "5334"
                    }
                ],
                "id": 25,
                "label": "云南省",
                "value": "53"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "5401",
                                "id": 2554,
                                "label": "城关区",
                                "value": "540102"
                            },
                            {
                                "father": "5401",
                                "id": 2555,
                                "label": "堆龙德庆区",
                                "value": "540103"
                            },
                            {
                                "father": "5401",
                                "id": 2556,
                                "label": "达孜区",
                                "value": "540104"
                            },
                            {
                                "father": "5401",
                                "id": 2557,
                                "label": "林周县",
                                "value": "540121"
                            },
                            {
                                "father": "5401",
                                "id": 2558,
                                "label": "当雄县",
                                "value": "540122"
                            },
                            {
                                "father": "5401",
                                "id": 2559,
                                "label": "尼木县",
                                "value": "540123"
                            },
                            {
                                "father": "5401",
                                "id": 2560,
                                "label": "曲水县",
                                "value": "540124"
                            },
                            {
                                "father": "5401",
                                "id": 2561,
                                "label": "墨竹工卡县",
                                "value": "540127"
                            },
                            {
                                "father": "5401",
                                "id": 2562,
                                "label": "格尔木藏青工业园区",
                                "value": "540171"
                            },
                            {
                                "father": "5401",
                                "id": 2563,
                                "label": "拉萨经济技术开发区",
                                "value": "540172"
                            },
                            {
                                "father": "5401",
                                "id": 2564,
                                "label": "西藏文化旅游创意园区",
                                "value": "540173"
                            },
                            {
                                "father": "5401",
                                "id": 2565,
                                "label": "达孜工业园区",
                                "value": "540174"
                            }
                        ],
                        "father": "54",
                        "id": 284,
                        "label": "拉萨市",
                        "value": "5401"
                    },
                    {
                        "children": [
                            {
                                "father": "5402",
                                "id": 2566,
                                "label": "桑珠孜区",
                                "value": "540202"
                            },
                            {
                                "father": "5402",
                                "id": 2567,
                                "label": "南木林县",
                                "value": "540221"
                            },
                            {
                                "father": "5402",
                                "id": 2568,
                                "label": "江孜县",
                                "value": "540222"
                            },
                            {
                                "father": "5402",
                                "id": 2569,
                                "label": "定日县",
                                "value": "540223"
                            },
                            {
                                "father": "5402",
                                "id": 2570,
                                "label": "萨迦县",
                                "value": "540224"
                            },
                            {
                                "father": "5402",
                                "id": 2571,
                                "label": "拉孜县",
                                "value": "540225"
                            },
                            {
                                "father": "5402",
                                "id": 2572,
                                "label": "昂仁县",
                                "value": "540226"
                            },
                            {
                                "father": "5402",
                                "id": 2573,
                                "label": "谢通门县",
                                "value": "540227"
                            },
                            {
                                "father": "5402",
                                "id": 2574,
                                "label": "白朗县",
                                "value": "540228"
                            },
                            {
                                "father": "5402",
                                "id": 2575,
                                "label": "仁布县",
                                "value": "540229"
                            },
                            {
                                "father": "5402",
                                "id": 2576,
                                "label": "康马县",
                                "value": "540230"
                            },
                            {
                                "father": "5402",
                                "id": 2577,
                                "label": "定结县",
                                "value": "540231"
                            },
                            {
                                "father": "5402",
                                "id": 2578,
                                "label": "仲巴县",
                                "value": "540232"
                            },
                            {
                                "father": "5402",
                                "id": 2579,
                                "label": "亚东县",
                                "value": "540233"
                            },
                            {
                                "father": "5402",
                                "id": 2580,
                                "label": "吉隆县",
                                "value": "540234"
                            },
                            {
                                "father": "5402",
                                "id": 2581,
                                "label": "聂拉木县",
                                "value": "540235"
                            },
                            {
                                "father": "5402",
                                "id": 2582,
                                "label": "萨嘎县",
                                "value": "540236"
                            },
                            {
                                "father": "5402",
                                "id": 2583,
                                "label": "岗巴县",
                                "value": "540237"
                            }
                        ],
                        "father": "54",
                        "id": 285,
                        "label": "日喀则市",
                        "value": "5402"
                    },
                    {
                        "children": [
                            {
                                "father": "5403",
                                "id": 2584,
                                "label": "卡若区",
                                "value": "540302"
                            },
                            {
                                "father": "5403",
                                "id": 2585,
                                "label": "江达县",
                                "value": "540321"
                            },
                            {
                                "father": "5403",
                                "id": 2586,
                                "label": "贡觉县",
                                "value": "540322"
                            },
                            {
                                "father": "5403",
                                "id": 2587,
                                "label": "类乌齐县",
                                "value": "540323"
                            },
                            {
                                "father": "5403",
                                "id": 2588,
                                "label": "丁青县",
                                "value": "540324"
                            },
                            {
                                "father": "5403",
                                "id": 2589,
                                "label": "察雅县",
                                "value": "540325"
                            },
                            {
                                "father": "5403",
                                "id": 2590,
                                "label": "八宿县",
                                "value": "540326"
                            },
                            {
                                "father": "5403",
                                "id": 2591,
                                "label": "左贡县",
                                "value": "540327"
                            },
                            {
                                "father": "5403",
                                "id": 2592,
                                "label": "芒康县",
                                "value": "540328"
                            },
                            {
                                "father": "5403",
                                "id": 2593,
                                "label": "洛隆县",
                                "value": "540329"
                            },
                            {
                                "father": "5403",
                                "id": 2594,
                                "label": "边坝县",
                                "value": "540330"
                            }
                        ],
                        "father": "54",
                        "id": 286,
                        "label": "昌都市",
                        "value": "5403"
                    },
                    {
                        "children": [
                            {
                                "father": "5404",
                                "id": 2595,
                                "label": "巴宜区",
                                "value": "540402"
                            },
                            {
                                "father": "5404",
                                "id": 2596,
                                "label": "工布江达县",
                                "value": "540421"
                            },
                            {
                                "father": "5404",
                                "id": 2597,
                                "label": "米林县",
                                "value": "540422"
                            },
                            {
                                "father": "5404",
                                "id": 2598,
                                "label": "墨脱县",
                                "value": "540423"
                            },
                            {
                                "father": "5404",
                                "id": 2599,
                                "label": "波密县",
                                "value": "540424"
                            },
                            {
                                "father": "5404",
                                "id": 2600,
                                "label": "察隅县",
                                "value": "540425"
                            },
                            {
                                "father": "5404",
                                "id": 2601,
                                "label": "朗县",
                                "value": "540426"
                            }
                        ],
                        "father": "54",
                        "id": 287,
                        "label": "林芝市",
                        "value": "5404"
                    },
                    {
                        "children": [
                            {
                                "father": "5405",
                                "id": 2602,
                                "label": "乃东区",
                                "value": "540502"
                            },
                            {
                                "father": "5405",
                                "id": 2603,
                                "label": "扎囊县",
                                "value": "540521"
                            },
                            {
                                "father": "5405",
                                "id": 2604,
                                "label": "贡嘎县",
                                "value": "540522"
                            },
                            {
                                "father": "5405",
                                "id": 2605,
                                "label": "桑日县",
                                "value": "540523"
                            },
                            {
                                "father": "5405",
                                "id": 2606,
                                "label": "琼结县",
                                "value": "540524"
                            },
                            {
                                "father": "5405",
                                "id": 2607,
                                "label": "曲松县",
                                "value": "540525"
                            },
                            {
                                "father": "5405",
                                "id": 2608,
                                "label": "措美县",
                                "value": "540526"
                            },
                            {
                                "father": "5405",
                                "id": 2609,
                                "label": "洛扎县",
                                "value": "540527"
                            },
                            {
                                "father": "5405",
                                "id": 2610,
                                "label": "加查县",
                                "value": "540528"
                            },
                            {
                                "father": "5405",
                                "id": 2611,
                                "label": "隆子县",
                                "value": "540529"
                            },
                            {
                                "father": "5405",
                                "id": 2612,
                                "label": "错那县",
                                "value": "540530"
                            },
                            {
                                "father": "5405",
                                "id": 2613,
                                "label": "浪卡子县",
                                "value": "540531"
                            }
                        ],
                        "father": "54",
                        "id": 288,
                        "label": "山南市",
                        "value": "5405"
                    },
                    {
                        "children": [
                            {
                                "father": "5406",
                                "id": 2614,
                                "label": "色尼区",
                                "value": "540602"
                            },
                            {
                                "father": "5406",
                                "id": 2615,
                                "label": "嘉黎县",
                                "value": "540621"
                            },
                            {
                                "father": "5406",
                                "id": 2616,
                                "label": "比如县",
                                "value": "540622"
                            },
                            {
                                "father": "5406",
                                "id": 2617,
                                "label": "聂荣县",
                                "value": "540623"
                            },
                            {
                                "father": "5406",
                                "id": 2618,
                                "label": "安多县",
                                "value": "540624"
                            },
                            {
                                "father": "5406",
                                "id": 2619,
                                "label": "申扎县",
                                "value": "540625"
                            },
                            {
                                "father": "5406",
                                "id": 2620,
                                "label": "索县",
                                "value": "540626"
                            },
                            {
                                "father": "5406",
                                "id": 2621,
                                "label": "班戈县",
                                "value": "540627"
                            },
                            {
                                "father": "5406",
                                "id": 2622,
                                "label": "巴青县",
                                "value": "540628"
                            },
                            {
                                "father": "5406",
                                "id": 2623,
                                "label": "尼玛县",
                                "value": "540629"
                            },
                            {
                                "father": "5406",
                                "id": 2624,
                                "label": "双湖县",
                                "value": "540630"
                            }
                        ],
                        "father": "54",
                        "id": 289,
                        "label": "那曲市",
                        "value": "5406"
                    },
                    {
                        "children": [
                            {
                                "father": "5425",
                                "id": 2625,
                                "label": "普兰县",
                                "value": "542521"
                            },
                            {
                                "father": "5425",
                                "id": 2626,
                                "label": "札达县",
                                "value": "542522"
                            },
                            {
                                "father": "5425",
                                "id": 2627,
                                "label": "噶尔县",
                                "value": "542523"
                            },
                            {
                                "father": "5425",
                                "id": 2628,
                                "label": "日土县",
                                "value": "542524"
                            },
                            {
                                "father": "5425",
                                "id": 2629,
                                "label": "革吉县",
                                "value": "542525"
                            },
                            {
                                "father": "5425",
                                "id": 2630,
                                "label": "改则县",
                                "value": "542526"
                            },
                            {
                                "father": "5425",
                                "id": 2631,
                                "label": "措勤县",
                                "value": "542527"
                            }
                        ],
                        "father": "54",
                        "id": 290,
                        "label": "阿里地区",
                        "value": "5425"
                    }
                ],
                "id": 26,
                "label": "西藏自治区",
                "value": "54"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "6101",
                                "id": 2632,
                                "label": "新城区",
                                "value": "610102"
                            },
                            {
                                "father": "6101",
                                "id": 2633,
                                "label": "碑林区",
                                "value": "610103"
                            },
                            {
                                "father": "6101",
                                "id": 2634,
                                "label": "莲湖区",
                                "value": "610104"
                            },
                            {
                                "father": "6101",
                                "id": 2635,
                                "label": "灞桥区",
                                "value": "610111"
                            },
                            {
                                "father": "6101",
                                "id": 2636,
                                "label": "未央区",
                                "value": "610112"
                            },
                            {
                                "father": "6101",
                                "id": 2637,
                                "label": "雁塔区",
                                "value": "610113"
                            },
                            {
                                "father": "6101",
                                "id": 2638,
                                "label": "阎良区",
                                "value": "610114"
                            },
                            {
                                "father": "6101",
                                "id": 2639,
                                "label": "临潼区",
                                "value": "610115"
                            },
                            {
                                "father": "6101",
                                "id": 2640,
                                "label": "长安区",
                                "value": "610116"
                            },
                            {
                                "father": "6101",
                                "id": 2641,
                                "label": "高陵区",
                                "value": "610117"
                            },
                            {
                                "father": "6101",
                                "id": 2642,
                                "label": "鄠邑区",
                                "value": "610118"
                            },
                            {
                                "father": "6101",
                                "id": 2643,
                                "label": "蓝田县",
                                "value": "610122"
                            },
                            {
                                "father": "6101",
                                "id": 2644,
                                "label": "周至县",
                                "value": "610124"
                            }
                        ],
                        "father": "61",
                        "id": 291,
                        "label": "西安市",
                        "value": "6101"
                    },
                    {
                        "children": [
                            {
                                "father": "6102",
                                "id": 2645,
                                "label": "王益区",
                                "value": "610202"
                            },
                            {
                                "father": "6102",
                                "id": 2646,
                                "label": "印台区",
                                "value": "610203"
                            },
                            {
                                "father": "6102",
                                "id": 2647,
                                "label": "耀州区",
                                "value": "610204"
                            },
                            {
                                "father": "6102",
                                "id": 2648,
                                "label": "宜君县",
                                "value": "610222"
                            }
                        ],
                        "father": "61",
                        "id": 292,
                        "label": "铜川市",
                        "value": "6102"
                    },
                    {
                        "children": [
                            {
                                "father": "6103",
                                "id": 2649,
                                "label": "渭滨区",
                                "value": "610302"
                            },
                            {
                                "father": "6103",
                                "id": 2650,
                                "label": "金台区",
                                "value": "610303"
                            },
                            {
                                "father": "6103",
                                "id": 2651,
                                "label": "陈仓区",
                                "value": "610304"
                            },
                            {
                                "father": "6103",
                                "id": 2652,
                                "label": "凤翔县",
                                "value": "610322"
                            },
                            {
                                "father": "6103",
                                "id": 2653,
                                "label": "岐山县",
                                "value": "610323"
                            },
                            {
                                "father": "6103",
                                "id": 2654,
                                "label": "扶风县",
                                "value": "610324"
                            },
                            {
                                "father": "6103",
                                "id": 2655,
                                "label": "眉县",
                                "value": "610326"
                            },
                            {
                                "father": "6103",
                                "id": 2656,
                                "label": "陇县",
                                "value": "610327"
                            },
                            {
                                "father": "6103",
                                "id": 2657,
                                "label": "千阳县",
                                "value": "610328"
                            },
                            {
                                "father": "6103",
                                "id": 2658,
                                "label": "麟游县",
                                "value": "610329"
                            },
                            {
                                "father": "6103",
                                "id": 2659,
                                "label": "凤县",
                                "value": "610330"
                            },
                            {
                                "father": "6103",
                                "id": 2660,
                                "label": "太白县",
                                "value": "610331"
                            }
                        ],
                        "father": "61",
                        "id": 293,
                        "label": "宝鸡市",
                        "value": "6103"
                    },
                    {
                        "children": [
                            {
                                "father": "6104",
                                "id": 2661,
                                "label": "秦都区",
                                "value": "610402"
                            },
                            {
                                "father": "6104",
                                "id": 2662,
                                "label": "杨陵区",
                                "value": "610403"
                            },
                            {
                                "father": "6104",
                                "id": 2663,
                                "label": "渭城区",
                                "value": "610404"
                            },
                            {
                                "father": "6104",
                                "id": 2664,
                                "label": "三原县",
                                "value": "610422"
                            },
                            {
                                "father": "6104",
                                "id": 2665,
                                "label": "泾阳县",
                                "value": "610423"
                            },
                            {
                                "father": "6104",
                                "id": 2666,
                                "label": "乾县",
                                "value": "610424"
                            },
                            {
                                "father": "6104",
                                "id": 2667,
                                "label": "礼泉县",
                                "value": "610425"
                            },
                            {
                                "father": "6104",
                                "id": 2668,
                                "label": "永寿县",
                                "value": "610426"
                            },
                            {
                                "father": "6104",
                                "id": 2669,
                                "label": "长武县",
                                "value": "610428"
                            },
                            {
                                "father": "6104",
                                "id": 2670,
                                "label": "旬邑县",
                                "value": "610429"
                            },
                            {
                                "father": "6104",
                                "id": 2671,
                                "label": "淳化县",
                                "value": "610430"
                            },
                            {
                                "father": "6104",
                                "id": 2672,
                                "label": "武功县",
                                "value": "610431"
                            },
                            {
                                "father": "6104",
                                "id": 2673,
                                "label": "兴平市",
                                "value": "610481"
                            },
                            {
                                "father": "6104",
                                "id": 2674,
                                "label": "彬州市",
                                "value": "610482"
                            }
                        ],
                        "father": "61",
                        "id": 294,
                        "label": "咸阳市",
                        "value": "6104"
                    },
                    {
                        "children": [
                            {
                                "father": "6105",
                                "id": 2675,
                                "label": "临渭区",
                                "value": "610502"
                            },
                            {
                                "father": "6105",
                                "id": 2676,
                                "label": "华州区",
                                "value": "610503"
                            },
                            {
                                "father": "6105",
                                "id": 2677,
                                "label": "潼关县",
                                "value": "610522"
                            },
                            {
                                "father": "6105",
                                "id": 2678,
                                "label": "大荔县",
                                "value": "610523"
                            },
                            {
                                "father": "6105",
                                "id": 2679,
                                "label": "合阳县",
                                "value": "610524"
                            },
                            {
                                "father": "6105",
                                "id": 2680,
                                "label": "澄城县",
                                "value": "610525"
                            },
                            {
                                "father": "6105",
                                "id": 2681,
                                "label": "蒲城县",
                                "value": "610526"
                            },
                            {
                                "father": "6105",
                                "id": 2682,
                                "label": "白水县",
                                "value": "610527"
                            },
                            {
                                "father": "6105",
                                "id": 2683,
                                "label": "富平县",
                                "value": "610528"
                            },
                            {
                                "father": "6105",
                                "id": 2684,
                                "label": "韩城市",
                                "value": "610581"
                            },
                            {
                                "father": "6105",
                                "id": 2685,
                                "label": "华阴市",
                                "value": "610582"
                            }
                        ],
                        "father": "61",
                        "id": 295,
                        "label": "渭南市",
                        "value": "6105"
                    },
                    {
                        "children": [
                            {
                                "father": "6106",
                                "id": 2686,
                                "label": "宝塔区",
                                "value": "610602"
                            },
                            {
                                "father": "6106",
                                "id": 2687,
                                "label": "安塞区",
                                "value": "610603"
                            },
                            {
                                "father": "6106",
                                "id": 2688,
                                "label": "延长县",
                                "value": "610621"
                            },
                            {
                                "father": "6106",
                                "id": 2689,
                                "label": "延川县",
                                "value": "610622"
                            },
                            {
                                "father": "6106",
                                "id": 2690,
                                "label": "志丹县",
                                "value": "610625"
                            },
                            {
                                "father": "6106",
                                "id": 2691,
                                "label": "吴起县",
                                "value": "610626"
                            },
                            {
                                "father": "6106",
                                "id": 2692,
                                "label": "甘泉县",
                                "value": "610627"
                            },
                            {
                                "father": "6106",
                                "id": 2693,
                                "label": "富县",
                                "value": "610628"
                            },
                            {
                                "father": "6106",
                                "id": 2694,
                                "label": "洛川县",
                                "value": "610629"
                            },
                            {
                                "father": "6106",
                                "id": 2695,
                                "label": "宜川县",
                                "value": "610630"
                            },
                            {
                                "father": "6106",
                                "id": 2696,
                                "label": "黄龙县",
                                "value": "610631"
                            },
                            {
                                "father": "6106",
                                "id": 2697,
                                "label": "黄陵县",
                                "value": "610632"
                            },
                            {
                                "father": "6106",
                                "id": 2698,
                                "label": "子长市",
                                "value": "610681"
                            }
                        ],
                        "father": "61",
                        "id": 296,
                        "label": "延安市",
                        "value": "6106"
                    },
                    {
                        "children": [
                            {
                                "father": "6107",
                                "id": 2699,
                                "label": "汉台区",
                                "value": "610702"
                            },
                            {
                                "father": "6107",
                                "id": 2700,
                                "label": "南郑区",
                                "value": "610703"
                            },
                            {
                                "father": "6107",
                                "id": 2701,
                                "label": "城固县",
                                "value": "610722"
                            },
                            {
                                "father": "6107",
                                "id": 2702,
                                "label": "洋县",
                                "value": "610723"
                            },
                            {
                                "father": "6107",
                                "id": 2703,
                                "label": "西乡县",
                                "value": "610724"
                            },
                            {
                                "father": "6107",
                                "id": 2704,
                                "label": "勉县",
                                "value": "610725"
                            },
                            {
                                "father": "6107",
                                "id": 2705,
                                "label": "宁强县",
                                "value": "610726"
                            },
                            {
                                "father": "6107",
                                "id": 2706,
                                "label": "略阳县",
                                "value": "610727"
                            },
                            {
                                "father": "6107",
                                "id": 2707,
                                "label": "镇巴县",
                                "value": "610728"
                            },
                            {
                                "father": "6107",
                                "id": 2708,
                                "label": "留坝县",
                                "value": "610729"
                            },
                            {
                                "father": "6107",
                                "id": 2709,
                                "label": "佛坪县",
                                "value": "610730"
                            }
                        ],
                        "father": "61",
                        "id": 297,
                        "label": "汉中市",
                        "value": "6107"
                    },
                    {
                        "children": [
                            {
                                "father": "6108",
                                "id": 2710,
                                "label": "榆阳区",
                                "value": "610802"
                            },
                            {
                                "father": "6108",
                                "id": 2711,
                                "label": "横山区",
                                "value": "610803"
                            },
                            {
                                "father": "6108",
                                "id": 2712,
                                "label": "府谷县",
                                "value": "610822"
                            },
                            {
                                "father": "6108",
                                "id": 2713,
                                "label": "靖边县",
                                "value": "610824"
                            },
                            {
                                "father": "6108",
                                "id": 2714,
                                "label": "定边县",
                                "value": "610825"
                            },
                            {
                                "father": "6108",
                                "id": 2715,
                                "label": "绥德县",
                                "value": "610826"
                            },
                            {
                                "father": "6108",
                                "id": 2716,
                                "label": "米脂县",
                                "value": "610827"
                            },
                            {
                                "father": "6108",
                                "id": 2717,
                                "label": "佳县",
                                "value": "610828"
                            },
                            {
                                "father": "6108",
                                "id": 2718,
                                "label": "吴堡县",
                                "value": "610829"
                            },
                            {
                                "father": "6108",
                                "id": 2719,
                                "label": "清涧县",
                                "value": "610830"
                            },
                            {
                                "father": "6108",
                                "id": 2720,
                                "label": "子洲县",
                                "value": "610831"
                            },
                            {
                                "father": "6108",
                                "id": 2721,
                                "label": "神木市",
                                "value": "610881"
                            }
                        ],
                        "father": "61",
                        "id": 298,
                        "label": "榆林市",
                        "value": "6108"
                    },
                    {
                        "children": [
                            {
                                "father": "6109",
                                "id": 2722,
                                "label": "汉滨区",
                                "value": "610902"
                            },
                            {
                                "father": "6109",
                                "id": 2723,
                                "label": "汉阴县",
                                "value": "610921"
                            },
                            {
                                "father": "6109",
                                "id": 2724,
                                "label": "石泉县",
                                "value": "610922"
                            },
                            {
                                "father": "6109",
                                "id": 2725,
                                "label": "宁陕县",
                                "value": "610923"
                            },
                            {
                                "father": "6109",
                                "id": 2726,
                                "label": "紫阳县",
                                "value": "610924"
                            },
                            {
                                "father": "6109",
                                "id": 2727,
                                "label": "岚皋县",
                                "value": "610925"
                            },
                            {
                                "father": "6109",
                                "id": 2728,
                                "label": "平利县",
                                "value": "610926"
                            },
                            {
                                "father": "6109",
                                "id": 2729,
                                "label": "镇坪县",
                                "value": "610927"
                            },
                            {
                                "father": "6109",
                                "id": 2730,
                                "label": "旬阳县",
                                "value": "610928"
                            },
                            {
                                "father": "6109",
                                "id": 2731,
                                "label": "白河县",
                                "value": "610929"
                            }
                        ],
                        "father": "61",
                        "id": 299,
                        "label": "安康市",
                        "value": "6109"
                    },
                    {
                        "children": [
                            {
                                "father": "6110",
                                "id": 2732,
                                "label": "商州区",
                                "value": "611002"
                            },
                            {
                                "father": "6110",
                                "id": 2733,
                                "label": "洛南县",
                                "value": "611021"
                            },
                            {
                                "father": "6110",
                                "id": 2734,
                                "label": "丹凤县",
                                "value": "611022"
                            },
                            {
                                "father": "6110",
                                "id": 2735,
                                "label": "商南县",
                                "value": "611023"
                            },
                            {
                                "father": "6110",
                                "id": 2736,
                                "label": "山阳县",
                                "value": "611024"
                            },
                            {
                                "father": "6110",
                                "id": 2737,
                                "label": "镇安县",
                                "value": "611025"
                            },
                            {
                                "father": "6110",
                                "id": 2738,
                                "label": "柞水县",
                                "value": "611026"
                            }
                        ],
                        "father": "61",
                        "id": 300,
                        "label": "商洛市",
                        "value": "6110"
                    }
                ],
                "id": 27,
                "label": "陕西省",
                "value": "61"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "6201",
                                "id": 2739,
                                "label": "城关区",
                                "value": "620102"
                            },
                            {
                                "father": "6201",
                                "id": 2740,
                                "label": "七里河区",
                                "value": "620103"
                            },
                            {
                                "father": "6201",
                                "id": 2741,
                                "label": "西固区",
                                "value": "620104"
                            },
                            {
                                "father": "6201",
                                "id": 2742,
                                "label": "安宁区",
                                "value": "620105"
                            },
                            {
                                "father": "6201",
                                "id": 2743,
                                "label": "红古区",
                                "value": "620111"
                            },
                            {
                                "father": "6201",
                                "id": 2744,
                                "label": "永登县",
                                "value": "620121"
                            },
                            {
                                "father": "6201",
                                "id": 2745,
                                "label": "皋兰县",
                                "value": "620122"
                            },
                            {
                                "father": "6201",
                                "id": 2746,
                                "label": "榆中县",
                                "value": "620123"
                            },
                            {
                                "father": "6201",
                                "id": 2747,
                                "label": "兰州新区",
                                "value": "620171"
                            }
                        ],
                        "father": "62",
                        "id": 301,
                        "label": "兰州市",
                        "value": "6201"
                    },
                    {
                        "children": [
                            {
                                "father": "6202",
                                "id": 2748,
                                "label": "嘉峪关市",
                                "value": "620201"
                            }
                        ],
                        "father": "62",
                        "id": 302,
                        "label": "嘉峪关市",
                        "value": "6202"
                    },
                    {
                        "children": [
                            {
                                "father": "6203",
                                "id": 2749,
                                "label": "金川区",
                                "value": "620302"
                            },
                            {
                                "father": "6203",
                                "id": 2750,
                                "label": "永昌县",
                                "value": "620321"
                            }
                        ],
                        "father": "62",
                        "id": 303,
                        "label": "金昌市",
                        "value": "6203"
                    },
                    {
                        "children": [
                            {
                                "father": "6204",
                                "id": 2751,
                                "label": "白银区",
                                "value": "620402"
                            },
                            {
                                "father": "6204",
                                "id": 2752,
                                "label": "平川区",
                                "value": "620403"
                            },
                            {
                                "father": "6204",
                                "id": 2753,
                                "label": "靖远县",
                                "value": "620421"
                            },
                            {
                                "father": "6204",
                                "id": 2754,
                                "label": "会宁县",
                                "value": "620422"
                            },
                            {
                                "father": "6204",
                                "id": 2755,
                                "label": "景泰县",
                                "value": "620423"
                            }
                        ],
                        "father": "62",
                        "id": 304,
                        "label": "白银市",
                        "value": "6204"
                    },
                    {
                        "children": [
                            {
                                "father": "6205",
                                "id": 2756,
                                "label": "秦州区",
                                "value": "620502"
                            },
                            {
                                "father": "6205",
                                "id": 2757,
                                "label": "麦积区",
                                "value": "620503"
                            },
                            {
                                "father": "6205",
                                "id": 2758,
                                "label": "清水县",
                                "value": "620521"
                            },
                            {
                                "father": "6205",
                                "id": 2759,
                                "label": "秦安县",
                                "value": "620522"
                            },
                            {
                                "father": "6205",
                                "id": 2760,
                                "label": "甘谷县",
                                "value": "620523"
                            },
                            {
                                "father": "6205",
                                "id": 2761,
                                "label": "武山县",
                                "value": "620524"
                            },
                            {
                                "father": "6205",
                                "id": 2762,
                                "label": "张家川回族自治县",
                                "value": "620525"
                            }
                        ],
                        "father": "62",
                        "id": 305,
                        "label": "天水市",
                        "value": "6205"
                    },
                    {
                        "children": [
                            {
                                "father": "6206",
                                "id": 2763,
                                "label": "凉州区",
                                "value": "620602"
                            },
                            {
                                "father": "6206",
                                "id": 2764,
                                "label": "民勤县",
                                "value": "620621"
                            },
                            {
                                "father": "6206",
                                "id": 2765,
                                "label": "古浪县",
                                "value": "620622"
                            },
                            {
                                "father": "6206",
                                "id": 2766,
                                "label": "天祝藏族自治县",
                                "value": "620623"
                            }
                        ],
                        "father": "62",
                        "id": 306,
                        "label": "武威市",
                        "value": "6206"
                    },
                    {
                        "children": [
                            {
                                "father": "6207",
                                "id": 2767,
                                "label": "甘州区",
                                "value": "620702"
                            },
                            {
                                "father": "6207",
                                "id": 2768,
                                "label": "肃南裕固族自治县",
                                "value": "620721"
                            },
                            {
                                "father": "6207",
                                "id": 2769,
                                "label": "民乐县",
                                "value": "620722"
                            },
                            {
                                "father": "6207",
                                "id": 2770,
                                "label": "临泽县",
                                "value": "620723"
                            },
                            {
                                "father": "6207",
                                "id": 2771,
                                "label": "高台县",
                                "value": "620724"
                            },
                            {
                                "father": "6207",
                                "id": 2772,
                                "label": "山丹县",
                                "value": "620725"
                            }
                        ],
                        "father": "62",
                        "id": 307,
                        "label": "张掖市",
                        "value": "6207"
                    },
                    {
                        "children": [
                            {
                                "father": "6208",
                                "id": 2773,
                                "label": "崆峒区",
                                "value": "620802"
                            },
                            {
                                "father": "6208",
                                "id": 2774,
                                "label": "泾川县",
                                "value": "620821"
                            },
                            {
                                "father": "6208",
                                "id": 2775,
                                "label": "灵台县",
                                "value": "620822"
                            },
                            {
                                "father": "6208",
                                "id": 2776,
                                "label": "崇信县",
                                "value": "620823"
                            },
                            {
                                "father": "6208",
                                "id": 2777,
                                "label": "庄浪县",
                                "value": "620825"
                            },
                            {
                                "father": "6208",
                                "id": 2778,
                                "label": "静宁县",
                                "value": "620826"
                            },
                            {
                                "father": "6208",
                                "id": 2779,
                                "label": "华亭市",
                                "value": "620881"
                            }
                        ],
                        "father": "62",
                        "id": 308,
                        "label": "平凉市",
                        "value": "6208"
                    },
                    {
                        "children": [
                            {
                                "father": "6209",
                                "id": 2780,
                                "label": "肃州区",
                                "value": "620902"
                            },
                            {
                                "father": "6209",
                                "id": 2781,
                                "label": "金塔县",
                                "value": "620921"
                            },
                            {
                                "father": "6209",
                                "id": 2782,
                                "label": "瓜州县",
                                "value": "620922"
                            },
                            {
                                "father": "6209",
                                "id": 2783,
                                "label": "肃北蒙古族自治县",
                                "value": "620923"
                            },
                            {
                                "father": "6209",
                                "id": 2784,
                                "label": "阿克塞哈萨克族自治县",
                                "value": "620924"
                            },
                            {
                                "father": "6209",
                                "id": 2785,
                                "label": "玉门市",
                                "value": "620981"
                            },
                            {
                                "father": "6209",
                                "id": 2786,
                                "label": "敦煌市",
                                "value": "620982"
                            }
                        ],
                        "father": "62",
                        "id": 309,
                        "label": "酒泉市",
                        "value": "6209"
                    },
                    {
                        "children": [
                            {
                                "father": "6210",
                                "id": 2787,
                                "label": "西峰区",
                                "value": "621002"
                            },
                            {
                                "father": "6210",
                                "id": 2788,
                                "label": "庆城县",
                                "value": "621021"
                            },
                            {
                                "father": "6210",
                                "id": 2789,
                                "label": "环县",
                                "value": "621022"
                            },
                            {
                                "father": "6210",
                                "id": 2790,
                                "label": "华池县",
                                "value": "621023"
                            },
                            {
                                "father": "6210",
                                "id": 2791,
                                "label": "合水县",
                                "value": "621024"
                            },
                            {
                                "father": "6210",
                                "id": 2792,
                                "label": "正宁县",
                                "value": "621025"
                            },
                            {
                                "father": "6210",
                                "id": 2793,
                                "label": "宁县",
                                "value": "621026"
                            },
                            {
                                "father": "6210",
                                "id": 2794,
                                "label": "镇原县",
                                "value": "621027"
                            }
                        ],
                        "father": "62",
                        "id": 310,
                        "label": "庆阳市",
                        "value": "6210"
                    },
                    {
                        "children": [
                            {
                                "father": "6211",
                                "id": 2795,
                                "label": "安定区",
                                "value": "621102"
                            },
                            {
                                "father": "6211",
                                "id": 2796,
                                "label": "通渭县",
                                "value": "621121"
                            },
                            {
                                "father": "6211",
                                "id": 2797,
                                "label": "陇西县",
                                "value": "621122"
                            },
                            {
                                "father": "6211",
                                "id": 2798,
                                "label": "渭源县",
                                "value": "621123"
                            },
                            {
                                "father": "6211",
                                "id": 2799,
                                "label": "临洮县",
                                "value": "621124"
                            },
                            {
                                "father": "6211",
                                "id": 2800,
                                "label": "漳县",
                                "value": "621125"
                            },
                            {
                                "father": "6211",
                                "id": 2801,
                                "label": "岷县",
                                "value": "621126"
                            }
                        ],
                        "father": "62",
                        "id": 311,
                        "label": "定西市",
                        "value": "6211"
                    },
                    {
                        "children": [
                            {
                                "father": "6212",
                                "id": 2802,
                                "label": "武都区",
                                "value": "621202"
                            },
                            {
                                "father": "6212",
                                "id": 2803,
                                "label": "成县",
                                "value": "621221"
                            },
                            {
                                "father": "6212",
                                "id": 2804,
                                "label": "文县",
                                "value": "621222"
                            },
                            {
                                "father": "6212",
                                "id": 2805,
                                "label": "宕昌县",
                                "value": "621223"
                            },
                            {
                                "father": "6212",
                                "id": 2806,
                                "label": "康县",
                                "value": "621224"
                            },
                            {
                                "father": "6212",
                                "id": 2807,
                                "label": "西和县",
                                "value": "621225"
                            },
                            {
                                "father": "6212",
                                "id": 2808,
                                "label": "礼县",
                                "value": "621226"
                            },
                            {
                                "father": "6212",
                                "id": 2809,
                                "label": "徽县",
                                "value": "621227"
                            },
                            {
                                "father": "6212",
                                "id": 2810,
                                "label": "两当县",
                                "value": "621228"
                            }
                        ],
                        "father": "62",
                        "id": 312,
                        "label": "陇南市",
                        "value": "6212"
                    },
                    {
                        "children": [
                            {
                                "father": "6229",
                                "id": 2811,
                                "label": "临夏市",
                                "value": "622901"
                            },
                            {
                                "father": "6229",
                                "id": 2812,
                                "label": "临夏县",
                                "value": "622921"
                            },
                            {
                                "father": "6229",
                                "id": 2813,
                                "label": "康乐县",
                                "value": "622922"
                            },
                            {
                                "father": "6229",
                                "id": 2814,
                                "label": "永靖县",
                                "value": "622923"
                            },
                            {
                                "father": "6229",
                                "id": 2815,
                                "label": "广河县",
                                "value": "622924"
                            },
                            {
                                "father": "6229",
                                "id": 2816,
                                "label": "和政县",
                                "value": "622925"
                            },
                            {
                                "father": "6229",
                                "id": 2817,
                                "label": "东乡族自治县",
                                "value": "622926"
                            },
                            {
                                "father": "6229",
                                "id": 2818,
                                "label": "积石山保安族东乡族撒拉族自治县",
                                "value": "622927"
                            }
                        ],
                        "father": "62",
                        "id": 313,
                        "label": "临夏回族自治州",
                        "value": "6229"
                    },
                    {
                        "children": [
                            {
                                "father": "6230",
                                "id": 2819,
                                "label": "合作市",
                                "value": "623001"
                            },
                            {
                                "father": "6230",
                                "id": 2820,
                                "label": "临潭县",
                                "value": "623021"
                            },
                            {
                                "father": "6230",
                                "id": 2821,
                                "label": "卓尼县",
                                "value": "623022"
                            },
                            {
                                "father": "6230",
                                "id": 2822,
                                "label": "舟曲县",
                                "value": "623023"
                            },
                            {
                                "father": "6230",
                                "id": 2823,
                                "label": "迭部县",
                                "value": "623024"
                            },
                            {
                                "father": "6230",
                                "id": 2824,
                                "label": "玛曲县",
                                "value": "623025"
                            },
                            {
                                "father": "6230",
                                "id": 2825,
                                "label": "碌曲县",
                                "value": "623026"
                            },
                            {
                                "father": "6230",
                                "id": 2826,
                                "label": "夏河县",
                                "value": "623027"
                            }
                        ],
                        "father": "62",
                        "id": 314,
                        "label": "甘南藏族自治州",
                        "value": "6230"
                    }
                ],
                "id": 28,
                "label": "甘肃省",
                "value": "62"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "6301",
                                "id": 2827,
                                "label": "城东区",
                                "value": "630102"
                            },
                            {
                                "father": "6301",
                                "id": 2828,
                                "label": "城中区",
                                "value": "630103"
                            },
                            {
                                "father": "6301",
                                "id": 2829,
                                "label": "城西区",
                                "value": "630104"
                            },
                            {
                                "father": "6301",
                                "id": 2830,
                                "label": "城北区",
                                "value": "630105"
                            },
                            {
                                "father": "6301",
                                "id": 2831,
                                "label": "大通回族土族自治县",
                                "value": "630121"
                            },
                            {
                                "father": "6301",
                                "id": 2832,
                                "label": "湟中县",
                                "value": "630122"
                            },
                            {
                                "father": "6301",
                                "id": 2833,
                                "label": "湟源县",
                                "value": "630123"
                            }
                        ],
                        "father": "63",
                        "id": 315,
                        "label": "西宁市",
                        "value": "6301"
                    },
                    {
                        "children": [
                            {
                                "father": "6302",
                                "id": 2834,
                                "label": "乐都区",
                                "value": "630202"
                            },
                            {
                                "father": "6302",
                                "id": 2835,
                                "label": "平安区",
                                "value": "630203"
                            },
                            {
                                "father": "6302",
                                "id": 2836,
                                "label": "民和回族土族自治县",
                                "value": "630222"
                            },
                            {
                                "father": "6302",
                                "id": 2837,
                                "label": "互助土族自治县",
                                "value": "630223"
                            },
                            {
                                "father": "6302",
                                "id": 2838,
                                "label": "化隆回族自治县",
                                "value": "630224"
                            },
                            {
                                "father": "6302",
                                "id": 2839,
                                "label": "循化撒拉族自治县",
                                "value": "630225"
                            }
                        ],
                        "father": "63",
                        "id": 316,
                        "label": "海东市",
                        "value": "6302"
                    },
                    {
                        "children": [
                            {
                                "father": "6322",
                                "id": 2840,
                                "label": "门源回族自治县",
                                "value": "632221"
                            },
                            {
                                "father": "6322",
                                "id": 2841,
                                "label": "祁连县",
                                "value": "632222"
                            },
                            {
                                "father": "6322",
                                "id": 2842,
                                "label": "海晏县",
                                "value": "632223"
                            },
                            {
                                "father": "6322",
                                "id": 2843,
                                "label": "刚察县",
                                "value": "632224"
                            }
                        ],
                        "father": "63",
                        "id": 317,
                        "label": "海北藏族自治州",
                        "value": "6322"
                    },
                    {
                        "children": [
                            {
                                "father": "6323",
                                "id": 2844,
                                "label": "同仁县",
                                "value": "632321"
                            },
                            {
                                "father": "6323",
                                "id": 2845,
                                "label": "尖扎县",
                                "value": "632322"
                            },
                            {
                                "father": "6323",
                                "id": 2846,
                                "label": "泽库县",
                                "value": "632323"
                            },
                            {
                                "father": "6323",
                                "id": 2847,
                                "label": "河南蒙古族自治县",
                                "value": "632324"
                            }
                        ],
                        "father": "63",
                        "id": 318,
                        "label": "黄南藏族自治州",
                        "value": "6323"
                    },
                    {
                        "children": [
                            {
                                "father": "6325",
                                "id": 2848,
                                "label": "共和县",
                                "value": "632521"
                            },
                            {
                                "father": "6325",
                                "id": 2849,
                                "label": "同德县",
                                "value": "632522"
                            },
                            {
                                "father": "6325",
                                "id": 2850,
                                "label": "贵德县",
                                "value": "632523"
                            },
                            {
                                "father": "6325",
                                "id": 2851,
                                "label": "兴海县",
                                "value": "632524"
                            },
                            {
                                "father": "6325",
                                "id": 2852,
                                "label": "贵南县",
                                "value": "632525"
                            }
                        ],
                        "father": "63",
                        "id": 319,
                        "label": "海南藏族自治州",
                        "value": "6325"
                    },
                    {
                        "children": [
                            {
                                "father": "6326",
                                "id": 2853,
                                "label": "玛沁县",
                                "value": "632621"
                            },
                            {
                                "father": "6326",
                                "id": 2854,
                                "label": "班玛县",
                                "value": "632622"
                            },
                            {
                                "father": "6326",
                                "id": 2855,
                                "label": "甘德县",
                                "value": "632623"
                            },
                            {
                                "father": "6326",
                                "id": 2856,
                                "label": "达日县",
                                "value": "632624"
                            },
                            {
                                "father": "6326",
                                "id": 2857,
                                "label": "久治县",
                                "value": "632625"
                            },
                            {
                                "father": "6326",
                                "id": 2858,
                                "label": "玛多县",
                                "value": "632626"
                            }
                        ],
                        "father": "63",
                        "id": 320,
                        "label": "果洛藏族自治州",
                        "value": "6326"
                    },
                    {
                        "children": [
                            {
                                "father": "6327",
                                "id": 2859,
                                "label": "玉树市",
                                "value": "632701"
                            },
                            {
                                "father": "6327",
                                "id": 2860,
                                "label": "杂多县",
                                "value": "632722"
                            },
                            {
                                "father": "6327",
                                "id": 2861,
                                "label": "称多县",
                                "value": "632723"
                            },
                            {
                                "father": "6327",
                                "id": 2862,
                                "label": "治多县",
                                "value": "632724"
                            },
                            {
                                "father": "6327",
                                "id": 2863,
                                "label": "囊谦县",
                                "value": "632725"
                            },
                            {
                                "father": "6327",
                                "id": 2864,
                                "label": "曲麻莱县",
                                "value": "632726"
                            }
                        ],
                        "father": "63",
                        "id": 321,
                        "label": "玉树藏族自治州",
                        "value": "6327"
                    },
                    {
                        "children": [
                            {
                                "father": "6328",
                                "id": 2865,
                                "label": "格尔木市",
                                "value": "632801"
                            },
                            {
                                "father": "6328",
                                "id": 2866,
                                "label": "德令哈市",
                                "value": "632802"
                            },
                            {
                                "father": "6328",
                                "id": 2867,
                                "label": "茫崖市",
                                "value": "632803"
                            },
                            {
                                "father": "6328",
                                "id": 2868,
                                "label": "乌兰县",
                                "value": "632821"
                            },
                            {
                                "father": "6328",
                                "id": 2869,
                                "label": "都兰县",
                                "value": "632822"
                            },
                            {
                                "father": "6328",
                                "id": 2870,
                                "label": "天峻县",
                                "value": "632823"
                            },
                            {
                                "father": "6328",
                                "id": 2871,
                                "label": "大柴旦行政委员会",
                                "value": "632857"
                            }
                        ],
                        "father": "63",
                        "id": 322,
                        "label": "海西蒙古族藏族自治州",
                        "value": "6328"
                    }
                ],
                "id": 29,
                "label": "青海省",
                "value": "63"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "6401",
                                "id": 2872,
                                "label": "兴庆区",
                                "value": "640104"
                            },
                            {
                                "father": "6401",
                                "id": 2873,
                                "label": "西夏区",
                                "value": "640105"
                            },
                            {
                                "father": "6401",
                                "id": 2874,
                                "label": "金凤区",
                                "value": "640106"
                            },
                            {
                                "father": "6401",
                                "id": 2875,
                                "label": "永宁县",
                                "value": "640121"
                            },
                            {
                                "father": "6401",
                                "id": 2876,
                                "label": "贺兰县",
                                "value": "640122"
                            },
                            {
                                "father": "6401",
                                "id": 2877,
                                "label": "灵武市",
                                "value": "640181"
                            }
                        ],
                        "father": "64",
                        "id": 323,
                        "label": "银川市",
                        "value": "6401"
                    },
                    {
                        "children": [
                            {
                                "father": "6402",
                                "id": 2878,
                                "label": "大武口区",
                                "value": "640202"
                            },
                            {
                                "father": "6402",
                                "id": 2879,
                                "label": "惠农区",
                                "value": "640205"
                            },
                            {
                                "father": "6402",
                                "id": 2880,
                                "label": "平罗县",
                                "value": "640221"
                            }
                        ],
                        "father": "64",
                        "id": 324,
                        "label": "石嘴山市",
                        "value": "6402"
                    },
                    {
                        "children": [
                            {
                                "father": "6403",
                                "id": 2881,
                                "label": "利通区",
                                "value": "640302"
                            },
                            {
                                "father": "6403",
                                "id": 2882,
                                "label": "红寺堡区",
                                "value": "640303"
                            },
                            {
                                "father": "6403",
                                "id": 2883,
                                "label": "盐池县",
                                "value": "640323"
                            },
                            {
                                "father": "6403",
                                "id": 2884,
                                "label": "同心县",
                                "value": "640324"
                            },
                            {
                                "father": "6403",
                                "id": 2885,
                                "label": "青铜峡市",
                                "value": "640381"
                            }
                        ],
                        "father": "64",
                        "id": 325,
                        "label": "吴忠市",
                        "value": "6403"
                    },
                    {
                        "children": [
                            {
                                "father": "6404",
                                "id": 2886,
                                "label": "原州区",
                                "value": "640402"
                            },
                            {
                                "father": "6404",
                                "id": 2887,
                                "label": "西吉县",
                                "value": "640422"
                            },
                            {
                                "father": "6404",
                                "id": 2888,
                                "label": "隆德县",
                                "value": "640423"
                            },
                            {
                                "father": "6404",
                                "id": 2889,
                                "label": "泾源县",
                                "value": "640424"
                            },
                            {
                                "father": "6404",
                                "id": 2890,
                                "label": "彭阳县",
                                "value": "640425"
                            }
                        ],
                        "father": "64",
                        "id": 326,
                        "label": "固原市",
                        "value": "6404"
                    },
                    {
                        "children": [
                            {
                                "father": "6405",
                                "id": 2891,
                                "label": "沙坡头区",
                                "value": "640502"
                            },
                            {
                                "father": "6405",
                                "id": 2892,
                                "label": "中宁县",
                                "value": "640521"
                            },
                            {
                                "father": "6405",
                                "id": 2893,
                                "label": "海原县",
                                "value": "640522"
                            }
                        ],
                        "father": "64",
                        "id": 327,
                        "label": "中卫市",
                        "value": "6405"
                    }
                ],
                "id": 30,
                "label": "宁夏回族自治区",
                "value": "64"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "6501",
                                "id": 2894,
                                "label": "天山区",
                                "value": "650102"
                            },
                            {
                                "father": "6501",
                                "id": 2895,
                                "label": "沙依巴克区",
                                "value": "650103"
                            },
                            {
                                "father": "6501",
                                "id": 2896,
                                "label": "新市区",
                                "value": "650104"
                            },
                            {
                                "father": "6501",
                                "id": 2897,
                                "label": "水磨沟区",
                                "value": "650105"
                            },
                            {
                                "father": "6501",
                                "id": 2898,
                                "label": "头屯河区",
                                "value": "650106"
                            },
                            {
                                "father": "6501",
                                "id": 2899,
                                "label": "达坂城区",
                                "value": "650107"
                            },
                            {
                                "father": "6501",
                                "id": 2900,
                                "label": "米东区",
                                "value": "650109"
                            },
                            {
                                "father": "6501",
                                "id": 2901,
                                "label": "乌鲁木齐县",
                                "value": "650121"
                            }
                        ],
                        "father": "65",
                        "id": 328,
                        "label": "乌鲁木齐市",
                        "value": "6501"
                    },
                    {
                        "children": [
                            {
                                "father": "6502",
                                "id": 2902,
                                "label": "独山子区",
                                "value": "650202"
                            },
                            {
                                "father": "6502",
                                "id": 2903,
                                "label": "克拉玛依区",
                                "value": "650203"
                            },
                            {
                                "father": "6502",
                                "id": 2904,
                                "label": "白碱滩区",
                                "value": "650204"
                            },
                            {
                                "father": "6502",
                                "id": 2905,
                                "label": "乌尔禾区",
                                "value": "650205"
                            }
                        ],
                        "father": "65",
                        "id": 329,
                        "label": "克拉玛依市",
                        "value": "6502"
                    },
                    {
                        "children": [
                            {
                                "father": "6504",
                                "id": 2906,
                                "label": "高昌区",
                                "value": "650402"
                            },
                            {
                                "father": "6504",
                                "id": 2907,
                                "label": "鄯善县",
                                "value": "650421"
                            },
                            {
                                "father": "6504",
                                "id": 2908,
                                "label": "托克逊县",
                                "value": "650422"
                            }
                        ],
                        "father": "65",
                        "id": 330,
                        "label": "吐鲁番市",
                        "value": "6504"
                    },
                    {
                        "children": [
                            {
                                "father": "6505",
                                "id": 2909,
                                "label": "伊州区",
                                "value": "650502"
                            },
                            {
                                "father": "6505",
                                "id": 2910,
                                "label": "巴里坤哈萨克自治县",
                                "value": "650521"
                            },
                            {
                                "father": "6505",
                                "id": 2911,
                                "label": "伊吾县",
                                "value": "650522"
                            }
                        ],
                        "father": "65",
                        "id": 331,
                        "label": "哈密市",
                        "value": "6505"
                    },
                    {
                        "children": [
                            {
                                "father": "6523",
                                "id": 2912,
                                "label": "昌吉市",
                                "value": "652301"
                            },
                            {
                                "father": "6523",
                                "id": 2913,
                                "label": "阜康市",
                                "value": "652302"
                            },
                            {
                                "father": "6523",
                                "id": 2914,
                                "label": "呼图壁县",
                                "value": "652323"
                            },
                            {
                                "father": "6523",
                                "id": 2915,
                                "label": "玛纳斯县",
                                "value": "652324"
                            },
                            {
                                "father": "6523",
                                "id": 2916,
                                "label": "奇台县",
                                "value": "652325"
                            },
                            {
                                "father": "6523",
                                "id": 2917,
                                "label": "吉木萨尔县",
                                "value": "652327"
                            },
                            {
                                "father": "6523",
                                "id": 2918,
                                "label": "木垒哈萨克自治县",
                                "value": "652328"
                            }
                        ],
                        "father": "65",
                        "id": 332,
                        "label": "昌吉回族自治州",
                        "value": "6523"
                    },
                    {
                        "children": [
                            {
                                "father": "6527",
                                "id": 2919,
                                "label": "博乐市",
                                "value": "652701"
                            },
                            {
                                "father": "6527",
                                "id": 2920,
                                "label": "阿拉山口市",
                                "value": "652702"
                            },
                            {
                                "father": "6527",
                                "id": 2921,
                                "label": "精河县",
                                "value": "652722"
                            },
                            {
                                "father": "6527",
                                "id": 2922,
                                "label": "温泉县",
                                "value": "652723"
                            }
                        ],
                        "father": "65",
                        "id": 333,
                        "label": "博尔塔拉蒙古自治州",
                        "value": "6527"
                    },
                    {
                        "children": [
                            {
                                "father": "6528",
                                "id": 2923,
                                "label": "库尔勒市",
                                "value": "652801"
                            },
                            {
                                "father": "6528",
                                "id": 2924,
                                "label": "轮台县",
                                "value": "652822"
                            },
                            {
                                "father": "6528",
                                "id": 2925,
                                "label": "尉犁县",
                                "value": "652823"
                            },
                            {
                                "father": "6528",
                                "id": 2926,
                                "label": "若羌县",
                                "value": "652824"
                            },
                            {
                                "father": "6528",
                                "id": 2927,
                                "label": "且末县",
                                "value": "652825"
                            },
                            {
                                "father": "6528",
                                "id": 2928,
                                "label": "焉耆回族自治县",
                                "value": "652826"
                            },
                            {
                                "father": "6528",
                                "id": 2929,
                                "label": "和静县",
                                "value": "652827"
                            },
                            {
                                "father": "6528",
                                "id": 2930,
                                "label": "和硕县",
                                "value": "652828"
                            },
                            {
                                "father": "6528",
                                "id": 2931,
                                "label": "博湖县",
                                "value": "652829"
                            },
                            {
                                "father": "6528",
                                "id": 2932,
                                "label": "库尔勒经济技术开发区",
                                "value": "652871"
                            }
                        ],
                        "father": "65",
                        "id": 334,
                        "label": "巴音郭楞蒙古自治州",
                        "value": "6528"
                    },
                    {
                        "children": [
                            {
                                "father": "6529",
                                "id": 2933,
                                "label": "阿克苏市",
                                "value": "652901"
                            },
                            {
                                "father": "6529",
                                "id": 2934,
                                "label": "温宿县",
                                "value": "652922"
                            },
                            {
                                "father": "6529",
                                "id": 2935,
                                "label": "库车县",
                                "value": "652923"
                            },
                            {
                                "father": "6529",
                                "id": 2936,
                                "label": "沙雅县",
                                "value": "652924"
                            },
                            {
                                "father": "6529",
                                "id": 2937,
                                "label": "新和县",
                                "value": "652925"
                            },
                            {
                                "father": "6529",
                                "id": 2938,
                                "label": "拜城县",
                                "value": "652926"
                            },
                            {
                                "father": "6529",
                                "id": 2939,
                                "label": "乌什县",
                                "value": "652927"
                            },
                            {
                                "father": "6529",
                                "id": 2940,
                                "label": "阿瓦提县",
                                "value": "652928"
                            },
                            {
                                "father": "6529",
                                "id": 2941,
                                "label": "柯坪县",
                                "value": "652929"
                            }
                        ],
                        "father": "65",
                        "id": 335,
                        "label": "阿克苏地区",
                        "value": "6529"
                    },
                    {
                        "children": [
                            {
                                "father": "6530",
                                "id": 2942,
                                "label": "阿图什市",
                                "value": "653001"
                            },
                            {
                                "father": "6530",
                                "id": 2943,
                                "label": "阿克陶县",
                                "value": "653022"
                            },
                            {
                                "father": "6530",
                                "id": 2944,
                                "label": "阿合奇县",
                                "value": "653023"
                            },
                            {
                                "father": "6530",
                                "id": 2945,
                                "label": "乌恰县",
                                "value": "653024"
                            }
                        ],
                        "father": "65",
                        "id": 336,
                        "label": "克孜勒苏柯尔克孜自治州",
                        "value": "6530"
                    },
                    {
                        "children": [
                            {
                                "father": "6531",
                                "id": 2946,
                                "label": "喀什市",
                                "value": "653101"
                            },
                            {
                                "father": "6531",
                                "id": 2947,
                                "label": "疏附县",
                                "value": "653121"
                            },
                            {
                                "father": "6531",
                                "id": 2948,
                                "label": "疏勒县",
                                "value": "653122"
                            },
                            {
                                "father": "6531",
                                "id": 2949,
                                "label": "英吉沙县",
                                "value": "653123"
                            },
                            {
                                "father": "6531",
                                "id": 2950,
                                "label": "泽普县",
                                "value": "653124"
                            },
                            {
                                "father": "6531",
                                "id": 2951,
                                "label": "莎车县",
                                "value": "653125"
                            },
                            {
                                "father": "6531",
                                "id": 2952,
                                "label": "叶城县",
                                "value": "653126"
                            },
                            {
                                "father": "6531",
                                "id": 2953,
                                "label": "麦盖提县",
                                "value": "653127"
                            },
                            {
                                "father": "6531",
                                "id": 2954,
                                "label": "岳普湖县",
                                "value": "653128"
                            },
                            {
                                "father": "6531",
                                "id": 2955,
                                "label": "伽师县",
                                "value": "653129"
                            },
                            {
                                "father": "6531",
                                "id": 2956,
                                "label": "巴楚县",
                                "value": "653130"
                            },
                            {
                                "father": "6531",
                                "id": 2957,
                                "label": "塔什库尔干塔吉克自治县",
                                "value": "653131"
                            }
                        ],
                        "father": "65",
                        "id": 337,
                        "label": "喀什地区",
                        "value": "6531"
                    },
                    {
                        "children": [
                            {
                                "father": "6532",
                                "id": 2958,
                                "label": "和田市",
                                "value": "653201"
                            },
                            {
                                "father": "6532",
                                "id": 2959,
                                "label": "和田县",
                                "value": "653221"
                            },
                            {
                                "father": "6532",
                                "id": 2960,
                                "label": "墨玉县",
                                "value": "653222"
                            },
                            {
                                "father": "6532",
                                "id": 2961,
                                "label": "皮山县",
                                "value": "653223"
                            },
                            {
                                "father": "6532",
                                "id": 2962,
                                "label": "洛浦县",
                                "value": "653224"
                            },
                            {
                                "father": "6532",
                                "id": 2963,
                                "label": "策勒县",
                                "value": "653225"
                            },
                            {
                                "father": "6532",
                                "id": 2964,
                                "label": "于田县",
                                "value": "653226"
                            },
                            {
                                "father": "6532",
                                "id": 2965,
                                "label": "民丰县",
                                "value": "653227"
                            }
                        ],
                        "father": "65",
                        "id": 338,
                        "label": "和田地区",
                        "value": "6532"
                    },
                    {
                        "children": [
                            {
                                "father": "6540",
                                "id": 2966,
                                "label": "伊宁市",
                                "value": "654002"
                            },
                            {
                                "father": "6540",
                                "id": 2967,
                                "label": "奎屯市",
                                "value": "654003"
                            },
                            {
                                "father": "6540",
                                "id": 2968,
                                "label": "霍尔果斯市",
                                "value": "654004"
                            },
                            {
                                "father": "6540",
                                "id": 2969,
                                "label": "伊宁县",
                                "value": "654021"
                            },
                            {
                                "father": "6540",
                                "id": 2970,
                                "label": "察布查尔锡伯自治县",
                                "value": "654022"
                            },
                            {
                                "father": "6540",
                                "id": 2971,
                                "label": "霍城县",
                                "value": "654023"
                            },
                            {
                                "father": "6540",
                                "id": 2972,
                                "label": "巩留县",
                                "value": "654024"
                            },
                            {
                                "father": "6540",
                                "id": 2973,
                                "label": "新源县",
                                "value": "654025"
                            },
                            {
                                "father": "6540",
                                "id": 2974,
                                "label": "昭苏县",
                                "value": "654026"
                            },
                            {
                                "father": "6540",
                                "id": 2975,
                                "label": "特克斯县",
                                "value": "654027"
                            },
                            {
                                "father": "6540",
                                "id": 2976,
                                "label": "尼勒克县",
                                "value": "654028"
                            }
                        ],
                        "father": "65",
                        "id": 339,
                        "label": "伊犁哈萨克自治州",
                        "value": "6540"
                    },
                    {
                        "children": [
                            {
                                "father": "6542",
                                "id": 2977,
                                "label": "塔城市",
                                "value": "654201"
                            },
                            {
                                "father": "6542",
                                "id": 2978,
                                "label": "乌苏市",
                                "value": "654202"
                            },
                            {
                                "father": "6542",
                                "id": 2979,
                                "label": "额敏县",
                                "value": "654221"
                            },
                            {
                                "father": "6542",
                                "id": 2980,
                                "label": "沙湾县",
                                "value": "654223"
                            },
                            {
                                "father": "6542",
                                "id": 2981,
                                "label": "托里县",
                                "value": "654224"
                            },
                            {
                                "father": "6542",
                                "id": 2982,
                                "label": "裕民县",
                                "value": "654225"
                            },
                            {
                                "father": "6542",
                                "id": 2983,
                                "label": "和布克赛尔蒙古自治县",
                                "value": "654226"
                            }
                        ],
                        "father": "65",
                        "id": 340,
                        "label": "塔城地区",
                        "value": "6542"
                    },
                    {
                        "children": [
                            {
                                "father": "6543",
                                "id": 2984,
                                "label": "阿勒泰市",
                                "value": "654301"
                            },
                            {
                                "father": "6543",
                                "id": 2985,
                                "label": "布尔津县",
                                "value": "654321"
                            },
                            {
                                "father": "6543",
                                "id": 2986,
                                "label": "富蕴县",
                                "value": "654322"
                            },
                            {
                                "father": "6543",
                                "id": 2987,
                                "label": "福海县",
                                "value": "654323"
                            },
                            {
                                "father": "6543",
                                "id": 2988,
                                "label": "哈巴河县",
                                "value": "654324"
                            },
                            {
                                "father": "6543",
                                "id": 2989,
                                "label": "青河县",
                                "value": "654325"
                            },
                            {
                                "father": "6543",
                                "id": 2990,
                                "label": "吉木乃县",
                                "value": "654326"
                            }
                        ],
                        "father": "65",
                        "id": 341,
                        "label": "阿勒泰地区",
                        "value": "6543"
                    },
                    {
                        "children": [
                            {
                                "father": "6590",
                                "id": 2991,
                                "label": "石河子市",
                                "value": "659001"
                            },
                            {
                                "father": "6590",
                                "id": 2992,
                                "label": "阿拉尔市",
                                "value": "659002"
                            },
                            {
                                "father": "6590",
                                "id": 2993,
                                "label": "图木舒克市",
                                "value": "659003"
                            },
                            {
                                "father": "6590",
                                "id": 2994,
                                "label": "五家渠市",
                                "value": "659004"
                            },
                            {
                                "father": "6590",
                                "id": 2995,
                                "label": "铁门关市",
                                "value": "659006"
                            }
                        ],
                        "father": "65",
                        "id": 342,
                        "label": "自治区直辖县级行政区划",
                        "value": "6590"
                    }
                ],
                "id": 31,
                "label": "新疆维吾尔自治区",
                "value": "65"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "8101",
                                "id": 3021,
                                "label": "中西区",
                                "value": "810101"
                            },
                            {
                                "father": "8101",
                                "id": 3022,
                                "label": "湾仔区",
                                "value": "810102"
                            },
                            {
                                "father": "8101",
                                "id": 3023,
                                "label": "东区",
                                "value": "810103"
                            },
                            {
                                "father": "8101",
                                "id": 3024,
                                "label": "南区",
                                "value": "810104"
                            }
                        ],
                        "father": "81",
                        "id": 346,
                        "label": "香港岛",
                        "value": "8101"
                    },
                    {
                        "children": [
                            {
                                "father": "8102",
                                "id": 3025,
                                "label": "油尖旺区",
                                "value": "810201"
                            },
                            {
                                "father": "8102",
                                "id": 3026,
                                "label": "深水埗区",
                                "value": "810202"
                            },
                            {
                                "father": "8102",
                                "id": 3027,
                                "label": "九龙城区",
                                "value": "810203"
                            },
                            {
                                "father": "8102",
                                "id": 3028,
                                "label": "黄大仙区",
                                "value": "810204"
                            },
                            {
                                "father": "8102",
                                "id": 3029,
                                "label": "观塘区",
                                "value": "810205"
                            }
                        ],
                        "father": "81",
                        "id": 347,
                        "label": "九龙",
                        "value": "8102"
                    },
                    {
                        "children": [
                            {
                                "father": "8103",
                                "id": 3030,
                                "label": "葵青区",
                                "value": "810301"
                            },
                            {
                                "father": "8103",
                                "id": 3031,
                                "label": "荃湾区",
                                "value": "810302"
                            },
                            {
                                "father": "8103",
                                "id": 3032,
                                "label": "屯门区",
                                "value": "810303"
                            },
                            {
                                "father": "8103",
                                "id": 3033,
                                "label": "元朗区",
                                "value": "810304"
                            },
                            {
                                "father": "8103",
                                "id": 3034,
                                "label": "北区",
                                "value": "810305"
                            },
                            {
                                "father": "8103",
                                "id": 3035,
                                "label": "大埔区",
                                "value": "810306"
                            },
                            {
                                "father": "8103",
                                "id": 3036,
                                "label": "沙田区",
                                "value": "810307"
                            },
                            {
                                "father": "8103",
                                "id": 3037,
                                "label": "西贡区",
                                "value": "810308"
                            },
                            {
                                "father": "8103",
                                "id": 3038,
                                "label": "离岛区",
                                "value": "810309"
                            }
                        ],
                        "father": "81",
                        "id": 348,
                        "label": "新界",
                        "value": "8103"
                    }
                ],
                "id": 35,
                "label": "香港特别行政区",
                "value": "81"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "8201",
                                "id": 3039,
                                "label": "大堂区",
                                "value": "820101"
                            },
                            {
                                "father": "8201",
                                "id": 3040,
                                "label": "望德堂区",
                                "value": "820102"
                            },
                            {
                                "father": "8201",
                                "id": 3041,
                                "label": "风顺堂区",
                                "value": "820103"
                            },
                            {
                                "father": "8201",
                                "id": 3042,
                                "label": "花地玛堂区",
                                "value": "820104"
                            },
                            {
                                "father": "8201",
                                "id": 3043,
                                "label": "圣安多尼堂区",
                                "value": "820105"
                            }
                        ],
                        "father": "82",
                        "id": 349,
                        "label": "澳门半岛",
                        "value": "8201"
                    },
                    {
                        "children": [
                            {
                                "father": "8202",
                                "id": 3044,
                                "label": "嘉模堂区（氹仔）",
                                "value": "820201"
                            },
                            {
                                "father": "8202",
                                "id": 3045,
                                "label": "圣方济各堂区（路环）",
                                "value": "820202"
                            }
                        ],
                        "father": "82",
                        "id": 350,
                        "label": "澳门外岛",
                        "value": "8202"
                    }
                ],
                "id": 36,
                "label": "澳门特别行政区",
                "value": "82"
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "father": "7101",
                                "id": 3046,
                                "label": "大安区",
                                "value": "710101"
                            },
                            {
                                "father": "7101",
                                "id": 3047,
                                "label": "内湖区",
                                "value": "710102"
                            },
                            {
                                "father": "7101",
                                "id": 3048,
                                "label": "士林区",
                                "value": "710103"
                            },
                            {
                                "father": "7101",
                                "id": 3049,
                                "label": "文山区",
                                "value": "710104"
                            },
                            {
                                "father": "7101",
                                "id": 3050,
                                "label": "北投区",
                                "value": "710105"
                            },
                            {
                                "father": "7101",
                                "id": 3051,
                                "label": "中山区",
                                "value": "710106"
                            },
                            {
                                "father": "7101",
                                "id": 3052,
                                "label": "信义区",
                                "value": "710107"
                            },
                            {
                                "father": "7101",
                                "id": 3053,
                                "label": "松山区",
                                "value": "710108"
                            },
                            {
                                "father": "7101",
                                "id": 3054,
                                "label": "万华区",
                                "value": "710109"
                            },
                            {
                                "father": "7101",
                                "id": 3055,
                                "label": "中正区",
                                "value": "710110"
                            },
                            {
                                "father": "7101",
                                "id": 3056,
                                "label": "大同区",
                                "value": "710111"
                            },
                            {
                                "father": "7101",
                                "id": 3057,
                                "label": "南港区",
                                "value": "710112"
                            }
                        ],
                        "father": "71",
                        "id": 351,
                        "label": "台北市",
                        "value": "7101"
                    },
                    {
                        "children": [
                            {
                                "father": "7102",
                                "id": 3058,
                                "label": "板桥区",
                                "value": "710201"
                            },
                            {
                                "father": "7102",
                                "id": 3059,
                                "label": "新庄区",
                                "value": "710202"
                            },
                            {
                                "father": "7102",
                                "id": 3060,
                                "label": "中和区",
                                "value": "710203"
                            },
                            {
                                "father": "7102",
                                "id": 3061,
                                "label": "三重区",
                                "value": "710204"
                            },
                            {
                                "father": "7102",
                                "id": 3062,
                                "label": "新店区",
                                "value": "710205"
                            },
                            {
                                "father": "7102",
                                "id": 3063,
                                "label": "土城区",
                                "value": "710206"
                            },
                            {
                                "father": "7102",
                                "id": 3064,
                                "label": "永和区",
                                "value": "710207"
                            },
                            {
                                "father": "7102",
                                "id": 3065,
                                "label": "芦洲区",
                                "value": "710208"
                            },
                            {
                                "father": "7102",
                                "id": 3066,
                                "label": "汐止区",
                                "value": "710209"
                            },
                            {
                                "father": "7102",
                                "id": 3067,
                                "label": "树林区",
                                "value": "710210"
                            },
                            {
                                "father": "7102",
                                "id": 3068,
                                "label": "淡水区",
                                "value": "710211"
                            },
                            {
                                "father": "7102",
                                "id": 3069,
                                "label": "三峡区",
                                "value": "710212"
                            },
                            {
                                "father": "7102",
                                "id": 3070,
                                "label": "林口区",
                                "value": "710213"
                            },
                            {
                                "father": "7102",
                                "id": 3071,
                                "label": "莺歌区",
                                "value": "710214"
                            },
                            {
                                "father": "7102",
                                "id": 3072,
                                "label": "五股区",
                                "value": "710215"
                            },
                            {
                                "father": "7102",
                                "id": 3073,
                                "label": "泰山区",
                                "value": "710216"
                            },
                            {
                                "father": "7102",
                                "id": 3074,
                                "label": "瑞芳区",
                                "value": "710217"
                            },
                            {
                                "father": "7102",
                                "id": 3075,
                                "label": "八里区",
                                "value": "710218"
                            },
                            {
                                "father": "7102",
                                "id": 3076,
                                "label": "深坑区",
                                "value": "710219"
                            },
                            {
                                "father": "7102",
                                "id": 3077,
                                "label": "三芝区",
                                "value": "710220"
                            },
                            {
                                "father": "7102",
                                "id": 3078,
                                "label": "万里区",
                                "value": "710221"
                            },
                            {
                                "father": "7102",
                                "id": 3079,
                                "label": "金山区",
                                "value": "710222"
                            },
                            {
                                "father": "7102",
                                "id": 3080,
                                "label": "贡寮区",
                                "value": "710223"
                            },
                            {
                                "father": "7102",
                                "id": 3081,
                                "label": "石门区",
                                "value": "710224"
                            },
                            {
                                "father": "7102",
                                "id": 3082,
                                "label": "双溪区",
                                "value": "710225"
                            },
                            {
                                "father": "7102",
                                "id": 3083,
                                "label": "石碇区",
                                "value": "710226"
                            },
                            {
                                "father": "7102",
                                "id": 3084,
                                "label": "坪林区",
                                "value": "710227"
                            },
                            {
                                "father": "7102",
                                "id": 3085,
                                "label": "乌来区",
                                "value": "710228"
                            },
                            {
                                "father": "7102",
                                "id": 3086,
                                "label": "平溪区",
                                "value": "710229"
                            }
                        ],
                        "father": "71",
                        "id": 352,
                        "label": "新北市",
                        "value": "7102"
                    },
                    {
                        "children": [
                            {
                                "father": "7103",
                                "id": 3087,
                                "label": "桃园区",
                                "value": "710301"
                            },
                            {
                                "father": "7103",
                                "id": 3088,
                                "label": "中坜区",
                                "value": "710302"
                            },
                            {
                                "father": "7103",
                                "id": 3089,
                                "label": "平镇区",
                                "value": "710303"
                            },
                            {
                                "father": "7103",
                                "id": 3090,
                                "label": "八德区",
                                "value": "710304"
                            },
                            {
                                "father": "7103",
                                "id": 3091,
                                "label": "杨梅区",
                                "value": "710305"
                            },
                            {
                                "father": "7103",
                                "id": 3092,
                                "label": "芦竹区",
                                "value": "710306"
                            },
                            {
                                "father": "7103",
                                "id": 3093,
                                "label": "龟山区",
                                "value": "710307"
                            },
                            {
                                "father": "7103",
                                "id": 3094,
                                "label": "龙潭区",
                                "value": "710308"
                            },
                            {
                                "father": "7103",
                                "id": 3095,
                                "label": "大溪区",
                                "value": "710309"
                            },
                            {
                                "father": "7103",
                                "id": 3096,
                                "label": "大园区",
                                "value": "710310"
                            },
                            {
                                "father": "7103",
                                "id": 3097,
                                "label": "观音区",
                                "value": "710311"
                            },
                            {
                                "father": "7103",
                                "id": 3098,
                                "label": "新屋区",
                                "value": "710312"
                            },
                            {
                                "father": "7103",
                                "id": 3099,
                                "label": "复兴区",
                                "value": "710313"
                            }
                        ],
                        "father": "71",
                        "id": 353,
                        "label": "桃园市",
                        "value": "7103"
                    },
                    {
                        "children": [
                            {
                                "father": "7104",
                                "id": 3100,
                                "label": "北屯区",
                                "value": "710401"
                            },
                            {
                                "father": "7104",
                                "id": 3101,
                                "label": "西屯区",
                                "value": "710402"
                            },
                            {
                                "father": "7104",
                                "id": 3102,
                                "label": "大里区",
                                "value": "710403"
                            },
                            {
                                "father": "7104",
                                "id": 3103,
                                "label": "太平区",
                                "value": "710404"
                            },
                            {
                                "father": "7104",
                                "id": 3104,
                                "label": "南屯区",
                                "value": "710405"
                            },
                            {
                                "father": "7104",
                                "id": 3105,
                                "label": "丰原区",
                                "value": "710406"
                            },
                            {
                                "father": "7104",
                                "id": 3106,
                                "label": "东区",
                                "value": "710407"
                            },
                            {
                                "father": "7104",
                                "id": 3107,
                                "label": "南区",
                                "value": "710408"
                            },
                            {
                                "father": "7104",
                                "id": 3108,
                                "label": "西区",
                                "value": "710409"
                            },
                            {
                                "father": "7104",
                                "id": 3109,
                                "label": "北区",
                                "value": "710410"
                            },
                            {
                                "father": "7104",
                                "id": 3110,
                                "label": "中区",
                                "value": "710411"
                            },
                            {
                                "father": "7104",
                                "id": 3111,
                                "label": "潭子区",
                                "value": "710412"
                            },
                            {
                                "father": "7104",
                                "id": 3112,
                                "label": "大雅区",
                                "value": "710413"
                            },
                            {
                                "father": "7104",
                                "id": 3113,
                                "label": "沙鹿区",
                                "value": "710414"
                            },
                            {
                                "father": "7104",
                                "id": 3114,
                                "label": "清水区",
                                "value": "710415"
                            },
                            {
                                "father": "7104",
                                "id": 3115,
                                "label": "龙井区",
                                "value": "710416"
                            },
                            {
                                "father": "7104",
                                "id": 3116,
                                "label": "大甲区",
                                "value": "710417"
                            },
                            {
                                "father": "7104",
                                "id": 3117,
                                "label": "乌日区",
                                "value": "710418"
                            },
                            {
                                "father": "7104",
                                "id": 3118,
                                "label": "神冈区",
                                "value": "710419"
                            },
                            {
                                "father": "7104",
                                "id": 3119,
                                "label": "雾峰区",
                                "value": "710420"
                            },
                            {
                                "father": "7104",
                                "id": 3120,
                                "label": "梧栖区",
                                "value": "710421"
                            },
                            {
                                "father": "7104",
                                "id": 3121,
                                "label": "大肚区",
                                "value": "710422"
                            },
                            {
                                "father": "7104",
                                "id": 3122,
                                "label": "后里区",
                                "value": "710423"
                            },
                            {
                                "father": "7104",
                                "id": 3123,
                                "label": "东势区",
                                "value": "710424"
                            },
                            {
                                "father": "7104",
                                "id": 3124,
                                "label": "外埔区",
                                "value": "710425"
                            },
                            {
                                "father": "7104",
                                "id": 3125,
                                "label": "新社区",
                                "value": "710426"
                            },
                            {
                                "father": "7104",
                                "id": 3126,
                                "label": "大安区",
                                "value": "710427"
                            },
                            {
                                "father": "7104",
                                "id": 3127,
                                "label": "石冈区",
                                "value": "710428"
                            },
                            {
                                "father": "7104",
                                "id": 3128,
                                "label": "和平区",
                                "value": "710429"
                            }
                        ],
                        "father": "71",
                        "id": 354,
                        "label": "台中市",
                        "value": "7104"
                    },
                    {
                        "children": [
                            {
                                "father": "7105",
                                "id": 3129,
                                "label": "永康区",
                                "value": "710501"
                            },
                            {
                                "father": "7105",
                                "id": 3130,
                                "label": "安南区",
                                "value": "710502"
                            },
                            {
                                "father": "7105",
                                "id": 3131,
                                "label": "东区",
                                "value": "710503"
                            },
                            {
                                "father": "7105",
                                "id": 3132,
                                "label": "北区",
                                "value": "710504"
                            },
                            {
                                "father": "7105",
                                "id": 3133,
                                "label": "南区",
                                "value": "710505"
                            },
                            {
                                "father": "7105",
                                "id": 3134,
                                "label": "中西区",
                                "value": "710506"
                            },
                            {
                                "father": "7105",
                                "id": 3135,
                                "label": "新营区",
                                "value": "710507"
                            },
                            {
                                "father": "7105",
                                "id": 3136,
                                "label": "仁德区",
                                "value": "710508"
                            },
                            {
                                "father": "7105",
                                "id": 3137,
                                "label": "归仁区",
                                "value": "710509"
                            },
                            {
                                "father": "7105",
                                "id": 3138,
                                "label": "安平区",
                                "value": "710510"
                            },
                            {
                                "father": "7105",
                                "id": 3139,
                                "label": "佳里区",
                                "value": "710511"
                            },
                            {
                                "father": "7105",
                                "id": 3140,
                                "label": "善化区",
                                "value": "710512"
                            },
                            {
                                "father": "7105",
                                "id": 3141,
                                "label": "麻豆区",
                                "value": "710513"
                            },
                            {
                                "father": "7105",
                                "id": 3142,
                                "label": "新化区",
                                "value": "710514"
                            },
                            {
                                "father": "7105",
                                "id": 3143,
                                "label": "新市区",
                                "value": "710515"
                            },
                            {
                                "father": "7105",
                                "id": 3144,
                                "label": "关庙区",
                                "value": "710516"
                            },
                            {
                                "father": "7105",
                                "id": 3145,
                                "label": "安定区",
                                "value": "710517"
                            },
                            {
                                "father": "7105",
                                "id": 3146,
                                "label": "白河区",
                                "value": "710518"
                            },
                            {
                                "father": "7105",
                                "id": 3147,
                                "label": "学甲区",
                                "value": "710519"
                            },
                            {
                                "father": "7105",
                                "id": 3148,
                                "label": "盐水区",
                                "value": "710520"
                            },
                            {
                                "father": "7105",
                                "id": 3149,
                                "label": "西港区",
                                "value": "710521"
                            },
                            {
                                "father": "7105",
                                "id": 3150,
                                "label": "下营区",
                                "value": "710522"
                            },
                            {
                                "father": "7105",
                                "id": 3151,
                                "label": "后壁区",
                                "value": "710523"
                            },
                            {
                                "father": "7105",
                                "id": 3152,
                                "label": "七股区",
                                "value": "710524"
                            },
                            {
                                "father": "7105",
                                "id": 3153,
                                "label": "六甲区",
                                "value": "710525"
                            },
                            {
                                "father": "7105",
                                "id": 3154,
                                "label": "官田区",
                                "value": "710526"
                            },
                            {
                                "father": "7105",
                                "id": 3155,
                                "label": "柳营区",
                                "value": "710527"
                            },
                            {
                                "father": "7105",
                                "id": 3156,
                                "label": "东山区",
                                "value": "710528"
                            },
                            {
                                "father": "7105",
                                "id": 3157,
                                "label": "将军区",
                                "value": "710529"
                            },
                            {
                                "father": "7105",
                                "id": 3158,
                                "label": "玉井区",
                                "value": "710530"
                            },
                            {
                                "father": "7105",
                                "id": 3159,
                                "label": "北门区",
                                "value": "710531"
                            },
                            {
                                "father": "7105",
                                "id": 3160,
                                "label": "大内区",
                                "value": "710532"
                            },
                            {
                                "father": "7105",
                                "id": 3161,
                                "label": "楠西区",
                                "value": "710533"
                            },
                            {
                                "father": "7105",
                                "id": 3162,
                                "label": "南化区",
                                "value": "710534"
                            },
                            {
                                "father": "7105",
                                "id": 3163,
                                "label": "山上区",
                                "value": "710535"
                            },
                            {
                                "father": "7105",
                                "id": 3164,
                                "label": "左镇区",
                                "value": "710536"
                            },
                            {
                                "father": "7105",
                                "id": 3165,
                                "label": "龙崎区",
                                "value": "710537"
                            }
                        ],
                        "father": "71",
                        "id": 355,
                        "label": "台南市",
                        "value": "7105"
                    },
                    {
                        "children": [
                            {
                                "father": "7106",
                                "id": 3166,
                                "label": "凤山区",
                                "value": "710601"
                            },
                            {
                                "father": "7106",
                                "id": 3167,
                                "label": "三民区",
                                "value": "710602"
                            },
                            {
                                "father": "7106",
                                "id": 3168,
                                "label": "左营区",
                                "value": "710603"
                            },
                            {
                                "father": "7106",
                                "id": 3169,
                                "label": "前镇区",
                                "value": "710604"
                            },
                            {
                                "father": "7106",
                                "id": 3170,
                                "label": "楠梓区",
                                "value": "710605"
                            },
                            {
                                "father": "7106",
                                "id": 3171,
                                "label": "苓雅区",
                                "value": "710606"
                            },
                            {
                                "father": "7106",
                                "id": 3172,
                                "label": "小港区",
                                "value": "710607"
                            },
                            {
                                "father": "7106",
                                "id": 3173,
                                "label": "鼓山区",
                                "value": "710608"
                            },
                            {
                                "father": "7106",
                                "id": 3174,
                                "label": "大寮区",
                                "value": "710609"
                            },
                            {
                                "father": "7106",
                                "id": 3175,
                                "label": "冈山区",
                                "value": "710610"
                            },
                            {
                                "father": "7106",
                                "id": 3176,
                                "label": "仁武区",
                                "value": "710611"
                            },
                            {
                                "father": "7106",
                                "id": 3177,
                                "label": "林园区",
                                "value": "710612"
                            },
                            {
                                "father": "7106",
                                "id": 3178,
                                "label": "路竹区",
                                "value": "710613"
                            },
                            {
                                "father": "7106",
                                "id": 3179,
                                "label": "新兴区",
                                "value": "710614"
                            },
                            {
                                "father": "7106",
                                "id": 3180,
                                "label": "鸟松区",
                                "value": "710615"
                            },
                            {
                                "father": "7106",
                                "id": 3181,
                                "label": "大树区",
                                "value": "710616"
                            },
                            {
                                "father": "7106",
                                "id": 3182,
                                "label": "美浓区",
                                "value": "710617"
                            },
                            {
                                "father": "7106",
                                "id": 3183,
                                "label": "桥头区",
                                "value": "710618"
                            },
                            {
                                "father": "7106",
                                "id": 3184,
                                "label": "旗山区",
                                "value": "710619"
                            },
                            {
                                "father": "7106",
                                "id": 3185,
                                "label": "梓官区",
                                "value": "710620"
                            },
                            {
                                "father": "7106",
                                "id": 3186,
                                "label": "大社区",
                                "value": "710621"
                            },
                            {
                                "father": "7106",
                                "id": 3187,
                                "label": "茄萣区",
                                "value": "710622"
                            },
                            {
                                "father": "7106",
                                "id": 3188,
                                "label": "燕巢区",
                                "value": "710623"
                            },
                            {
                                "father": "7106",
                                "id": 3189,
                                "label": "湖内区",
                                "value": "710624"
                            },
                            {
                                "father": "7106",
                                "id": 3190,
                                "label": "阿莲区",
                                "value": "710625"
                            },
                            {
                                "father": "7106",
                                "id": 3191,
                                "label": "旗津区",
                                "value": "710626"
                            },
                            {
                                "father": "7106",
                                "id": 3192,
                                "label": "前金区",
                                "value": "710627"
                            },
                            {
                                "father": "7106",
                                "id": 3193,
                                "label": "盐埕区",
                                "value": "710628"
                            },
                            {
                                "father": "7106",
                                "id": 3194,
                                "label": "弥陀区",
                                "value": "710629"
                            },
                            {
                                "father": "7106",
                                "id": 3195,
                                "label": "内门区",
                                "value": "710630"
                            },
                            {
                                "father": "7106",
                                "id": 3196,
                                "label": "永安区",
                                "value": "710631"
                            },
                            {
                                "father": "7106",
                                "id": 3197,
                                "label": "六龟区",
                                "value": "710632"
                            },
                            {
                                "father": "7106",
                                "id": 3198,
                                "label": "杉林区",
                                "value": "710633"
                            },
                            {
                                "father": "7106",
                                "id": 3199,
                                "label": "田寮区",
                                "value": "710634"
                            },
                            {
                                "father": "7106",
                                "id": 3200,
                                "label": "甲仙区",
                                "value": "710635"
                            },
                            {
                                "father": "7106",
                                "id": 3201,
                                "label": "桃源区",
                                "value": "710636"
                            },
                            {
                                "father": "7106",
                                "id": 3202,
                                "label": "那玛夏区",
                                "value": "710637"
                            },
                            {
                                "father": "7106",
                                "id": 3203,
                                "label": "茂林区",
                                "value": "710638"
                            }
                        ],
                        "father": "71",
                        "id": 356,
                        "label": "高雄市",
                        "value": "7106"
                    },
                    {
                        "children": [
                            {
                                "father": "7107",
                                "id": 3204,
                                "label": "安乐区",
                                "value": "710701"
                            },
                            {
                                "father": "7107",
                                "id": 3205,
                                "label": "七堵区",
                                "value": "710702"
                            },
                            {
                                "father": "7107",
                                "id": 3206,
                                "label": "信义区",
                                "value": "710703"
                            },
                            {
                                "father": "7107",
                                "id": 3207,
                                "label": "中正区",
                                "value": "710704"
                            },
                            {
                                "father": "7107",
                                "id": 3208,
                                "label": "中山区",
                                "value": "710705"
                            },
                            {
                                "father": "7107",
                                "id": 3209,
                                "label": "仁爱区",
                                "value": "710706"
                            },
                            {
                                "father": "7107",
                                "id": 3210,
                                "label": "暖暖区",
                                "value": "710707"
                            }
                        ],
                        "father": "71",
                        "id": 357,
                        "label": "基隆市",
                        "value": "7107"
                    },
                    {
                        "children": [
                            {
                                "father": "7108",
                                "id": 3211,
                                "label": "东区",
                                "value": "710801"
                            },
                            {
                                "father": "7108",
                                "id": 3212,
                                "label": "北区",
                                "value": "710802"
                            },
                            {
                                "father": "7108",
                                "id": 3213,
                                "label": "香山区",
                                "value": "710803"
                            }
                        ],
                        "father": "71",
                        "id": 358,
                        "label": "新竹市",
                        "value": "7108"
                    },
                    {
                        "children": [
                            {
                                "father": "7109",
                                "id": 3214,
                                "label": "东区",
                                "value": "710901"
                            },
                            {
                                "father": "7109",
                                "id": 3215,
                                "label": "西区",
                                "value": "710902"
                            }
                        ],
                        "father": "71",
                        "id": 359,
                        "label": "嘉义市",
                        "value": "7109"
                    },
                    {
                        "children": [
                            {
                                "father": "7110",
                                "id": 3216,
                                "label": "竹北市",
                                "value": "711001"
                            },
                            {
                                "father": "7110",
                                "id": 3217,
                                "label": "竹东镇",
                                "value": "711002"
                            },
                            {
                                "father": "7110",
                                "id": 3218,
                                "label": "新埔镇",
                                "value": "711003"
                            },
                            {
                                "father": "7110",
                                "id": 3219,
                                "label": "关西镇",
                                "value": "711004"
                            },
                            {
                                "father": "7110",
                                "id": 3220,
                                "label": "湖口乡",
                                "value": "711005"
                            },
                            {
                                "father": "7110",
                                "id": 3221,
                                "label": "新丰乡",
                                "value": "711006"
                            },
                            {
                                "father": "7110",
                                "id": 3222,
                                "label": "芎林乡",
                                "value": "711007"
                            },
                            {
                                "father": "7110",
                                "id": 3223,
                                "label": "宝山乡",
                                "value": "711008"
                            },
                            {
                                "father": "7110",
                                "id": 3224,
                                "label": "横山乡",
                                "value": "711009"
                            },
                            {
                                "father": "7110",
                                "id": 3225,
                                "label": "尖石乡",
                                "value": "711010"
                            },
                            {
                                "father": "7110",
                                "id": 3226,
                                "label": "北埔乡",
                                "value": "711011"
                            },
                            {
                                "father": "7110",
                                "id": 3227,
                                "label": "峨眉乡",
                                "value": "711012"
                            },
                            {
                                "father": "7110",
                                "id": 3228,
                                "label": "五峰乡",
                                "value": "711013"
                            }
                        ],
                        "father": "71",
                        "id": 360,
                        "label": "新竹县",
                        "value": "7110"
                    },
                    {
                        "children": [
                            {
                                "father": "7111",
                                "id": 3229,
                                "label": "头份市",
                                "value": "711101"
                            },
                            {
                                "father": "7111",
                                "id": 3230,
                                "label": "苗栗市",
                                "value": "711102"
                            },
                            {
                                "father": "7111",
                                "id": 3231,
                                "label": "竹南镇",
                                "value": "711103"
                            },
                            {
                                "father": "7111",
                                "id": 3232,
                                "label": "苑里镇",
                                "value": "711104"
                            },
                            {
                                "father": "7111",
                                "id": 3233,
                                "label": "后龙镇",
                                "value": "711105"
                            },
                            {
                                "father": "7111",
                                "id": 3234,
                                "label": "通霄镇",
                                "value": "711106"
                            },
                            {
                                "father": "7111",
                                "id": 3235,
                                "label": "卓兰镇",
                                "value": "711107"
                            },
                            {
                                "father": "7111",
                                "id": 3236,
                                "label": "公馆乡",
                                "value": "711108"
                            },
                            {
                                "father": "7111",
                                "id": 3237,
                                "label": "铜锣乡",
                                "value": "711109"
                            },
                            {
                                "father": "7111",
                                "id": 3238,
                                "label": "三义乡",
                                "value": "711110"
                            },
                            {
                                "father": "7111",
                                "id": 3239,
                                "label": "大湖乡",
                                "value": "711111"
                            },
                            {
                                "father": "7111",
                                "id": 3240,
                                "label": "造桥乡",
                                "value": "711112"
                            },
                            {
                                "father": "7111",
                                "id": 3241,
                                "label": "头屋乡",
                                "value": "711113"
                            },
                            {
                                "father": "7111",
                                "id": 3242,
                                "label": "南庄乡",
                                "value": "711114"
                            },
                            {
                                "father": "7111",
                                "id": 3243,
                                "label": "西湖乡",
                                "value": "711115"
                            },
                            {
                                "father": "7111",
                                "id": 3244,
                                "label": "三湾乡",
                                "value": "711116"
                            },
                            {
                                "father": "7111",
                                "id": 3245,
                                "label": "泰安乡",
                                "value": "711117"
                            },
                            {
                                "father": "7111",
                                "id": 3246,
                                "label": "狮潭乡",
                                "value": "711118"
                            }
                        ],
                        "father": "71",
                        "id": 361,
                        "label": "苗栗县",
                        "value": "7111"
                    },
                    {
                        "children": [
                            {
                                "father": "7112",
                                "id": 3247,
                                "label": "彰化市",
                                "value": "711201"
                            },
                            {
                                "father": "7112",
                                "id": 3248,
                                "label": "员林市",
                                "value": "711202"
                            },
                            {
                                "father": "7112",
                                "id": 3249,
                                "label": "和美镇",
                                "value": "711203"
                            },
                            {
                                "father": "7112",
                                "id": 3250,
                                "label": "鹿港镇",
                                "value": "711204"
                            },
                            {
                                "father": "7112",
                                "id": 3251,
                                "label": "溪湖镇",
                                "value": "711205"
                            },
                            {
                                "father": "7112",
                                "id": 3252,
                                "label": "二林镇",
                                "value": "711206"
                            },
                            {
                                "father": "7112",
                                "id": 3253,
                                "label": "田中镇",
                                "value": "711207"
                            },
                            {
                                "father": "7112",
                                "id": 3254,
                                "label": "北斗镇",
                                "value": "711208"
                            },
                            {
                                "father": "7112",
                                "id": 3255,
                                "label": "福兴乡",
                                "value": "711209"
                            },
                            {
                                "father": "7112",
                                "id": 3256,
                                "label": "花坛乡",
                                "value": "711210"
                            },
                            {
                                "father": "7112",
                                "id": 3257,
                                "label": "社头乡",
                                "value": "711211"
                            },
                            {
                                "father": "7112",
                                "id": 3258,
                                "label": "秀水乡",
                                "value": "711212"
                            },
                            {
                                "father": "7112",
                                "id": 3259,
                                "label": "伸港乡",
                                "value": "711213"
                            },
                            {
                                "father": "7112",
                                "id": 3260,
                                "label": "大村乡",
                                "value": "711214"
                            },
                            {
                                "father": "7112",
                                "id": 3261,
                                "label": "永靖乡",
                                "value": "711215"
                            },
                            {
                                "father": "7112",
                                "id": 3262,
                                "label": "埔心乡",
                                "value": "711216"
                            },
                            {
                                "father": "7112",
                                "id": 3263,
                                "label": "芳苑乡",
                                "value": "711217"
                            },
                            {
                                "father": "7112",
                                "id": 3264,
                                "label": "埔盐乡",
                                "value": "711218"
                            },
                            {
                                "father": "7112",
                                "id": 3265,
                                "label": "埤头乡",
                                "value": "711219"
                            },
                            {
                                "father": "7112",
                                "id": 3266,
                                "label": "溪州乡",
                                "value": "711220"
                            },
                            {
                                "father": "7112",
                                "id": 3267,
                                "label": "田尾乡",
                                "value": "711221"
                            },
                            {
                                "father": "7112",
                                "id": 3268,
                                "label": "芬园乡",
                                "value": "711222"
                            },
                            {
                                "father": "7112",
                                "id": 3269,
                                "label": "线西乡",
                                "value": "711223"
                            },
                            {
                                "father": "7112",
                                "id": 3270,
                                "label": "大城乡",
                                "value": "711224"
                            },
                            {
                                "father": "7112",
                                "id": 3271,
                                "label": "二水乡",
                                "value": "711225"
                            },
                            {
                                "father": "7112",
                                "id": 3272,
                                "label": "竹塘乡",
                                "value": "711226"
                            }
                        ],
                        "father": "71",
                        "id": 362,
                        "label": "彰化县",
                        "value": "7112"
                    },
                    {
                        "children": [
                            {
                                "father": "7113",
                                "id": 3273,
                                "label": "南投市",
                                "value": "711301"
                            },
                            {
                                "father": "7113",
                                "id": 3274,
                                "label": "草屯镇",
                                "value": "711302"
                            },
                            {
                                "father": "7113",
                                "id": 3275,
                                "label": "埔里镇",
                                "value": "711303"
                            },
                            {
                                "father": "7113",
                                "id": 3276,
                                "label": "竹山镇",
                                "value": "711304"
                            },
                            {
                                "father": "7113",
                                "id": 3277,
                                "label": "集集镇",
                                "value": "711305"
                            },
                            {
                                "father": "7113",
                                "id": 3278,
                                "label": "名间乡",
                                "value": "711306"
                            },
                            {
                                "father": "7113",
                                "id": 3279,
                                "label": "国姓乡",
                                "value": "711307"
                            },
                            {
                                "father": "7113",
                                "id": 3280,
                                "label": "鹿谷乡",
                                "value": "711308"
                            },
                            {
                                "father": "7113",
                                "id": 3281,
                                "label": "水里乡",
                                "value": "711309"
                            },
                            {
                                "father": "7113",
                                "id": 3282,
                                "label": "信义乡",
                                "value": "711310"
                            },
                            {
                                "father": "7113",
                                "id": 3283,
                                "label": "仁爱乡",
                                "value": "711311"
                            },
                            {
                                "father": "7113",
                                "id": 3284,
                                "label": "鱼池乡",
                                "value": "711312"
                            },
                            {
                                "father": "7113",
                                "id": 3285,
                                "label": "中寮乡",
                                "value": "711313"
                            }
                        ],
                        "father": "71",
                        "id": 363,
                        "label": "南投县",
                        "value": "7113"
                    },
                    {
                        "children": [
                            {
                                "father": "7114",
                                "id": 3286,
                                "label": "斗六市",
                                "value": "711401"
                            },
                            {
                                "father": "7114",
                                "id": 3287,
                                "label": "虎尾镇",
                                "value": "711402"
                            },
                            {
                                "father": "7114",
                                "id": 3288,
                                "label": "西螺镇",
                                "value": "711403"
                            },
                            {
                                "father": "7114",
                                "id": 3289,
                                "label": "斗南镇",
                                "value": "711404"
                            },
                            {
                                "father": "7114",
                                "id": 3290,
                                "label": "北港镇",
                                "value": "711405"
                            },
                            {
                                "father": "7114",
                                "id": 3291,
                                "label": "土库镇",
                                "value": "711406"
                            },
                            {
                                "father": "7114",
                                "id": 3292,
                                "label": "麦寮乡",
                                "value": "711407"
                            },
                            {
                                "father": "7114",
                                "id": 3293,
                                "label": "古坑乡",
                                "value": "711408"
                            },
                            {
                                "father": "7114",
                                "id": 3294,
                                "label": "莿桐乡",
                                "value": "711409"
                            },
                            {
                                "father": "7114",
                                "id": 3295,
                                "label": "口湖乡",
                                "value": "711410"
                            },
                            {
                                "father": "7114",
                                "id": 3296,
                                "label": "二仑乡",
                                "value": "711411"
                            },
                            {
                                "father": "7114",
                                "id": 3297,
                                "label": "元长乡",
                                "value": "711412"
                            },
                            {
                                "father": "7114",
                                "id": 3298,
                                "label": "水林乡",
                                "value": "711413"
                            },
                            {
                                "father": "7114",
                                "id": 3299,
                                "label": "仑背乡",
                                "value": "711414"
                            },
                            {
                                "father": "7114",
                                "id": 3300,
                                "label": "台西乡",
                                "value": "711415"
                            },
                            {
                                "father": "7114",
                                "id": 3301,
                                "label": "四湖乡",
                                "value": "711416"
                            },
                            {
                                "father": "7114",
                                "id": 3302,
                                "label": "大埤乡",
                                "value": "711417"
                            },
                            {
                                "father": "7114",
                                "id": 3303,
                                "label": "林内乡",
                                "value": "711418"
                            },
                            {
                                "father": "7114",
                                "id": 3304,
                                "label": "东势乡",
                                "value": "711419"
                            },
                            {
                                "father": "7114",
                                "id": 3305,
                                "label": "褒忠乡",
                                "value": "711420"
                            }
                        ],
                        "father": "71",
                        "id": 364,
                        "label": "云林县",
                        "value": "7114"
                    },
                    {
                        "children": [
                            {
                                "father": "7115",
                                "id": 3306,
                                "label": "朴子市",
                                "value": "711501"
                            },
                            {
                                "father": "7115",
                                "id": 3307,
                                "label": "太保市",
                                "value": "711502"
                            },
                            {
                                "father": "7115",
                                "id": 3308,
                                "label": "大林镇",
                                "value": "711503"
                            },
                            {
                                "father": "7115",
                                "id": 3309,
                                "label": "布袋镇",
                                "value": "711504"
                            },
                            {
                                "father": "7115",
                                "id": 3310,
                                "label": "民雄乡",
                                "value": "711505"
                            },
                            {
                                "father": "7115",
                                "id": 3311,
                                "label": "水上乡",
                                "value": "711506"
                            },
                            {
                                "father": "7115",
                                "id": 3312,
                                "label": "中埔乡",
                                "value": "711507"
                            },
                            {
                                "father": "7115",
                                "id": 3313,
                                "label": "竹崎乡",
                                "value": "711508"
                            },
                            {
                                "father": "7115",
                                "id": 3314,
                                "label": "新港乡",
                                "value": "711509"
                            },
                            {
                                "father": "7115",
                                "id": 3315,
                                "label": "东石乡",
                                "value": "711510"
                            },
                            {
                                "father": "7115",
                                "id": 3316,
                                "label": "六脚乡",
                                "value": "711511"
                            },
                            {
                                "father": "7115",
                                "id": 3317,
                                "label": "梅山乡",
                                "value": "711512"
                            },
                            {
                                "father": "7115",
                                "id": 3318,
                                "label": "义竹乡",
                                "value": "711513"
                            },
                            {
                                "father": "7115",
                                "id": 3319,
                                "label": "鹿草乡",
                                "value": "711514"
                            },
                            {
                                "father": "7115",
                                "id": 3320,
                                "label": "溪口乡",
                                "value": "711515"
                            },
                            {
                                "father": "7115",
                                "id": 3321,
                                "label": "番路乡",
                                "value": "711516"
                            },
                            {
                                "father": "7115",
                                "id": 3322,
                                "label": "阿里山乡",
                                "value": "711517"
                            },
                            {
                                "father": "7115",
                                "id": 3323,
                                "label": "大埔乡",
                                "value": "711518"
                            }
                        ],
                        "father": "71",
                        "id": 365,
                        "label": "嘉义县",
                        "value": "7115"
                    },
                    {
                        "children": [
                            {
                                "father": "7116",
                                "id": 3324,
                                "label": "屏东市",
                                "value": "711601"
                            },
                            {
                                "father": "7116",
                                "id": 3325,
                                "label": "潮州镇",
                                "value": "711602"
                            },
                            {
                                "father": "7116",
                                "id": 3326,
                                "label": "东港镇",
                                "value": "711603"
                            },
                            {
                                "father": "7116",
                                "id": 3327,
                                "label": "恒春镇",
                                "value": "711604"
                            },
                            {
                                "father": "7116",
                                "id": 3328,
                                "label": "内埔乡",
                                "value": "711605"
                            },
                            {
                                "father": "7116",
                                "id": 3329,
                                "label": "万丹乡",
                                "value": "711606"
                            },
                            {
                                "father": "7116",
                                "id": 3330,
                                "label": "新园乡",
                                "value": "711607"
                            },
                            {
                                "father": "7116",
                                "id": 3331,
                                "label": "长治乡",
                                "value": "711608"
                            },
                            {
                                "father": "7116",
                                "id": 3332,
                                "label": "里港乡",
                                "value": "711609"
                            },
                            {
                                "father": "7116",
                                "id": 3333,
                                "label": "盐埔乡",
                                "value": "711610"
                            },
                            {
                                "father": "7116",
                                "id": 3334,
                                "label": "高树乡",
                                "value": "711611"
                            },
                            {
                                "father": "7116",
                                "id": 3335,
                                "label": "枋寮乡",
                                "value": "711612"
                            },
                            {
                                "father": "7116",
                                "id": 3336,
                                "label": "九如乡",
                                "value": "711613"
                            },
                            {
                                "father": "7116",
                                "id": 3337,
                                "label": "万峦乡",
                                "value": "711614"
                            },
                            {
                                "father": "7116",
                                "id": 3338,
                                "label": "佳冬乡",
                                "value": "711615"
                            },
                            {
                                "father": "7116",
                                "id": 3339,
                                "label": "林边乡",
                                "value": "711616"
                            },
                            {
                                "father": "7116",
                                "id": 3340,
                                "label": "竹田乡",
                                "value": "711617"
                            },
                            {
                                "father": "7116",
                                "id": 3341,
                                "label": "崁顶乡",
                                "value": "711618"
                            },
                            {
                                "father": "7116",
                                "id": 3342,
                                "label": "琉球乡",
                                "value": "711619"
                            },
                            {
                                "father": "7116",
                                "id": 3343,
                                "label": "麟洛乡",
                                "value": "711620"
                            },
                            {
                                "father": "7116",
                                "id": 3344,
                                "label": "南州乡",
                                "value": "711621"
                            },
                            {
                                "father": "7116",
                                "id": 3345,
                                "label": "新埤乡",
                                "value": "711622"
                            },
                            {
                                "father": "7116",
                                "id": 3346,
                                "label": "车城乡",
                                "value": "711623"
                            },
                            {
                                "father": "7116",
                                "id": 3347,
                                "label": "满州乡",
                                "value": "711624"
                            },
                            {
                                "father": "7116",
                                "id": 3348,
                                "label": "三地门乡",
                                "value": "711625"
                            },
                            {
                                "father": "7116",
                                "id": 3349,
                                "label": "来义乡",
                                "value": "711626"
                            },
                            {
                                "father": "7116",
                                "id": 3350,
                                "label": "玛家乡",
                                "value": "711627"
                            },
                            {
                                "father": "7116",
                                "id": 3351,
                                "label": "枋山乡",
                                "value": "711628"
                            },
                            {
                                "father": "7116",
                                "id": 3352,
                                "label": "泰武乡",
                                "value": "711629"
                            },
                            {
                                "father": "7116",
                                "id": 3353,
                                "label": "牡丹乡",
                                "value": "711630"
                            },
                            {
                                "father": "7116",
                                "id": 3354,
                                "label": "狮子乡",
                                "value": "711631"
                            },
                            {
                                "father": "7116",
                                "id": 3355,
                                "label": "春日乡",
                                "value": "711632"
                            },
                            {
                                "father": "7116",
                                "id": 3356,
                                "label": "雾台乡",
                                "value": "711633"
                            }
                        ],
                        "father": "71",
                        "id": 366,
                        "label": "屏东县",
                        "value": "7116"
                    },
                    {
                        "children": [
                            {
                                "father": "7117",
                                "id": 3357,
                                "label": "宜兰市",
                                "value": "711701"
                            },
                            {
                                "father": "7117",
                                "id": 3358,
                                "label": "罗东镇",
                                "value": "711702"
                            },
                            {
                                "father": "7117",
                                "id": 3359,
                                "label": "苏澳镇",
                                "value": "711703"
                            },
                            {
                                "father": "7117",
                                "id": 3360,
                                "label": "头城镇",
                                "value": "711704"
                            },
                            {
                                "father": "7117",
                                "id": 3361,
                                "label": "冬山乡",
                                "value": "711705"
                            },
                            {
                                "father": "7117",
                                "id": 3362,
                                "label": "五结乡",
                                "value": "711706"
                            },
                            {
                                "father": "7117",
                                "id": 3363,
                                "label": "礁溪乡",
                                "value": "711707"
                            },
                            {
                                "father": "7117",
                                "id": 3364,
                                "label": "员山乡",
                                "value": "711708"
                            },
                            {
                                "father": "7117",
                                "id": 3365,
                                "label": "壮围乡",
                                "value": "711709"
                            },
                            {
                                "father": "7117",
                                "id": 3366,
                                "label": "三星乡",
                                "value": "711710"
                            },
                            {
                                "father": "7117",
                                "id": 3367,
                                "label": "大同乡",
                                "value": "711711"
                            },
                            {
                                "father": "7117",
                                "id": 3368,
                                "label": "南澳乡",
                                "value": "711712"
                            }
                        ],
                        "father": "71",
                        "id": 367,
                        "label": "宜兰县",
                        "value": "7117"
                    },
                    {
                        "children": [
                            {
                                "father": "7118",
                                "id": 3369,
                                "label": "花莲市",
                                "value": "711801"
                            },
                            {
                                "father": "7118",
                                "id": 3370,
                                "label": "玉里镇",
                                "value": "711802"
                            },
                            {
                                "father": "7118",
                                "id": 3371,
                                "label": "凤林镇",
                                "value": "711803"
                            },
                            {
                                "father": "7118",
                                "id": 3372,
                                "label": "吉安乡",
                                "value": "711804"
                            },
                            {
                                "father": "7118",
                                "id": 3373,
                                "label": "新城乡",
                                "value": "711805"
                            },
                            {
                                "father": "7118",
                                "id": 3374,
                                "label": "寿丰乡",
                                "value": "711806"
                            },
                            {
                                "father": "7118",
                                "id": 3375,
                                "label": "秀林乡",
                                "value": "711807"
                            },
                            {
                                "father": "7118",
                                "id": 3376,
                                "label": "光复乡",
                                "value": "711808"
                            },
                            {
                                "father": "7118",
                                "id": 3377,
                                "label": "瑞穗乡",
                                "value": "711809"
                            },
                            {
                                "father": "7118",
                                "id": 3378,
                                "label": "富里乡",
                                "value": "711810"
                            },
                            {
                                "father": "7118",
                                "id": 3379,
                                "label": "万荣乡",
                                "value": "711811"
                            },
                            {
                                "father": "7118",
                                "id": 3380,
                                "label": "卓溪乡",
                                "value": "711812"
                            },
                            {
                                "father": "7118",
                                "id": 3381,
                                "label": "丰滨乡",
                                "value": "711813"
                            }
                        ],
                        "father": "71",
                        "id": 368,
                        "label": "花莲县",
                        "value": "7118"
                    },
                    {
                        "children": [
                            {
                                "father": "7119",
                                "id": 3382,
                                "label": "台东市",
                                "value": "711901"
                            },
                            {
                                "father": "7119",
                                "id": 3383,
                                "label": "卑南乡",
                                "value": "711902"
                            },
                            {
                                "father": "7119",
                                "id": 3384,
                                "label": "成功镇",
                                "value": "711903"
                            },
                            {
                                "father": "7119",
                                "id": 3385,
                                "label": "太麻里乡",
                                "value": "711904"
                            },
                            {
                                "father": "7119",
                                "id": 3386,
                                "label": "关山镇",
                                "value": "711905"
                            },
                            {
                                "father": "7119",
                                "id": 3387,
                                "label": "东河乡",
                                "value": "711906"
                            },
                            {
                                "father": "7119",
                                "id": 3388,
                                "label": "池上乡",
                                "value": "711907"
                            },
                            {
                                "father": "7119",
                                "id": 3389,
                                "label": "鹿野乡",
                                "value": "711908"
                            },
                            {
                                "father": "7119",
                                "id": 3390,
                                "label": "长滨乡",
                                "value": "711909"
                            },
                            {
                                "father": "7119",
                                "id": 3391,
                                "label": "大武乡",
                                "value": "711910"
                            },
                            {
                                "father": "7119",
                                "id": 3392,
                                "label": "兰屿乡",
                                "value": "711911"
                            },
                            {
                                "father": "7119",
                                "id": 3393,
                                "label": "海端乡",
                                "value": "711912"
                            },
                            {
                                "father": "7119",
                                "id": 3394,
                                "label": "绿岛乡",
                                "value": "711913"
                            },
                            {
                                "father": "7119",
                                "id": 3395,
                                "label": "金峰乡",
                                "value": "711914"
                            },
                            {
                                "father": "7119",
                                "id": 3396,
                                "label": "延平乡",
                                "value": "711915"
                            },
                            {
                                "father": "7119",
                                "id": 3397,
                                "label": "达仁乡",
                                "value": "711916"
                            }
                        ],
                        "father": "71",
                        "id": 369,
                        "label": "台东县",
                        "value": "7119"
                    },
                    {
                        "children": [
                            {
                                "father": "7120",
                                "id": 3398,
                                "label": "马公市",
                                "value": "712001"
                            },
                            {
                                "father": "7120",
                                "id": 3399,
                                "label": "湖西乡",
                                "value": "712002"
                            },
                            {
                                "father": "7120",
                                "id": 3400,
                                "label": "白沙乡",
                                "value": "712003"
                            },
                            {
                                "father": "7120",
                                "id": 3401,
                                "label": "西屿乡",
                                "value": "712004"
                            },
                            {
                                "father": "7120",
                                "id": 3402,
                                "label": "望安乡",
                                "value": "712005"
                            },
                            {
                                "father": "7120",
                                "id": 3403,
                                "label": "七美乡",
                                "value": "712006"
                            }
                        ],
                        "father": "71",
                        "id": 370,
                        "label": "澎湖县",
                        "value": "7120"
                    }
                ],
                "id": 37,
                "label": "台湾省",
                "value": "71"
            }
       
]